/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 23);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(30);
} else {
  module.exports = require('./cjs/react.development.js');
}


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) {
  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
    Symbol.for &&
    Symbol.for('react.element')) ||
    0xeac7;

  var isValidElement = function(object) {
    return typeof object === 'object' &&
      object !== null &&
      object.$$typeof === REACT_ELEMENT_TYPE;
  };

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(isValidElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(44)();
}


/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
function insertRule(e){try{return sheet.insertRule(e,sheet.cssRules.length)}catch(e){console.warn("react-reveal - animation failed")}}function cascade(e,n,t,o,r){var s=Math.log(o),i=Math.log(r),a=(i-s)/(t-n);return Math.exp(s+a*(e-n))}function animation(e){if(!sheet)return"";var n="@keyframes "+(name+counter)+"{"+e+"}",t=effectMap[e];return t?""+name+t:(sheet.insertRule(n,sheet.cssRules.length),effectMap[e]=counter,""+name+counter++)}function hideAll(){globalHide||(exports.globalHide=globalHide=!0,window.removeEventListener("scroll",hideAll,!0),insertRule("."+namespace+" { opacity: 0; }"),window.removeEventListener("orientationchange",hideAll,!0),window.document.removeEventListener("visibilitychange",hideAll))}function config(e){var n=e.ssrFadeout;exports.fadeOutEnabled=fadeOutEnabled=n}Object.defineProperty(exports,"__esModule",{value:!0}),exports.insertRule=insertRule,exports.cascade=cascade,exports.animation=animation,exports.hideAll=hideAll,exports.default=config;var namespace=exports.namespace="react-reveal",defaults=exports.defaults={duration:1e3,delay:0,count:1},ssr=exports.ssr=!0,observerMode=exports.observerMode=!1,raf=exports.raf=function(e){return window.setTimeout(e,66)},disableSsr=exports.disableSsr=function(){return exports.ssr=ssr=!1},fadeOutEnabled=exports.fadeOutEnabled=!1,ssrFadeout=exports.ssrFadeout=function(){var e=arguments.length>0&&void 0!==arguments[0]&&arguments[0];return exports.fadeOutEnabled=fadeOutEnabled=e},globalHide=exports.globalHide=!1,ie10=exports.ie10=!1,collapseend=exports.collapseend=void 0,counter=1,effectMap={},sheet=!1,name=namespace+"-"+Math.floor(1e15*Math.random())+"-";if("undefined"!=typeof window&&"nodejs"!==window.name&&window.document&&"undefined"!=typeof navigator){exports.observerMode=observerMode="IntersectionObserver"in window&&"IntersectionObserverEntry"in window&&"intersectionRatio"in window.IntersectionObserverEntry.prototype&&/\{\s*\[native code\]\s*\}/.test(""+IntersectionObserver),exports.raf=raf=window.requestAnimationFrame||window.webkitRequestAnimationFrame||window.mozRequestAnimationFrame||raf,exports.ssr=ssr=window.document.querySelectorAll("div[data-reactroot]").length>0,-1!==navigator.appVersion.indexOf("MSIE 10")&&(exports.ie10=ie10=!0),ssr&&"performance"in window&&"timing"in window.performance&&"domContentLoadedEventEnd"in window.performance.timing&&window.performance.timing.domLoading&&Date.now()-window.performance.timing.domLoading<300&&(exports.ssr=ssr=!1),ssr&&window.setTimeout(disableSsr,1500),observerMode||(exports.collapseend=collapseend=document.createEvent("Event"),collapseend.initEvent("collapseend",!0,!0));var element=document.createElement("style");document.head.appendChild(element),element.sheet&&element.sheet.cssRules&&element.sheet.insertRule&&(sheet=element.sheet,window.addEventListener("scroll",hideAll,!0),window.addEventListener("orientationchange",hideAll,!0),window.document.addEventListener("visibilitychange",hideAll))}

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
function _interopRequireDefault(e){return e&&e.__esModule?e:{default:e}}function wrap(e,t,a,r){return"in"in e&&(e.when=e.in),_react2.default.Children.count(r)<2?_react2.default.createElement(_RevealBase2.default,_extends({},e,{inEffect:t,outEffect:a,children:r})):(r=_react2.default.Children.map(r,function(r){return _react2.default.createElement(_RevealBase2.default,_extends({},e,{inEffect:t,outEffect:a,children:r}))}),"Fragment"in _react2.default?_react2.default.createElement(_react2.default.Fragment,null,r):_react2.default.createElement("span",null,r))}Object.defineProperty(exports,"__esModule",{value:!0});var _extends=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var a=arguments[t];for(var r in a)Object.prototype.hasOwnProperty.call(a,r)&&(e[r]=a[r])}return e};exports.default=wrap;var _react=__webpack_require__(0),_react2=_interopRequireDefault(_react),_RevealBase=__webpack_require__(163),_RevealBase2=_interopRequireDefault(_RevealBase);module.exports=exports.default;

/***/ }),
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Alert */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return Container; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return Row; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return Col; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return Navbar; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return NavbarBrand; });
/* unused harmony export NavbarToggler */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return Nav; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return NavItem; });
/* unused harmony export NavDropdown */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return NavLink; });
/* unused harmony export Breadcrumb */
/* unused harmony export BreadcrumbItem */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Button; });
/* unused harmony export ButtonDropdown */
/* unused harmony export ButtonGroup */
/* unused harmony export ButtonToolbar */
/* unused harmony export Dropdown */
/* unused harmony export DropdownItem */
/* unused harmony export DropdownMenu */
/* unused harmony export DropdownToggle */
/* unused harmony export Fade */
/* unused harmony export Badge */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Card; });
/* unused harmony export CardLink */
/* unused harmony export CardGroup */
/* unused harmony export CardDeck */
/* unused harmony export CardColumns */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return CardBody; });
/* unused harmony export CardBlock */
/* unused harmony export CardFooter */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return CardHeader; });
/* unused harmony export CardImg */
/* unused harmony export CardImgOverlay */
/* unused harmony export Carousel */
/* unused harmony export UncontrolledCarousel */
/* unused harmony export CarouselControl */
/* unused harmony export CarouselItem */
/* unused harmony export CarouselIndicators */
/* unused harmony export CarouselCaption */
/* unused harmony export CardSubtitle */
/* unused harmony export CardText */
/* unused harmony export CardTitle */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return Popover; });
/* unused harmony export PopoverContent */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return PopoverBody; });
/* unused harmony export PopoverTitle */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return PopoverHeader; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return Progress; });
/* unused harmony export Modal */
/* unused harmony export ModalHeader */
/* unused harmony export ModalBody */
/* unused harmony export ModalFooter */
/* unused harmony export PopperContent */
/* unused harmony export PopperTargetHelper */
/* unused harmony export Tooltip */
/* unused harmony export Table */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return ListGroup; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return Form; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return FormFeedback; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return FormGroup; });
/* unused harmony export FormText */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return Input; });
/* unused harmony export InputGroup */
/* unused harmony export InputGroupAddon */
/* unused harmony export InputGroupButton */
/* unused harmony export InputGroupButtonDropdown */
/* unused harmony export InputGroupText */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return Label; });
/* unused harmony export Media */
/* unused harmony export Pagination */
/* unused harmony export PaginationItem */
/* unused harmony export PaginationLink */
/* unused harmony export TabContent */
/* unused harmony export TabPane */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return Jumbotron; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return Collapse; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return ListGroupItem; });
/* unused harmony export ListGroupItemText */
/* unused harmony export ListGroupItemHeading */
/* unused harmony export UncontrolledAlert */
/* unused harmony export UncontrolledButtonDropdown */
/* unused harmony export UncontrolledDropdown */
/* unused harmony export UncontrolledNavDropdown */
/* unused harmony export UncontrolledTooltip */
/* unused harmony export Util */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_isfunction__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_isfunction___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_isfunction__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_isobject__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_isobject___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash_isobject__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_dom__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_popper__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_popper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_popper__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_tonumber__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_tonumber___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_lodash_tonumber__);









// https://github.com/twbs/bootstrap/blob/v4.0.0-alpha.4/js/src/modal.js#L436-L443
function getScrollbarWidth() {
  var scrollDiv = document.createElement('div');
  // .modal-scrollbar-measure styles // https://github.com/twbs/bootstrap/blob/v4.0.0-alpha.4/scss/_modal.scss#L106-L113
  scrollDiv.style.position = 'absolute';
  scrollDiv.style.top = '-9999px';
  scrollDiv.style.width = '50px';
  scrollDiv.style.height = '50px';
  scrollDiv.style.overflow = 'scroll';
  document.body.appendChild(scrollDiv);
  var scrollbarWidth = scrollDiv.offsetWidth - scrollDiv.clientWidth;
  document.body.removeChild(scrollDiv);
  return scrollbarWidth;
}

function setScrollbarWidth(padding) {
  document.body.style.paddingRight = padding > 0 ? padding + 'px' : null;
}

function isBodyOverflowing() {
  return document.body.clientWidth < window.innerWidth;
}

function getOriginalBodyPadding() {
  var style = window.getComputedStyle(document.body, null);

  return parseInt(style && style.getPropertyValue('padding-right') || 0, 10);
}

function conditionallyUpdateScrollbar() {
  var scrollbarWidth = getScrollbarWidth();
  // https://github.com/twbs/bootstrap/blob/v4.0.0-alpha.6/js/src/modal.js#L433
  var fixedContent = document.querySelectorAll('.fixed-top, .fixed-bottom, .is-fixed, .sticky-top')[0];
  var bodyPadding = fixedContent ? parseInt(fixedContent.style.paddingRight || 0, 10) : 0;

  if (isBodyOverflowing()) {
    setScrollbarWidth(bodyPadding + scrollbarWidth);
  }
}

var globalCssModule = void 0;

function setGlobalCssModule(cssModule) {
  globalCssModule = cssModule;
}

function mapToCssModules() {
  var className = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var cssModule = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : globalCssModule;

  if (!cssModule) return className;
  return className.split(' ').map(function (c) {
    return cssModule[c] || c;
  }).join(' ');
}

/**
 * Returns a new object with the key/value pairs from `obj` that are not in the array `omitKeys`.
 */
function omit(obj, omitKeys) {
  var result = {};
  Object.keys(obj).forEach(function (key) {
    if (omitKeys.indexOf(key) === -1) {
      result[key] = obj[key];
    }
  });
  return result;
}

/**
 * Returns a filtered copy of an object with only the specified keys.
 */
function pick(obj, keys) {
  var pickKeys = Array.isArray(keys) ? keys : [keys];
  var length = pickKeys.length;
  var key = void 0;
  var result = {};

  while (length > 0) {
    length -= 1;
    key = pickKeys[length];
    result[key] = obj[key];
  }
  return result;
}

var warned = {};

function warnOnce(message) {
  if (!warned[message]) {
    /* istanbul ignore else */
    if (typeof console !== 'undefined') {
      console.error(message); // eslint-disable-line no-console
    }
    warned[message] = true;
  }
}

function deprecated(propType, explanation) {
  return function validate(props, propName, componentName) {
    if (props[propName] !== null && typeof props[propName] !== 'undefined') {
      warnOnce('"' + propName + '" property of "' + componentName + '" has been deprecated.\n' + explanation);
    }

    for (var _len = arguments.length, rest = Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
      rest[_key - 3] = arguments[_key];
    }

    return propType.apply(undefined, [props, propName, componentName].concat(rest));
  };
}

function DOMElement(props, propName, componentName) {
  if (!(props[propName] instanceof Element)) {
    return new Error('Invalid prop `' + propName + '` supplied to `' + componentName + '`. Expected prop to be an instance of Element. Validation failed.');
  }
}

function getTarget(target) {
  if (__WEBPACK_IMPORTED_MODULE_3_lodash_isfunction___default()(target)) {
    return target();
  }

  if (typeof target === 'string' && document) {
    var selection = document.querySelector(target);
    if (selection === null) {
      selection = document.querySelector('#' + target);
    }
    if (selection === null) {
      throw new Error('The target \'' + target + '\' could not be identified in the dom, tip: check spelling');
    }
    return selection;
  }

  return target;
}

/* eslint key-spacing: ["error", { afterColon: true, align: "value" }] */
// These are all setup to match what is in the bootstrap _variables.scss
// https://github.com/twbs/bootstrap/blob/v4-dev/scss/_variables.scss
var TransitionTimeouts = {
  Fade: 150, // $transition-fade
  Collapse: 350, // $transition-collapse
  Modal: 300, // $modal-transition
  Carousel: 600 // $carousel-transition
};

// Duplicated Transition.propType keys to ensure that Reactstrap builds
// for distribution properly exclude these keys for nested child HTML attributes
// since `react-transition-group` removes propTypes in production builds.
var TransitionPropTypeKeys = ['in', 'mountOnEnter', 'unmountOnExit', 'appear', 'enter', 'exit', 'timeout', 'onEnter', 'onEntering', 'onEntered', 'onExit', 'onExiting', 'onExited'];

var TransitionStatuses = {
  ENTERING: 'entering',
  ENTERED: 'entered',
  EXITING: 'exiting',
  EXITED: 'exited'
};

var keyCodes = {
  esc: 27,
  space: 32,
  tab: 9,
  up: 38,
  down: 40
};

var PopperPlacements = ['auto-start', 'auto', 'auto-end', 'top-start', 'top', 'top-end', 'right-start', 'right', 'right-end', 'bottom-end', 'bottom', 'bottom-start', 'left-end', 'left', 'left-start'];

var utils = Object.freeze({
	getScrollbarWidth: getScrollbarWidth,
	setScrollbarWidth: setScrollbarWidth,
	isBodyOverflowing: isBodyOverflowing,
	getOriginalBodyPadding: getOriginalBodyPadding,
	conditionallyUpdateScrollbar: conditionallyUpdateScrollbar,
	setGlobalCssModule: setGlobalCssModule,
	mapToCssModules: mapToCssModules,
	omit: omit,
	pick: pick,
	warnOnce: warnOnce,
	deprecated: deprecated,
	DOMElement: DOMElement,
	getTarget: getTarget,
	TransitionTimeouts: TransitionTimeouts,
	TransitionPropTypeKeys: TransitionPropTypeKeys,
	TransitionStatuses: TransitionStatuses,
	keyCodes: keyCodes,
	PopperPlacements: PopperPlacements
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};











var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();





var defineProperty = function (obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};



var inherits = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};









var objectWithoutProperties = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

var possibleConstructorReturn = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
};

var propTypes = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  fluid: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps = {
  tag: 'div'
};

var Container = function Container(props) {
  var className = props.className,
      cssModule = props.cssModule,
      fluid = props.fluid,
      Tag = props.tag,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'fluid', 'tag']);


  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, fluid ? 'container-fluid' : 'container'), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

Container.propTypes = propTypes;
Container.defaultProps = defaultProps;

var propTypes$1 = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  noGutters: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps$1 = {
  tag: 'div'
};

var Row = function Row(props) {
  var className = props.className,
      cssModule = props.cssModule,
      noGutters = props.noGutters,
      Tag = props.tag,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'noGutters', 'tag']);


  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, noGutters ? 'no-gutters' : null, 'row'), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

Row.propTypes = propTypes$1;
Row.defaultProps = defaultProps$1;

var colWidths = ['xs', 'sm', 'md', 'lg', 'xl'];
var stringOrNumberProp = __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]);

var columnProps = __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
  size: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  push: deprecated(stringOrNumberProp, 'Please use the prop "order"'),
  pull: deprecated(stringOrNumberProp, 'Please use the prop "order"'),
  order: stringOrNumberProp,
  offset: stringOrNumberProp
})]);

var propTypes$2 = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  xs: columnProps,
  sm: columnProps,
  md: columnProps,
  lg: columnProps,
  xl: columnProps,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  widths: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array
};

var defaultProps$2 = {
  tag: 'div',
  widths: colWidths
};

var getColumnSizeClass = function getColumnSizeClass(isXs, colWidth, colSize) {
  if (colSize === true || colSize === '') {
    return isXs ? 'col' : 'col-' + colWidth;
  } else if (colSize === 'auto') {
    return isXs ? 'col-auto' : 'col-' + colWidth + '-auto';
  }

  return isXs ? 'col-' + colSize : 'col-' + colWidth + '-' + colSize;
};

var Col = function Col(props) {
  var className = props.className,
      cssModule = props.cssModule,
      widths = props.widths,
      Tag = props.tag,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'widths', 'tag']);

  var colClasses = [];

  widths.forEach(function (colWidth, i) {
    var columnProp = props[colWidth];

    if (!i && columnProp === undefined) {
      columnProp = true;
    }

    delete attributes[colWidth];

    if (!columnProp && columnProp !== '') {
      return;
    }

    var isXs = !i;
    var colClass = void 0;

    if (__WEBPACK_IMPORTED_MODULE_4_lodash_isobject___default()(columnProp)) {
      var _classNames;

      var colSizeInterfix = isXs ? '-' : '-' + colWidth + '-';
      colClass = getColumnSizeClass(isXs, colWidth, columnProp.size);

      colClasses.push(mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()((_classNames = {}, defineProperty(_classNames, colClass, columnProp.size || columnProp.size === ''), defineProperty(_classNames, 'order' + colSizeInterfix + columnProp.order, columnProp.order || columnProp.order === 0), defineProperty(_classNames, 'offset' + colSizeInterfix + columnProp.offset, columnProp.offset || columnProp.offset === 0), _classNames))), cssModule);
    } else {
      colClass = getColumnSizeClass(isXs, colWidth, columnProp);
      colClasses.push(colClass);
    }
  });

  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, colClasses), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

Col.propTypes = propTypes$2;
Col.defaultProps = defaultProps$2;

var propTypes$3 = {
  light: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  dark: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  inverse: deprecated(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool, 'Please use the prop "dark"'),
  full: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  fixed: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  sticky: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  color: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  role: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  toggleable: deprecated(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]), 'Please use the prop "expand"'),
  expand: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string])
};

var defaultProps$3 = {
  tag: 'nav',
  expand: false
};

var getExpandClass = function getExpandClass(expand) {
  if (expand === false) {
    return false;
  } else if (expand === true || expand === 'xs') {
    return 'navbar-expand';
  }

  return 'navbar-expand-' + expand;
};

// To better maintain backwards compatibility while toggleable is deprecated.
// We must map breakpoints to the next breakpoint so that toggleable and expand do the same things at the same breakpoint.
var toggleableToExpand = {
  xs: 'sm',
  sm: 'md',
  md: 'lg',
  lg: 'xl'
};

var getToggleableClass = function getToggleableClass(toggleable) {
  if (toggleable === undefined || toggleable === 'xl') {
    return false;
  } else if (toggleable === false) {
    return 'navbar-expand';
  }

  return 'navbar-expand-' + (toggleable === true ? 'sm' : toggleableToExpand[toggleable] || toggleable);
};

var Navbar = function Navbar(props) {
  var _classNames;

  var toggleable = props.toggleable,
      expand = props.expand,
      className = props.className,
      cssModule = props.cssModule,
      light = props.light,
      dark = props.dark,
      inverse = props.inverse,
      fixed = props.fixed,
      sticky = props.sticky,
      color = props.color,
      Tag = props.tag,
      attributes = objectWithoutProperties(props, ['toggleable', 'expand', 'className', 'cssModule', 'light', 'dark', 'inverse', 'fixed', 'sticky', 'color', 'tag']);


  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'navbar', getExpandClass(expand) || getToggleableClass(toggleable), (_classNames = {
    'navbar-light': light,
    'navbar-dark': inverse || dark
  }, defineProperty(_classNames, 'bg-' + color, color), defineProperty(_classNames, 'fixed-' + fixed, fixed), defineProperty(_classNames, 'sticky-' + sticky, sticky), _classNames)), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

Navbar.propTypes = propTypes$3;
Navbar.defaultProps = defaultProps$3;

var propTypes$4 = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps$4 = {
  tag: 'a'
};

var NavbarBrand = function NavbarBrand(props) {
  var className = props.className,
      cssModule = props.cssModule,
      Tag = props.tag,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'tag']);


  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'navbar-brand'), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

NavbarBrand.propTypes = propTypes$4;
NavbarBrand.defaultProps = defaultProps$4;

var propTypes$5 = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  type: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node
};

var defaultProps$5 = {
  tag: 'button',
  type: 'button'
};

var NavbarToggler = function NavbarToggler(props) {
  var className = props.className,
      cssModule = props.cssModule,
      children = props.children,
      Tag = props.tag,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'children', 'tag']);


  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'navbar-toggler'), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    Tag,
    _extends({}, attributes, { className: classes }),
    children || __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: mapToCssModules('navbar-toggler-icon', cssModule) })
  );
};

NavbarToggler.propTypes = propTypes$5;
NavbarToggler.defaultProps = defaultProps$5;

var propTypes$6 = {
  tabs: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  pills: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  vertical: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  horizontal: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  justified: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  fill: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  navbar: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  card: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps$6 = {
  tag: 'ul',
  vertical: false
};

var getVerticalClass = function getVerticalClass(vertical) {
  if (vertical === false) {
    return false;
  } else if (vertical === true || vertical === 'xs') {
    return 'flex-column';
  }

  return 'flex-' + vertical + '-column';
};

var Nav = function Nav(props) {
  var className = props.className,
      cssModule = props.cssModule,
      tabs = props.tabs,
      pills = props.pills,
      vertical = props.vertical,
      horizontal = props.horizontal,
      justified = props.justified,
      fill = props.fill,
      navbar = props.navbar,
      card = props.card,
      Tag = props.tag,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'tabs', 'pills', 'vertical', 'horizontal', 'justified', 'fill', 'navbar', 'card', 'tag']);


  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, navbar ? 'navbar-nav' : 'nav', horizontal ? 'justify-content-' + horizontal : false, getVerticalClass(vertical), {
    'nav-tabs': tabs,
    'card-header-tabs': card && tabs,
    'nav-pills': pills,
    'card-header-pills': card && pills,
    'nav-justified': justified,
    'nav-fill': fill
  }), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

Nav.propTypes = propTypes$6;
Nav.defaultProps = defaultProps$6;

var propTypes$7 = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  active: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps$7 = {
  tag: 'li'
};

var NavItem = function NavItem(props) {
  var className = props.className,
      cssModule = props.cssModule,
      active = props.active,
      Tag = props.tag,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'active', 'tag']);


  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'nav-item', active ? 'active' : false), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

NavItem.propTypes = propTypes$7;
NavItem.defaultProps = defaultProps$7;

/* eslint react/no-find-dom-node: 0 */
// https://github.com/yannickcr/eslint-plugin-react/blob/master/docs/rules/no-find-dom-node.md

var propTypes$8 = {
  disabled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  dropup: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  group: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  isOpen: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  nav: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  addonType: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['prepend', 'append'])]),
  size: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  toggle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  inNavbar: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
};

var defaultProps$8 = {
  isOpen: false,
  dropup: false,
  nav: false,
  addonType: false,
  inNavbar: false
};

var childContextTypes = {
  toggle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  isOpen: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  dropup: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  inNavbar: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired
};

var Dropdown = function (_React$Component) {
  inherits(Dropdown, _React$Component);

  function Dropdown(props) {
    classCallCheck(this, Dropdown);

    var _this = possibleConstructorReturn(this, (Dropdown.__proto__ || Object.getPrototypeOf(Dropdown)).call(this, props));

    _this.addEvents = _this.addEvents.bind(_this);
    _this.handleDocumentClick = _this.handleDocumentClick.bind(_this);
    _this.handleKeyDown = _this.handleKeyDown.bind(_this);
    _this.removeEvents = _this.removeEvents.bind(_this);
    _this.toggle = _this.toggle.bind(_this);
    return _this;
  }

  createClass(Dropdown, [{
    key: 'getChildContext',
    value: function getChildContext() {
      return {
        toggle: this.props.toggle,
        isOpen: this.props.isOpen,
        dropup: this.props.dropup,
        inNavbar: this.props.inNavbar
      };
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.handleProps();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      if (this.props.isOpen !== prevProps.isOpen) {
        this.handleProps();
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.removeEvents();
    }
  }, {
    key: 'getContainer',
    value: function getContainer() {
      return __WEBPACK_IMPORTED_MODULE_5_react_dom___default.a.findDOMNode(this);
    }
  }, {
    key: 'addEvents',
    value: function addEvents() {
      var _this2 = this;

      ['click', 'touchstart', 'keyup'].forEach(function (event) {
        return document.addEventListener(event, _this2.handleDocumentClick, true);
      });
    }
  }, {
    key: 'removeEvents',
    value: function removeEvents() {
      var _this3 = this;

      ['click', 'touchstart', 'keyup'].forEach(function (event) {
        return document.removeEventListener(event, _this3.handleDocumentClick, true);
      });
    }
  }, {
    key: 'handleDocumentClick',
    value: function handleDocumentClick(e) {
      if (e && (e.which === 3 || e.type === 'keyup' && e.which !== keyCodes.tab)) return;
      var container = this.getContainer();

      if (container.contains(e.target) && container !== e.target && (e.type !== 'keyup' || e.which === keyCodes.tab)) {
        return;
      }

      this.toggle(e);
    }
  }, {
    key: 'handleKeyDown',
    value: function handleKeyDown(e) {
      if ([keyCodes.esc, keyCodes.up, keyCodes.down, keyCodes.space].indexOf(e.which) === -1 || /button/i.test(e.target.tagName) && e.which === keyCodes.space || /input|textarea/i.test(e.target.tagName)) {
        return;
      }

      e.preventDefault();
      if (this.props.disabled) return;

      var container = this.getContainer();

      if (e.which === keyCodes.space && this.props.isOpen && container !== e.target) {
        e.target.click();
      }

      if (e.which === keyCodes.esc || !this.props.isOpen) {
        this.toggle(e);
        container.querySelector('[aria-expanded]').focus();
        return;
      }

      var menuClass = mapToCssModules('dropdown-menu', this.props.cssModule);
      var itemClass = mapToCssModules('dropdown-item', this.props.cssModule);
      var disabledClass = mapToCssModules('disabled', this.props.cssModule);

      var items = container.querySelectorAll('.' + menuClass + ' .' + itemClass + ':not(.' + disabledClass + ')');

      if (!items.length) return;

      var index = -1;
      for (var i = 0; i < items.length; i += 1) {
        if (items[i] === e.target) {
          index = i;
          break;
        }
      }

      if (e.which === keyCodes.up && index > 0) {
        index -= 1;
      }

      if (e.which === keyCodes.down && index < items.length - 1) {
        index += 1;
      }

      if (index < 0) {
        index = 0;
      }

      items[index].focus();
    }
  }, {
    key: 'handleProps',
    value: function handleProps() {
      if (this.props.isOpen) {
        this.addEvents();
      } else {
        this.removeEvents();
      }
    }
  }, {
    key: 'toggle',
    value: function toggle(e) {
      if (this.props.disabled) {
        return e && e.preventDefault();
      }

      return this.props.toggle(e);
    }
  }, {
    key: 'render',
    value: function render() {
      var _classNames;

      var _omit = omit(this.props, ['toggle', 'disabled', 'inNavbar']),
          className = _omit.className,
          cssModule = _omit.cssModule,
          dropup = _omit.dropup,
          isOpen = _omit.isOpen,
          group = _omit.group,
          size = _omit.size,
          nav = _omit.nav,
          addonType = _omit.addonType,
          attrs = objectWithoutProperties(_omit, ['className', 'cssModule', 'dropup', 'isOpen', 'group', 'size', 'nav', 'addonType']);

      attrs.tag = attrs.tag || (nav ? 'li' : 'div');

      var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, (_classNames = {}, defineProperty(_classNames, 'input-group-' + addonType, addonType), defineProperty(_classNames, 'btn-group', group), defineProperty(_classNames, 'btn-group-' + size, !!size), defineProperty(_classNames, 'dropdown', !group && !addonType), defineProperty(_classNames, 'show', isOpen), defineProperty(_classNames, 'dropup', dropup), defineProperty(_classNames, 'nav-item', nav), _classNames)), cssModule);
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_popper__["Manager"], _extends({}, attrs, { className: classes, onKeyDown: this.handleKeyDown }));
    }
  }]);
  return Dropdown;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Dropdown.propTypes = propTypes$8;
Dropdown.defaultProps = defaultProps$8;
Dropdown.childContextTypes = childContextTypes;

function NavDropdown(props) {
  warnOnce('The "NavDropdown" component has been deprecated.\nPlease use component "Dropdown" with nav prop.');
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Dropdown, _extends({ nav: true }, props));
}

var propTypes$9 = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  innerRef: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  disabled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  active: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  onClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  href: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any
};

var defaultProps$9 = {
  tag: 'a'
};

var NavLink = function (_React$Component) {
  inherits(NavLink, _React$Component);

  function NavLink(props) {
    classCallCheck(this, NavLink);

    var _this = possibleConstructorReturn(this, (NavLink.__proto__ || Object.getPrototypeOf(NavLink)).call(this, props));

    _this.onClick = _this.onClick.bind(_this);
    return _this;
  }

  createClass(NavLink, [{
    key: 'onClick',
    value: function onClick(e) {
      if (this.props.disabled) {
        e.preventDefault();
        return;
      }

      if (this.props.href === '#') {
        e.preventDefault();
      }

      if (this.props.onClick) {
        this.props.onClick(e);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          className = _props.className,
          cssModule = _props.cssModule,
          active = _props.active,
          Tag = _props.tag,
          innerRef = _props.innerRef,
          attributes = objectWithoutProperties(_props, ['className', 'cssModule', 'active', 'tag', 'innerRef']);


      var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'nav-link', {
        disabled: attributes.disabled,
        active: active
      }), cssModule);

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { ref: innerRef, onClick: this.onClick, className: classes }));
    }
  }]);
  return NavLink;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

NavLink.propTypes = propTypes$9;
NavLink.defaultProps = defaultProps$9;

var propTypes$10 = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps$10 = {
  tag: 'ol'
};

var Breadcrumb = function Breadcrumb(props) {
  var className = props.className,
      cssModule = props.cssModule,
      Tag = props.tag,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'tag']);

  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'breadcrumb'), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

Breadcrumb.propTypes = propTypes$10;
Breadcrumb.defaultProps = defaultProps$10;

var propTypes$11 = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  active: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps$11 = {
  tag: 'li'
};

var BreadcrumbItem = function BreadcrumbItem(props) {
  var className = props.className,
      cssModule = props.cssModule,
      active = props.active,
      Tag = props.tag,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'active', 'tag']);

  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, active ? 'active' : false, 'breadcrumb-item'), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

BreadcrumbItem.propTypes = propTypes$11;
BreadcrumbItem.defaultProps = defaultProps$11;

var propTypes$12 = {
  active: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  block: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  color: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  disabled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  outline: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  innerRef: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  onClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  size: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps$12 = {
  color: 'secondary',
  tag: 'button'
};

var Button = function (_React$Component) {
  inherits(Button, _React$Component);

  function Button(props) {
    classCallCheck(this, Button);

    var _this = possibleConstructorReturn(this, (Button.__proto__ || Object.getPrototypeOf(Button)).call(this, props));

    _this.onClick = _this.onClick.bind(_this);
    return _this;
  }

  createClass(Button, [{
    key: 'onClick',
    value: function onClick(e) {
      if (this.props.disabled) {
        e.preventDefault();
        return;
      }

      if (this.props.onClick) {
        this.props.onClick(e);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          active = _props.active,
          block = _props.block,
          className = _props.className,
          cssModule = _props.cssModule,
          color = _props.color,
          outline = _props.outline,
          size = _props.size,
          Tag = _props.tag,
          innerRef = _props.innerRef,
          attributes = objectWithoutProperties(_props, ['active', 'block', 'className', 'cssModule', 'color', 'outline', 'size', 'tag', 'innerRef']);


      var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'btn', 'btn' + (outline ? '-outline' : '') + '-' + color, size ? 'btn-' + size : false, block ? 'btn-block' : false, { active: active, disabled: this.props.disabled }), cssModule);

      if (attributes.href && Tag === 'button') {
        Tag = 'a';
      }

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({
        type: Tag === 'button' && attributes.onClick ? 'button' : undefined
      }, attributes, {
        className: classes,
        ref: innerRef,
        onClick: this.onClick
      }));
    }
  }]);
  return Button;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Button.propTypes = propTypes$12;
Button.defaultProps = defaultProps$12;

var propTypes$13 = {
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node
};

var ButtonDropdown = function ButtonDropdown(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Dropdown, _extends({ group: true }, props));
};

ButtonDropdown.propTypes = propTypes$13;

var propTypes$14 = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  'aria-label': __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  role: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  size: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  vertical: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
};

var defaultProps$13 = {
  tag: 'div',
  role: 'group'
};

var ButtonGroup = function ButtonGroup(props) {
  var className = props.className,
      cssModule = props.cssModule,
      size = props.size,
      vertical = props.vertical,
      Tag = props.tag,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'size', 'vertical', 'tag']);


  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, size ? 'btn-group-' + size : false, vertical ? 'btn-group-vertical' : 'btn-group'), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

ButtonGroup.propTypes = propTypes$14;
ButtonGroup.defaultProps = defaultProps$13;

var propTypes$15 = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  'aria-label': __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  role: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};

var defaultProps$14 = {
  tag: 'div',
  role: 'toolbar'
};

var ButtonToolbar = function ButtonToolbar(props) {
  var className = props.className,
      cssModule = props.cssModule,
      Tag = props.tag,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'tag']);


  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'btn-toolbar'), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

ButtonToolbar.propTypes = propTypes$15;
ButtonToolbar.defaultProps = defaultProps$14;

var propTypes$16 = {
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  active: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  disabled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  divider: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  header: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  onClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  toggle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
};

var contextTypes = {
  toggle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
};

var defaultProps$15 = {
  tag: 'button',
  toggle: true
};

var DropdownItem = function (_React$Component) {
  inherits(DropdownItem, _React$Component);

  function DropdownItem(props) {
    classCallCheck(this, DropdownItem);

    var _this = possibleConstructorReturn(this, (DropdownItem.__proto__ || Object.getPrototypeOf(DropdownItem)).call(this, props));

    _this.onClick = _this.onClick.bind(_this);
    _this.getTabIndex = _this.getTabIndex.bind(_this);
    return _this;
  }

  createClass(DropdownItem, [{
    key: 'onClick',
    value: function onClick(e) {
      if (this.props.disabled || this.props.header || this.props.divider) {
        e.preventDefault();
        return;
      }

      if (this.props.onClick) {
        this.props.onClick(e);
      }

      if (this.props.toggle) {
        this.context.toggle(e);
      }
    }
  }, {
    key: 'getTabIndex',
    value: function getTabIndex() {
      if (this.props.disabled || this.props.header || this.props.divider) {
        return '-1';
      }

      return '0';
    }
  }, {
    key: 'render',
    value: function render() {
      var tabIndex = this.getTabIndex();

      var _omit = omit(this.props, ['toggle']),
          className = _omit.className,
          cssModule = _omit.cssModule,
          divider = _omit.divider,
          Tag = _omit.tag,
          header = _omit.header,
          active = _omit.active,
          props = objectWithoutProperties(_omit, ['className', 'cssModule', 'divider', 'tag', 'header', 'active']);

      var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, {
        disabled: props.disabled,
        'dropdown-item': !divider && !header,
        active: active,
        'dropdown-header': header,
        'dropdown-divider': divider
      }), cssModule);

      if (Tag === 'button') {
        if (header) {
          Tag = 'h6';
        } else if (divider) {
          Tag = 'div';
        } else if (props.href) {
          Tag = 'a';
        }
      }

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({
        type: Tag === 'button' && (props.onClick || this.props.toggle) ? 'button' : undefined
      }, props, {
        tabIndex: tabIndex,
        className: classes,
        onClick: this.onClick
      }));
    }
  }]);
  return DropdownItem;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

DropdownItem.propTypes = propTypes$16;
DropdownItem.defaultProps = defaultProps$15;
DropdownItem.contextTypes = contextTypes;

var propTypes$17 = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node.isRequired,
  right: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  flip: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps$16 = {
  tag: 'div',
  flip: true
};

var contextTypes$1 = {
  isOpen: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  dropup: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  inNavbar: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired
};

var noFlipModifier = { flip: { enabled: false } };

var DropdownMenu = function DropdownMenu(props, context) {
  var className = props.className,
      cssModule = props.cssModule,
      right = props.right,
      tag = props.tag,
      flip = props.flip,
      attrs = objectWithoutProperties(props, ['className', 'cssModule', 'right', 'tag', 'flip']);

  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'dropdown-menu', {
    'dropdown-menu-right': right,
    show: context.isOpen
  }), cssModule);

  var Tag = tag;

  if (context.isOpen && !context.inNavbar) {
    Tag = __WEBPACK_IMPORTED_MODULE_6_react_popper__["Popper"];
    var position1 = context.dropup ? 'top' : 'bottom';
    var position2 = right ? 'end' : 'start';
    attrs.placement = position1 + '-' + position2;
    attrs.component = tag;
    attrs.modifiers = !flip ? noFlipModifier : undefined;
  }

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({
    tabIndex: '-1',
    role: 'menu'
  }, attrs, {
    'aria-hidden': !context.isOpen,
    className: classes
  }));
};

DropdownMenu.propTypes = propTypes$17;
DropdownMenu.defaultProps = defaultProps$16;
DropdownMenu.contextTypes = contextTypes$1;

var propTypes$18 = {
  caret: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  color: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  disabled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  onClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  'aria-haspopup': __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  split: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  nav: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
};

var defaultProps$17 = {
  'aria-haspopup': true,
  color: 'secondary'
};

var contextTypes$2 = {
  isOpen: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  toggle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  inNavbar: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired
};

var DropdownToggle = function (_React$Component) {
  inherits(DropdownToggle, _React$Component);

  function DropdownToggle(props) {
    classCallCheck(this, DropdownToggle);

    var _this = possibleConstructorReturn(this, (DropdownToggle.__proto__ || Object.getPrototypeOf(DropdownToggle)).call(this, props));

    _this.onClick = _this.onClick.bind(_this);
    return _this;
  }

  createClass(DropdownToggle, [{
    key: 'onClick',
    value: function onClick(e) {
      if (this.props.disabled) {
        e.preventDefault();
        return;
      }

      if (this.props.nav && !this.props.tag) {
        e.preventDefault();
      }

      if (this.props.onClick) {
        this.props.onClick(e);
      }

      this.context.toggle(e);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          className = _props.className,
          color = _props.color,
          cssModule = _props.cssModule,
          caret = _props.caret,
          split = _props.split,
          nav = _props.nav,
          tag = _props.tag,
          props = objectWithoutProperties(_props, ['className', 'color', 'cssModule', 'caret', 'split', 'nav', 'tag']);

      var ariaLabel = props['aria-label'] || 'Toggle Dropdown';
      var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, {
        'dropdown-toggle': caret || split,
        'dropdown-toggle-split': split,
        'nav-link': nav
      }), cssModule);
      var children = props.children || __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'span',
        { className: 'sr-only' },
        ariaLabel
      );

      var Tag = void 0;

      if (nav && !tag) {
        Tag = 'a';
        props.href = '#';
      } else if (!tag) {
        Tag = Button;
        props.color = color;
        props.cssModule = cssModule;
      } else {
        Tag = tag;
      }

      if (this.context.inNavbar) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, props, {
          className: classes,
          onClick: this.onClick,
          'aria-expanded': this.context.isOpen,
          children: children
        }));
      }

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_popper__["Target"], _extends({}, props, {
        className: classes,
        component: Tag,
        onClick: this.onClick,
        'aria-expanded': this.context.isOpen,
        children: children
      }));
    }
  }]);
  return DropdownToggle;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

DropdownToggle.propTypes = propTypes$18;
DropdownToggle.defaultProps = defaultProps$17;
DropdownToggle.contextTypes = contextTypes$2;

function unwrapExports (x) {
	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}

function createCommonjsModule(fn, module) {
	return module = { exports: {} }, fn(module, module.exports), module.exports;
}

var PropTypes$1 = createCommonjsModule(function (module, exports) {
  'use strict';

  exports.__esModule = true;
  exports.classNamesShape = exports.timeoutsShape = undefined;
  exports.transitionTimeout = transitionTimeout;

  var _propTypes2 = _interopRequireDefault(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
  }

  function transitionTimeout(transitionType) {
    var timeoutPropName = 'transition' + transitionType + 'Timeout';
    var enabledPropName = 'transition' + transitionType;

    return function (props) {
      // If the transition is enabled
      if (props[enabledPropName]) {
        // If no timeout duration is provided
        if (props[timeoutPropName] == null) {
          return new Error(timeoutPropName + ' wasn\'t supplied to CSSTransitionGroup: ' + 'this can cause unreliable animations and won\'t be supported in ' + 'a future version of React. See ' + 'https://fb.me/react-animation-transition-group-timeout for more ' + 'information.');

          // If the duration isn't a number
        } else if (typeof props[timeoutPropName] !== 'number') {
          return new Error(timeoutPropName + ' must be a number (in milliseconds)');
        }
      }

      return null;
    };
  }

  var timeoutsShape = exports.timeoutsShape = _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.shape({
    enter: _propTypes2.default.number,
    exit: _propTypes2.default.number
  }).isRequired]);

  var classNamesShape = exports.classNamesShape = _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.shape({
    enter: _propTypes2.default.string,
    exit: _propTypes2.default.string,
    active: _propTypes2.default.string
  }), _propTypes2.default.shape({
    enter: _propTypes2.default.string,
    enterActive: _propTypes2.default.string,
    exit: _propTypes2.default.string,
    exitActive: _propTypes2.default.string
  })]);
});

unwrapExports(PropTypes$1);

var Transition_1 = createCommonjsModule(function (module, exports) {
  'use strict';

  exports.__esModule = true;
  exports.EXITING = exports.ENTERED = exports.ENTERING = exports.EXITED = exports.UNMOUNTED = undefined;

  var PropTypes$$1 = _interopRequireWildcard(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a);

  var _react2 = _interopRequireDefault(__WEBPACK_IMPORTED_MODULE_0_react___default.a);

  var _reactDom2 = _interopRequireDefault(__WEBPACK_IMPORTED_MODULE_5_react_dom___default.a);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
  }

  function _interopRequireWildcard(obj) {
    if (obj && obj.__esModule) {
      return obj;
    } else {
      var newObj = {};if (obj != null) {
        for (var key in obj) {
          if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
        }
      }newObj.default = obj;return newObj;
    }
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
    }return target;
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }return call && ((typeof call === 'undefined' ? 'undefined' : _typeof(call)) === "object" || typeof call === "function") ? call : self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === 'undefined' ? 'undefined' : _typeof(superClass)));
    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }

  var UNMOUNTED = exports.UNMOUNTED = 'unmounted';
  var EXITED = exports.EXITED = 'exited';
  var ENTERING = exports.ENTERING = 'entering';
  var ENTERED = exports.ENTERED = 'entered';
  var EXITING = exports.EXITING = 'exiting';

  /**
   * The Transition component lets you describe a transition from one component
   * state to another _over time_ with a simple declarative API. Most commonly
   * it's used to animate the mounting and unmounting of a component, but can also
   * be used to describe in-place transition states as well.
   *
   * By default the `Transition` component does not alter the behavior of the
   * component it renders, it only tracks "enter" and "exit" states for the components.
   * It's up to you to give meaning and effect to those states. For example we can
   * add styles to a component when it enters or exits:
   *
   * ```jsx
   * import Transition from 'react-transition-group/Transition';
   *
   * const duration = 300;
   *
   * const defaultStyle = {
   *   transition: `opacity ${duration}ms ease-in-out`,
   *   opacity: 0,
   * }
   *
   * const transitionStyles = {
   *   entering: { opacity: 0 },
   *   entered:  { opacity: 1 },
   * };
   *
   * const Fade = ({ in: inProp }) => (
   *   <Transition in={inProp} timeout={duration}>
   *     {(state) => (
   *       <div style={{
   *         ...defaultStyle,
   *         ...transitionStyles[state]
   *       }}>
   *         I'm A fade Transition!
   *       </div>
   *     )}
   *   </Transition>
   * );
   * ```
   *
   * As noted the `Transition` component doesn't _do_ anything by itself to its child component.
   * What it does do is track transition states over time so you can update the
   * component (such as by adding styles or classes) when it changes states.
   *
   * There are 4 main states a Transition can be in:
   *  - `ENTERING`
   *  - `ENTERED`
   *  - `EXITING`
   *  - `EXITED`
   *
   * Transition state is toggled via the `in` prop. When `true` the component begins the
   * "Enter" stage. During this stage, the component will shift from its current transition state,
   * to `'entering'` for the duration of the transition and then to the `'entered'` stage once
   * it's complete. Let's take the following example:
   *
   * ```jsx
   * state= { in: false };
   *
   * toggleEnterState = () => {
   *   this.setState({ in: true });
   * }
   *
   * render() {
   *   return (
   *     <div>
   *       <Transition in={this.state.in} timeout={500} />
   *       <button onClick={this.toggleEnterState}>Click to Enter</button>
   *     </div>
   *   );
   * }
   * ```
   *
   * When the button is clicked the component will shift to the `'entering'` state and
   * stay there for 500ms (the value of `timeout`) when finally switches to `'entered'`.
   *
   * When `in` is `false` the same thing happens except the state moves from `'exiting'` to `'exited'`.
   */

  var Transition = function (_React$Component) {
    _inherits(Transition, _React$Component);

    function Transition(props, context) {
      _classCallCheck(this, Transition);

      var _this = _possibleConstructorReturn(this, _React$Component.call(this, props, context));

      var parentGroup = context.transitionGroup;
      // In the context of a TransitionGroup all enters are really appears
      var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;

      var initialStatus = void 0;
      _this.nextStatus = null;

      if (props.in) {
        if (appear) {
          initialStatus = EXITED;
          _this.nextStatus = ENTERING;
        } else {
          initialStatus = ENTERED;
        }
      } else {
        if (props.unmountOnExit || props.mountOnEnter) {
          initialStatus = UNMOUNTED;
        } else {
          initialStatus = EXITED;
        }
      }

      _this.state = { status: initialStatus };

      _this.nextCallback = null;
      return _this;
    }

    Transition.prototype.getChildContext = function getChildContext() {
      return { transitionGroup: null }; // allows for nested Transitions
    };

    Transition.prototype.componentDidMount = function componentDidMount() {
      this.updateStatus(true);
    };

    Transition.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
      var _ref = this.pendingState || this.state,
          status = _ref.status;

      if (nextProps.in) {
        if (status === UNMOUNTED) {
          this.setState({ status: EXITED });
        }
        if (status !== ENTERING && status !== ENTERED) {
          this.nextStatus = ENTERING;
        }
      } else {
        if (status === ENTERING || status === ENTERED) {
          this.nextStatus = EXITING;
        }
      }
    };

    Transition.prototype.componentDidUpdate = function componentDidUpdate() {
      this.updateStatus();
    };

    Transition.prototype.componentWillUnmount = function componentWillUnmount() {
      this.cancelNextCallback();
    };

    Transition.prototype.getTimeouts = function getTimeouts() {
      var timeout = this.props.timeout;

      var exit = void 0,
          enter = void 0,
          appear = void 0;

      exit = enter = appear = timeout;

      if (timeout != null && typeof timeout !== 'number') {
        exit = timeout.exit;
        enter = timeout.enter;
        appear = timeout.appear;
      }
      return { exit: exit, enter: enter, appear: appear };
    };

    Transition.prototype.updateStatus = function updateStatus() {
      var mounting = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      var nextStatus = this.nextStatus;

      if (nextStatus !== null) {
        this.nextStatus = null;
        // nextStatus will always be ENTERING or EXITING.
        this.cancelNextCallback();
        var node = _reactDom2.default.findDOMNode(this);

        if (nextStatus === ENTERING) {
          this.performEnter(node, mounting);
        } else {
          this.performExit(node);
        }
      } else if (this.props.unmountOnExit && this.state.status === EXITED) {
        this.setState({ status: UNMOUNTED });
      }
    };

    Transition.prototype.performEnter = function performEnter(node, mounting) {
      var _this2 = this;

      var enter = this.props.enter;

      var appearing = this.context.transitionGroup ? this.context.transitionGroup.isMounting : mounting;

      var timeouts = this.getTimeouts();

      // no enter animation skip right to ENTERED
      // if we are mounting and running this it means appear _must_ be set
      if (!mounting && !enter) {
        this.safeSetState({ status: ENTERED }, function () {
          _this2.props.onEntered(node);
        });
        return;
      }

      this.props.onEnter(node, appearing);

      this.safeSetState({ status: ENTERING }, function () {
        _this2.props.onEntering(node, appearing);

        // FIXME: appear timeout?
        _this2.onTransitionEnd(node, timeouts.enter, function () {
          _this2.safeSetState({ status: ENTERED }, function () {
            _this2.props.onEntered(node, appearing);
          });
        });
      });
    };

    Transition.prototype.performExit = function performExit(node) {
      var _this3 = this;

      var exit = this.props.exit;

      var timeouts = this.getTimeouts();

      // no exit animation skip right to EXITED
      if (!exit) {
        this.safeSetState({ status: EXITED }, function () {
          _this3.props.onExited(node);
        });
        return;
      }
      this.props.onExit(node);

      this.safeSetState({ status: EXITING }, function () {
        _this3.props.onExiting(node);

        _this3.onTransitionEnd(node, timeouts.exit, function () {
          _this3.safeSetState({ status: EXITED }, function () {
            _this3.props.onExited(node);
          });
        });
      });
    };

    Transition.prototype.cancelNextCallback = function cancelNextCallback() {
      if (this.nextCallback !== null) {
        this.nextCallback.cancel();
        this.nextCallback = null;
      }
    };

    Transition.prototype.safeSetState = function safeSetState(nextState, callback) {
      var _this4 = this;

      // We need to track pending updates for instances where a cWRP fires quickly
      // after cDM and before the state flushes, which would double trigger a
      // transition
      this.pendingState = nextState;

      // This shouldn't be necessary, but there are weird race conditions with
      // setState callbacks and unmounting in testing, so always make sure that
      // we can cancel any pending setState callbacks after we unmount.
      callback = this.setNextCallback(callback);
      this.setState(nextState, function () {
        _this4.pendingState = null;
        callback();
      });
    };

    Transition.prototype.setNextCallback = function setNextCallback(callback) {
      var _this5 = this;

      var active = true;

      this.nextCallback = function (event) {
        if (active) {
          active = false;
          _this5.nextCallback = null;

          callback(event);
        }
      };

      this.nextCallback.cancel = function () {
        active = false;
      };

      return this.nextCallback;
    };

    Transition.prototype.onTransitionEnd = function onTransitionEnd(node, timeout, handler) {
      this.setNextCallback(handler);

      if (node) {
        if (this.props.addEndListener) {
          this.props.addEndListener(node, this.nextCallback);
        }
        if (timeout != null) {
          setTimeout(this.nextCallback, timeout);
        }
      } else {
        setTimeout(this.nextCallback, 0);
      }
    };

    Transition.prototype.render = function render() {
      var status = this.state.status;
      if (status === UNMOUNTED) {
        return null;
      }

      var _props = this.props,
          children = _props.children,
          childProps = _objectWithoutProperties(_props, ['children']);
      // filter props for Transtition


      delete childProps.in;
      delete childProps.mountOnEnter;
      delete childProps.unmountOnExit;
      delete childProps.appear;
      delete childProps.enter;
      delete childProps.exit;
      delete childProps.timeout;
      delete childProps.addEndListener;
      delete childProps.onEnter;
      delete childProps.onEntering;
      delete childProps.onEntered;
      delete childProps.onExit;
      delete childProps.onExiting;
      delete childProps.onExited;

      if (typeof children === 'function') {
        return children(status, childProps);
      }

      var child = _react2.default.Children.only(children);
      return _react2.default.cloneElement(child, childProps);
    };

    return Transition;
  }(_react2.default.Component);

  Transition.contextTypes = {
    transitionGroup: PropTypes$$1.object
  };
  Transition.childContextTypes = {
    transitionGroup: function transitionGroup() {}
  };

  Transition.propTypes =  false ? {
    /**
     * A `function` child can be used instead of a React element.
     * This function is called with the current transition status
     * ('entering', 'entered', 'exiting', 'exited', 'unmounted'), which can used
     * to apply context specific props to a component.
     *
     * ```jsx
     * <Transition timeout={150}>
     *   {(status) => (
     *     <MyComponent className={`fade fade-${status}`} />
     *   )}
     * </Transition>
     * ```
     */
    children: PropTypes$$1.oneOfType([PropTypes$$1.func.isRequired, PropTypes$$1.element.isRequired]).isRequired,

    /**
     * Show the component; triggers the enter or exit states
     */
    in: PropTypes$$1.bool,

    /**
     * By default the child component is mounted immediately along with
     * the parent `Transition` component. If you want to "lazy mount" the component on the
     * first `in={true}` you can set `mountOnEnter`. After the first enter transition the component will stay
     * mounted, even on "exited", unless you also specify `unmountOnExit`.
     */
    mountOnEnter: PropTypes$$1.bool,

    /**
     * By default the child component stays mounted after it reaches the `'exited'` state.
     * Set `unmountOnExit` if you'd prefer to unmount the component after it finishes exiting.
     */
    unmountOnExit: PropTypes$$1.bool,

    /**
     * Normally a component is not transitioned if it is shown when the `<Transition>` component mounts.
     * If you want to transition on the first mount set `appear` to `true`, and the
     * component will transition in as soon as the `<Transition>` mounts.
     *
     * > Note: there are no specific "appear" states. `appear` only adds an additional `enter` transition.
     */
    appear: PropTypes$$1.bool,

    /**
     * Enable or disable enter transitions.
     */
    enter: PropTypes$$1.bool,

    /**
     * Enable or disable exit transitions.
     */
    exit: PropTypes$$1.bool,

    /**
     * The duration of the transition, in milliseconds.
     * Required unless `addEventListener` is provided
     *
     * You may specify a single timeout for all transitions like: `timeout={500}`,
     * or individually like:
     *
     * ```jsx
     * timeout={{
     *  enter: 300,
     *  exit: 500,
     * }}
     * ```
     *
     * @type {number | { enter?: number, exit?: number }}
     */
    timeout: function timeout(props) {
      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      var pt = PropTypes$1.timeoutsShape;
      if (!props.addEndListener) pt = pt.isRequired;
      return pt.apply(undefined, [props].concat(args));
    },

    /**
     * Add a custom transition end trigger. Called with the transitioning
     * DOM node and a `done` callback. Allows for more fine grained transition end
     * logic. **Note:** Timeouts are still used as a fallback if provided.
     *
     * ```jsx
     * addEndListener={(node, done) => {
     *   // use the css transitionend event to mark the finish of a transition
     *   node.addEventListener('transitionend', done, false);
     * }}
     * ```
     */
    addEndListener: PropTypes$$1.func,

    /**
     * Callback fired before the "entering" status is applied. An extra parameter
     * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
     *
     * @type Function(node: HtmlElement, isAppearing: bool) -> void
     */
    onEnter: PropTypes$$1.func,

    /**
     * Callback fired after the "entering" status is applied. An extra parameter
     * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
     *
     * @type Function(node: HtmlElement, isAppearing: bool)
     */
    onEntering: PropTypes$$1.func,

    /**
     * Callback fired after the "entered" status is applied. An extra parameter
     * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
     *
     * @type Function(node: HtmlElement, isAppearing: bool) -> void
     */
    onEntered: PropTypes$$1.func,

    /**
     * Callback fired before the "exiting" status is applied.
     *
     * @type Function(node: HtmlElement) -> void
     */
    onExit: PropTypes$$1.func,

    /**
     * Callback fired after the "exiting" status is applied.
     *
     * @type Function(node: HtmlElement) -> void
     */
    onExiting: PropTypes$$1.func,

    /**
     * Callback fired after the "exited" status is applied.
     *
     * @type Function(node: HtmlElement) -> void
     */
    onExited: PropTypes$$1.func
  } : {};

  // Name the function so it is clearer in the documentation
  function noop() {}

  Transition.defaultProps = {
    in: false,
    mountOnEnter: false,
    unmountOnExit: false,
    appear: false,
    enter: true,
    exit: true,

    onEnter: noop,
    onEntering: noop,
    onEntered: noop,

    onExit: noop,
    onExiting: noop,
    onExited: noop
  };

  Transition.UNMOUNTED = 0;
  Transition.EXITED = 1;
  Transition.ENTERING = 2;
  Transition.ENTERED = 3;
  Transition.EXITING = 4;

  exports.default = Transition;
});

var Transition = unwrapExports(Transition_1);

var propTypes$19 = _extends({}, Transition.propTypes, {
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node), __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node]),
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func]),
  baseClass: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  baseClassActive: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
});

var defaultProps$18 = _extends({}, Transition.defaultProps, {
  tag: 'div',
  baseClass: 'fade',
  baseClassActive: 'show',
  timeout: TransitionTimeouts.Fade,
  appear: true,
  enter: true,
  exit: true,
  in: true
});

function Fade(props) {
  var Tag = props.tag,
      baseClass = props.baseClass,
      baseClassActive = props.baseClassActive,
      className = props.className,
      cssModule = props.cssModule,
      children = props.children,
      otherProps = objectWithoutProperties(props, ['tag', 'baseClass', 'baseClassActive', 'className', 'cssModule', 'children']);

  // In NODE_ENV=production the Transition.propTypes are wrapped which results in an
  // empty object "{}". This is the result of the `react-transition-group` babel
  // configuration settings. Therefore, to ensure that production builds work without
  // error, we can either explicitly define keys or use the Transition.defaultProps.
  // Using the Transition.defaultProps excludes any required props. Thus, the best
  // solution is to explicitly define required props in our utilities and reference these.
  // This also gives us more flexibility in the future to remove the prop-types
  // dependency in distribution builds (Similar to how `react-transition-group` does).
  // Note: Without omitting the `react-transition-group` props, the resulting child
  // Tag component would inherit the Transition properties as attributes for the HTML
  // element which results in errors/warnings for non-valid attributes.

  var transitionProps = pick(otherProps, TransitionPropTypeKeys);
  var childProps = omit(otherProps, TransitionPropTypeKeys);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    Transition,
    transitionProps,
    function (status) {
      var isActive = status === 'entered';
      var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, baseClass, isActive && baseClassActive), cssModule);
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        Tag,
        _extends({ className: classes }, childProps),
        children
      );
    }
  );
}

Fade.propTypes = propTypes$19;
Fade.defaultProps = defaultProps$18;

var propTypes$20 = {
  color: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  pill: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps$19 = {
  color: 'secondary',
  pill: false,
  tag: 'span'
};

var Badge = function Badge(props) {
  var className = props.className,
      cssModule = props.cssModule,
      color = props.color,
      pill = props.pill,
      Tag = props.tag,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'color', 'pill', 'tag']);


  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'badge', 'badge-' + color, pill ? 'badge-pill' : false), cssModule);

  if (attributes.href && Tag === 'span') {
    Tag = 'a';
  }

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

Badge.propTypes = propTypes$20;
Badge.defaultProps = defaultProps$19;

var propTypes$21 = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  inverse: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  color: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  block: deprecated(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool, 'Please use the props "body"'),
  body: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  outline: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps$20 = {
  tag: 'div'
};

var Card = function Card(props) {
  var className = props.className,
      cssModule = props.cssModule,
      color = props.color,
      block = props.block,
      body = props.body,
      inverse = props.inverse,
      outline = props.outline,
      Tag = props.tag,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'color', 'block', 'body', 'inverse', 'outline', 'tag']);

  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'card', inverse ? 'text-white' : false, block || body ? 'card-body' : false, color ? (outline ? 'border' : 'bg') + '-' + color : false), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

Card.propTypes = propTypes$21;
Card.defaultProps = defaultProps$20;

var propTypes$22 = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps$21 = {
  tag: 'div'
};

var CardGroup = function CardGroup(props) {
  var className = props.className,
      cssModule = props.cssModule,
      Tag = props.tag,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'tag']);

  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'card-group'), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

CardGroup.propTypes = propTypes$22;
CardGroup.defaultProps = defaultProps$21;

var propTypes$23 = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps$22 = {
  tag: 'div'
};

var CardDeck = function CardDeck(props) {
  var className = props.className,
      cssModule = props.cssModule,
      Tag = props.tag,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'tag']);

  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'card-deck'), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

CardDeck.propTypes = propTypes$23;
CardDeck.defaultProps = defaultProps$22;

var propTypes$24 = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps$23 = {
  tag: 'div'
};

var CardColumns = function CardColumns(props) {
  var className = props.className,
      cssModule = props.cssModule,
      Tag = props.tag,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'tag']);

  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'card-columns'), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

CardColumns.propTypes = propTypes$24;
CardColumns.defaultProps = defaultProps$23;

var propTypes$25 = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps$24 = {
  tag: 'div'
};

var CardBody = function CardBody(props) {
  var className = props.className,
      cssModule = props.cssModule,
      Tag = props.tag,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'tag']);

  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'card-body'), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

CardBody.propTypes = propTypes$25;
CardBody.defaultProps = defaultProps$24;

function CardBlock(props) {
  warnOnce('The "CardBlock" component has been deprecated.\nPlease use component "CardBody".');
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(CardBody, props);
}

var propTypes$26 = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  innerRef: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps$25 = {
  tag: 'a'
};

var CardLink = function CardLink(props) {
  var className = props.className,
      cssModule = props.cssModule,
      Tag = props.tag,
      innerRef = props.innerRef,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'tag', 'innerRef']);

  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'card-link'), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { ref: innerRef, className: classes }));
};

CardLink.propTypes = propTypes$26;
CardLink.defaultProps = defaultProps$25;

var propTypes$27 = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps$26 = {
  tag: 'div'
};

var CardFooter = function CardFooter(props) {
  var className = props.className,
      cssModule = props.cssModule,
      Tag = props.tag,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'tag']);

  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'card-footer'), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

CardFooter.propTypes = propTypes$27;
CardFooter.defaultProps = defaultProps$26;

var propTypes$28 = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps$27 = {
  tag: 'div'
};

var CardHeader = function CardHeader(props) {
  var className = props.className,
      cssModule = props.cssModule,
      Tag = props.tag,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'tag']);

  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'card-header'), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

CardHeader.propTypes = propTypes$28;
CardHeader.defaultProps = defaultProps$27;

var propTypes$29 = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  top: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  bottom: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps$28 = {
  tag: 'img'
};

var CardImg = function CardImg(props) {
  var className = props.className,
      cssModule = props.cssModule,
      top = props.top,
      bottom = props.bottom,
      Tag = props.tag,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'top', 'bottom', 'tag']);


  var cardImgClassName = 'card-img';
  if (top) {
    cardImgClassName = 'card-img-top';
  }
  if (bottom) {
    cardImgClassName = 'card-img-bottom';
  }

  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, cardImgClassName), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

CardImg.propTypes = propTypes$29;
CardImg.defaultProps = defaultProps$28;

var propTypes$30 = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps$29 = {
  tag: 'div'
};

var CardImgOverlay = function CardImgOverlay(props) {
  var className = props.className,
      cssModule = props.cssModule,
      Tag = props.tag,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'tag']);

  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'card-img-overlay'), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

CardImgOverlay.propTypes = propTypes$30;
CardImgOverlay.defaultProps = defaultProps$29;

var CarouselItem = function (_React$Component) {
  inherits(CarouselItem, _React$Component);

  function CarouselItem(props) {
    classCallCheck(this, CarouselItem);

    var _this = possibleConstructorReturn(this, (CarouselItem.__proto__ || Object.getPrototypeOf(CarouselItem)).call(this, props));

    _this.state = {
      startAnimation: false
    };

    _this.onEnter = _this.onEnter.bind(_this);
    _this.onEntering = _this.onEntering.bind(_this);
    _this.onExit = _this.onExit.bind(_this);
    _this.onExiting = _this.onExiting.bind(_this);
    _this.onExited = _this.onExited.bind(_this);
    return _this;
  }

  createClass(CarouselItem, [{
    key: 'onEnter',
    value: function onEnter(node, isAppearing) {
      this.setState({ startAnimation: false });
      this.props.onEnter(node, isAppearing);
    }
  }, {
    key: 'onEntering',
    value: function onEntering(node, isAppearing) {
      // getting this variable triggers a reflow
      var offsetHeight = node.offsetHeight;
      this.setState({ startAnimation: true });
      this.props.onEntering(node, isAppearing);
      return offsetHeight;
    }
  }, {
    key: 'onExit',
    value: function onExit(node) {
      this.setState({ startAnimation: false });
      this.props.onExit(node);
    }
  }, {
    key: 'onExiting',
    value: function onExiting(node) {
      this.setState({ startAnimation: true });
      node.dispatchEvent(new CustomEvent('slide.bs.carousel'));
      this.props.onExiting(node);
    }
  }, {
    key: 'onExited',
    value: function onExited(node) {
      node.dispatchEvent(new CustomEvent('slid.bs.carousel'));
      this.props.onExited(node);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          isIn = _props.in,
          children = _props.children,
          cssModule = _props.cssModule,
          slide = _props.slide,
          Tag = _props.tag,
          className = _props.className,
          transitionProps = objectWithoutProperties(_props, ['in', 'children', 'cssModule', 'slide', 'tag', 'className']);


      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        Transition,
        _extends({}, transitionProps, {
          enter: slide,
          exit: slide,
          'in': isIn,
          onEnter: this.onEnter,
          onEntering: this.onEntering,
          onExit: this.onExit,
          onExiting: this.onExiting,
          onExited: this.onExited
        }),
        function (status) {
          var direction = _this2.context.direction;

          var isActive = status === TransitionStatuses.ENTERED || status === TransitionStatuses.EXITING;
          var directionClassName = (status === TransitionStatuses.ENTERING || status === TransitionStatuses.EXITING) && _this2.state.startAnimation && (direction === 'right' ? 'carousel-item-left' : 'carousel-item-right');
          var orderClassName = status === TransitionStatuses.ENTERING && (direction === 'right' ? 'carousel-item-next' : 'carousel-item-prev');
          var itemClasses = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'carousel-item', isActive && 'active', directionClassName, orderClassName), cssModule);

          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            Tag,
            { className: itemClasses },
            children
          );
        }
      );
    }
  }]);
  return CarouselItem;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

CarouselItem.propTypes = _extends({}, Transition.propTypes, {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  in: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  slide: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
});

CarouselItem.defaultProps = _extends({}, Transition.defaultProps, {
  tag: 'div',
  timeout: TransitionTimeouts.Carousel,
  slide: true
});

CarouselItem.contextTypes = {
  direction: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};

var Carousel = function (_React$Component) {
  inherits(Carousel, _React$Component);

  function Carousel(props) {
    classCallCheck(this, Carousel);

    var _this = possibleConstructorReturn(this, (Carousel.__proto__ || Object.getPrototypeOf(Carousel)).call(this, props));

    _this.handleKeyPress = _this.handleKeyPress.bind(_this);
    _this.renderItems = _this.renderItems.bind(_this);
    _this.hoverStart = _this.hoverStart.bind(_this);
    _this.hoverEnd = _this.hoverEnd.bind(_this);
    _this.state = { direction: 'right' };
    return _this;
  }

  createClass(Carousel, [{
    key: 'getChildContext',
    value: function getChildContext() {
      return { direction: this.state.direction };
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      // Set up the cycle
      if (this.props.ride === 'carousel') {
        this.setInterval();
      }

      // TODO: move this to the specific carousel like bootstrap. Currently it will trigger ALL carousels on the page.
      document.addEventListener('keyup', this.handleKeyPress);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      this.setInterval(nextProps);
      // Calculate the direction to turn
      if (this.props.activeIndex + 1 === nextProps.activeIndex) {
        this.setState({ direction: 'right' });
      } else if (this.props.activeIndex - 1 === nextProps.activeIndex) {
        this.setState({ direction: 'left' });
      } else if (this.props.activeIndex > nextProps.activeIndex) {
        this.setState({ direction: 'right' });
      } else if (this.props.activeIndex !== nextProps.activeIndex) {
        this.setState({ direction: 'left' });
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.clearInterval();
      document.removeEventListener('keyup', this.handleKeyPress);
    }
  }, {
    key: 'setInterval',
    value: function (_setInterval) {
      function setInterval() {
        return _setInterval.apply(this, arguments);
      }

      setInterval.toString = function () {
        return _setInterval.toString();
      };

      return setInterval;
    }(function () {
      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;

      // make sure not to have multiple intervals going...
      this.clearInterval();
      if (props.interval) {
        this.cycleInterval = setInterval(function () {
          props.next();
        }, parseInt(props.interval, 10));
      }
    })
  }, {
    key: 'clearInterval',
    value: function (_clearInterval) {
      function clearInterval() {
        return _clearInterval.apply(this, arguments);
      }

      clearInterval.toString = function () {
        return _clearInterval.toString();
      };

      return clearInterval;
    }(function () {
      clearInterval(this.cycleInterval);
    })
  }, {
    key: 'hoverStart',
    value: function hoverStart() {
      if (this.props.pause === 'hover') {
        this.clearInterval();
      }
      if (this.props.mouseEnter) {
        var _props;

        (_props = this.props).mouseEnter.apply(_props, arguments);
      }
    }
  }, {
    key: 'hoverEnd',
    value: function hoverEnd() {
      if (this.props.pause === 'hover') {
        this.setInterval();
      }
      if (this.props.mouseLeave) {
        var _props2;

        (_props2 = this.props).mouseLeave.apply(_props2, arguments);
      }
    }
  }, {
    key: 'handleKeyPress',
    value: function handleKeyPress(evt) {
      if (this.props.keyboard) {
        if (evt.keyCode === 37) {
          this.props.previous();
        } else if (evt.keyCode === 39) {
          this.props.next();
        }
      }
    }
  }, {
    key: 'renderItems',
    value: function renderItems(carouselItems, className) {
      var _this2 = this;

      var slide = this.props.slide;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { role: 'listbox', className: className },
        carouselItems.map(function (item, index) {
          var isIn = index === _this2.props.activeIndex;
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.cloneElement(item, {
            in: isIn,
            slide: slide
          });
        })
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _props3 = this.props,
          children = _props3.children,
          cssModule = _props3.cssModule,
          slide = _props3.slide,
          className = _props3.className;

      var outerClasses = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'carousel', slide && 'slide'), cssModule);

      var innerClasses = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()('carousel-inner'), cssModule);

      var slidesOnly = children.every(function (child) {
        return child.type === CarouselItem;
      });

      // Rendering only slides
      if (slidesOnly) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: outerClasses, onMouseEnter: this.hoverStart, onMouseLeave: this.hoverEnd },
          this.renderItems(children, innerClasses)
        );
      }

      // Rendering slides and controls
      if (children[0] instanceof Array) {
        var _carouselItems = children[0];
        var _controlLeft = children[1];
        var _controlRight = children[2];

        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: outerClasses, onMouseEnter: this.hoverStart, onMouseLeave: this.hoverEnd },
          this.renderItems(_carouselItems, innerClasses),
          _controlLeft,
          _controlRight
        );
      }

      // Rendering indicators, slides and controls
      var indicators = children[0];
      var carouselItems = children[1];
      var controlLeft = children[2];
      var controlRight = children[3];

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: outerClasses, onMouseEnter: this.hoverStart, onMouseLeave: this.hoverEnd },
        indicators,
        this.renderItems(carouselItems, innerClasses),
        controlLeft,
        controlRight
      );
    }
  }]);
  return Carousel;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Carousel.propTypes = {
  // the current active slide of the carousel
  activeIndex: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  // a function which should advance the carousel to the next slide (via activeIndex)
  next: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  // a function which should advance the carousel to the previous slide (via activeIndex)
  previous: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  // controls if the left and right arrow keys should control the carousel
  keyboard: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  /* If set to "hover", pauses the cycling of the carousel on mouseenter and resumes the cycling of the carousel on
   * mouseleave. If set to false, hovering over the carousel won't pause it. (default: "hover")
   */
  pause: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['hover', false]),
  // Autoplays the carousel after the user manually cycles the first item. If "carousel", autoplays the carousel on load.
  // This is how bootstrap defines it... I would prefer a bool named autoplay or something...
  ride: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['carousel']),
  // the interval at which the carousel automatically cycles (default: 5000)
  // eslint-disable-next-line react/no-unused-prop-types
  interval: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool]),
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
  // called when the mouse enters the Carousel
  mouseEnter: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  // called when the mouse exits the Carousel
  mouseLeave: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  // controls whether the slide animation on the Carousel works or not
  slide: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};

Carousel.defaultProps = {
  interval: 5000,
  pause: 'hover',
  keyboard: true,
  slide: true
};

Carousel.childContextTypes = {
  direction: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};

var CarouselControl = function CarouselControl(props) {
  var direction = props.direction,
      onClickHandler = props.onClickHandler,
      cssModule = props.cssModule,
      directionText = props.directionText,
      className = props.className;


  var anchorClasses = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'carousel-control-' + direction), cssModule);

  var iconClasses = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()('carousel-control-' + direction + '-icon'), cssModule);

  var screenReaderClasses = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()('sr-only'), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'a',
    {
      className: anchorClasses,
      role: 'button',
      tabIndex: '0',
      onClick: function onClick(e) {
        e.preventDefault();
        onClickHandler();
      }
    },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: iconClasses, 'aria-hidden': 'true' }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'span',
      { className: screenReaderClasses },
      directionText || direction
    )
  );
};

CarouselControl.propTypes = {
  direction: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['prev', 'next']).isRequired,
  onClickHandler: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  directionText: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};

var CarouselIndicators = function CarouselIndicators(props) {
  var items = props.items,
      activeIndex = props.activeIndex,
      cssModule = props.cssModule,
      onClickHandler = props.onClickHandler,
      className = props.className;


  var listClasses = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'carousel-indicators'), cssModule);
  var indicators = items.map(function (item, idx) {
    var indicatorClasses = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()({ active: activeIndex === idx }), cssModule);
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', {
      key: '' + (item.key || item.src) + item.caption + item.altText,
      onClick: function onClick(e) {
        e.preventDefault();
        onClickHandler(idx);
      },
      className: indicatorClasses
    });
  });

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'ol',
    { className: listClasses },
    indicators
  );
};

CarouselIndicators.propTypes = {
  items: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array.isRequired,
  activeIndex: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  onClickHandler: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};

var CarouselCaption = function CarouselCaption(props) {
  var captionHeader = props.captionHeader,
      captionText = props.captionText,
      cssModule = props.cssModule,
      className = props.className;

  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'carousel-caption', 'd-none', 'd-md-block'), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: classes },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'h3',
      null,
      captionHeader
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'p',
      null,
      captionText
    )
  );
};

CarouselCaption.propTypes = {
  captionHeader: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  captionText: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};

var propTypes$31 = {
  items: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array.isRequired,
  indicators: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  controls: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  autoPlay: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  activeIndex: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  next: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  previous: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  goToIndex: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
};

var UncontrolledCarousel = function (_Component) {
  inherits(UncontrolledCarousel, _Component);

  function UncontrolledCarousel(props) {
    classCallCheck(this, UncontrolledCarousel);

    var _this = possibleConstructorReturn(this, (UncontrolledCarousel.__proto__ || Object.getPrototypeOf(UncontrolledCarousel)).call(this, props));

    _this.animating = false;
    _this.state = { activeIndex: 0 };
    _this.next = _this.next.bind(_this);
    _this.previous = _this.previous.bind(_this);
    _this.goToIndex = _this.goToIndex.bind(_this);
    _this.onExiting = _this.onExiting.bind(_this);
    _this.onExited = _this.onExited.bind(_this);
    return _this;
  }

  createClass(UncontrolledCarousel, [{
    key: 'onExiting',
    value: function onExiting() {
      this.animating = true;
    }
  }, {
    key: 'onExited',
    value: function onExited() {
      this.animating = false;
    }
  }, {
    key: 'next',
    value: function next() {
      if (this.animating) return;
      var nextIndex = this.state.activeIndex === this.props.items.length - 1 ? 0 : this.state.activeIndex + 1;
      this.setState({ activeIndex: nextIndex });
    }
  }, {
    key: 'previous',
    value: function previous() {
      if (this.animating) return;
      var nextIndex = this.state.activeIndex === 0 ? this.props.items.length - 1 : this.state.activeIndex - 1;
      this.setState({ activeIndex: nextIndex });
    }
  }, {
    key: 'goToIndex',
    value: function goToIndex(newIndex) {
      if (this.animating) return;
      this.setState({ activeIndex: newIndex });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          autoPlay = _props.autoPlay,
          indicators = _props.indicators,
          controls = _props.controls,
          items = _props.items,
          goToIndex = _props.goToIndex,
          props = objectWithoutProperties(_props, ['autoPlay', 'indicators', 'controls', 'items', 'goToIndex']);
      var activeIndex = this.state.activeIndex;


      var slides = items.map(function (item) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          CarouselItem,
          {
            onExiting: _this2.onExiting,
            onExited: _this2.onExited,
            key: item.src
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { src: item.src, alt: item.altText }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(CarouselCaption, { captionText: item.caption, captionHeader: item.caption })
        );
      });

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        Carousel,
        _extends({
          activeIndex: activeIndex,
          next: this.next,
          previous: this.previous,
          ride: autoPlay ? 'carousel' : undefined
        }, props),
        indicators && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(CarouselIndicators, {
          items: items,
          activeIndex: props.activeIndex || activeIndex,
          onClickHandler: goToIndex || this.goToIndex
        }),
        slides,
        controls && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(CarouselControl, {
          direction: 'prev',
          directionText: 'Previous',
          onClickHandler: props.previous || this.previous
        }),
        controls && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(CarouselControl, {
          direction: 'next',
          directionText: 'Next',
          onClickHandler: props.next || this.next
        })
      );
    }
  }]);
  return UncontrolledCarousel;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

UncontrolledCarousel.propTypes = propTypes$31;
UncontrolledCarousel.defaultProps = {
  controls: true,
  indicators: true,
  autoPlay: true
};

var propTypes$32 = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps$30 = {
  tag: 'h6'
};

var CardSubtitle = function CardSubtitle(props) {
  var className = props.className,
      cssModule = props.cssModule,
      Tag = props.tag,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'tag']);

  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'card-subtitle'), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

CardSubtitle.propTypes = propTypes$32;
CardSubtitle.defaultProps = defaultProps$30;

var propTypes$33 = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps$31 = {
  tag: 'p'
};

var CardText = function CardText(props) {
  var className = props.className,
      cssModule = props.cssModule,
      Tag = props.tag,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'tag']);

  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'card-text'), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

CardText.propTypes = propTypes$33;
CardText.defaultProps = defaultProps$31;

var propTypes$34 = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps$32 = {
  tag: 'h5'
};

var CardTitle = function CardTitle(props) {
  var className = props.className,
      cssModule = props.cssModule,
      Tag = props.tag,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'tag']);

  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'card-title'), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

CardTitle.propTypes = propTypes$34;
CardTitle.defaultProps = defaultProps$32;

var propTypes$35 = {
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node.isRequired,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  placement: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  placementPrefix: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  isOpen: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  offset: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number]),
  fallbackPlacement: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array]),
  flip: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  container: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, DOMElement]),
  target: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, DOMElement]).isRequired,
  modifiers: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps$33 = {
  placement: 'auto',
  isOpen: false,
  offset: 0,
  fallbackPlacement: 'flip',
  flip: true,
  container: 'body',
  modifiers: {}
};

var childContextTypes$1 = {
  popperManager: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired
};

var PopperContent = function (_React$Component) {
  inherits(PopperContent, _React$Component);

  function PopperContent(props) {
    classCallCheck(this, PopperContent);

    var _this = possibleConstructorReturn(this, (PopperContent.__proto__ || Object.getPrototypeOf(PopperContent)).call(this, props));

    _this.handlePlacementChange = _this.handlePlacementChange.bind(_this);
    _this.setTargetNode = _this.setTargetNode.bind(_this);
    _this.getTargetNode = _this.getTargetNode.bind(_this);
    _this.state = {};
    return _this;
  }

  createClass(PopperContent, [{
    key: 'getChildContext',
    value: function getChildContext() {
      return {
        popperManager: {
          setTargetNode: this.setTargetNode,
          getTargetNode: this.getTargetNode
        }
      };
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.handleProps();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      if (this.props.isOpen !== prevProps.isOpen) {
        this.handleProps();
      } else if (this._element) {
        // rerender
        this.renderIntoSubtree();
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.hide();
    }
  }, {
    key: 'setTargetNode',
    value: function setTargetNode(node) {
      this.targetNode = node;
    }
  }, {
    key: 'getTargetNode',
    value: function getTargetNode() {
      return this.targetNode;
    }
  }, {
    key: 'getContainerNode',
    value: function getContainerNode() {
      return getTarget(this.props.container);
    }
  }, {
    key: 'handlePlacementChange',
    value: function handlePlacementChange(data) {
      if (this.state.placement !== data.placement) {
        this.setState({ placement: data.placement });
      }
      return data;
    }
  }, {
    key: 'handleProps',
    value: function handleProps() {
      if (this.props.container !== 'inline') {
        if (this.props.isOpen) {
          this.show();
        } else {
          this.hide();
        }
      }
    }
  }, {
    key: 'hide',
    value: function hide() {
      if (this._element) {
        this.getContainerNode().removeChild(this._element);
        __WEBPACK_IMPORTED_MODULE_5_react_dom___default.a.unmountComponentAtNode(this._element);
        this._element = null;
      }
    }
  }, {
    key: 'show',
    value: function show() {
      this._element = document.createElement('div');
      this.getContainerNode().appendChild(this._element);
      this.renderIntoSubtree();
      if (this._element.childNodes && this._element.childNodes[0] && this._element.childNodes[0].focus) {
        this._element.childNodes[0].focus();
      }
    }
  }, {
    key: 'renderIntoSubtree',
    value: function renderIntoSubtree() {
      __WEBPACK_IMPORTED_MODULE_5_react_dom___default.a.unstable_renderSubtreeIntoContainer(this, this.renderChildren(), this._element);
    }
  }, {
    key: 'renderChildren',
    value: function renderChildren() {
      var _props = this.props,
          cssModule = _props.cssModule,
          children = _props.children,
          isOpen = _props.isOpen,
          flip = _props.flip,
          target = _props.target,
          offset = _props.offset,
          fallbackPlacement = _props.fallbackPlacement,
          placementPrefix = _props.placementPrefix,
          className = _props.className,
          tag = _props.tag,
          container = _props.container,
          modifiers = _props.modifiers,
          attrs = objectWithoutProperties(_props, ['cssModule', 'children', 'isOpen', 'flip', 'target', 'offset', 'fallbackPlacement', 'placementPrefix', 'className', 'tag', 'container', 'modifiers']);

      var arrowClassName = mapToCssModules('arrow', cssModule);
      var placement = (this.state.placement || attrs.placement).split('-')[0];
      var popperClassName = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, placementPrefix ? placementPrefix + '-' + placement : placement), this.props.cssModule);

      var extendedModifiers = _extends({
        offset: { offset: offset },
        flip: { enabled: flip, behavior: fallbackPlacement },
        update: {
          enabled: true,
          order: 950,
          fn: this.handlePlacementChange
        }
      }, modifiers);

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_6_react_popper__["Popper"],
        _extends({ modifiers: extendedModifiers }, attrs, { component: tag, className: popperClassName }),
        children,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_popper__["Arrow"], { className: arrowClassName })
      );
    }
  }, {
    key: 'render',
    value: function render() {
      this.setTargetNode(getTarget(this.props.target));

      if (this.props.container === 'inline') {
        return this.props.isOpen ? this.renderChildren() : null;
      }

      return null;
    }
  }]);
  return PopperContent;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

PopperContent.propTypes = propTypes$35;
PopperContent.defaultProps = defaultProps$33;
PopperContent.childContextTypes = childContextTypes$1;

var PopperTargetHelper = function PopperTargetHelper(props, context) {
  context.popperManager.setTargetNode(getTarget(props.target));
  return null;
};

PopperTargetHelper.contextTypes = {
  popperManager: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired
};

PopperTargetHelper.propTypes = {
  target: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, DOMElement]).isRequired
};

var propTypes$36 = {
  placement: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(PopperPlacements),
  target: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, DOMElement]).isRequired,
  container: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, DOMElement]),
  isOpen: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  disabled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  innerClassName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  placementPrefix: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  toggle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  delay: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({ show: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number, hide: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number }), __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number]),
  modifiers: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var DEFAULT_DELAYS = {
  show: 0,
  hide: 0
};

var defaultProps$34 = {
  isOpen: false,
  placement: 'right',
  placementPrefix: 'bs-popover',
  delay: DEFAULT_DELAYS,
  toggle: function toggle() {}
};

var Popover = function (_React$Component) {
  inherits(Popover, _React$Component);

  function Popover(props) {
    classCallCheck(this, Popover);

    var _this = possibleConstructorReturn(this, (Popover.__proto__ || Object.getPrototypeOf(Popover)).call(this, props));

    _this.addTargetEvents = _this.addTargetEvents.bind(_this);
    _this.handleDocumentClick = _this.handleDocumentClick.bind(_this);
    _this.removeTargetEvents = _this.removeTargetEvents.bind(_this);
    _this.getRef = _this.getRef.bind(_this);
    _this.toggle = _this.toggle.bind(_this);
    _this.show = _this.show.bind(_this);
    _this.hide = _this.hide.bind(_this);
    return _this;
  }

  createClass(Popover, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this._target = getTarget(this.props.target);
      this.handleProps();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      this.handleProps();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.clearShowTimeout();
      this.clearHideTimeout();
      this.removeTargetEvents();
    }
  }, {
    key: 'getRef',
    value: function getRef(ref) {
      this._popover = ref;
    }
  }, {
    key: 'getDelay',
    value: function getDelay(key) {
      var delay = this.props.delay;

      if ((typeof delay === 'undefined' ? 'undefined' : _typeof(delay)) === 'object') {
        return isNaN(delay[key]) ? DEFAULT_DELAYS[key] : delay[key];
      }
      return delay;
    }
  }, {
    key: 'handleProps',
    value: function handleProps() {
      if (this.props.isOpen) {
        this.show();
      } else {
        this.hide();
      }
    }
  }, {
    key: 'show',
    value: function show() {
      this.clearHideTimeout();
      this.addTargetEvents();
      if (!this.props.isOpen) {
        this.clearShowTimeout();
        this._showTimeout = setTimeout(this.toggle, this.getDelay('show'));
      }
    }
  }, {
    key: 'hide',
    value: function hide() {
      this.clearShowTimeout();
      this.removeTargetEvents();
      if (this.props.isOpen) {
        this.clearHideTimeout();
        this._hideTimeout = setTimeout(this.toggle, this.getDelay('hide'));
      }
    }
  }, {
    key: 'clearShowTimeout',
    value: function clearShowTimeout() {
      clearTimeout(this._showTimeout);
      this._showTimeout = undefined;
    }
  }, {
    key: 'clearHideTimeout',
    value: function clearHideTimeout() {
      clearTimeout(this._hideTimeout);
      this._hideTimeout = undefined;
    }
  }, {
    key: 'handleDocumentClick',
    value: function handleDocumentClick(e) {
      if (e.target !== this._target && !this._target.contains(e.target) && e.target !== this._popover && !(this._popover && this._popover.contains(e.target))) {
        if (this._hideTimeout) {
          this.clearHideTimeout();
        }

        if (this.props.isOpen) {
          this.toggle();
        }
      }
    }
  }, {
    key: 'addTargetEvents',
    value: function addTargetEvents() {
      var _this2 = this;

      ['click', 'touchstart'].forEach(function (event) {
        return document.addEventListener(event, _this2.handleDocumentClick, true);
      });
    }
  }, {
    key: 'removeTargetEvents',
    value: function removeTargetEvents() {
      var _this3 = this;

      ['click', 'touchstart'].forEach(function (event) {
        return document.removeEventListener(event, _this3.handleDocumentClick, true);
      });
    }
  }, {
    key: 'toggle',
    value: function toggle(e) {
      if (this.props.disabled) {
        return e && e.preventDefault();
      }

      return this.props.toggle();
    }
  }, {
    key: 'render',
    value: function render() {
      if (!this.props.isOpen) {
        return null;
      }

      var attributes = omit(this.props, Object.keys(propTypes$36));
      var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()('popover-inner', this.props.innerClassName), this.props.cssModule);

      var popperClasses = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()('popover', 'show', this.props.className), this.props.cssModule);

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        PopperContent,
        {
          className: popperClasses,
          target: this.props.target,
          isOpen: this.props.isOpen,
          placement: this.props.placement,
          placementPrefix: this.props.placementPrefix,
          container: this.props.container,
          modifiers: this.props.modifiers
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', _extends({}, attributes, { className: classes, ref: this.getRef }))
      );
    }
  }]);
  return Popover;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Popover.propTypes = propTypes$36;
Popover.defaultProps = defaultProps$34;

var propTypes$37 = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps$35 = {
  tag: 'h3'
};

var PopoverHeader = function PopoverHeader(props) {
  var className = props.className,
      cssModule = props.cssModule,
      Tag = props.tag,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'tag']);


  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'popover-header'), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

PopoverHeader.propTypes = propTypes$37;
PopoverHeader.defaultProps = defaultProps$35;

function PopoverTitle(props) {
  warnOnce('The "PopoverTitle" component has been deprecated.\nPlease use component "PopoverHeader".');
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(PopoverHeader, props);
}

var propTypes$38 = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps$36 = {
  tag: 'div'
};

var PopoverBody = function PopoverBody(props) {
  var className = props.className,
      cssModule = props.cssModule,
      Tag = props.tag,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'tag']);


  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'popover-body'), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

PopoverBody.propTypes = propTypes$38;
PopoverBody.defaultProps = defaultProps$36;

function PopoverContent(props) {
  warnOnce('The "PopoverContent" component has been deprecated.\nPlease use component "PopoverBody".');
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(PopoverBody, props);
}

var propTypes$39 = {
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  bar: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  multi: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  value: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number]),
  max: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number]),
  animated: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  striped: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  color: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  barClassName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps$37 = {
  tag: 'div',
  value: 0,
  max: 100
};

var Progress = function Progress(props) {
  var children = props.children,
      className = props.className,
      barClassName = props.barClassName,
      cssModule = props.cssModule,
      value = props.value,
      max = props.max,
      animated = props.animated,
      striped = props.striped,
      color = props.color,
      bar = props.bar,
      multi = props.multi,
      Tag = props.tag,
      attributes = objectWithoutProperties(props, ['children', 'className', 'barClassName', 'cssModule', 'value', 'max', 'animated', 'striped', 'color', 'bar', 'multi', 'tag']);


  var percent = __WEBPACK_IMPORTED_MODULE_7_lodash_tonumber___default()(value) / __WEBPACK_IMPORTED_MODULE_7_lodash_tonumber___default()(max) * 100;

  var progressClasses = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'progress'), cssModule);

  var progressBarClasses = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()('progress-bar', bar ? className || barClassName : barClassName, animated ? 'progress-bar-animated' : null, color ? 'bg-' + color : null, striped || animated ? 'progress-bar-striped' : null), cssModule);

  var ProgressBar = multi ? children : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', {
    className: progressBarClasses,
    style: { width: percent + '%' },
    role: 'progressbar',
    'aria-valuenow': value,
    'aria-valuemin': '0',
    'aria-valuemax': max,
    children: children
  });

  if (bar) {
    return ProgressBar;
  }

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: progressClasses, children: ProgressBar }));
};

Progress.propTypes = propTypes$39;
Progress.defaultProps = defaultProps$37;

function noop() {}

var FadePropTypes = __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape(Fade.propTypes);

var propTypes$40 = {
  isOpen: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  autoFocus: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  size: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  toggle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  keyboard: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  role: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  labelledBy: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  backdrop: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['static'])]),
  onEnter: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onExit: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onOpened: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onClosed: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  wrapClassName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  modalClassName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  backdropClassName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  contentClassName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  fade: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  zIndex: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  backdropTransition: FadePropTypes,
  modalTransition: FadePropTypes
};

var propsToOmit = Object.keys(propTypes$40);

var defaultProps$38 = {
  isOpen: false,
  autoFocus: true,
  role: 'dialog',
  backdrop: true,
  keyboard: true,
  zIndex: 1050,
  fade: true,
  onOpened: noop,
  onClosed: noop,
  modalTransition: {
    timeout: TransitionTimeouts.Modal
  },
  backdropTransition: {
    mountOnEnter: true,
    timeout: TransitionTimeouts.Fade // uses standard fade transition
  }
};

var Modal = function (_React$Component) {
  inherits(Modal, _React$Component);

  function Modal(props) {
    classCallCheck(this, Modal);

    var _this = possibleConstructorReturn(this, (Modal.__proto__ || Object.getPrototypeOf(Modal)).call(this, props));

    _this.originalBodyPadding = null;
    _this.isBodyOverflowing = false;
    _this.togglePortal = _this.togglePortal.bind(_this);
    _this.handleBackdropClick = _this.handleBackdropClick.bind(_this);
    _this.handleEscape = _this.handleEscape.bind(_this);
    _this.destroy = _this.destroy.bind(_this);
    _this.onOpened = _this.onOpened.bind(_this);
    _this.onClosed = _this.onClosed.bind(_this);
    return _this;
  }

  createClass(Modal, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (this.props.isOpen) {
        this.togglePortal();
      }
      if (this.props.onEnter) {
        this.props.onEnter();
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      if (this.props.isOpen !== prevProps.isOpen) {
        // handle portal events/dom updates
        this.togglePortal();
      } else if (this._element) {
        // rerender portal
        this.renderIntoSubtree();
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.destroy();
      if (this.props.onExit) {
        this.props.onExit();
      }
    }
  }, {
    key: 'onOpened',
    value: function onOpened(node, isAppearing) {
      this.props.onOpened();
      (this.props.modalTransition.onEntered || noop)(node, isAppearing);
    }
  }, {
    key: 'onClosed',
    value: function onClosed(node) {
      var _this2 = this;

      // so all methods get called before it is unmounted
      setTimeout(function () {
        return _this2.destroy();
      }, 0);
      this.props.onClosed();
      (this.props.modalTransition.onExited || noop)(node);
    }
  }, {
    key: 'handleEscape',
    value: function handleEscape(e) {
      if (this.props.keyboard && e.keyCode === 27 && this.props.toggle) {
        this.props.toggle();
      }
    }
  }, {
    key: 'handleBackdropClick',
    value: function handleBackdropClick(e) {
      if (this.props.backdrop !== true) return;

      var container = this._dialog;

      if (e.target && !container.contains(e.target) && this.props.toggle) {
        this.props.toggle();
      }
    }
  }, {
    key: 'togglePortal',
    value: function togglePortal() {
      if (this.props.isOpen) {
        if (this.props.autoFocus) {
          this._focus = true;
        }
        this.show();
      } else {
        this.hide();
      }
    }
  }, {
    key: 'destroy',
    value: function destroy() {
      if (this._element) {
        __WEBPACK_IMPORTED_MODULE_5_react_dom___default.a.unmountComponentAtNode(this._element);
        document.body.removeChild(this._element);
        this._element = null;
      }

      // Use regex to prevent matching `modal-open` as part of a different class, e.g. `my-modal-opened`
      var classes = document.body.className.replace(/(^| )modal-open( |$)/, ' ');
      document.body.className = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(classes).trim(), this.props.cssModule);
      setScrollbarWidth(this.originalBodyPadding);
    }
  }, {
    key: 'hide',
    value: function hide() {
      this.renderIntoSubtree();
    }
  }, {
    key: 'show',
    value: function show() {
      if (this._dialog) {
        if (this.props.toggle) {
          this.props.toggle(true);
        }
        return;
      }
      var classes = document.body.className;
      this._element = document.createElement('div');
      this._element.setAttribute('tabindex', '-1');
      this._element.style.position = 'relative';
      this._element.style.zIndex = this.props.zIndex;
      this.originalBodyPadding = getOriginalBodyPadding();

      conditionallyUpdateScrollbar();

      document.body.appendChild(this._element);

      document.body.className = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(classes, 'modal-open'), this.props.cssModule);

      this.renderIntoSubtree();
    }
  }, {
    key: 'renderModalDialog',
    value: function renderModalDialog() {
      var _this3 = this;

      var attributes = omit(this.props, propsToOmit);

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        _extends({
          className: mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()('modal-dialog', this.props.className, defineProperty({}, 'modal-' + this.props.size, this.props.size)), this.props.cssModule),
          role: 'document',
          ref: function ref(c) {
            _this3._dialog = c;
          }
        }, attributes),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          {
            className: mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()('modal-content', this.props.contentClassName), this.props.cssModule)
          },
          this.props.children
        )
      );
    }
  }, {
    key: 'renderIntoSubtree',
    value: function renderIntoSubtree() {
      __WEBPACK_IMPORTED_MODULE_5_react_dom___default.a.unstable_renderSubtreeIntoContainer(this, this.renderChildren(), this._element);

      // check if modal should receive focus
      if (this._focus) {
        if (this._dialog && this._dialog.parentNode && typeof this._dialog.parentNode.focus === 'function') {
          this._dialog.parentNode.focus();
        }
        this._focus = false;
      }
    }
  }, {
    key: 'renderChildren',
    value: function renderChildren() {
      var _props = this.props,
          wrapClassName = _props.wrapClassName,
          modalClassName = _props.modalClassName,
          backdropClassName = _props.backdropClassName,
          cssModule = _props.cssModule,
          isOpen = _props.isOpen,
          backdrop = _props.backdrop,
          role = _props.role,
          labelledBy = _props.labelledBy;


      var modalAttributes = {
        onClickCapture: this.handleBackdropClick,
        onKeyUp: this.handleEscape,
        style: { display: 'block' },
        'aria-labelledby': labelledBy,
        role: role,
        tabIndex: '-1'
      };

      var hasTransition = this.props.fade;
      var modalTransition = _extends({}, Fade.defaultProps, this.props.modalTransition, {
        baseClass: hasTransition ? this.props.modalTransition.baseClass : '',
        timeout: hasTransition ? this.props.modalTransition.timeout : 0
      });
      var backdropTransition = _extends({}, Fade.defaultProps, this.props.backdropTransition, {
        baseClass: hasTransition ? this.props.backdropTransition.baseClass : '',
        timeout: hasTransition ? this.props.backdropTransition.timeout : 0
      });
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: mapToCssModules(wrapClassName) },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          Fade,
          _extends({}, modalAttributes, modalTransition, {
            'in': isOpen,
            onEntered: this.onOpened,
            onExited: this.onClosed,
            cssModule: cssModule,
            className: mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()('modal', modalClassName), cssModule)
          }),
          this.renderModalDialog()
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Fade, _extends({}, backdropTransition, {
          'in': isOpen && !!backdrop,
          cssModule: cssModule,
          className: mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()('modal-backdrop', backdropClassName), cssModule)
        }))
      );
    }
  }, {
    key: 'render',
    value: function render() {
      return null;
    }
  }]);
  return Modal;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Modal.propTypes = propTypes$40;
Modal.defaultProps = defaultProps$38;

var propTypes$41 = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  wrapTag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  toggle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  closeAriaLabel: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};

var defaultProps$39 = {
  tag: 'h5',
  wrapTag: 'div',
  closeAriaLabel: 'Close'
};

var ModalHeader = function ModalHeader(props) {
  var closeButton = void 0;
  var className = props.className,
      cssModule = props.cssModule,
      children = props.children,
      toggle = props.toggle,
      Tag = props.tag,
      WrapTag = props.wrapTag,
      closeAriaLabel = props.closeAriaLabel,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'children', 'toggle', 'tag', 'wrapTag', 'closeAriaLabel']);


  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'modal-header'), cssModule);

  if (toggle) {
    closeButton = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'button',
      { type: 'button', onClick: toggle, className: mapToCssModules('close', cssModule), 'aria-label': closeAriaLabel },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'span',
        { 'aria-hidden': 'true' },
        String.fromCharCode(215)
      )
    );
  }

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    WrapTag,
    _extends({}, attributes, { className: classes }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      Tag,
      { className: mapToCssModules('modal-title', cssModule) },
      children
    ),
    closeButton
  );
};

ModalHeader.propTypes = propTypes$41;
ModalHeader.defaultProps = defaultProps$39;

var propTypes$42 = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps$40 = {
  tag: 'div'
};

var ModalBody = function ModalBody(props) {
  var className = props.className,
      cssModule = props.cssModule,
      Tag = props.tag,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'tag']);

  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'modal-body'), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

ModalBody.propTypes = propTypes$42;
ModalBody.defaultProps = defaultProps$40;

var propTypes$43 = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps$41 = {
  tag: 'div'
};

var ModalFooter = function ModalFooter(props) {
  var className = props.className,
      cssModule = props.cssModule,
      Tag = props.tag,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'tag']);

  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'modal-footer'), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

ModalFooter.propTypes = propTypes$43;
ModalFooter.defaultProps = defaultProps$41;

var propTypes$44 = {
  placement: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(PopperPlacements),
  target: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, DOMElement]).isRequired,
  container: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, DOMElement]),
  isOpen: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  disabled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  innerClassName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  toggle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  autohide: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  placementPrefix: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  delay: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({ show: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number, hide: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number }), __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number]),
  modifiers: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var DEFAULT_DELAYS$1 = {
  show: 0,
  hide: 250
};

var defaultProps$42 = {
  isOpen: false,
  placement: 'top',
  placementPrefix: 'bs-tooltip',
  delay: DEFAULT_DELAYS$1,
  autohide: true,
  toggle: function toggle() {}
};

var Tooltip = function (_React$Component) {
  inherits(Tooltip, _React$Component);

  function Tooltip(props) {
    classCallCheck(this, Tooltip);

    var _this = possibleConstructorReturn(this, (Tooltip.__proto__ || Object.getPrototypeOf(Tooltip)).call(this, props));

    _this.addTargetEvents = _this.addTargetEvents.bind(_this);
    _this.handleDocumentClick = _this.handleDocumentClick.bind(_this);
    _this.removeTargetEvents = _this.removeTargetEvents.bind(_this);
    _this.toggle = _this.toggle.bind(_this);
    _this.onMouseOverTooltip = _this.onMouseOverTooltip.bind(_this);
    _this.onMouseLeaveTooltip = _this.onMouseLeaveTooltip.bind(_this);
    _this.onMouseOverTooltipContent = _this.onMouseOverTooltipContent.bind(_this);
    _this.onMouseLeaveTooltipContent = _this.onMouseLeaveTooltipContent.bind(_this);
    _this.show = _this.show.bind(_this);
    _this.hide = _this.hide.bind(_this);
    return _this;
  }

  createClass(Tooltip, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this._target = getTarget(this.props.target);
      this.addTargetEvents();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.removeTargetEvents();
    }
  }, {
    key: 'onMouseOverTooltip',
    value: function onMouseOverTooltip() {
      if (this._hideTimeout) {
        this.clearHideTimeout();
      }
      this._showTimeout = setTimeout(this.show, this.getDelay('show'));
    }
  }, {
    key: 'onMouseLeaveTooltip',
    value: function onMouseLeaveTooltip() {
      if (this._showTimeout) {
        this.clearShowTimeout();
      }
      this._hideTimeout = setTimeout(this.hide, this.getDelay('hide'));
    }
  }, {
    key: 'onMouseOverTooltipContent',
    value: function onMouseOverTooltipContent() {
      if (this.props.autohide) {
        return;
      }
      if (this._hideTimeout) {
        this.clearHideTimeout();
      }
    }
  }, {
    key: 'onMouseLeaveTooltipContent',
    value: function onMouseLeaveTooltipContent() {
      if (this.props.autohide) {
        return;
      }
      if (this._showTimeout) {
        this.clearShowTimeout();
      }
      this._hideTimeout = setTimeout(this.hide, this.getDelay('hide'));
    }
  }, {
    key: 'getDelay',
    value: function getDelay(key) {
      var delay = this.props.delay;

      if ((typeof delay === 'undefined' ? 'undefined' : _typeof(delay)) === 'object') {
        return isNaN(delay[key]) ? DEFAULT_DELAYS$1[key] : delay[key];
      }
      return delay;
    }
  }, {
    key: 'show',
    value: function show() {
      if (!this.props.isOpen) {
        this.clearShowTimeout();
        this.toggle();
      }
    }
  }, {
    key: 'hide',
    value: function hide() {
      if (this.props.isOpen) {
        this.clearHideTimeout();
        this.toggle();
      }
    }
  }, {
    key: 'clearShowTimeout',
    value: function clearShowTimeout() {
      clearTimeout(this._showTimeout);
      this._showTimeout = undefined;
    }
  }, {
    key: 'clearHideTimeout',
    value: function clearHideTimeout() {
      clearTimeout(this._hideTimeout);
      this._hideTimeout = undefined;
    }
  }, {
    key: 'handleDocumentClick',
    value: function handleDocumentClick(e) {
      if (e.target === this._target || this._target.contains(e.target)) {
        if (this._hideTimeout) {
          this.clearHideTimeout();
        }

        if (!this.props.isOpen) {
          this.toggle();
        }
      }
    }
  }, {
    key: 'addTargetEvents',
    value: function addTargetEvents() {
      var _this2 = this;

      this._target.addEventListener('mouseover', this.onMouseOverTooltip, true);
      this._target.addEventListener('mouseout', this.onMouseLeaveTooltip, true);
      ['click', 'touchstart'].forEach(function (event) {
        return document.addEventListener(event, _this2.handleDocumentClick, true);
      });
    }
  }, {
    key: 'removeTargetEvents',
    value: function removeTargetEvents() {
      var _this3 = this;

      this._target.removeEventListener('mouseover', this.onMouseOverTooltip, true);
      this._target.removeEventListener('mouseout', this.onMouseLeaveTooltip, true);
      ['click', 'touchstart'].forEach(function (event) {
        return document.removeEventListener(event, _this3.handleDocumentClick, true);
      });
    }
  }, {
    key: 'toggle',
    value: function toggle(e) {
      if (this.props.disabled) {
        return e && e.preventDefault();
      }

      return this.props.toggle();
    }
  }, {
    key: 'render',
    value: function render() {
      if (!this.props.isOpen) {
        return null;
      }

      var attributes = omit(this.props, Object.keys(propTypes$44));
      var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()('tooltip-inner', this.props.innerClassName), this.props.cssModule);

      var popperClasses = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()('tooltip', 'show', this.props.className), this.props.cssModule);

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        PopperContent,
        {
          className: popperClasses,
          target: this.props.target,
          isOpen: this.props.isOpen,
          placement: this.props.placement,
          placementPrefix: this.props.placementPrefix,
          container: this.props.container,
          modifiers: this.props.modifiers
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', _extends({}, attributes, {
          className: classes,
          onMouseOver: this.onMouseOverTooltipContent,
          onMouseLeave: this.onMouseLeaveTooltipContent
        }))
      );
    }
  }]);
  return Tooltip;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Tooltip.propTypes = propTypes$44;
Tooltip.defaultProps = defaultProps$42;

var propTypes$45 = {
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  size: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  bordered: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  striped: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  inverse: deprecated(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool, 'Please use the prop "dark"'),
  dark: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  hover: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  responsive: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  responsiveTag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string])
};

var defaultProps$43 = {
  tag: 'table',
  responsiveTag: 'div'
};

var Table = function Table(props) {
  var className = props.className,
      cssModule = props.cssModule,
      size = props.size,
      bordered = props.bordered,
      striped = props.striped,
      inverse = props.inverse,
      dark = props.dark,
      hover = props.hover,
      responsive = props.responsive,
      Tag = props.tag,
      ResponsiveTag = props.responsiveTag,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'size', 'bordered', 'striped', 'inverse', 'dark', 'hover', 'responsive', 'tag', 'responsiveTag']);


  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'table', size ? 'table-' + size : false, bordered ? 'table-bordered' : false, striped ? 'table-striped' : false, dark || inverse ? 'table-dark' : false, hover ? 'table-hover' : false), cssModule);

  var table = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));

  if (responsive) {
    var responsiveClassName = responsive === true ? 'table-responsive' : 'table-responsive-' + responsive;

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      ResponsiveTag,
      { className: responsiveClassName },
      table
    );
  }

  return table;
};

Table.propTypes = propTypes$45;
Table.defaultProps = defaultProps$43;

var propTypes$46 = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  flush: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps$44 = {
  tag: 'ul'
};

var ListGroup = function ListGroup(props) {
  var className = props.className,
      cssModule = props.cssModule,
      Tag = props.tag,
      flush = props.flush,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'tag', 'flush']);

  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'list-group', flush ? 'list-group-flush' : false), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

ListGroup.propTypes = propTypes$46;
ListGroup.defaultProps = defaultProps$44;

var propTypes$47 = {
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  inline: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  innerRef: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps$45 = {
  tag: 'form'
};

var Form = function Form(props) {
  var className = props.className,
      cssModule = props.cssModule,
      inline = props.inline,
      Tag = props.tag,
      innerRef = props.innerRef,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'inline', 'tag', 'innerRef']);


  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, inline ? 'form-inline' : false), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { ref: innerRef, className: classes }));
};

Form.propTypes = propTypes$47;
Form.defaultProps = defaultProps$45;

var propTypes$48 = {
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps$46 = {
  tag: 'div'
};

var FormFeedback = function FormFeedback(props) {
  var className = props.className,
      cssModule = props.cssModule,
      Tag = props.tag,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'tag']);


  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'invalid-feedback'), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

FormFeedback.propTypes = propTypes$48;
FormFeedback.defaultProps = defaultProps$46;

var propTypes$49 = {
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  row: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  check: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  inline: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  disabled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps$47 = {
  tag: 'div'
};

var FormGroup = function FormGroup(props) {
  var className = props.className,
      cssModule = props.cssModule,
      row = props.row,
      disabled = props.disabled,
      check = props.check,
      inline = props.inline,
      Tag = props.tag,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'row', 'disabled', 'check', 'inline', 'tag']);


  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, row ? 'row' : false, check ? 'form-check' : 'form-group', check && inline ? 'form-check-inline' : false, check && disabled ? 'disabled' : false), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

FormGroup.propTypes = propTypes$49;
FormGroup.defaultProps = defaultProps$47;

var propTypes$50 = {
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  inline: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  color: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps$48 = {
  tag: 'small',
  color: 'muted'
};

var FormText = function FormText(props) {
  var className = props.className,
      cssModule = props.cssModule,
      inline = props.inline,
      color = props.color,
      Tag = props.tag,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'inline', 'color', 'tag']);


  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, !inline ? 'form-text' : false, color ? 'text-' + color : false), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

FormText.propTypes = propTypes$50;
FormText.defaultProps = defaultProps$48;

/* eslint react/prefer-stateless-function: 0 */

var propTypes$51 = {
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  type: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  size: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  bsSize: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  state: deprecated(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, 'Please use the prop "valid"'),
  valid: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  innerRef: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  static: deprecated(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool, 'Please use the prop "plaintext"'),
  plaintext: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  addon: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps$49 = {
  type: 'text'
};

var Input = function (_React$Component) {
  inherits(Input, _React$Component);

  function Input() {
    classCallCheck(this, Input);
    return possibleConstructorReturn(this, (Input.__proto__ || Object.getPrototypeOf(Input)).apply(this, arguments));
  }

  createClass(Input, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          className = _props.className,
          cssModule = _props.cssModule,
          type = _props.type,
          bsSize = _props.bsSize,
          state = _props.state,
          valid = _props.valid,
          tag = _props.tag,
          addon = _props.addon,
          staticInput = _props.static,
          plaintext = _props.plaintext,
          innerRef = _props.innerRef,
          attributes = objectWithoutProperties(_props, ['className', 'cssModule', 'type', 'bsSize', 'state', 'valid', 'tag', 'addon', 'static', 'plaintext', 'innerRef']);


      var checkInput = ['radio', 'checkbox'].indexOf(type) > -1;
      var isNotaNumber = new RegExp('\\D', 'g');

      var fileInput = type === 'file';
      var textareaInput = type === 'textarea';
      var selectInput = type === 'select';
      var Tag = tag || (selectInput || textareaInput ? type : 'input');

      var formControlClass = 'form-control';

      if (plaintext || staticInput) {
        formControlClass = formControlClass + '-plaintext';
        Tag = tag || 'p';
      } else if (fileInput) {
        formControlClass = formControlClass + '-file';
      } else if (checkInput) {
        if (addon) {
          formControlClass = null;
        } else {
          formControlClass = 'form-check-input';
        }
      }

      if (state && typeof valid === 'undefined') {
        if (state === 'danger') {
          valid = false;
        } else if (state === 'success') {
          valid = true;
        }
      }

      if (attributes.size && isNotaNumber.test(attributes.size)) {
        warnOnce('Please use the prop "bsSize" instead of the "size" to bootstrap\'s input sizing.');
        bsSize = attributes.size;
        delete attributes.size;
      }

      var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, valid === false && 'is-invalid', valid && 'is-valid', bsSize ? 'form-control-' + bsSize : false, formControlClass), cssModule);

      if (Tag === 'input' || typeof tag !== 'string') {
        attributes.type = type;
      }

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { ref: innerRef, className: classes }));
    }
  }]);
  return Input;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Input.propTypes = propTypes$51;
Input.defaultProps = defaultProps$49;

var propTypes$52 = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  size: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps$50 = {
  tag: 'div'
};

var InputGroup = function InputGroup(props) {
  var className = props.className,
      cssModule = props.cssModule,
      Tag = props.tag,
      size = props.size,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'tag', 'size']);

  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'input-group', size ? 'input-group-' + size : null), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

InputGroup.propTypes = propTypes$52;
InputGroup.defaultProps = defaultProps$50;

var propTypes$54 = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps$52 = {
  tag: 'span'
};

var InputGroupText = function InputGroupText(props) {
  var className = props.className,
      cssModule = props.cssModule,
      Tag = props.tag,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'tag']);


  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'input-group-text'), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

InputGroupText.propTypes = propTypes$54;
InputGroupText.defaultProps = defaultProps$52;

var propTypes$53 = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  addonType: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['prepend', 'append']).isRequired,
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps$51 = {
  tag: 'div'
};

var InputGroupAddon = function InputGroupAddon(props) {
  var className = props.className,
      cssModule = props.cssModule,
      Tag = props.tag,
      addonType = props.addonType,
      children = props.children,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'tag', 'addonType', 'children']);


  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'input-group-' + addonType), cssModule);

  // Convenience to assist with transition
  if (typeof children === 'string') {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      Tag,
      _extends({}, attributes, { className: classes }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(InputGroupText, { children: children })
    );
  }

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes, children: children }));
};

InputGroupAddon.propTypes = propTypes$53;
InputGroupAddon.defaultProps = defaultProps$51;

var propTypes$55 = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  addonType: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['prepend', 'append']).isRequired,
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  groupClassName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  groupAttributes: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var InputGroupButton = function InputGroupButton(props) {
  warnOnce('The "InputGroupButton" component has been deprecated.\nPlease use component "InputGroupAddon".');

  var children = props.children,
      groupClassName = props.groupClassName,
      groupAttributes = props.groupAttributes,
      propsWithoutGroup = objectWithoutProperties(props, ['children', 'groupClassName', 'groupAttributes']);


  if (typeof children === 'string') {
    var cssModule = propsWithoutGroup.cssModule,
        tag = propsWithoutGroup.tag,
        addonType = propsWithoutGroup.addonType,
        attributes = objectWithoutProperties(propsWithoutGroup, ['cssModule', 'tag', 'addonType']);


    var allGroupAttributes = _extends({}, groupAttributes, {
      cssModule: cssModule,
      tag: tag,
      addonType: addonType
    });

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      InputGroupAddon,
      _extends({}, allGroupAttributes, { className: groupClassName }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Button, _extends({}, attributes, { children: children }))
    );
  }

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(InputGroupAddon, _extends({}, props, { children: children }));
};

InputGroupButton.propTypes = propTypes$55;

var propTypes$56 = {
  addonType: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['prepend', 'append']).isRequired,
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node
};

var InputGroupButtonDropdown = function InputGroupButtonDropdown(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Dropdown, props);
};

InputGroupButtonDropdown.propTypes = propTypes$56;

var colWidths$1 = ['xs', 'sm', 'md', 'lg', 'xl'];

var stringOrNumberProp$1 = __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]);

var columnProps$1 = __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
  size: stringOrNumberProp$1,
  push: deprecated(stringOrNumberProp$1, 'Please use the prop "order"'),
  pull: deprecated(stringOrNumberProp$1, 'Please use the prop "order"'),
  order: stringOrNumberProp$1,
  offset: stringOrNumberProp$1
})]);

var propTypes$57 = {
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  hidden: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  check: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  size: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  for: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  xs: columnProps$1,
  sm: columnProps$1,
  md: columnProps$1,
  lg: columnProps$1,
  xl: columnProps$1,
  widths: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array
};

var defaultProps$53 = {
  tag: 'label',
  widths: colWidths$1
};

var getColumnSizeClass$1 = function getColumnSizeClass(isXs, colWidth, colSize) {
  if (colSize === true || colSize === '') {
    return isXs ? 'col' : 'col-' + colWidth;
  } else if (colSize === 'auto') {
    return isXs ? 'col-auto' : 'col-' + colWidth + '-auto';
  }

  return isXs ? 'col-' + colSize : 'col-' + colWidth + '-' + colSize;
};

var Label = function Label(props) {
  var className = props.className,
      cssModule = props.cssModule,
      hidden = props.hidden,
      widths = props.widths,
      Tag = props.tag,
      check = props.check,
      size = props.size,
      htmlFor = props.for,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'hidden', 'widths', 'tag', 'check', 'size', 'for']);


  var colClasses = [];

  widths.forEach(function (colWidth, i) {
    var columnProp = props[colWidth];

    delete attributes[colWidth];

    if (!columnProp && columnProp !== '') {
      return;
    }

    var isXs = !i;
    var colClass = void 0;

    if (__WEBPACK_IMPORTED_MODULE_4_lodash_isobject___default()(columnProp)) {
      var _classNames;

      var colSizeInterfix = isXs ? '-' : '-' + colWidth + '-';
      colClass = getColumnSizeClass$1(isXs, colWidth, columnProp.size);

      colClasses.push(mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()((_classNames = {}, defineProperty(_classNames, colClass, columnProp.size || columnProp.size === ''), defineProperty(_classNames, 'order' + colSizeInterfix + columnProp.order, columnProp.order || columnProp.order === 0), defineProperty(_classNames, 'offset' + colSizeInterfix + columnProp.offset, columnProp.offset || columnProp.offset === 0), _classNames))), cssModule);
    } else {
      colClass = getColumnSizeClass$1(isXs, colWidth, columnProp);
      colClasses.push(colClass);
    }
  });

  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, hidden ? 'sr-only' : false, check ? 'form-check-label' : false, size ? 'col-form-label-' + size : false, colClasses, colClasses.length ? 'col-form-label' : false), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({ htmlFor: htmlFor }, attributes, { className: classes }));
};

Label.propTypes = propTypes$57;
Label.defaultProps = defaultProps$53;

var propTypes$58 = {
  body: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  bottom: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  heading: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  left: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  list: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  middle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  object: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  right: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  top: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
};

var Media = function Media(props) {
  var body = props.body,
      bottom = props.bottom,
      className = props.className,
      cssModule = props.cssModule,
      heading = props.heading,
      left = props.left,
      list = props.list,
      middle = props.middle,
      object = props.object,
      right = props.right,
      tag = props.tag,
      top = props.top,
      attributes = objectWithoutProperties(props, ['body', 'bottom', 'className', 'cssModule', 'heading', 'left', 'list', 'middle', 'object', 'right', 'tag', 'top']);


  var defaultTag = void 0;
  if (heading) {
    defaultTag = 'h4';
  } else if (left || right) {
    defaultTag = 'a';
  } else if (object) {
    defaultTag = 'img';
  } else if (list) {
    defaultTag = 'ul';
  } else {
    defaultTag = 'div';
  }
  var Tag = tag || defaultTag;

  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, {
    'media-body': body,
    'media-heading': heading,
    'media-left': left,
    'media-right': right,
    'media-top': top,
    'media-bottom': bottom,
    'media-middle': middle,
    'media-object': object,
    'media-list': list,
    media: !body && !heading && !left && !right && !top && !bottom && !middle && !object && !list
  }), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

Media.propTypes = propTypes$58;

var propTypes$59 = {
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  size: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string])
};

var defaultProps$54 = {
  tag: 'ul'
};

var Pagination = function Pagination(props) {
  var className = props.className,
      cssModule = props.cssModule,
      size = props.size,
      Tag = props.tag,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'size', 'tag']);


  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'pagination', defineProperty({}, 'pagination-' + size, !!size)), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

Pagination.propTypes = propTypes$59;
Pagination.defaultProps = defaultProps$54;

var propTypes$60 = {
  active: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  disabled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string])
};

var defaultProps$55 = {
  tag: 'li'
};

var PaginationItem = function PaginationItem(props) {
  var active = props.active,
      className = props.className,
      cssModule = props.cssModule,
      disabled = props.disabled,
      Tag = props.tag,
      attributes = objectWithoutProperties(props, ['active', 'className', 'cssModule', 'disabled', 'tag']);


  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'page-item', {
    active: active,
    disabled: disabled
  }), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

PaginationItem.propTypes = propTypes$60;
PaginationItem.defaultProps = defaultProps$55;

var propTypes$61 = {
  'aria-label': __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  next: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  previous: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string])
};

var defaultProps$56 = {
  tag: 'a'
};

var PaginationLink = function PaginationLink(props) {
  var className = props.className,
      cssModule = props.cssModule,
      next = props.next,
      previous = props.previous,
      Tag = props.tag,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'next', 'previous', 'tag']);


  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'page-link'), cssModule);

  var defaultAriaLabel = void 0;
  if (previous) {
    defaultAriaLabel = 'Previous';
  } else if (next) {
    defaultAriaLabel = 'Next';
  }
  var ariaLabel = props['aria-label'] || defaultAriaLabel;

  var defaultCaret = void 0;
  if (previous) {
    defaultCaret = '\xAB';
  } else if (next) {
    defaultCaret = '\xBB';
  }

  var children = props.children;
  if (children && Array.isArray(children) && children.length === 0) {
    children = null;
  }

  if (previous || next) {
    children = [__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'span',
      {
        'aria-hidden': 'true',
        key: 'caret'
      },
      children || defaultCaret
    ), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'span',
      {
        className: 'sr-only',
        key: 'sr'
      },
      ariaLabel
    )];
  }

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    Tag,
    _extends({}, attributes, {
      className: classes,
      'aria-label': ariaLabel
    }),
    children
  );
};

PaginationLink.propTypes = propTypes$61;
PaginationLink.defaultProps = defaultProps$56;

var propTypes$62 = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  activeTab: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps$57 = {
  tag: 'div'
};

var childContextTypes$2 = {
  activeTabId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any
};

var TabContent = function (_Component) {
  inherits(TabContent, _Component);

  function TabContent(props) {
    classCallCheck(this, TabContent);

    var _this = possibleConstructorReturn(this, (TabContent.__proto__ || Object.getPrototypeOf(TabContent)).call(this, props));

    _this.state = {
      activeTab: _this.props.activeTab
    };
    return _this;
  }

  createClass(TabContent, [{
    key: 'getChildContext',
    value: function getChildContext() {
      return {
        activeTabId: this.state.activeTab
      };
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (this.state.activeTab !== nextProps.activeTab) {
        this.setState({
          activeTab: nextProps.activeTab
        });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          className = _props.className,
          cssModule = _props.cssModule,
          Tag = _props.tag;


      var attributes = omit(this.props, Object.keys(propTypes$62));

      var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()('tab-content', className), cssModule);

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
    }
  }]);
  return TabContent;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

TabContent.propTypes = propTypes$62;
TabContent.defaultProps = defaultProps$57;
TabContent.childContextTypes = childContextTypes$2;

var propTypes$63 = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  tabId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any
};

var defaultProps$58 = {
  tag: 'div'
};

var contextTypes$3 = {
  activeTabId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any
};

function TabPane(props, context) {
  var className = props.className,
      cssModule = props.cssModule,
      tabId = props.tabId,
      Tag = props.tag,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'tabId', 'tag']);

  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()('tab-pane', className, { active: tabId === context.activeTabId }), cssModule);
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
}
TabPane.propTypes = propTypes$63;
TabPane.defaultProps = defaultProps$58;
TabPane.contextTypes = contextTypes$3;

var propTypes$64 = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  fluid: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps$59 = {
  tag: 'div'
};

var Jumbotron = function Jumbotron(props) {
  var className = props.className,
      cssModule = props.cssModule,
      Tag = props.tag,
      fluid = props.fluid,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'tag', 'fluid']);


  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'jumbotron', fluid ? 'jumbotron-fluid' : false), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

Jumbotron.propTypes = propTypes$64;
Jumbotron.defaultProps = defaultProps$59;

var propTypes$65 = {
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  closeClassName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  closeAriaLabel: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  color: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  isOpen: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  toggle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  transition: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape(Fade.propTypes)
};

var defaultProps$60 = {
  color: 'success',
  isOpen: true,
  tag: 'div',
  closeAriaLabel: 'Close',
  transition: _extends({}, Fade.defaultProps, {
    unmountOnExit: true
  })
};

function Alert(props) {
  var className = props.className,
      closeClassName = props.closeClassName,
      closeAriaLabel = props.closeAriaLabel,
      cssModule = props.cssModule,
      Tag = props.tag,
      color = props.color,
      isOpen = props.isOpen,
      toggle = props.toggle,
      children = props.children,
      transition = props.transition,
      attributes = objectWithoutProperties(props, ['className', 'closeClassName', 'closeAriaLabel', 'cssModule', 'tag', 'color', 'isOpen', 'toggle', 'children', 'transition']);


  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'alert', 'alert-' + color, { 'alert-dismissible': toggle }), cssModule);

  var closeClasses = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()('close', closeClassName), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    Fade,
    _extends({}, attributes, transition, { tag: Tag, className: classes, 'in': isOpen, role: 'alert' }),
    toggle ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'button',
      { type: 'button', className: closeClasses, 'aria-label': closeAriaLabel, onClick: toggle },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'span',
        { 'aria-hidden': 'true' },
        '\xD7'
      )
    ) : null,
    children
  );
}

Alert.propTypes = propTypes$65;
Alert.defaultProps = defaultProps$60;

var _transitionStatusToCl;

var propTypes$66 = _extends({}, Transition.propTypes, {
  isOpen: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node), __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node]),
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  navbar: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
});

var defaultProps$61 = _extends({}, Transition.defaultProps, {
  isOpen: false,
  appear: false,
  enter: true,
  exit: true,
  tag: 'div',
  timeout: TransitionTimeouts.Collapse
});

var transitionStatusToClassHash = (_transitionStatusToCl = {}, defineProperty(_transitionStatusToCl, TransitionStatuses.ENTERING, 'collapsing'), defineProperty(_transitionStatusToCl, TransitionStatuses.ENTERED, 'collapse show'), defineProperty(_transitionStatusToCl, TransitionStatuses.EXITING, 'collapsing'), defineProperty(_transitionStatusToCl, TransitionStatuses.EXITED, 'collapse'), _transitionStatusToCl);

function getTransitionClass(status) {
  return transitionStatusToClassHash[status] || 'collapse';
}

function getHeight(node) {
  return node.scrollHeight;
}

var Collapse = function (_Component) {
  inherits(Collapse, _Component);

  function Collapse(props) {
    classCallCheck(this, Collapse);

    var _this = possibleConstructorReturn(this, (Collapse.__proto__ || Object.getPrototypeOf(Collapse)).call(this, props));

    _this.state = {
      height: null
    };

    ['onEntering', 'onEntered', 'onExit', 'onExiting', 'onExited'].forEach(function (name) {
      _this[name] = _this[name].bind(_this);
    });
    return _this;
  }

  createClass(Collapse, [{
    key: 'onEntering',
    value: function onEntering(node, isAppearing) {
      this.setState({ height: getHeight(node) });
      this.props.onEntering(node, isAppearing);
    }
  }, {
    key: 'onEntered',
    value: function onEntered(node, isAppearing) {
      this.setState({ height: null });
      this.props.onEntered(node, isAppearing);
    }
  }, {
    key: 'onExit',
    value: function onExit(node) {
      this.setState({ height: getHeight(node) });
      this.props.onExit(node);
    }
  }, {
    key: 'onExiting',
    value: function onExiting(node) {
      // getting this variable triggers a reflow
      var _unused = node.offsetHeight; // eslint-disable-line no-unused-vars
      this.setState({ height: 0 });
      this.props.onExiting(node);
    }
  }, {
    key: 'onExited',
    value: function onExited(node) {
      this.setState({ height: null });
      this.props.onExited(node);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          Tag = _props.tag,
          isOpen = _props.isOpen,
          className = _props.className,
          navbar = _props.navbar,
          cssModule = _props.cssModule,
          children = _props.children,
          otherProps = objectWithoutProperties(_props, ['tag', 'isOpen', 'className', 'navbar', 'cssModule', 'children']);
      var height = this.state.height;

      // In NODE_ENV=production the Transition.propTypes are wrapped which results in an
      // empty object "{}". This is the result of the `react-transition-group` babel
      // configuration settings. Therefore, to ensure that production builds work without
      // error, we can either explicitly define keys or use the Transition.defaultProps.
      // Using the Transition.defaultProps excludes any required props. Thus, the best
      // solution is to explicitly define required props in our utilities and reference these.
      // This also gives us more flexibility in the future to remove the prop-types
      // dependency in distribution builds (Similar to how `react-transition-group` does).
      // Note: Without omitting the `react-transition-group` props, the resulting child
      // Tag component would inherit the Transition properties as attributes for the HTML
      // element which results in errors/warnings for non-valid attributes.

      var transitionProps = pick(otherProps, TransitionPropTypeKeys);
      var childProps = omit(otherProps, TransitionPropTypeKeys);

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        Transition,
        _extends({}, transitionProps, {
          'in': isOpen,
          onEntering: this.onEntering,
          onEntered: this.onEntered,
          onExit: this.onExit,
          onExiting: this.onExiting,
          onExited: this.onExited
        }),
        function (status) {
          var collapseClass = getTransitionClass(status);
          var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, collapseClass, navbar && 'navbar-collapse'), cssModule);
          var style = height === null ? null : { height: height };
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            Tag,
            _extends({}, childProps, {
              style: _extends({}, childProps.style, style),
              className: classes
            }),
            children
          );
        }
      );
    }
  }]);
  return Collapse;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

Collapse.propTypes = propTypes$66;
Collapse.defaultProps = defaultProps$61;

var propTypes$67 = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  active: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  disabled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  color: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  action: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps$62 = {
  tag: 'li'
};

var handleDisabledOnClick = function handleDisabledOnClick(e) {
  e.preventDefault();
};

var ListGroupItem = function ListGroupItem(props) {
  var className = props.className,
      cssModule = props.cssModule,
      Tag = props.tag,
      active = props.active,
      disabled = props.disabled,
      action = props.action,
      color = props.color,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'tag', 'active', 'disabled', 'action', 'color']);

  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, active ? 'active' : false, disabled ? 'disabled' : false, action ? 'list-group-item-action' : false, color ? 'list-group-item-' + color : false, 'list-group-item'), cssModule);

  // Prevent click event when disabled.
  if (disabled) {
    attributes.onClick = handleDisabledOnClick;
  }
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

ListGroupItem.propTypes = propTypes$67;
ListGroupItem.defaultProps = defaultProps$62;

var propTypes$68 = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps$63 = {
  tag: 'h5'
};

var ListGroupItemHeading = function ListGroupItemHeading(props) {
  var className = props.className,
      cssModule = props.cssModule,
      Tag = props.tag,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'tag']);

  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'list-group-item-heading'), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

ListGroupItemHeading.propTypes = propTypes$68;
ListGroupItemHeading.defaultProps = defaultProps$63;

var propTypes$69 = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps$64 = {
  tag: 'p'
};

var ListGroupItemText = function ListGroupItemText(props) {
  var className = props.className,
      cssModule = props.cssModule,
      Tag = props.tag,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'tag']);

  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'list-group-item-text'), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

ListGroupItemText.propTypes = propTypes$69;
ListGroupItemText.defaultProps = defaultProps$64;

var UncontrolledAlert = function (_Component) {
  inherits(UncontrolledAlert, _Component);

  function UncontrolledAlert(props) {
    classCallCheck(this, UncontrolledAlert);

    var _this = possibleConstructorReturn(this, (UncontrolledAlert.__proto__ || Object.getPrototypeOf(UncontrolledAlert)).call(this, props));

    _this.state = { isOpen: true };
    _this.toggle = _this.toggle.bind(_this);
    return _this;
  }

  createClass(UncontrolledAlert, [{
    key: 'toggle',
    value: function toggle() {
      this.setState({ isOpen: !this.state.isOpen });
    }
  }, {
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Alert, _extends({ isOpen: this.state.isOpen, toggle: this.toggle }, this.props));
    }
  }]);
  return UncontrolledAlert;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

var UncontrolledButtonDropdown = function (_Component) {
  inherits(UncontrolledButtonDropdown, _Component);

  function UncontrolledButtonDropdown(props) {
    classCallCheck(this, UncontrolledButtonDropdown);

    var _this = possibleConstructorReturn(this, (UncontrolledButtonDropdown.__proto__ || Object.getPrototypeOf(UncontrolledButtonDropdown)).call(this, props));

    _this.state = { isOpen: false };
    _this.toggle = _this.toggle.bind(_this);
    return _this;
  }

  createClass(UncontrolledButtonDropdown, [{
    key: 'toggle',
    value: function toggle() {
      this.setState({ isOpen: !this.state.isOpen });
    }
  }, {
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ButtonDropdown, _extends({ isOpen: this.state.isOpen, toggle: this.toggle }, this.props));
    }
  }]);
  return UncontrolledButtonDropdown;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

var UncontrolledDropdown = function (_Component) {
  inherits(UncontrolledDropdown, _Component);

  function UncontrolledDropdown(props) {
    classCallCheck(this, UncontrolledDropdown);

    var _this = possibleConstructorReturn(this, (UncontrolledDropdown.__proto__ || Object.getPrototypeOf(UncontrolledDropdown)).call(this, props));

    _this.state = { isOpen: false };
    _this.toggle = _this.toggle.bind(_this);
    return _this;
  }

  createClass(UncontrolledDropdown, [{
    key: 'toggle',
    value: function toggle() {
      this.setState({ isOpen: !this.state.isOpen });
    }
  }, {
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Dropdown, _extends({ isOpen: this.state.isOpen, toggle: this.toggle }, this.props));
    }
  }]);
  return UncontrolledDropdown;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

var UncontrolledNavDropdown = function (_Component) {
  inherits(UncontrolledNavDropdown, _Component);

  function UncontrolledNavDropdown(props) {
    classCallCheck(this, UncontrolledNavDropdown);

    var _this = possibleConstructorReturn(this, (UncontrolledNavDropdown.__proto__ || Object.getPrototypeOf(UncontrolledNavDropdown)).call(this, props));

    _this.state = { isOpen: false };
    _this.toggle = _this.toggle.bind(_this);
    return _this;
  }

  createClass(UncontrolledNavDropdown, [{
    key: 'toggle',
    value: function toggle() {
      this.setState({ isOpen: !this.state.isOpen });
    }
  }, {
    key: 'render',
    value: function render() {
      warnOnce('The "UncontrolledNavDropdown" component has been deprecated.\nPlease use component "UncontrolledDropdown" with nav prop.');

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(NavDropdown, _extends({ isOpen: this.state.isOpen, toggle: this.toggle }, this.props));
    }
  }]);
  return UncontrolledNavDropdown;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

var UncontrolledTooltip = function (_Component) {
  inherits(UncontrolledTooltip, _Component);

  function UncontrolledTooltip(props) {
    classCallCheck(this, UncontrolledTooltip);

    var _this = possibleConstructorReturn(this, (UncontrolledTooltip.__proto__ || Object.getPrototypeOf(UncontrolledTooltip)).call(this, props));

    _this.state = { isOpen: false };
    _this.toggle = _this.toggle.bind(_this);
    return _this;
  }

  createClass(UncontrolledTooltip, [{
    key: 'toggle',
    value: function toggle() {
      this.setState({ isOpen: !this.state.isOpen });
    }
  }, {
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tooltip, _extends({ isOpen: this.state.isOpen, toggle: this.toggle }, this.props));
    }
  }]);
  return UncontrolledTooltip;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);


//# sourceMappingURL=reactstrap.es.js.map


/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

function makeEmptyFunction(arg) {
  return function () {
    return arg;
  };
}

/**
 * This function accepts and discards inputs; it has no side effects. This is
 * primarily useful idiomatically for overridable function endpoints which
 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
 */
var emptyFunction = function emptyFunction() {};

emptyFunction.thatReturns = makeEmptyFunction;
emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
emptyFunction.thatReturnsNull = makeEmptyFunction(null);
emptyFunction.thatReturnsThis = function () {
  return this;
};
emptyFunction.thatReturnsArgument = function (arg) {
  return arg;
};

module.exports = emptyFunction;

/***/ }),
/* 6 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 7 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/


/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

module.exports = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};


/***/ }),
/* 9 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return MONSTERS; });
/* unused harmony export MONSTER_LIST */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BOSS_STATS; });
/* unused harmony export BOSS_CARDS */
/* unused harmony export BOSS_LIST */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__aoe_circle_svg__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__aoe_circle_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__aoe_circle_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__aoe_circle_with_middle_black_svg__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__aoe_circle_with_middle_black_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__aoe_circle_with_middle_black_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__aoe_circle_with_side_black_svg__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__aoe_circle_with_side_black_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__aoe_circle_with_side_black_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__aoe_triangle_2_svg__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__aoe_triangle_2_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__aoe_triangle_2_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__aoe_triangle_2_with_black_svg__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__aoe_triangle_2_with_black_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__aoe_triangle_2_with_black_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__aoe_triangle_3_with_corner_black_svg__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__aoe_triangle_3_with_corner_black_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__aoe_triangle_3_with_corner_black_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__aoe_line_3_with_black_svg__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__aoe_line_3_with_black_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__aoe_line_3_with_black_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__aoe_line_4_with_black_svg__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__aoe_line_4_with_black_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__aoe_line_4_with_black_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__aoe_line_6_with_black_svg__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__aoe_line_6_with_black_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__aoe_line_6_with_black_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__aoe_4_with_black_svg__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__aoe_4_with_black_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__aoe_4_with_black_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__elderDrakeSpecial1Area_svg__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__elderDrakeSpecial1Area_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__elderDrakeSpecial1Area_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__inoxBodyguardSpecial1Area_svg__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__inoxBodyguardSpecial1Area_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__inoxBodyguardSpecial1Area_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__sightlessEyeSpecial1Area_svg__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__sightlessEyeSpecial1Area_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__sightlessEyeSpecial1Area_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__sightlessEyeSpecial2Area_svg__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__sightlessEyeSpecial2Area_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__sightlessEyeSpecial2Area_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__cards__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__elements__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__statusEffects__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__actions__ = __webpack_require__(17);
var ARCHER_CARDS=[{initiative:29,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["c" /* MOVE */],"+0"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"-1",[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["e" /* RANGE */],"+1"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["d" /* IMMOBILIZE */])])],endAction:__WEBPACK_IMPORTED_MODULE_14__cards__["a" /* END_ACTIONS */].SHUFFLE},{initiative:16,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["c" /* MOVE */],"+1"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"-1")]},{initiative:56,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"-1",[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["h" /* TARGET */],"2")])]},{initiative:68,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"+1",[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["e" /* RANGE */],"+1")])],endAction:__WEBPACK_IMPORTED_MODULE_14__cards__["a" /* END_ACTIONS */].SHUFFLE},{initiative:32,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["c" /* MOVE */],"+0"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"+1",[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["e" /* RANGE */],"-1")])]},{initiative:44,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["c" /* MOVE */],"-1"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"+1")]},{initiative:14,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["c" /* MOVE */],"-1"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"-1"),"Create a 3 damage trap in an adjacent empty hex closest to an enemy."]},{initiative:31,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["c" /* MOVE */],"+0"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"+0")]}];var GUARD_CARDS=[{initiative:70,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["c" /* MOVE */],"-1"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"+1")]},{initiative:30,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["c" /* MOVE */],"+1"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"-1")]},{initiative:50,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["c" /* MOVE */],"+0"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"+0")]},{initiative:15,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* SHIELD */],"1"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["f" /* RETALIATE */],"2")],endAction:__WEBPACK_IMPORTED_MODULE_14__cards__["a" /* END_ACTIONS */].SHUFFLE},{initiative:15,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* SHIELD */],"1"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"+0",[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["g" /* POISON */])])],endAction:__WEBPACK_IMPORTED_MODULE_14__cards__["a" /* END_ACTIONS */].SHUFFLE},{initiative:55,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["c" /* MOVE */],"-1"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"+0"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["j" /* STRENGTHEN */],null,["Self"])]},{initiative:50,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["c" /* MOVE */],"+0"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"+0")]}];var IMP_CARDS=[{initiative:24,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["j" /* STRENGTHEN */],null,["Affect all allies within range 2"]),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["f" /* MUDDLE */],null,["Target all enemies within range 2"])]},{initiative:43,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["c" /* MOVE */],"+0"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"-1",[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["h" /* TARGET */],"2"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["b" /* CURSE */])])],endAction:__WEBPACK_IMPORTED_MODULE_14__cards__["a" /* END_ACTIONS */].SHUFFLE},{initiative:76,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["c" /* MOVE */],"-1"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"+1")]},{initiative:43,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["c" /* MOVE */],"+0"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"-1",[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["h" /* TARGET */],"2"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["g" /* POISON */])])],endAction:__WEBPACK_IMPORTED_MODULE_14__cards__["a" /* END_ACTIONS */].SHUFFLE},{initiative:42,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["c" /* MOVE */],"+1"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["b" /* HEAL */],"2",[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["e" /* RANGE */],"3")])]},{initiative:5,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* SHIELD */],"5"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["b" /* HEAL */],"1",["Self"])]},{initiative:37,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["c" /* MOVE */],"+0"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"+0")]},{initiative:37,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["c" /* MOVE */],"+0"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"+0")]}];var SHAMAN_CARDS=[{initiative:8,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["c" /* MOVE */],"+0"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"-1",[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["c" /* DISARM */])])]},{initiative:9,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["c" /* MOVE */],"+1"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"-1",[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["b" /* CURSE */]),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["h" /* TARGET */],"2")])]},{initiative:23,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["c" /* MOVE */],"+0"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["b" /* HEAL */],"3",[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["e" /* RANGE */],"3")])],endAction:__WEBPACK_IMPORTED_MODULE_14__cards__["a" /* END_ACTIONS */].SHUFFLE},{initiative:89,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["c" /* MOVE */],"-1"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["b" /* HEAL */],"1",["Affect all adjacent allies"]),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["a" /* BLESS */],null,["Self"])]},{initiative:62,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["c" /* MOVE */],"+0"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"+0")]},{initiative:23,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["c" /* MOVE */],"+0"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["b" /* HEAL */],"3",[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["e" /* RANGE */],"3")])],endAction:__WEBPACK_IMPORTED_MODULE_14__cards__["a" /* END_ACTIONS */].SHUFFLE},{initiative:8,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["c" /* MOVE */],"-1"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"+0"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["d" /* IMMOBILIZE */])]},{initiative:74,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["c" /* MOVE */],"-1"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"+1")]}];var SCOUT_CARDS=[{initiative:29,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["c" /* MOVE */],"-1"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"-1",[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["e" /* RANGE */],"3")])]},{initiative:35,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["c" /* MOVE */],"+1",["jump"]),"loot 1"],endAction:__WEBPACK_IMPORTED_MODULE_14__cards__["a" /* END_ACTIONS */].SHUFFLE},{initiative:40,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["c" /* MOVE */],"+1"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"-1")]},{initiative:53,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["c" /* MOVE */],"+0"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"+0")]},{initiative:54,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["c" /* MOVE */],"-2"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"+0",[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["e" /* RANGE */],"3"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["g" /* POISON */])])]},{initiative:69,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["c" /* MOVE */],"-1"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"+1")]},{initiative:79,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"-1",[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["e" /* RANGE */],"4"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["h" /* TARGET */],"2")])]},{initiative:92,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"+2",[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["g" /* POISON */])])],endAction:__WEBPACK_IMPORTED_MODULE_14__cards__["a" /* END_ACTIONS */].SHUFFLE}];var MONSTERS={"Ancient Artillery":{tokenCount:6,stats:[{normal:{maxHP:4,move:0,attack:2,range:4,extra:[]},elite:{maxHP:7,move:0,attack:3,range:5,extra:[]}},{normal:{maxHP:6,move:0,attack:2,range:4,extra:[]},elite:{maxHP:9,move:0,attack:3,range:5,extra:[]}},{normal:{maxHP:7,move:0,attack:2,range:5,extra:[]},elite:{maxHP:11,move:0,attack:3,range:6,extra:[]}},{normal:{maxHP:8,move:0,attack:3,range:5,extra:[]},elite:{maxHP:13,move:0,attack:4,range:6,extra:[]}},{normal:{maxHP:9,move:0,attack:4,range:5,extra:[]},elite:{maxHP:13,move:0,attack:4,range:6,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["h" /* TARGET */],"2")]}},{normal:{maxHP:11,move:0,attack:4,range:6,extra:[]},elite:{maxHP:15,move:0,attack:4,range:7,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["h" /* TARGET */],"2")]}},{normal:{maxHP:14,move:0,attack:4,range:6,extra:[]},elite:{maxHP:16,move:0,attack:5,range:7,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["h" /* TARGET */],"2")]}},{normal:{maxHP:16,move:0,attack:4,range:7,extra:[]},elite:{maxHP:20,move:0,attack:5,range:7,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["h" /* TARGET */],"2")]}}],cards:[{initiative:17,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["i" /* PUSH */],"2",["Target all adjacent enemies"]),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* SHIELD */],"2"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"-2")]},{initiative:37,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["i" /* PUSH */],"1",["Target all adjacent enemies"]),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"-1",[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["e" /* RANGE */],"-1")],__WEBPACK_IMPORTED_MODULE_0__aoe_circle_svg___default.a)]},{initiative:37,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["i" /* PUSH */],"1",["Target all adjacent enemies"]),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"-1",[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["e" /* RANGE */],"-1")],__WEBPACK_IMPORTED_MODULE_3__aoe_triangle_2_svg___default.a)]},{initiative:46,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"-1",[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["d" /* IMMOBILIZE */])],__WEBPACK_IMPORTED_MODULE_3__aoe_triangle_2_svg___default.a)]},{initiative:46,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"-1",[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["e" /* RANGE */],"+2")])]},{initiative:71,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"+0",["All adjacent enemies suffer 2 damage"])],endAction:__WEBPACK_IMPORTED_MODULE_14__cards__["a" /* END_ACTIONS */].SHUFFLE},{initiative:71,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"+0",["All adjacent enemies suffer 2 damage"])],endAction:__WEBPACK_IMPORTED_MODULE_14__cards__["a" /* END_ACTIONS */].SHUFFLE},{initiative:95,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"+1")]}]},"Bandit Archer":{tokenCount:6,stats:[{normal:{maxHP:4,move:2,attack:2,range:3,extra:[]},elite:{maxHP:6,move:2,attack:3,range:3,extra:[]}},{normal:{maxHP:5,move:2,attack:2,range:4,extra:[]},elite:{maxHP:7,move:2,attack:3,range:5,extra:[]}},{normal:{maxHP:6,move:3,attack:2,range:4,extra:[]},elite:{maxHP:9,move:3,attack:3,range:5,extra:[]}},{normal:{maxHP:6,move:3,attack:3,range:4,extra:[]},elite:{maxHP:10,move:3,attack:4,range:5,extra:[]}},{normal:{maxHP:8,move:3,attack:3,range:4,extra:[]},elite:{maxHP:10,move:3,attack:4,range:6,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["g" /* POISON */])]}},{normal:{maxHP:10,move:3,attack:3,range:5,extra:[]},elite:{maxHP:12,move:4,attack:4,range:6,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["g" /* POISON */])]}},{normal:{maxHP:10,move:3,attack:4,range:5,extra:[]},elite:{maxHP:13,move:4,attack:5,range:6,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["g" /* POISON */])]}},{normal:{maxHP:13,move:3,attack:4,range:5,extra:[]},elite:{maxHP:17,move:4,attack:5,range:6,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["g" /* POISON */])]}}],cards:ARCHER_CARDS},"Bandit Guard":{tokenCount:6,stats:[{normal:{maxHP:5,move:2,attack:2,range:0,extra:[]},elite:{maxHP:9,move:2,attack:3,range:0,extra:[]}},{normal:{maxHP:6,move:3,attack:2,range:0,extra:[]},elite:{maxHP:9,move:2,attack:3,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* SHIELD */],"1")]}},{normal:{maxHP:6,move:3,attack:3,range:0,extra:[]},elite:{maxHP:10,move:2,attack:4,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* SHIELD */],"1")]}},{normal:{maxHP:9,move:3,attack:3,range:0,extra:[]},elite:{maxHP:10,move:3,attack:4,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* SHIELD */],"2")]}},{normal:{maxHP:10,move:4,attack:3,range:0,extra:[]},elite:{maxHP:11,move:3,attack:4,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["f" /* MUDDLE */]),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* SHIELD */],"2")]}},{normal:{maxHP:11,move:4,attack:4,range:0,extra:[]},elite:{maxHP:12,move:3,attack:5,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["f" /* MUDDLE */]),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* SHIELD */],"2")]}},{normal:{maxHP:14,move:4,attack:4,range:0,extra:[]},elite:{maxHP:14,move:4,attack:5,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["f" /* MUDDLE */]),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* SHIELD */],"2")]}},{normal:{maxHP:16,move:5,attack:4,range:0,extra:[]},elite:{maxHP:14,move:3,attack:5,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["f" /* MUDDLE */]),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* SHIELD */],"3")]}}],cards:GUARD_CARDS},"Black Imp":{tokenCount:10,stats:[{normal:{maxHP:3,move:1,attack:1,range:3,extra:[]},elite:{maxHP:4,move:1,attack:2,range:3,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["g" /* POISON */])]}},{normal:{maxHP:4,move:1,attack:1,range:3,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["g" /* POISON */])]},elite:{maxHP:6,move:1,attack:2,range:3,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["g" /* POISON */])]}},{normal:{maxHP:5,move:1,attack:1,range:4,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["g" /* POISON */])]},elite:{maxHP:8,move:1,attack:2,range:4,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["g" /* POISON */])]}},{normal:{maxHP:5,move:1,attack:2,range:4,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["g" /* POISON */])]},elite:{maxHP:8,move:1,attack:3,range:4,extra:["Attackers gain disadvantage",Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["g" /* POISON */])]}},{normal:{maxHP:7,move:1,attack:2,range:4,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["g" /* POISON */])]},elite:{maxHP:11,move:1,attack:3,range:4,extra:["Attackers gain disadvantage",Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["g" /* POISON */])]}},{normal:{maxHP:9,move:1,attack:2,range:4,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["g" /* POISON */])]},elite:{maxHP:12,move:1,attack:3,range:5,extra:["Attackers gain disadvantage",Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["g" /* POISON */])]}},{normal:{maxHP:10,move:1,attack:3,range:4,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["g" /* POISON */])]},elite:{maxHP:14,move:1,attack:4,range:5,extra:["Attackers gain disadvantage",Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["g" /* POISON */])]}},{normal:{maxHP:12,move:1,attack:3,range:4,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["g" /* POISON */])]},elite:{maxHP:17,move:1,attack:4,range:5,extra:["Attackers gain disadvantage",Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["g" /* POISON */])]}}],cards:IMP_CARDS},"Cave Bear":{tokenCount:4,stats:[{normal:{maxHP:7,move:3,attack:3,range:0,extra:[]},elite:{maxHP:11,move:3,attack:4,range:0,extra:[]}},{normal:{maxHP:9,move:3,attack:3,range:0,extra:[]},elite:{maxHP:14,move:3,attack:4,range:0,extra:[]}},{normal:{maxHP:11,move:4,attack:3,range:0,extra:[]},elite:{maxHP:17,move:4,attack:4,range:0,extra:[]}},{normal:{maxHP:13,move:4,attack:4,range:0,extra:[]},elite:{maxHP:20,move:4,attack:5,range:0,extra:[]}},{normal:{maxHP:16,move:4,attack:4,range:0,extra:[]},elite:{maxHP:21,move:5,attack:5,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["l" /* WOUND */])]}},{normal:{maxHP:17,move:5,attack:4,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["l" /* WOUND */])]},elite:{maxHP:24,move:5,attack:6,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["l" /* WOUND */])]}},{normal:{maxHP:19,move:5,attack:5,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["l" /* WOUND */])]},elite:{maxHP:28,move:5,attack:7,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["l" /* WOUND */])]}},{normal:{maxHP:22,move:5,attack:5,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["l" /* WOUND */])]},elite:{maxHP:33,move:5,attack:7,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["l" /* WOUND */])]}}],cards:[{initiative:3,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* SHIELD */],"1"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["f" /* RETALIATE */],"2"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["b" /* HEAL */],"2",["Self"])]},{initiative:13,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["c" /* MOVE */],"+1"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"-1")]},{initiative:14,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["c" /* MOVE */],"-1"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"-1",[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["d" /* IMMOBILIZE */])])]},{initiative:34,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"+1",[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["l" /* WOUND */])])],endAction:__WEBPACK_IMPORTED_MODULE_14__cards__["a" /* END_ACTIONS */].SHUFFLE},{initiative:41,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["c" /* MOVE */],"+0"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"+0")]},{initiative:60,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["c" /* MOVE */],"-1"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"+1")]},{initiative:61,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["c" /* MOVE */],"+0"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"-1",[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["h" /* TARGET */],"2")])]},{initiative:80,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"-1"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["c" /* MOVE */],"-2"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"-1",[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["l" /* WOUND */])])],endAction:__WEBPACK_IMPORTED_MODULE_14__cards__["a" /* END_ACTIONS */].SHUFFLE}]},"City Archer":{tokenCount:6,stats:[{normal:{maxHP:4,move:1,attack:2,range:3,extra:[]},elite:{maxHP:6,move:1,attack:3,range:4,extra:[]}},{normal:{maxHP:5,move:1,attack:2,range:4,extra:[]},elite:{maxHP:6,move:1,attack:3,range:5,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["d" /* PIERCE */],"1"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* SHIELD */],"1")]}},{normal:{maxHP:6,move:1,attack:3,range:4,extra:[]},elite:{maxHP:7,move:1,attack:4,range:5,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["d" /* PIERCE */],"2"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* SHIELD */],"1")]}},{normal:{maxHP:6,move:2,attack:3,range:4,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* SHIELD */],"1")]},elite:{maxHP:8,move:2,attack:4,range:5,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["d" /* PIERCE */],"2"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* SHIELD */],"2")]}},{normal:{maxHP:8,move:2,attack:3,range:5,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* SHIELD */],"1")]},elite:{maxHP:10,move:2,attack:4,range:6,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["d" /* PIERCE */],"2"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* SHIELD */],"2")]}},{normal:{maxHP:9,move:2,attack:4,range:5,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* SHIELD */],"1")]},elite:{maxHP:11,move:2,attack:5,range:6,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["d" /* PIERCE */],"3"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* SHIELD */],"2")]}},{normal:{maxHP:9,move:3,attack:4,range:5,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* SHIELD */],"2")]},elite:{maxHP:12,move:3,attack:6,range:6,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["d" /* PIERCE */],"3"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* SHIELD */],"2")]}},{normal:{maxHP:10,move:3,attack:4,range:6,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* SHIELD */],"2")]},elite:{maxHP:13,move:3,attack:6,range:7,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["d" /* PIERCE */],"3"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* SHIELD */],"3")]}}],cards:ARCHER_CARDS},"City Guard":{tokenCount:6,stats:[{normal:{maxHP:5,move:2,attack:2,range:0,extra:[]},elite:{maxHP:6,move:2,attack:3,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* SHIELD */],"1")]}},{normal:{maxHP:5,move:2,attack:2,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* SHIELD */],"1")]},elite:{maxHP:6,move:2,attack:3,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* SHIELD */],"2")]}},{normal:{maxHP:7,move:2,attack:2,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* SHIELD */],"1")]},elite:{maxHP:9,move:2,attack:3,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* SHIELD */],"2")]}},{normal:{maxHP:8,move:2,attack:3,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* SHIELD */],"1")]},elite:{maxHP:9,move:2,attack:4,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["f" /* RETALIATE */],"1"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* SHIELD */],"2")]}},{normal:{maxHP:9,move:3,attack:3,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* SHIELD */],"1")]},elite:{maxHP:10,move:3,attack:4,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["f" /* RETALIATE */],"2"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* SHIELD */],"2")]}},{normal:{maxHP:10,move:3,attack:3,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* SHIELD */],"2")]},elite:{maxHP:12,move:3,attack:4,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["f" /* RETALIATE */],"2"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* SHIELD */],"3")]}},{normal:{maxHP:11,move:3,attack:4,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* SHIELD */],"2")]},elite:{maxHP:13,move:3,attack:5,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["f" /* RETALIATE */],"3"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* SHIELD */],"3")]}},{normal:{maxHP:13,move:3,attack:4,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* SHIELD */],"2")]},elite:{maxHP:14,move:3,attack:6,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["f" /* RETALIATE */],"3"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* SHIELD */],"3")]}}],cards:GUARD_CARDS},"Cultist":{tokenCount:6,stats:[{normal:{maxHP:4,move:2,attack:1,range:0,extra:[]},elite:{maxHP:7,move:2,attack:2,range:0,extra:[]}},{normal:{maxHP:5,move:2,attack:1,range:0,extra:[]},elite:{maxHP:9,move:2,attack:2,range:0,extra:[]}},{normal:{maxHP:7,move:2,attack:1,range:0,extra:[]},elite:{maxHP:12,move:2,attack:2,range:0,extra:[]}},{normal:{maxHP:9,move:3,attack:1,range:0,extra:[]},elite:{maxHP:13,move:3,attack:2,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["b" /* CURSE */])]}},{normal:{maxHP:10,move:3,attack:2,range:0,extra:[]},elite:{maxHP:15,move:3,attack:3,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["b" /* CURSE */])]}},{normal:{maxHP:11,move:3,attack:2,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["b" /* CURSE */])]},elite:{maxHP:18,move:3,attack:3,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["b" /* CURSE */])]}},{normal:{maxHP:14,move:3,attack:2,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["b" /* CURSE */])]},elite:{maxHP:22,move:3,attack:3,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["b" /* CURSE */])]}},{normal:{maxHP:15,move:3,attack:3,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["b" /* CURSE */])]},elite:{maxHP:25,move:3,attack:4,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["b" /* CURSE */])]}}],cards:[{initiative:39,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["c" /* MOVE */],"-1"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"+0"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["b" /* HEAL */],"1",["Self"])]},{initiative:10,//TODO
actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["c" /* MOVE */],"-1"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"+0"),{action:"on death: attack +2",image:__WEBPACK_IMPORTED_MODULE_1__aoe_circle_with_middle_black_svg___default.a}]},{initiative:10,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["c" /* MOVE */],"-1"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"-1"),{action:"on death: attack +2",image:__WEBPACK_IMPORTED_MODULE_1__aoe_circle_with_middle_black_svg___default.a}]},{initiative:31,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["c" /* MOVE */],"-1"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["b" /* HEAL */],"3",[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["e" /* RANGE */],"3")])]},{initiative:63,actions:["Summon normal Living Bones","Cultist suffers 2 damage."],endAction:__WEBPACK_IMPORTED_MODULE_14__cards__["a" /* END_ACTIONS */].SHUFFLE},{initiative:63,actions:["Summon normal Living Bones","Cultist suffers 2 damage."],endAction:__WEBPACK_IMPORTED_MODULE_14__cards__["a" /* END_ACTIONS */].SHUFFLE},{initiative:27,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["c" /* MOVE */],"+0"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"+0")]},{initiative:27,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["c" /* MOVE */],"+0"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"+0")]}]},"Deep Terror":{tokenCount:10,stats:[{normal:{maxHP:3,move:0,attack:2,range:0,extra:[]},elite:{maxHP:5,move:0,attack:3,range:0,extra:[]}},{normal:{maxHP:4,move:0,attack:2,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["f" /* RETALIATE */],"1")]},elite:{maxHP:6,move:0,attack:3,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["f" /* RETALIATE */],"1")]}},{normal:{maxHP:4,move:0,attack:3,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["f" /* RETALIATE */],"1")]},elite:{maxHP:7,move:0,attack:4,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["f" /* RETALIATE */],"1")]}},{normal:{maxHP:5,move:0,attack:3,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["f" /* RETALIATE */],"2")]},elite:{maxHP:8,move:0,attack:4,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["f" /* RETALIATE */],"2")]}},{normal:{maxHP:6,move:0,attack:4,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["f" /* RETALIATE */],"2")]},elite:{maxHP:9,move:0,attack:5,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["f" /* RETALIATE */],"2")]}},{normal:{maxHP:7,move:0,attack:4,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["f" /* RETALIATE */],"3")]},elite:{maxHP:11,move:0,attack:5,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["f" /* RETALIATE */],"3")]}},{normal:{maxHP:8,move:0,attack:5,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["f" /* RETALIATE */],"3")]},elite:{maxHP:13,move:0,attack:6,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["f" /* RETALIATE */],"3")]}},{normal:{maxHP:9,move:0,attack:5,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["f" /* RETALIATE */],"4")]},elite:{maxHP:15,move:0,attack:6,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["f" /* RETALIATE */],"4")]}}],cards:[{initiative:65,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"+0",[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["e" /* RANGE */],"3"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["h" /* TARGET */],"3"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["b" /* CURSE */])])]},{initiative:60,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"+0",[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["d" /* PIERCE */],"3")],__WEBPACK_IMPORTED_MODULE_8__aoe_line_6_with_black_svg___default.a)],endAction:__WEBPACK_IMPORTED_MODULE_14__cards__["a" /* END_ACTIONS */].SHUFFLE},{initiative:60,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"+0",[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["d" /* PIERCE */],"3")],__WEBPACK_IMPORTED_MODULE_8__aoe_line_6_with_black_svg___default.a)],endAction:__WEBPACK_IMPORTED_MODULE_14__cards__["a" /* END_ACTIONS */].SHUFFLE},{initiative:84,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"-1",["Target all adjacent enemies"]),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"+0",[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["e" /* RANGE */],"4"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["l" /* WOUND */])])]},{initiative:75,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"+0",[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["g" /* POISON */])]),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"-1",[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["e" /* RANGE */],"5"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["d" /* IMMOBILIZE */])])]},{initiative:75,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"-2",["Target all adjacent enemies",Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["c" /* DISARM */])]),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"+0",[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["e" /* RANGE */],"3"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["h" /* TARGET */],"2")])]},{initiative:96,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"-2",[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["e" /* RANGE */],"6"),"Summon normal Deep Terror in a hex adjacent to the target"])]},{initiative:54,actions:["wound and poison, Target all adjacent enemies",Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"+0",[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["e" /* RANGE */],"4")])]}]},"Earth Demon":{tokenCount:6,stats:[{normal:{maxHP:7,move:1,attack:3,range:0,extra:[]},elite:{maxHP:10,move:2,attack:4,range:0,extra:[]}},{normal:{maxHP:9,move:1,attack:3,range:0,extra:[]},elite:{maxHP:13,move:2,attack:4,range:0,extra:[]}},{normal:{maxHP:12,move:1,attack:3,range:0,extra:[]},elite:{maxHP:18,move:2,attack:4,range:0,extra:[]}},{normal:{maxHP:13,move:2,attack:3,range:0,extra:[]},elite:{maxHP:20,move:2,attack:4,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["d" /* IMMOBILIZE */])]}},{normal:{maxHP:15,move:2,attack:4,range:0,extra:[]},elite:{maxHP:21,move:3,attack:5,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["d" /* IMMOBILIZE */])]}},{normal:{maxHP:17,move:2,attack:4,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["d" /* IMMOBILIZE */])]},elite:{maxHP:25,move:3,attack:5,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["d" /* IMMOBILIZE */])]}},{normal:{maxHP:20,move:2,attack:4,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["d" /* IMMOBILIZE */])]},elite:{maxHP:27,move:3,attack:6,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["d" /* IMMOBILIZE */])]}},{normal:{maxHP:22,move:3,attack:4,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["d" /* IMMOBILIZE */])]},elite:{maxHP:32,move:3,attack:6,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["d" /* IMMOBILIZE */])]}}],cards:[{initiative:93,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["c" /* MOVE */],"-1"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"-1",["Target all adjacent enemies"]),{type:"element",use:__WEBPACK_IMPORTED_MODULE_15__elements__["d" /* EARTH */],action:Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["i" /* PUSH */],"1")}]},{initiative:79,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["c" /* MOVE */],"+1"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"+0"),{type:"element",use:__WEBPACK_IMPORTED_MODULE_15__elements__["a" /* AIR */],action:"-2 attack"}]},{initiative:40,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["b" /* HEAL */],"3",["Self"]),{type:"element",use:__WEBPACK_IMPORTED_MODULE_15__elements__["d" /* EARTH */],action:Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["d" /* IMMOBILIZE */],null,["Target all enemies within range 3"])}],endAction:__WEBPACK_IMPORTED_MODULE_14__cards__["a" /* END_ACTIONS */].SHUFFLE},{initiative:42,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["c" /* MOVE */],"+1"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"-1")],endAction:__WEBPACK_IMPORTED_MODULE_14__cards__["a" /* END_ACTIONS */].SHUFFLE},{initiative:62,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["c" /* MOVE */],"+0"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"+0"),{type:"element",create:__WEBPACK_IMPORTED_MODULE_15__elements__["d" /* EARTH */]}]},{initiative:71,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"+0",[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["e" /* RANGE */],"4")]),{type:"element",use:__WEBPACK_IMPORTED_MODULE_15__elements__["d" /* EARTH */],action:Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["h" /* TARGET */],"2")}]},{initiative:83,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["c" /* MOVE */],"-1"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"+1"),{type:"element",create:__WEBPACK_IMPORTED_MODULE_15__elements__["d" /* EARTH */]}]},{initiative:87,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["c" /* MOVE */],"+0"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"-1",[],__WEBPACK_IMPORTED_MODULE_9__aoe_4_with_black_svg___default.a),{type:"element",use:__WEBPACK_IMPORTED_MODULE_15__elements__["b" /* ANY */],create:__WEBPACK_IMPORTED_MODULE_15__elements__["d" /* EARTH */]}]}]},"Flame Demon":{tokenCount:6,stats:[{normal:{maxHP:2,move:3,attack:2,range:3,extra:["flying",Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* SHIELD */],"2")]},elite:{maxHP:3,move:3,attack:2,range:3,extra:["flying",Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* SHIELD */],"3")]}},{normal:{maxHP:2,move:3,attack:2,range:3,extra:["flying",Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* SHIELD */],"3")]},elite:{maxHP:3,move:3,attack:2,range:4,extra:["flying",Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["f" /* RETALIATE */],"2",[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["e" /* RANGE */],"2")]),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* SHIELD */],"4")]}},{normal:{maxHP:3,move:3,attack:3,range:3,extra:["flying",Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* SHIELD */],"3")]},elite:{maxHP:4,move:3,attack:3,range:4,extra:["flying",Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["f" /* RETALIATE */],"3",[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["e" /* RANGE */],"2")]),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* SHIELD */],"4")]}},{normal:{maxHP:3,move:3,attack:3,range:4,extra:["flying",Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["f" /* RETALIATE */],"2",[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["e" /* RANGE */],"2")]),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* SHIELD */],"3")]},elite:{maxHP:5,move:3,attack:3,range:5,extra:["flying",Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["f" /* RETALIATE */],"3",[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["e" /* RANGE */],"3")]),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* SHIELD */],"4")]}},{normal:{maxHP:3,move:4,attack:3,range:4,extra:["flying",Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["f" /* RETALIATE */],"3",[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["e" /* RANGE */],"2")]),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* SHIELD */],"3")]},elite:{maxHP:5,move:4,attack:4,range:5,extra:["flying",Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["f" /* RETALIATE */],"4",[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["e" /* RANGE */],"3")]),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* SHIELD */],"4")]}},{normal:{maxHP:4,move:4,attack:3,range:4,extra:["flying",Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["f" /* RETALIATE */],"3",[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["e" /* RANGE */],"2")]),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* SHIELD */],"4")]},elite:{maxHP:6,move:4,attack:4,range:5,extra:["flying",Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["f" /* RETALIATE */],"4",[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["e" /* RANGE */],"3")]),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* SHIELD */],"5")]}},{normal:{maxHP:4,move:4,attack:4,range:4,extra:["flying",Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["f" /* RETALIATE */],"4",[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["e" /* RANGE */],"2")]),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* SHIELD */],"4")]},elite:{maxHP:7,move:4,attack:5,range:5,extra:["flying",Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["f" /* RETALIATE */],"5",[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["e" /* RANGE */],"3")]),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* SHIELD */],"5")]}},{normal:{maxHP:5,move:4,attack:4,range:5,extra:["flying",Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["f" /* RETALIATE */],"4",[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["e" /* RANGE */],"3")]),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* SHIELD */],"4")]},elite:{maxHP:8,move:4,attack:5,range:6,extra:["flying",Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["f" /* RETALIATE */],"5",[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["e" /* RANGE */],"4")]),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* SHIELD */],"5")]}}],cards:[{initiative:8,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["c" /* MOVE */],"-1"),"Create a 4 damage trap in an adjacent empty hex closest to an enemy.",{type:"element",use:__WEBPACK_IMPORTED_MODULE_15__elements__["b" /* ANY */],create:__WEBPACK_IMPORTED_MODULE_15__elements__["e" /* FIRE */]}]},{initiative:67,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["c" /* MOVE */],"-1"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"+1",[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["e" /* RANGE */],"-1")]),{type:"element",create:__WEBPACK_IMPORTED_MODULE_15__elements__["e" /* FIRE */]}]},{initiative:3,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["c" /* MOVE */],"+1"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"-1"),{type:"element",create:__WEBPACK_IMPORTED_MODULE_15__elements__["e" /* FIRE */]}]},{initiative:77,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"+0",["Target all adjacent enemies"]),{type:"element",use:__WEBPACK_IMPORTED_MODULE_15__elements__["f" /* ICE */],action:"Flame Demon suffers 1 damage"}]},{initiative:24,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["c" /* MOVE */],"+0"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"+0"),{type:"element",create:__WEBPACK_IMPORTED_MODULE_15__elements__["e" /* FIRE */]}]},{initiative:30,actions:[{type:"element",use:__WEBPACK_IMPORTED_MODULE_15__elements__["e" /* FIRE */],action:"All adjacent enemies suffer 2 damage."},Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["c" /* MOVE */],"+0"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"-2",[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["l" /* WOUND */]),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["h" /* TARGET */],"2")])],endAction:__WEBPACK_IMPORTED_MODULE_14__cards__["a" /* END_ACTIONS */].SHUFFLE},{initiative:46,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"+0"),{type:"element",use:__WEBPACK_IMPORTED_MODULE_15__elements__["e" /* FIRE */],image:__WEBPACK_IMPORTED_MODULE_0__aoe_circle_svg___default.a}],endAction:__WEBPACK_IMPORTED_MODULE_14__cards__["a" /* END_ACTIONS */].SHUFFLE},{initiative:49,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"+0",[],__WEBPACK_IMPORTED_MODULE_6__aoe_line_3_with_black_svg___default.a),{type:"element",use:__WEBPACK_IMPORTED_MODULE_15__elements__["e" /* FIRE */],action:Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"+1",[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["l" /* WOUND */])])}]}]},"Frost Demon":{tokenCount:6,stats:[{normal:{maxHP:5,move:2,attack:3,range:0,extra:[]},elite:{maxHP:10,move:3,attack:3,range:0,extra:[]}},{normal:{maxHP:6,move:2,attack:3,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["f" /* RETALIATE */],"1")]},elite:{maxHP:10,move:3,attack:3,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["f" /* RETALIATE */],"2")]}},{normal:{maxHP:7,move:3,attack:3,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["f" /* RETALIATE */],"2")]},elite:{maxHP:12,move:4,attack:4,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["f" /* RETALIATE */],"2")]}},{normal:{maxHP:8,move:3,attack:4,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["f" /* RETALIATE */],"2")]},elite:{maxHP:14,move:4,attack:4,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["f" /* RETALIATE */],"3")]}},{normal:{maxHP:10,move:3,attack:4,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["f" /* RETALIATE */],"2")]},elite:{maxHP:18,move:4,attack:4,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["f" /* RETALIATE */],"3")]}},{normal:{maxHP:11,move:3,attack:4,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["f" /* RETALIATE */],"3")]},elite:{maxHP:20,move:4,attack:5,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["f" /* RETALIATE */],"3")]}},{normal:{maxHP:12,move:3,attack:5,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["f" /* RETALIATE */],"3")]},elite:{maxHP:22,move:4,attack:5,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["f" /* RETALIATE */],"4")]}},{normal:{maxHP:14,move:3,attack:5,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["f" /* RETALIATE */],"3")]},elite:{maxHP:25,move:4,attack:5,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["f" /* RETALIATE */],"4")]}}],cards:[{initiative:18,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["d" /* IMMOBILIZE */],null,["Target all enemies within range 2"]),{type:"element",use:__WEBPACK_IMPORTED_MODULE_15__elements__["f" /* ICE */],action:Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["b" /* HEAL */],"3",["Self"])}]},{initiative:18,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* SHIELD */],"2"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["c" /* MOVE */],"+1"),{type:"element",use:__WEBPACK_IMPORTED_MODULE_15__elements__["e" /* FIRE */],action:"Frost Demon suffers 1 damage"}]},{initiative:38,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["c" /* MOVE */],"+1"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"-1")]},{initiative:58,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["c" /* MOVE */],"+0"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"+0")]},{initiative:58,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["c" /* MOVE */],"-1"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"+0",[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["e" /* RANGE */],"2")]),{type:"element",use:__WEBPACK_IMPORTED_MODULE_15__elements__["f" /* ICE */],action:"+2 attack, +1 range"}]},{initiative:58,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["c" /* MOVE */],"-1"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"-1",[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["d" /* PIERCE */],"3")]),{type:"element",use:__WEBPACK_IMPORTED_MODULE_15__elements__["b" /* ANY */],create:__WEBPACK_IMPORTED_MODULE_15__elements__["f" /* ICE */]}]},{initiative:78,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["c" /* MOVE */],"-1"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"+0",[],__WEBPACK_IMPORTED_MODULE_4__aoe_triangle_2_with_black_svg___default.a),{type:"element",create:__WEBPACK_IMPORTED_MODULE_15__elements__["f" /* ICE */]}],endAction:__WEBPACK_IMPORTED_MODULE_14__cards__["a" /* END_ACTIONS */].SHUFFLE},{initiative:78,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["c" /* MOVE */],"-1"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"+0",[],__WEBPACK_IMPORTED_MODULE_4__aoe_triangle_2_with_black_svg___default.a),{type:"element",create:__WEBPACK_IMPORTED_MODULE_15__elements__["f" /* ICE */]}],endAction:__WEBPACK_IMPORTED_MODULE_14__cards__["a" /* END_ACTIONS */].SHUFFLE}]},"Forest Imp":{tokenCount:10,stats:[{normal:{maxHP:1,move:3,attack:1,range:3,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* SHIELD */],"1")]},elite:{maxHP:4,move:3,attack:1,range:3,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* SHIELD */],"1")]}},{normal:{maxHP:2,move:3,attack:1,range:3,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* SHIELD */],"1")]},elite:{maxHP:5,move:3,attack:2,range:3,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* SHIELD */],"1")]}},{normal:{maxHP:2,move:3,attack:2,range:3,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* SHIELD */],"1")]},elite:{maxHP:6,move:3,attack:2,range:3,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["b" /* CURSE */]),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* SHIELD */],"1")]}},{normal:{maxHP:3,move:4,attack:2,range:4,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* SHIELD */],"1")]},elite:{maxHP:7,move:4,attack:2,range:4,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["b" /* CURSE */]),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* SHIELD */],"1")]}},{normal:{maxHP:3,move:4,attack:2,range:4,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* SHIELD */],"2")]},elite:{maxHP:7,move:4,attack:2,range:4,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["b" /* CURSE */]),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* SHIELD */],"2")]}},{normal:{maxHP:4,move:4,attack:2,range:4,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["b" /* CURSE */]),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* SHIELD */],"2")]},elite:{maxHP:8,move:4,attack:3,range:4,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["b" /* CURSE */]),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* SHIELD */],"2")]}},{normal:{maxHP:4,move:4,attack:3,range:4,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["b" /* CURSE */]),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* SHIELD */],"2")]},elite:{maxHP:9,move:4,attack:4,range:4,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["b" /* CURSE */]),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* SHIELD */],"2")]}},{normal:{maxHP:6,move:4,attack:3,range:4,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["b" /* CURSE */]),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* SHIELD */],"2")]},elite:{maxHP:11,move:4,attack:4,range:4,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["b" /* CURSE */]),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* SHIELD */],"2")]}}],cards:IMP_CARDS},"Giant Viper":{tokenCount:10,stats:[{normal:{maxHP:2,move:2,attack:1,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["g" /* POISON */])]},elite:{maxHP:3,move:2,attack:2,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["g" /* POISON */])]}},{normal:{maxHP:3,move:2,attack:1,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["g" /* POISON */])]},elite:{maxHP:5,move:2,attack:2,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["g" /* POISON */])]}},{normal:{maxHP:4,move:3,attack:1,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["g" /* POISON */])]},elite:{maxHP:7,move:3,attack:2,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["g" /* POISON */])]}},{normal:{maxHP:4,move:3,attack:2,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["g" /* POISON */])]},elite:{maxHP:8,move:3,attack:3,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["g" /* POISON */])]}},{normal:{maxHP:6,move:3,attack:2,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["g" /* POISON */])]},elite:{maxHP:11,move:3,attack:3,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["g" /* POISON */])]}},{normal:{maxHP:7,move:3,attack:3,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["g" /* POISON */])]},elite:{maxHP:13,move:4,attack:3,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["g" /* POISON */])]}},{normal:{maxHP:8,move:4,attack:3,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["g" /* POISON */])]},elite:{maxHP:14,move:4,attack:4,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["g" /* POISON */])]}},{normal:{maxHP:10,move:4,attack:3,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["g" /* POISON */])]},elite:{maxHP:17,move:4,attack:4,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["g" /* POISON */])]}}],cards:[{initiative:23,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["c" /* MOVE */],"-1"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"-1",[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["d" /* IMMOBILIZE */])]),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"-1")]},{initiative:43,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["c" /* MOVE */],"-1",["jump"]),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"+0",[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["h" /* TARGET */],"2")])]},{initiative:43,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["c" /* MOVE */],"+1",["jump"]),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"-1",["Target all adjacent enemies"])]},{initiative:32,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["c" /* MOVE */],"+0"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"+0"),"Add +2 attack if the target is adjacent to any of the Giant Viper's allies."],endAction:__WEBPACK_IMPORTED_MODULE_14__cards__["a" /* END_ACTIONS */].SHUFFLE},{initiative:32,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["c" /* MOVE */],"+0"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"+0"),"Add +2 attack if the target is adjacent to any of the Giant Viper's allies."],endAction:__WEBPACK_IMPORTED_MODULE_14__cards__["a" /* END_ACTIONS */].SHUFFLE},{initiative:11,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* SHIELD */],"1"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"-1")]},{initiative:58,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["c" /* MOVE */],"-1",["jump"]),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"+1")]},{initiative:58,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["c" /* MOVE */],"+1",["jump"]),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"-1"),"All attacks targeting Giant Viper this round gain Disadvantage."]}]},"Harrower Infester":{tokenCount:4,stats:[{normal:{maxHP:6,move:2,attack:2,range:0,extra:[]},elite:{maxHP:12,move:2,attack:2,range:0,extra:[]}},{normal:{maxHP:7,move:2,attack:2,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["f" /* RETALIATE */],"1")]},elite:{maxHP:12,move:3,attack:2,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["f" /* RETALIATE */],"2")]}},{normal:{maxHP:8,move:2,attack:2,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["f" /* RETALIATE */],"2")]},elite:{maxHP:14,move:3,attack:3,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["f" /* RETALIATE */],"2")]}},{normal:{maxHP:10,move:2,attack:3,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["f" /* RETALIATE */],"2")]},elite:{maxHP:17,move:3,attack:3,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["f" /* RETALIATE */],"3")]}},{normal:{maxHP:12,move:3,attack:3,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["f" /* RETALIATE */],"2")]},elite:{maxHP:19,move:3,attack:4,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["f" /* RETALIATE */],"3")]}},{normal:{maxHP:12,move:3,attack:4,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["f" /* RETALIATE */],"3")]},elite:{maxHP:21,move:3,attack:5,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["f" /* RETALIATE */],"3")]}},{normal:{maxHP:15,move:3,attack:4,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["f" /* RETALIATE */],"3")]},elite:{maxHP:22,move:4,attack:5,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["f" /* RETALIATE */],"4")]}},{normal:{maxHP:17,move:3,attack:4,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["f" /* RETALIATE */],"4")]},elite:{maxHP:26,move:4,attack:5,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["f" /* RETALIATE */],"4")]}}],cards:[{initiative:2,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* SHIELD */],"2"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["f" /* RETALIATE */],"2",[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["e" /* RANGE */],"3")])],endAction:__WEBPACK_IMPORTED_MODULE_14__cards__["a" /* END_ACTIONS */].SHUFFLE},{initiative:7,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["c" /* MOVE */],"+0"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"-1",[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["g" /* POISON */])]),{type:"element",create:__WEBPACK_IMPORTED_MODULE_15__elements__["c" /* DARK */]}]},{initiative:7,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"-1",[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["e" /* RANGE */],"3"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["f" /* MUDDLE */])]),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["b" /* HEAL */],"3",["Self"])],endAction:__WEBPACK_IMPORTED_MODULE_14__cards__["a" /* END_ACTIONS */].SHUFFLE},{initiative:16,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"+2",[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["d" /* IMMOBILIZE */])]),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["f" /* RETALIATE */],"2")]},{initiative:16,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["c" /* MOVE */],"-1"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"-1"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["b" /* HEAL */],"5",["Self"])]},{initiative:30,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["c" /* MOVE */],"-1"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"+0",[],__WEBPACK_IMPORTED_MODULE_7__aoe_line_4_with_black_svg___default.a),{type:"element",use:__WEBPACK_IMPORTED_MODULE_15__elements__["c" /* DARK */],action:'Perform "heal 2 Self" for each target damaged'}]},{initiative:38,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["c" /* MOVE */],"-1"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"+1",[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["h" /* TARGET */],"2")])]},{initiative:38,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["c" /* MOVE */],"+0"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"-1",[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["h" /* TARGET */],"2")]),{type:"element",use:__WEBPACK_IMPORTED_MODULE_15__elements__["c" /* DARK */],action:"+2 attack, disarm"}]}]},"Hound":{tokenCount:6,stats:[{normal:{maxHP:4,move:3,attack:2,range:0,extra:[]},elite:{maxHP:6,move:5,attack:2,range:0,extra:[]}},{normal:{maxHP:4,move:4,attack:2,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["f" /* RETALIATE */],"1")]},elite:{maxHP:6,move:5,attack:2,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["f" /* RETALIATE */],"2")]}},{normal:{maxHP:6,move:4,attack:2,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["f" /* RETALIATE */],"1")]},elite:{maxHP:7,move:5,attack:3,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["f" /* RETALIATE */],"2")]}},{normal:{maxHP:8,move:4,attack:2,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["f" /* RETALIATE */],"1")]},elite:{maxHP:8,move:5,attack:4,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["f" /* RETALIATE */],"2")]}},{normal:{maxHP:8,move:4,attack:3,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["f" /* RETALIATE */],"1")]},elite:{maxHP:11,move:5,attack:4,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["f" /* RETALIATE */],"2")]}},{normal:{maxHP:9,move:4,attack:3,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["f" /* RETALIATE */],"2")]},elite:{maxHP:12,move:5,attack:4,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["f" /* RETALIATE */],"3")]}},{normal:{maxHP:11,move:5,attack:3,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["f" /* RETALIATE */],"2")]},elite:{maxHP:15,move:6,attack:4,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["f" /* RETALIATE */],"3")]}},{normal:{maxHP:15,move:5,attack:3,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["f" /* RETALIATE */],"2")]},elite:{maxHP:15,move:6,attack:5,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["f" /* RETALIATE */],"4")]}}],cards:[{initiative:72,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"-1",[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["d" /* PIERCE */],"2")]),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["c" /* MOVE */],"-2"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"-1",[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["d" /* PIERCE */],"2")])]},{initiative:26,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["c" /* MOVE */],"+0"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"+0")]},{initiative:83,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["c" /* MOVE */],"-2"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"+1")]},{initiative:26,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["c" /* MOVE */],"+0"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"+0")]},{initiative:19,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["c" /* MOVE */],"+0"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"+0"),"Add +2 attack if the target is adjacent to any of the Hound's allies."],endAction:__WEBPACK_IMPORTED_MODULE_14__cards__["a" /* END_ACTIONS */].SHUFFLE},{initiative:19,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["c" /* MOVE */],"+0"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"+0"),"Add +2 attack if the target is adjacent to any of the Hound's allies."],endAction:__WEBPACK_IMPORTED_MODULE_14__cards__["a" /* END_ACTIONS */].SHUFFLE},{initiative:7,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["c" /* MOVE */],"+0"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["f" /* MUDDLE */],null,["Target all adjacent enemies"])]},{initiative:8,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["c" /* MOVE */],"-1"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"+0",[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["d" /* IMMOBILIZE */])])]}]},"Inox Archer":{tokenCount:6,stats:[{normal:{maxHP:5,move:2,attack:2,range:2,extra:[]},elite:{maxHP:7,move:2,attack:3,range:3,extra:[]}},{normal:{maxHP:6,move:2,attack:2,range:3,extra:[]},elite:{maxHP:8,move:2,attack:3,range:4,extra:[]}},{normal:{maxHP:8,move:2,attack:2,range:3,extra:[]},elite:{maxHP:11,move:2,attack:3,range:4,extra:[]}},{normal:{maxHP:9,move:2,attack:3,range:3,extra:[]},elite:{maxHP:13,move:2,attack:4,range:4,extra:[]}},{normal:{maxHP:10,move:3,attack:3,range:3,extra:[]},elite:{maxHP:14,move:3,attack:4,range:4,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["l" /* WOUND */])]}},{normal:{maxHP:12,move:3,attack:3,range:4,extra:[]},elite:{maxHP:17,move:3,attack:4,range:5,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["l" /* WOUND */])]}},{normal:{maxHP:12,move:3,attack:4,range:4,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["l" /* WOUND */])]},elite:{maxHP:19,move:3,attack:5,range:5,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["l" /* WOUND */])]}},{normal:{maxHP:15,move:3,attack:4,range:4,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["l" /* WOUND */])]},elite:{maxHP:23,move:3,attack:5,range:5,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["l" /* WOUND */])]}}],cards:ARCHER_CARDS},"Inox Guard":{tokenCount:6,stats:[{normal:{maxHP:5,move:2,attack:2,range:0,extra:[]},elite:{maxHP:9,move:1,attack:3,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["f" /* RETALIATE */],"1")]}},{normal:{maxHP:8,move:2,attack:2,range:0,extra:[]},elite:{maxHP:10,move:2,attack:3,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["f" /* RETALIATE */],"2")]}},{normal:{maxHP:9,move:2,attack:3,range:0,extra:[]},elite:{maxHP:12,move:2,attack:4,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["f" /* RETALIATE */],"2")]}},{normal:{maxHP:11,move:3,attack:3,range:0,extra:[]},elite:{maxHP:15,move:2,attack:4,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["f" /* RETALIATE */],"3")]}},{normal:{maxHP:12,move:3,attack:3,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["f" /* RETALIATE */],"1")]},elite:{maxHP:17,move:2,attack:5,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["f" /* RETALIATE */],"3")]}},{normal:{maxHP:13,move:3,attack:4,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["f" /* RETALIATE */],"1")]},elite:{maxHP:19,move:2,attack:5,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["f" /* RETALIATE */],"4")]}},{normal:{maxHP:16,move:3,attack:4,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["f" /* RETALIATE */],"1")]},elite:{maxHP:21,move:3,attack:5,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["f" /* RETALIATE */],"4")]}},{normal:{maxHP:19,move:3,attack:4,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["f" /* RETALIATE */],"2")]},elite:{maxHP:23,move:3,attack:6,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["f" /* RETALIATE */],"4")]}}],cards:GUARD_CARDS},"Inox Shaman":{tokenCount:4,stats:[{normal:{maxHP:4,move:1,attack:2,range:3,extra:[]},elite:{maxHP:6,move:2,attack:3,range:3,extra:[]}},{normal:{maxHP:6,move:1,attack:2,range:3,extra:[]},elite:{maxHP:9,move:2,attack:3,range:3,extra:[]}},{normal:{maxHP:7,move:2,attack:2,range:3,extra:[]},elite:{maxHP:11,move:3,attack:3,range:3,extra:[]}},{normal:{maxHP:9,move:2,attack:2,range:4,extra:[]},elite:{maxHP:14,move:3,attack:3,range:4,extra:[]}},{normal:{maxHP:10,move:2,attack:3,range:4,extra:[]},elite:{maxHP:16,move:3,attack:4,range:4,extra:[]}},{normal:{maxHP:13,move:2,attack:3,range:4,extra:[]},elite:{maxHP:20,move:3,attack:4,range:4,extra:[]}},{normal:{maxHP:15,move:3,attack:3,range:4,extra:[]},elite:{maxHP:24,move:4,attack:4,range:4,extra:[]}},{normal:{maxHP:16,move:3,attack:4,range:4,extra:[]},elite:{maxHP:27,move:4,attack:5,range:4,extra:[]}}],cards:SHAMAN_CARDS},"Living Bones":{tokenCount:10,stats:[{normal:{maxHP:5,move:2,attack:1,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["h" /* TARGET */],"2")]},elite:{maxHP:6,move:4,attack:2,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["h" /* TARGET */],"2")]}},{normal:{maxHP:5,move:3,attack:1,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["h" /* TARGET */],"2"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* SHIELD */],"1")]},elite:{maxHP:6,move:4,attack:2,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["h" /* TARGET */],"3"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* SHIELD */],"1")]}},{normal:{maxHP:5,move:3,attack:2,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["h" /* TARGET */],"2"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* SHIELD */],"1")]},elite:{maxHP:7,move:4,attack:3,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["h" /* TARGET */],"3"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* SHIELD */],"1")]}},{normal:{maxHP:7,move:3,attack:2,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["h" /* TARGET */],"2"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* SHIELD */],"1")]},elite:{maxHP:10,move:4,attack:3,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["h" /* TARGET */],"3"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* SHIELD */],"1")]}},{normal:{maxHP:7,move:3,attack:3,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["h" /* TARGET */],"2"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* SHIELD */],"1")]},elite:{maxHP:11,move:4,attack:4,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["h" /* TARGET */],"3"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* SHIELD */],"1")]}},{normal:{maxHP:9,move:3,attack:3,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["h" /* TARGET */],"2"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* SHIELD */],"1")]},elite:{maxHP:11,move:4,attack:4,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["h" /* TARGET */],"3"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* SHIELD */],"2")]}},{normal:{maxHP:10,move:4,attack:3,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["h" /* TARGET */],"2"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* SHIELD */],"1")]},elite:{maxHP:11,move:6,attack:4,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["h" /* TARGET */],"3"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* SHIELD */],"2")]}},{normal:{maxHP:13,move:4,attack:3,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["h" /* TARGET */],"2"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* SHIELD */],"1")]},elite:{maxHP:14,move:6,attack:4,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["h" /* TARGET */],"3"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* SHIELD */],"2")]}}],cards:[{initiative:81,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"+2")]},{initiative:45,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["c" /* MOVE */],"+0"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"+0")]},{initiative:64,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["c" /* MOVE */],"-1"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"+1")]},{initiative:12,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* SHIELD */],"1"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["b" /* HEAL */],"2",["Self"])],endAction:__WEBPACK_IMPORTED_MODULE_14__cards__["a" /* END_ACTIONS */].SHUFFLE},{initiative:45,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["c" /* MOVE */],"+0"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"+0")]},{initiative:74,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["c" /* MOVE */],"+0"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"+0",["Target one enemy with all attacks"])]},{initiative:25,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["c" /* MOVE */],"+1"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"-1")]},{initiative:20,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["c" /* MOVE */],"-2"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"+0"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["b" /* HEAL */],"2",["Self"])],endAction:__WEBPACK_IMPORTED_MODULE_14__cards__["a" /* END_ACTIONS */].SHUFFLE}]},"Living Corpse":{tokenCount:6,stats:[{normal:{maxHP:5,move:1,attack:3,range:0,extra:[]},elite:{maxHP:10,move:1,attack:3,range:0,extra:[]}},{normal:{maxHP:7,move:1,attack:3,range:0,extra:[]},elite:{maxHP:10,move:1,attack:4,range:0,extra:[]}},{normal:{maxHP:9,move:1,attack:3,range:0,extra:[]},elite:{maxHP:13,move:1,attack:4,range:0,extra:[]}},{normal:{maxHP:10,move:1,attack:4,range:0,extra:[]},elite:{maxHP:13,move:2,attack:5,range:0,extra:[]}},{normal:{maxHP:11,move:2,attack:4,range:0,extra:[]},elite:{maxHP:15,move:2,attack:5,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["g" /* POISON */])]}},{normal:{maxHP:13,move:2,attack:4,range:0,extra:[]},elite:{maxHP:17,move:2,attack:6,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["g" /* POISON */])]}},{normal:{maxHP:14,move:2,attack:4,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["g" /* POISON */])]},elite:{maxHP:21,move:2,attack:6,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["g" /* POISON */])]}},{normal:{maxHP:15,move:2,attack:5,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["g" /* POISON */])]},elite:{maxHP:25,move:2,attack:6,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["g" /* POISON */])]}}],cards:[{initiative:66,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["c" /* MOVE */],"+0"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"+0")],endAction:__WEBPACK_IMPORTED_MODULE_14__cards__["a" /* END_ACTIONS */].SHUFFLE},{initiative:66,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["c" /* MOVE */],"+0"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"+0")],endAction:__WEBPACK_IMPORTED_MODULE_14__cards__["a" /* END_ACTIONS */].SHUFFLE},{initiative:47,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["c" /* MOVE */],"+1"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"-1")]},{initiative:21,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["c" /* MOVE */],"+1"),"muddle and immobilize, Target one adjacent enemy"]},{initiative:66,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["c" /* MOVE */],"+0"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"+0")],endAction:__WEBPACK_IMPORTED_MODULE_14__cards__["a" /* END_ACTIONS */].SHUFFLE},{initiative:71,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["c" /* MOVE */],"+0"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"+1"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["g" /* POISON */],null,["Target all adjacent enemies"])]},{initiative:32,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"+2",[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["i" /* PUSH */],"1")]),"Living Corpse suffers 1 damage"]},{initiative:91,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["c" /* MOVE */],"+1"),"Living Corpse suffers 1 damage"]}]},"Living Spirit":{tokenCount:6,stats:[{normal:{maxHP:2,move:2,attack:2,range:2,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* SHIELD */],"1")]},elite:{maxHP:3,move:3,attack:3,range:3,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* SHIELD */],"2")]}},{normal:{maxHP:2,move:2,attack:2,range:2,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* SHIELD */],"2")]},elite:{maxHP:3,move:3,attack:3,range:3,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* SHIELD */],"3")]}},{normal:{maxHP:2,move:3,attack:2,range:3,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* SHIELD */],"2")]},elite:{maxHP:3,move:4,attack:3,range:4,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* SHIELD */],"3")]}},{normal:{maxHP:3,move:3,attack:3,range:3,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* SHIELD */],"2")]},elite:{maxHP:4,move:4,attack:4,range:4,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* SHIELD */],"3")]}},{normal:{maxHP:3,move:3,attack:3,range:3,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* SHIELD */],"3")]},elite:{maxHP:4,move:4,attack:4,range:4,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* SHIELD */],"4")]}},{normal:{maxHP:4,move:3,attack:3,range:4,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* SHIELD */],"3")]},elite:{maxHP:6,move:4,attack:4,range:4,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* SHIELD */],"4")]}},{normal:{maxHP:4,move:3,attack:4,range:4,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* SHIELD */],"3")]},elite:{maxHP:7,move:4,attack:5,range:5,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* SHIELD */],"4")]}},{normal:{maxHP:6,move:3,attack:4,range:4,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* SHIELD */],"3")]},elite:{maxHP:9,move:4,attack:5,range:5,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* SHIELD */],"4")]}}],cards:[{initiative:22,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["c" /* MOVE */],"-1"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"-1",[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["f" /* MUDDLE */])])],endAction:__WEBPACK_IMPORTED_MODULE_14__cards__["a" /* END_ACTIONS */].SHUFFLE},{initiative:33,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["c" /* MOVE */],"+0"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"-1",["Target all enemies in range"])],endAction:__WEBPACK_IMPORTED_MODULE_14__cards__["a" /* END_ACTIONS */].SHUFFLE},{initiative:48,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["c" /* MOVE */],"+0"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"+0")]},{initiative:48,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["c" /* MOVE */],"+0"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"+0")]},{initiative:55,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["c" /* MOVE */],"+0"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["b" /* CURSE */],null,["Target all enemies in range"]),{type:"element",create:__WEBPACK_IMPORTED_MODULE_15__elements__["f" /* ICE */]}]},{initiative:61,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"+0",[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["e" /* RANGE */],"-1"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["h" /* TARGET */],"2")])]},{initiative:67,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["c" /* MOVE */],"-1"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"+1"),{type:"element",use:__WEBPACK_IMPORTED_MODULE_15__elements__["f" /* ICE */],action:Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["k" /* STUN */])}]},{initiative:75,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["c" /* MOVE */],"-1"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"+1",[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["e" /* RANGE */],"-1")]),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["b" /* HEAL */],"1",["Self"])]}]},"Lurker":{tokenCount:6,stats:[{normal:{maxHP:5,move:2,attack:2,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["h" /* TARGET */],"2")]},elite:{maxHP:7,move:2,attack:3,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["h" /* TARGET */],"2"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* SHIELD */],"1")]}},{normal:{maxHP:7,move:2,attack:2,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["h" /* TARGET */],"2"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["d" /* PIERCE */],"1")]},elite:{maxHP:9,move:2,attack:3,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["h" /* TARGET */],"2"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["d" /* PIERCE */],"1"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* SHIELD */],"1")]}},{normal:{maxHP:9,move:3,attack:2,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["h" /* TARGET */],"2"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["d" /* PIERCE */],"1")]},elite:{maxHP:12,move:3,attack:3,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["h" /* TARGET */],"2"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["d" /* PIERCE */],"2"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* SHIELD */],"1")]}},{normal:{maxHP:10,move:3,attack:3,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["h" /* TARGET */],"2"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["d" /* PIERCE */],"2")]},elite:{maxHP:14,move:3,attack:4,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["h" /* TARGET */],"2"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["d" /* PIERCE */],"2"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* SHIELD */],"1")]}},{normal:{maxHP:10,move:3,attack:3,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["h" /* TARGET */],"2"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["d" /* PIERCE */],"2"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* SHIELD */],"1")]},elite:{maxHP:14,move:3,attack:4,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["h" /* TARGET */],"2"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["d" /* PIERCE */],"3"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* SHIELD */],"2")]}},{normal:{maxHP:11,move:3,attack:4,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["h" /* TARGET */],"2"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["d" /* PIERCE */],"2"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* SHIELD */],"1")]},elite:{maxHP:15,move:3,attack:5,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["h" /* TARGET */],"2"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["d" /* PIERCE */],"3"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* SHIELD */],"2")]}},{normal:{maxHP:12,move:4,attack:4,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["h" /* TARGET */],"2"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["d" /* PIERCE */],"3"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* SHIELD */],"1")]},elite:{maxHP:16,move:4,attack:5,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["h" /* TARGET */],"2"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["d" /* PIERCE */],"4"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* SHIELD */],"2")]}},{normal:{maxHP:14,move:4,attack:4,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["h" /* TARGET */],"2"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["d" /* PIERCE */],"3"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* SHIELD */],"1")]},elite:{maxHP:18,move:4,attack:5,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["h" /* TARGET */],"2"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["d" /* PIERCE */],"4"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* SHIELD */],"2")]}}],cards:[{initiative:11,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* SHIELD */],"1"),{type:"element",use:__WEBPACK_IMPORTED_MODULE_15__elements__["f" /* ICE */],action:Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* SHIELD */],"2 instead")},Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["l" /* WOUND */],null,["Target all adjacent enemies"])],endAction:__WEBPACK_IMPORTED_MODULE_14__cards__["a" /* END_ACTIONS */].SHUFFLE},{initiative:23,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* SHIELD */],"1"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["c" /* MOVE */],"+0"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"-1"),{type:"element",create:__WEBPACK_IMPORTED_MODULE_15__elements__["f" /* ICE */]}],endAction:__WEBPACK_IMPORTED_MODULE_14__cards__["a" /* END_ACTIONS */].SHUFFLE},{initiative:28,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["c" /* MOVE */],"+1"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"-1")]},{initiative:38,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["c" /* MOVE */],"+0"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"+0")]},{initiative:38,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["c" /* MOVE */],"+0"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"+0",["Target one enemy with all attacks"])]},{initiative:41,actions:[{type:"element",use:__WEBPACK_IMPORTED_MODULE_15__elements__["f" /* ICE */],action:Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["j" /* STRENGTHEN */],null,["Self"])},Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["c" /* MOVE */],"+0"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"-1",[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["l" /* WOUND */])])]},{initiative:61,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["c" /* MOVE */],"-1"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"+1")]},{initiative:64,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"+1",["Target all adjacent enemies"])]}]},"Night Demon":{tokenCount:6,stats:[{normal:{maxHP:3,move:3,attack:3,range:0,extra:["Attackers gain disadvantage"]},elite:{maxHP:5,move:4,attack:4,range:0,extra:["Attackers gain disadvantage"]}},{normal:{maxHP:5,move:3,attack:3,range:0,extra:["Attackers gain disadvantage"]},elite:{maxHP:8,move:4,attack:4,range:0,extra:["Attackers gain disadvantage"]}},{normal:{maxHP:6,move:3,attack:4,range:0,extra:["Attackers gain disadvantage"]},elite:{maxHP:11,move:4,attack:4,range:0,extra:["Attackers gain disadvantage"]}},{normal:{maxHP:7,move:4,attack:4,range:0,extra:["Attackers gain disadvantage"]},elite:{maxHP:13,move:4,attack:5,range:0,extra:["Attackers gain disadvantage"]}},{normal:{maxHP:8,move:4,attack:5,range:0,extra:["Attackers gain disadvantage"]},elite:{maxHP:15,move:5,attack:5,range:0,extra:["Attackers gain disadvantage"]}},{normal:{maxHP:11,move:4,attack:5,range:0,extra:["Attackers gain disadvantage"]},elite:{maxHP:17,move:5,attack:6,range:0,extra:["Attackers gain disadvantage"]}},{normal:{maxHP:14,move:4,attack:5,range:0,extra:["Attackers gain disadvantage"]},elite:{maxHP:21,move:5,attack:6,range:0,extra:["Attackers gain disadvantage"]}},{normal:{maxHP:15,move:4,attack:6,range:0,extra:["Attackers gain disadvantage"]},elite:{maxHP:21,move:5,attack:8,range:0,extra:["Attackers gain disadvantage"]}}],cards:[{initiative:35,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"-1"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"-1",[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["d" /* PIERCE */],"2")]),{type:"element",use:__WEBPACK_IMPORTED_MODULE_15__elements__["g" /* LIGHT */],action:Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["b" /* CURSE */],null,["Self"])}]},{initiative:15,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["c" /* MOVE */],"+0"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"-1"),"All adjacent enemies and allies suffer 1 damage",{type:"element",use:__WEBPACK_IMPORTED_MODULE_15__elements__["b" /* ANY */],create:__WEBPACK_IMPORTED_MODULE_15__elements__["c" /* DARK */]}]},{initiative:41,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["c" /* MOVE */],"-1"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"+1"),{type:"element",create:__WEBPACK_IMPORTED_MODULE_15__elements__["c" /* DARK */]}],endAction:__WEBPACK_IMPORTED_MODULE_14__cards__["a" /* END_ACTIONS */].SHUFFLE},{initiative:46,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["c" /* MOVE */],"-1"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"+1"),{type:"element",use:__WEBPACK_IMPORTED_MODULE_15__elements__["c" /* DARK */],action:"+2 attack"}],endAction:__WEBPACK_IMPORTED_MODULE_14__cards__["a" /* END_ACTIONS */].SHUFFLE},{initiative:7,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["c" /* MOVE */],"+1"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"-1"),{type:"element",use:__WEBPACK_IMPORTED_MODULE_15__elements__["c" /* DARK */],action:Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["e" /* INVISIBLE */],null,["Self"])}]},{initiative:26,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"-2",[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["e" /* RANGE */],"3"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["h" /* TARGET */],"3")]),{type:"element",use:__WEBPACK_IMPORTED_MODULE_15__elements__["c" /* DARK */],action:Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["f" /* MUDDLE */])}]},{initiative:4,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["c" /* MOVE */],"+1"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"-1"),{type:"element",create:__WEBPACK_IMPORTED_MODULE_15__elements__["c" /* DARK */]}]},{initiative:22,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["c" /* MOVE */],"+0"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"+0"),{type:"element",create:__WEBPACK_IMPORTED_MODULE_15__elements__["c" /* DARK */]}]}]},"Ooze":{tokenCount:10,stats:[{normal:{maxHP:4,move:1,attack:2,range:2,extra:[]},elite:{maxHP:8,move:1,attack:2,range:3,extra:[]}},{normal:{maxHP:5,move:1,attack:2,range:2,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* SHIELD */],"1")]},elite:{maxHP:9,move:1,attack:2,range:3,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* SHIELD */],"1")]}},{normal:{maxHP:7,move:1,attack:2,range:3,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* SHIELD */],"1")]},elite:{maxHP:11,move:1,attack:3,range:3,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* SHIELD */],"1")]}},{normal:{maxHP:8,move:1,attack:3,range:3,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* SHIELD */],"1")]},elite:{maxHP:11,move:2,attack:3,range:4,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["g" /* POISON */]),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* SHIELD */],"1")]}},{normal:{maxHP:9,move:2,attack:3,range:3,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* SHIELD */],"1")]},elite:{maxHP:13,move:2,attack:4,range:4,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["g" /* POISON */]),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* SHIELD */],"1")]}},{normal:{maxHP:10,move:2,attack:3,range:3,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["g" /* POISON */]),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* SHIELD */],"1")]},elite:{maxHP:15,move:3,attack:4,range:4,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["g" /* POISON */]),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* SHIELD */],"1")]}},{normal:{maxHP:12,move:2,attack:4,range:3,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["g" /* POISON */]),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* SHIELD */],"1")]},elite:{maxHP:16,move:3,attack:4,range:4,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["g" /* POISON */]),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* SHIELD */],"2")]}},{normal:{maxHP:14,move:2,attack:4,range:3,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["g" /* POISON */]),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* SHIELD */],"1")]},elite:{maxHP:18,move:3,attack:5,range:4,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["g" /* POISON */]),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* SHIELD */],"2")]}}],cards:[{initiative:36,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["c" /* MOVE */],"+1"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"-1")]},{initiative:57,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["c" /* MOVE */],"+0"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"+0")]},{initiative:59,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"+0",[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["h" /* TARGET */],"2"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["g" /* POISON */])])]},{initiative:66,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["c" /* MOVE */],"-1"),"loot 1",Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["b" /* HEAL */],"2",["Self"])]},{initiative:66,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["c" /* MOVE */],"-1"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"+1",[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["e" /* RANGE */],"+1")])]},{initiative:85,actions:["push 1 and poison, Target all adjacent enemies",Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"+1",[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["e" /* RANGE */],"-1")])]},{initiative:94,actions:["Ooze suffers 2 damage","Summon normal Ooze with a hit point value equal to the summoning Ooze's current hit point value (limited by a normal Ooze's specified maximum hit point value)"],endAction:__WEBPACK_IMPORTED_MODULE_14__cards__["a" /* END_ACTIONS */].SHUFFLE},{initiative:94,actions:["Ooze suffers 2 damage","Summon normal Ooze with a hit point value equal to the summoning Ooze's current hit point value (limited by a normal Ooze's specified maximum hit point value)"],endAction:__WEBPACK_IMPORTED_MODULE_14__cards__["a" /* END_ACTIONS */].SHUFFLE}]},"Rending Drake":{tokenCount:6,stats:[{normal:{maxHP:5,move:3,attack:3,range:0,extra:[]},elite:{maxHP:7,move:4,attack:4,range:0,extra:[]}},{normal:{maxHP:6,move:3,attack:3,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["l" /* WOUND */])]},elite:{maxHP:7,move:4,attack:5,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["l" /* WOUND */])]}},{normal:{maxHP:7,move:4,attack:3,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["l" /* WOUND */])]},elite:{maxHP:9,move:5,attack:5,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["l" /* WOUND */])]}},{normal:{maxHP:7,move:4,attack:4,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["l" /* WOUND */])]},elite:{maxHP:10,move:5,attack:6,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["l" /* WOUND */])]}},{normal:{maxHP:9,move:4,attack:4,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["l" /* WOUND */])]},elite:{maxHP:11,move:6,attack:6,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["l" /* WOUND */])]}},{normal:{maxHP:10,move:4,attack:5,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["l" /* WOUND */])]},elite:{maxHP:14,move:6,attack:6,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["l" /* WOUND */])]}},{normal:{maxHP:11,move:5,attack:5,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["l" /* WOUND */])]},elite:{maxHP:15,move:6,attack:7,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["l" /* WOUND */])]}},{normal:{maxHP:14,move:5,attack:5,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["l" /* WOUND */])]},elite:{maxHP:18,move:6,attack:7,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["l" /* WOUND */])]}}],cards:[{initiative:6,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* SHIELD */],"2"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["b" /* HEAL */],"2",["Self"]),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["j" /* STRENGTHEN */],null,["Self"])]},{initiative:12,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["c" /* MOVE */],"+1"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"-1")]},{initiative:13,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"-1"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["c" /* MOVE */],"-1"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"-1")],endAction:__WEBPACK_IMPORTED_MODULE_14__cards__["a" /* END_ACTIONS */].SHUFFLE},{initiative:25,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["c" /* MOVE */],"+0"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"+0")]},{initiative:39,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["c" /* MOVE */],"-1"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"+1")]},{initiative:54,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["c" /* MOVE */],"-2"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"-1",[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["e" /* RANGE */],"3"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["h" /* TARGET */],"2"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["g" /* POISON */])])]},{initiative:59,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["c" /* MOVE */],"-2"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"+1",[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["h" /* TARGET */],"2")])]},{initiative:72,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"-1"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"-1"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"-2")],endAction:__WEBPACK_IMPORTED_MODULE_14__cards__["a" /* END_ACTIONS */].SHUFFLE}]},"Savvas Lavaflow":{tokenCount:4,stats:[{normal:{maxHP:7,move:2,attack:2,range:3,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["d" /* PIERCE */],"3")]},elite:{maxHP:12,move:2,attack:3,range:4,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["d" /* PIERCE */],"3")]}},{normal:{maxHP:10,move:2,attack:2,range:4,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["d" /* PIERCE */],"3")]},elite:{maxHP:12,move:2,attack:3,range:5,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["d" /* PIERCE */],"3"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* SHIELD */],"1")]}},{normal:{maxHP:12,move:3,attack:2,range:4,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["d" /* PIERCE */],"3")]},elite:{maxHP:15,move:3,attack:3,range:5,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["d" /* PIERCE */],"3"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* SHIELD */],"1")]}},{normal:{maxHP:12,move:3,attack:3,range:4,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["d" /* PIERCE */],"3"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* SHIELD */],"1")]},elite:{maxHP:18,move:3,attack:4,range:6,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["d" /* PIERCE */],"3"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* SHIELD */],"1")]}},{normal:{maxHP:14,move:3,attack:3,range:5,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["d" /* PIERCE */],"3"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* SHIELD */],"1")]},elite:{maxHP:19,move:4,attack:4,range:6,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["d" /* PIERCE */],"3"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* SHIELD */],"2")]}},{normal:{maxHP:16,move:3,attack:4,range:5,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["d" /* PIERCE */],"3"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* SHIELD */],"1")]},elite:{maxHP:21,move:4,attack:5,range:6,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["d" /* PIERCE */],"3"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* SHIELD */],"2")]}},{normal:{maxHP:16,move:3,attack:4,range:5,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["d" /* PIERCE */],"3"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* SHIELD */],"2")]},elite:{maxHP:23,move:4,attack:6,range:6,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["d" /* PIERCE */],"3"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* SHIELD */],"2")]}},{normal:{maxHP:17,move:4,attack:4,range:6,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["d" /* PIERCE */],"3"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* SHIELD */],"2")]},elite:{maxHP:24,move:4,attack:6,range:6,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["d" /* PIERCE */],"4"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* SHIELD */],"3")]}}],cards:[{initiative:22,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["c" /* MOVE */],"+1"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"-1",["Target all adjacent enemies"]),{type:"element",use:__WEBPACK_IMPORTED_MODULE_15__elements__["e" /* FIRE */],action:Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["f" /* RETALIATE */],"3")}]},{initiative:31,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["b" /* HEAL */],"4",[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["e" /* RANGE */],"3")]),{type:"element",use:__WEBPACK_IMPORTED_MODULE_15__elements__["d" /* EARTH */],action:Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["h" /* TARGET */],"3")}]},{initiative:41,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["c" /* MOVE */],"+0"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"-1",[],__WEBPACK_IMPORTED_MODULE_7__aoe_line_4_with_black_svg___default.a),{type:"element",use:__WEBPACK_IMPORTED_MODULE_15__elements__["d" /* EARTH */],action:"+2 attack, immobilize"}]},{initiative:51,actions:["All enemies suffer 2 damage",{type:"element",use:__WEBPACK_IMPORTED_MODULE_15__elements__["e" /* FIRE */],action:"Wound all enemies"},{type:"element",use:__WEBPACK_IMPORTED_MODULE_15__elements__["d" /* EARTH */],action:"disarm all enemies"}]},{initiative:68,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["c" /* MOVE */],"-1"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"+1",[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["e" /* RANGE */],"3"),"All allies and enemies adjacent to the target suffer 2 damage."]),{type:"element",create:__WEBPACK_IMPORTED_MODULE_15__elements__["d" /* EARTH */]}],endAction:__WEBPACK_IMPORTED_MODULE_14__cards__["a" /* END_ACTIONS */].SHUFFLE},{initiative:68,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["c" /* MOVE */],"-1"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"-1",[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["e" /* RANGE */],"3"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["h" /* TARGET */],"2")]),{type:"element",create:__WEBPACK_IMPORTED_MODULE_15__elements__["e" /* FIRE */]}],endAction:__WEBPACK_IMPORTED_MODULE_14__cards__["a" /* END_ACTIONS */].SHUFFLE},{initiative:97,actions:["Summon normal Flame Demon",{type:"element",create:__WEBPACK_IMPORTED_MODULE_15__elements__["e" /* FIRE */]}]},{initiative:97,actions:["Summon normal Earth Demon",{type:"element",create:__WEBPACK_IMPORTED_MODULE_15__elements__["d" /* EARTH */]}]}]},"Savvas Icestorm":{tokenCount:4,stats:[{normal:{maxHP:8,move:3,attack:2,range:0,extra:[]},elite:{maxHP:13,move:3,attack:3,range:0,extra:[]}},{normal:{maxHP:9,move:3,attack:2,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["g" /* POISON */])]},elite:{maxHP:15,move:3,attack:3,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["l" /* WOUND */])]}},{normal:{maxHP:11,move:3,attack:3,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["g" /* POISON */])]},elite:{maxHP:18,move:3,attack:3,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["g" /* POISON */]),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["l" /* WOUND */])]}},{normal:{maxHP:14,move:3,attack:3,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["g" /* POISON */])]},elite:{maxHP:21,move:3,attack:4,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["g" /* POISON */]),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["l" /* WOUND */])]}},{normal:{maxHP:16,move:3,attack:4,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["g" /* POISON */])]},elite:{maxHP:24,move:4,attack:4,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["g" /* POISON */]),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["l" /* WOUND */])]}},{normal:{maxHP:18,move:3,attack:4,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["g" /* POISON */]),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["l" /* WOUND */])]},elite:{maxHP:27,move:4,attack:5,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["g" /* POISON */]),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["l" /* WOUND */])]}},{normal:{maxHP:20,move:4,attack:4,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["g" /* POISON */]),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["l" /* WOUND */])]},elite:{maxHP:30,move:4,attack:6,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["g" /* POISON */]),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["l" /* WOUND */])]}},{normal:{maxHP:24,move:4,attack:4,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["g" /* POISON */]),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["l" /* WOUND */])]},elite:{maxHP:35,move:4,attack:6,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["g" /* POISON */]),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["l" /* WOUND */])]}}],cards:[{initiative:14,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"+0"),{type:"element",use:__WEBPACK_IMPORTED_MODULE_15__elements__["f" /* ICE */],action:"+2 attack, immobiilize"},Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["f" /* RETALIATE */],"2"),{type:"element",create:__WEBPACK_IMPORTED_MODULE_15__elements__["a" /* AIR */]}]},{initiative:14,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* SHIELD */],"4"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["b" /* HEAL */],"2",[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["e" /* RANGE */],"3")]),{type:"element",use:__WEBPACK_IMPORTED_MODULE_15__elements__["f" /* ICE */],action:"+3 heal"},{type:"element",use:__WEBPACK_IMPORTED_MODULE_15__elements__["a" /* AIR */],action:Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"+0")}]},{initiative:19,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["c" /* MOVE */],"+0"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"-1",[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["e" /* RANGE */],"-1")]),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* SHIELD */],"1, Affect Self and all allies within range 2"),{type:"element",create:__WEBPACK_IMPORTED_MODULE_15__elements__["f" /* ICE */]}]},{initiative:35,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["c" /* MOVE */],"-1"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"-1",[],__WEBPACK_IMPORTED_MODULE_5__aoe_triangle_3_with_corner_black_svg___default.a),{type:"element",create:__WEBPACK_IMPORTED_MODULE_15__elements__["f" /* ICE */]}],endAction:__WEBPACK_IMPORTED_MODULE_14__cards__["a" /* END_ACTIONS */].SHUFFLE},{initiative:47,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["c" /* DISARM */],null,["Target all adjacent enemies"]),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["c" /* MOVE */],"+0"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"-1"),{type:"element",create:__WEBPACK_IMPORTED_MODULE_15__elements__["a" /* AIR */]}],endAction:__WEBPACK_IMPORTED_MODULE_14__cards__["a" /* END_ACTIONS */].SHUFFLE},{initiative:70,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["i" /* PUSH */],"2",["Target all adjacent enemies"]),{type:"element",use:__WEBPACK_IMPORTED_MODULE_15__elements__["a" /* AIR */],action:"push 4 instead"},Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"+1",[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["e" /* RANGE */],"+1")])]},{initiative:98,actions:["Summon normal Wind Demon",{type:"element",create:__WEBPACK_IMPORTED_MODULE_15__elements__["a" /* AIR */]}]},{initiative:98,actions:["Summon normal Frost Demon",{type:"element",create:__WEBPACK_IMPORTED_MODULE_15__elements__["f" /* ICE */]}]}]},"Spitting Drake":{tokenCount:6,stats:[{normal:{maxHP:5,move:3,attack:3,range:3,extra:[]},elite:{maxHP:8,move:3,attack:4,range:4,extra:[]}},{normal:{maxHP:6,move:3,attack:3,range:3,extra:[]},elite:{maxHP:9,move:3,attack:4,range:4,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["f" /* MUDDLE */])]}},{normal:{maxHP:8,move:3,attack:3,range:3,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["f" /* MUDDLE */])]},elite:{maxHP:10,move:3,attack:5,range:4,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["f" /* MUDDLE */])]}},{normal:{maxHP:8,move:3,attack:4,range:4,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["f" /* MUDDLE */])]},elite:{maxHP:12,move:3,attack:5,range:5,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["f" /* MUDDLE */])]}},{normal:{maxHP:9,move:4,attack:4,range:4,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["f" /* MUDDLE */])]},elite:{maxHP:14,move:4,attack:5,range:5,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["f" /* MUDDLE */])]}},{normal:{maxHP:12,move:4,attack:4,range:4,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["f" /* MUDDLE */])]},elite:{maxHP:16,move:4,attack:6,range:5,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["f" /* MUDDLE */])]}},{normal:{maxHP:13,move:4,attack:5,range:4,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["f" /* MUDDLE */])]},elite:{maxHP:19,move:4,attack:6,range:5,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["f" /* MUDDLE */])]}},{normal:{maxHP:16,move:4,attack:5,range:4,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["f" /* MUDDLE */])]},elite:{maxHP:21,move:4,attack:7,range:5,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["f" /* MUDDLE */])]}}],cards:[{initiative:27,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"+0",[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["h" /* TARGET */],"2"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["g" /* POISON */])])]},{initiative:6,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* SHIELD */],"2"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["b" /* HEAL */],"2",["Self"]),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["j" /* STRENGTHEN */],null,["Self"])]},{initiative:32,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["c" /* MOVE */],"+1"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"-1")]},{initiative:52,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["c" /* MOVE */],"+0"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"+0")]},{initiative:87,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["c" /* MOVE */],"-1"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"+1")]},{initiative:89,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"-2",[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["k" /* STUN */])])]},{initiative:57,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["c" /* MOVE */],"+0"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"-1",[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["e" /* RANGE */],"-1")],__WEBPACK_IMPORTED_MODULE_3__aoe_triangle_2_svg___default.a)],endAction:__WEBPACK_IMPORTED_MODULE_14__cards__["a" /* END_ACTIONS */].SHUFFLE},{initiative:89,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["c" /* MOVE */],"-1"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"-2",[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["e" /* RANGE */],"-2"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["g" /* POISON */])],__WEBPACK_IMPORTED_MODULE_0__aoe_circle_svg___default.a)],endAction:__WEBPACK_IMPORTED_MODULE_14__cards__["a" /* END_ACTIONS */].SHUFFLE}]},"Stone Golem":{tokenCount:6,stats:[{normal:{maxHP:10,move:1,attack:3,range:0,extra:[]},elite:{maxHP:10,move:2,attack:4,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* SHIELD */],"1")]}},{normal:{maxHP:10,move:1,attack:3,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* SHIELD */],"1")]},elite:{maxHP:11,move:2,attack:4,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* SHIELD */],"2")]}},{normal:{maxHP:11,move:1,attack:4,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* SHIELD */],"1")]},elite:{maxHP:14,move:2,attack:5,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* SHIELD */],"2")]}},{normal:{maxHP:11,move:1,attack:4,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* SHIELD */],"2")]},elite:{maxHP:15,move:2,attack:5,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* SHIELD */],"3")]}},{normal:{maxHP:12,move:2,attack:4,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* SHIELD */],"2")]},elite:{maxHP:17,move:2,attack:6,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* SHIELD */],"3")]}},{normal:{maxHP:13,move:2,attack:5,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* SHIELD */],"2")]},elite:{maxHP:19,move:3,attack:6,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* SHIELD */],"3")]}},{normal:{maxHP:16,move:2,attack:5,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* SHIELD */],"2")]},elite:{maxHP:20,move:3,attack:7,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* SHIELD */],"3")]}},{normal:{maxHP:16,move:2,attack:5,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* SHIELD */],"3")]},elite:{maxHP:21,move:3,attack:7,range:0,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* SHIELD */],"4")]}}],cards:[{initiative:51,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["c" /* MOVE */],"+1"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"-1")],endAction:__WEBPACK_IMPORTED_MODULE_14__cards__["a" /* END_ACTIONS */].SHUFFLE},{initiative:65,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["c" /* MOVE */],"+0"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"+0")]},{initiative:90,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["c" /* MOVE */],"-1"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"+1")],endAction:__WEBPACK_IMPORTED_MODULE_14__cards__["a" /* END_ACTIONS */].SHUFFLE},{initiative:11,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["f" /* RETALIATE */],"3",[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["e" /* RANGE */],"3")])]},{initiative:28,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["c" /* MOVE */],"+1"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"+0"),"Stone Golem suffers 1 damage"]},{initiative:72,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"+1",[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["e" /* RANGE */],"3")]),"Stone Golem suffers 2 damage"]},{initiative:83,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["c" /* MOVE */],"+0"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"-1",["Target all adjacent enemies"])]},{initiative:28,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["c" /* MOVE */],"+1"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"-2",[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["e" /* RANGE */],"3"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["h" /* PULL */],"2"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["d" /* IMMOBILIZE */])])]}]},"Sun Demon":{tokenCount:6,stats:[{normal:{maxHP:5,move:2,attack:2,range:0,extra:["advantage",Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* SHIELD */],"1")]},elite:{maxHP:9,move:2,attack:3,range:0,extra:["advantage",Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* SHIELD */],"1")]}},{normal:{maxHP:7,move:2,attack:2,range:0,extra:["advantage",Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* SHIELD */],"1")]},elite:{maxHP:12,move:2,attack:3,range:0,extra:["advantage",Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* SHIELD */],"1")]}},{normal:{maxHP:9,move:2,attack:2,range:0,extra:["advantage",Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* SHIELD */],"1")]},elite:{maxHP:13,move:2,attack:4,range:0,extra:["advantage",Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* SHIELD */],"1")]}},{normal:{maxHP:10,move:2,attack:3,range:0,extra:["advantage",Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* SHIELD */],"1")]},elite:{maxHP:15,move:3,attack:4,range:0,extra:["advantage",Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* SHIELD */],"1")]}},{normal:{maxHP:11,move:3,attack:3,range:0,extra:["advantage",Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* SHIELD */],"1")]},elite:{maxHP:16,move:3,attack:5,range:0,extra:["advantage",Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* SHIELD */],"1")]}},{normal:{maxHP:11,move:3,attack:3,range:0,extra:["advantage",Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* SHIELD */],"2")]},elite:{maxHP:16,move:3,attack:5,range:0,extra:["advantage",Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* SHIELD */],"2")]}},{normal:{maxHP:12,move:3,attack:4,range:0,extra:["advantage",Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* SHIELD */],"2")]},elite:{maxHP:18,move:4,attack:5,range:0,extra:["advantage",Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* SHIELD */],"2")]}},{normal:{maxHP:15,move:3,attack:4,range:0,extra:["advantage",Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* SHIELD */],"2")]},elite:{maxHP:22,move:4,attack:5,range:0,extra:["advantage",Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* SHIELD */],"2")]}}],cards:[{initiative:95,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["c" /* MOVE */],"-1"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"+0",[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["e" /* RANGE */],"4")]),{type:"element",use:__WEBPACK_IMPORTED_MODULE_15__elements__["g" /* LIGHT */],action:"Target all enemies within range"}]},{initiative:88,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["c" /* MOVE */],"-1"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"-1",["Target all adjacent enemies"]),{type:"element",use:__WEBPACK_IMPORTED_MODULE_15__elements__["c" /* DARK */],action:Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["f" /* MUDDLE */],null,["Self"])}]},{initiative:17,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["b" /* HEAL */],"3",[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["e" /* RANGE */],"3")]),{type:"element",use:__WEBPACK_IMPORTED_MODULE_15__elements__["g" /* LIGHT */],action:"Target all allies within range"}],endAction:__WEBPACK_IMPORTED_MODULE_14__cards__["a" /* END_ACTIONS */].SHUFFLE},{initiative:73,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["c" /* MOVE */],"+0"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"+1"),{type:"element",use:__WEBPACK_IMPORTED_MODULE_15__elements__["g" /* LIGHT */],action:Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["b" /* HEAL */],"3",["Self"])}],endAction:__WEBPACK_IMPORTED_MODULE_14__cards__["a" /* END_ACTIONS */].SHUFFLE},{initiative:68,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["c" /* MOVE */],"+0"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"+1"),{type:"element",create:__WEBPACK_IMPORTED_MODULE_15__elements__["g" /* LIGHT */]}]},{initiative:36,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["c" /* MOVE */],"+0"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"+0",["Target all adjacent enemies"]),{type:"element",create:__WEBPACK_IMPORTED_MODULE_15__elements__["g" /* LIGHT */]}]},{initiative:36,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["c" /* MOVE */],"+0"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"+0",["Target all adjacent enemies"]),{type:"element",create:__WEBPACK_IMPORTED_MODULE_15__elements__["g" /* LIGHT */]}]},{initiative:50,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["c" /* MOVE */],"+0"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"+0",[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["e" /* RANGE */],"3")]),{type:"element",use:__WEBPACK_IMPORTED_MODULE_15__elements__["b" /* ANY */],create:__WEBPACK_IMPORTED_MODULE_15__elements__["g" /* LIGHT */]}]}]},"Vermling Scout":{tokenCount:10,stats:[{normal:{maxHP:2,move:3,attack:1,range:0,extra:[]},elite:{maxHP:4,move:3,attack:2,range:0,extra:[]}},{normal:{maxHP:3,move:3,attack:1,range:0,extra:[]},elite:{maxHP:5,move:3,attack:2,range:0,extra:[]}},{normal:{maxHP:3,move:3,attack:2,range:0,extra:[]},elite:{maxHP:5,move:4,attack:3,range:0,extra:[]}},{normal:{maxHP:5,move:3,attack:2,range:0,extra:[]},elite:{maxHP:7,move:4,attack:3,range:0,extra:[]}},{normal:{maxHP:6,move:3,attack:3,range:0,extra:[]},elite:{maxHP:8,move:4,attack:4,range:0,extra:[]}},{normal:{maxHP:8,move:3,attack:3,range:0,extra:[]},elite:{maxHP:11,move:4,attack:4,range:0,extra:[]}},{normal:{maxHP:9,move:4,attack:3,range:0,extra:[]},elite:{maxHP:12,move:5,attack:4,range:0,extra:[]}},{normal:{maxHP:11,move:4,attack:3,range:0,extra:[]},elite:{maxHP:15,move:5,attack:4,range:0,extra:[]}}],cards:SCOUT_CARDS},"Vermling Shaman":{tokenCount:6,stats:[{normal:{maxHP:2,move:2,attack:1,range:3,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* SHIELD */],"2")]},elite:{maxHP:3,move:3,attack:2,range:3,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* SHIELD */],"2")]}},{normal:{maxHP:2,move:2,attack:1,range:3,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* SHIELD */],"3")]},elite:{maxHP:3,move:3,attack:2,range:3,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* SHIELD */],"3")]}},{normal:{maxHP:3,move:2,attack:1,range:4,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* SHIELD */],"3")]},elite:{maxHP:4,move:3,attack:2,range:4,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* SHIELD */],"3")]}},{normal:{maxHP:3,move:2,attack:2,range:4,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* SHIELD */],"3")]},elite:{maxHP:5,move:3,attack:3,range:4,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* SHIELD */],"3")]}},{normal:{maxHP:3,move:3,attack:2,range:4,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["f" /* MUDDLE */]),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* SHIELD */],"3")]},elite:{maxHP:5,move:3,attack:3,range:4,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["f" /* MUDDLE */]),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* SHIELD */],"4")]}},{normal:{maxHP:4,move:3,attack:3,range:4,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["f" /* MUDDLE */]),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* SHIELD */],"3")]},elite:{maxHP:6,move:3,attack:4,range:4,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["f" /* MUDDLE */]),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* SHIELD */],"4")]}},{normal:{maxHP:5,move:3,attack:4,range:4,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["f" /* MUDDLE */]),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* SHIELD */],"3")]},elite:{maxHP:6,move:3,attack:4,range:4,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["f" /* MUDDLE */]),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* SHIELD */],"5")]}},{normal:{maxHP:7,move:3,attack:4,range:4,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["f" /* MUDDLE */]),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* SHIELD */],"3")]},elite:{maxHP:8,move:3,attack:4,range:4,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["f" /* MUDDLE */]),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* SHIELD */],"5")]}}],cards:SHAMAN_CARDS},"Wind Demon":{tokenCount:6,stats:[{normal:{maxHP:3,move:3,attack:2,range:3,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* SHIELD */],"1")]},elite:{maxHP:5,move:4,attack:3,range:4,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* SHIELD */],"1")]}},{normal:{maxHP:3,move:3,attack:2,range:3,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* SHIELD */],"2")]},elite:{maxHP:5,move:4,attack:3,range:4,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* SHIELD */],"2")]}},{normal:{maxHP:4,move:4,attack:2,range:3,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* SHIELD */],"2")]},elite:{maxHP:7,move:5,attack:3,range:4,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* SHIELD */],"2")]}},{normal:{maxHP:5,move:4,attack:3,range:3,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* SHIELD */],"2")]},elite:{maxHP:8,move:5,attack:4,range:4,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* SHIELD */],"2")]}},{normal:{maxHP:7,move:4,attack:3,range:3,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* SHIELD */],"2")]},elite:{maxHP:8,move:5,attack:4,range:4,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["c" /* DISARM */]),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* SHIELD */],"2")]}},{normal:{maxHP:9,move:4,attack:3,range:4,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* SHIELD */],"2")]},elite:{maxHP:11,move:5,attack:4,range:4,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["c" /* DISARM */]),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* SHIELD */],"2")]}},{normal:{maxHP:10,move:4,attack:3,range:4,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* SHIELD */],"3")]},elite:{maxHP:12,move:5,attack:4,range:4,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["c" /* DISARM */]),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* SHIELD */],"3")]}},{normal:{maxHP:11,move:4,attack:4,range:4,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* SHIELD */],"3")]},elite:{maxHP:13,move:5,attack:5,range:4,extra:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["c" /* DISARM */]),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* SHIELD */],"3")]}}],cards:[{initiative:37,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["c" /* MOVE */],"+0"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"+0",[],__WEBPACK_IMPORTED_MODULE_9__aoe_4_with_black_svg___default.a),{type:"element",use:__WEBPACK_IMPORTED_MODULE_15__elements__["a" /* AIR */],action:"+1 attack",image:__WEBPACK_IMPORTED_MODULE_2__aoe_circle_with_side_black_svg___default.a}]},{initiative:9,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"-1"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["b" /* HEAL */],"1",["Self"]),{type:"element",use:__WEBPACK_IMPORTED_MODULE_15__elements__["a" /* AIR */],action:Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["e" /* INVISIBLE */],null,["Self"])}]},{initiative:21,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["c" /* MOVE */],"+0"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"+0",[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["h" /* PULL */],"1")]),{type:"element",create:__WEBPACK_IMPORTED_MODULE_15__elements__["a" /* AIR */]}],endAction:__WEBPACK_IMPORTED_MODULE_14__cards__["a" /* END_ACTIONS */].SHUFFLE},{initiative:21,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["c" /* MOVE */],"+0"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"+0",[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["h" /* PULL */],"1")]),{type:"element",create:__WEBPACK_IMPORTED_MODULE_15__elements__["a" /* AIR */]}],endAction:__WEBPACK_IMPORTED_MODULE_14__cards__["a" /* END_ACTIONS */].SHUFFLE},{initiative:29,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["c" /* MOVE */],"+0"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"-1",[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["h" /* TARGET */],"2")]),{type:"element",use:__WEBPACK_IMPORTED_MODULE_15__elements__["a" /* AIR */],action:Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["i" /* PUSH */],"2")}]},{initiative:43,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["c" /* MOVE */],"-1"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"+1"),{type:"element",use:__WEBPACK_IMPORTED_MODULE_15__elements__["a" /* AIR */],action:Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["h" /* TARGET */],"2")}]},{initiative:43,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["i" /* PUSH */],"1",["Target all adjacent enemies"]),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"+0"),{type:"element",use:__WEBPACK_IMPORTED_MODULE_15__elements__["d" /* EARTH */],action:"-2 range"}]},{initiative:2,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* SHIELD */],"1"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["c" /* MOVE */],"-1"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"+1"),{type:"element",use:__WEBPACK_IMPORTED_MODULE_15__elements__["b" /* ANY */],create:__WEBPACK_IMPORTED_MODULE_15__elements__["a" /* AIR */]}]}]}};var MONSTER_LIST=Object.keys(MONSTERS);var BOSS_STATS={"Bandit Commander":[function(numPlayers){return{maxHP:8*numPlayers,move:3,attack:3,range:0,specialOne:["Move to next door and reveal room"],specialTwo:["Summon Living Bones"],immunities:[__WEBPACK_IMPORTED_MODULE_16__statusEffects__["d" /* IMMOBILIZE */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["k" /* STUN */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["b" /* CURSE */]]};},function(numPlayers){return{maxHP:10*numPlayers,move:3,attack:3,range:0,specialOne:["Move to next door and reveal room"],specialTwo:["Summon Living Bones"],immunities:[__WEBPACK_IMPORTED_MODULE_16__statusEffects__["d" /* IMMOBILIZE */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["k" /* STUN */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["b" /* CURSE */]]};},function(numPlayers){return{maxHP:12*numPlayers,move:4,attack:3,range:0,specialOne:["Move to next door and reveal room"],specialTwo:["Summon Living Bones"],immunities:[__WEBPACK_IMPORTED_MODULE_16__statusEffects__["d" /* IMMOBILIZE */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["k" /* STUN */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["b" /* CURSE */]]};},function(numPlayers){return{maxHP:13*numPlayers,move:4,attack:4,range:0,specialOne:["Move to next door and reveal room"],specialTwo:["Summon Living Bones"],immunities:[__WEBPACK_IMPORTED_MODULE_16__statusEffects__["d" /* IMMOBILIZE */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["k" /* STUN */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["b" /* CURSE */]]};},function(numPlayers){return{maxHP:15*numPlayers,move:4,attack:4,range:0,specialOne:["Move to next door and reveal room"],specialTwo:["Summon Living Bones"],immunities:[__WEBPACK_IMPORTED_MODULE_16__statusEffects__["d" /* IMMOBILIZE */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["k" /* STUN */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["b" /* CURSE */]]};},function(numPlayers){return{maxHP:16*numPlayers,move:5,attack:5,range:0,specialOne:["Move to next door and reveal room"],specialTwo:["Summon Living Bones"],immunities:[__WEBPACK_IMPORTED_MODULE_16__statusEffects__["d" /* IMMOBILIZE */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["k" /* STUN */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["b" /* CURSE */]]};},function(numPlayers){return{maxHP:19*numPlayers,move:5,attack:5,range:0,specialOne:["Move to next door and reveal room"],specialTwo:["Summon Living Bones"],immunities:[__WEBPACK_IMPORTED_MODULE_16__statusEffects__["d" /* IMMOBILIZE */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["k" /* STUN */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["b" /* CURSE */]]};},function(numPlayers){return{maxHP:23*numPlayers,move:5,attack:5,range:0,specialOne:["Move to next door and reveal room"],specialTwo:["Summon Living Bones"],immunities:[__WEBPACK_IMPORTED_MODULE_16__statusEffects__["d" /* IMMOBILIZE */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["k" /* STUN */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["b" /* CURSE */]]};}],"The Betrayer":[function(numPlayers){return{maxHP:10*numPlayers,move:3,attack:4,range:3,specialOne:["Summon Giant Viper and Fear"],specialTwo:["Mind Control"],immunities:[__WEBPACK_IMPORTED_MODULE_16__statusEffects__["g" /* POISON */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["l" /* WOUND */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["c" /* DISARM */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["k" /* STUN */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["b" /* CURSE */]]};},function(numPlayers){return{maxHP:12*numPlayers,move:3,attack:5,range:3,specialOne:["Summon Giant Viper and Fear"],specialTwo:["Mind Control"],immunities:[__WEBPACK_IMPORTED_MODULE_16__statusEffects__["g" /* POISON */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["l" /* WOUND */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["c" /* DISARM */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["k" /* STUN */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["b" /* CURSE */]]};},function(numPlayers){return{maxHP:14*numPlayers,move:3,attack:6,range:4,specialOne:["Summon Giant Viper and Fear"],specialTwo:["Mind Control"],immunities:[__WEBPACK_IMPORTED_MODULE_16__statusEffects__["g" /* POISON */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["l" /* WOUND */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["c" /* DISARM */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["k" /* STUN */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["b" /* CURSE */]]};},function(numPlayers){return{maxHP:16*numPlayers,move:4,attack:7,range:4,specialOne:["Summon Giant Viper and Fear"],specialTwo:["Mind Control"],immunities:[__WEBPACK_IMPORTED_MODULE_16__statusEffects__["g" /* POISON */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["l" /* WOUND */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["c" /* DISARM */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["k" /* STUN */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["b" /* CURSE */]]};},function(numPlayers){return{maxHP:18*numPlayers,move:4,attack:8,range:4,specialOne:["Summon Giant Viper and Fear"],specialTwo:["Mind Control"],immunities:[__WEBPACK_IMPORTED_MODULE_16__statusEffects__["g" /* POISON */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["l" /* WOUND */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["c" /* DISARM */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["k" /* STUN */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["b" /* CURSE */]]};},function(numPlayers){return{maxHP:20*numPlayers,move:5,attack:8,range:5,specialOne:["Summon Giant Viper and Fear"],specialTwo:["Mind Control"],immunities:[__WEBPACK_IMPORTED_MODULE_16__statusEffects__["g" /* POISON */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["l" /* WOUND */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["c" /* DISARM */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["k" /* STUN */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["b" /* CURSE */]]};},function(numPlayers){return{maxHP:23*numPlayers,move:5,attack:9,range:5,specialOne:["Summon Giant Viper and Fear"],specialTwo:["Mind Control"],immunities:[__WEBPACK_IMPORTED_MODULE_16__statusEffects__["g" /* POISON */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["l" /* WOUND */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["c" /* DISARM */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["k" /* STUN */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["b" /* CURSE */]]};},function(numPlayers){return{maxHP:27*numPlayers,move:5,attack:9,range:5,specialOne:["Summon Giant Viper and Fear"],specialTwo:["Mind Control"],immunities:[__WEBPACK_IMPORTED_MODULE_16__statusEffects__["g" /* POISON */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["l" /* WOUND */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["c" /* DISARM */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["k" /* STUN */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["b" /* CURSE */]]};}],"Captain of the Guard":[function(numPlayers){return{maxHP:7*numPlayers,move:2,attack:3,range:0,specialOne:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["b" /* HEAL */],"2",["Affect Self and all allies"])],specialTwo:["All allies add +1 attack to all attacks this round"],immunities:[__WEBPACK_IMPORTED_MODULE_16__statusEffects__["l" /* WOUND */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["c" /* DISARM */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["k" /* STUN */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["f" /* MUDDLE */]]};},function(numPlayers){return{maxHP:9*numPlayers,move:2,attack:3,range:0,specialOne:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["b" /* HEAL */],"2",["Affect Self and all allies"])],specialTwo:["All allies add +1 attack to all attacks this round"],immunities:[__WEBPACK_IMPORTED_MODULE_16__statusEffects__["l" /* WOUND */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["c" /* DISARM */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["k" /* STUN */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["f" /* MUDDLE */]]};},function(numPlayers){return{maxHP:11*numPlayers,move:2,attack:4,range:0,specialOne:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["b" /* HEAL */],"2",["Affect Self and all allies"])],specialTwo:["All allies add +1 attack to all attacks this round"],immunities:[__WEBPACK_IMPORTED_MODULE_16__statusEffects__["l" /* WOUND */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["c" /* DISARM */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["k" /* STUN */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["f" /* MUDDLE */]]};},function(numPlayers){return{maxHP:14*numPlayers,move:3,attack:4,range:0,specialOne:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["b" /* HEAL */],"2",["Affect Self and all allies"])],specialTwo:["All allies add +1 attack to all attacks this round"],immunities:[__WEBPACK_IMPORTED_MODULE_16__statusEffects__["l" /* WOUND */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["c" /* DISARM */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["k" /* STUN */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["f" /* MUDDLE */]]};},function(numPlayers){return{maxHP:16*numPlayers,move:3,attack:5,range:0,specialOne:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["b" /* HEAL */],"2",["Affect Self and all allies"])],specialTwo:["All allies add +1 attack to all attacks this round"],immunities:[__WEBPACK_IMPORTED_MODULE_16__statusEffects__["l" /* WOUND */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["c" /* DISARM */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["k" /* STUN */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["f" /* MUDDLE */]]};},function(numPlayers){return{maxHP:20*numPlayers,move:3,attack:5,range:0,specialOne:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["b" /* HEAL */],"2",["Affect Self and all allies"])],specialTwo:["All allies add +1 attack to all attacks this round"],immunities:[__WEBPACK_IMPORTED_MODULE_16__statusEffects__["c" /* DISARM */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["l" /* WOUND */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["f" /* MUDDLE */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["k" /* STUN */]]};},function(numPlayers){return{maxHP:21*numPlayers,move:4,attack:6,range:0,specialOne:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["b" /* HEAL */],"2",["Affect Self and all allies"])],specialTwo:["All allies add +1 attack to all attacks this round"],immunities:[__WEBPACK_IMPORTED_MODULE_16__statusEffects__["l" /* WOUND */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["c" /* DISARM */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["k" /* STUN */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["f" /* MUDDLE */]]};},function(numPlayers){return{maxHP:25*numPlayers,move:4,attack:6,range:0,specialOne:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["b" /* HEAL */],"2",["Affect Self and all allies"])],specialTwo:["All allies add +1 attack to all attacks this round"],immunities:[__WEBPACK_IMPORTED_MODULE_16__statusEffects__["l" /* WOUND */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["c" /* DISARM */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["k" /* STUN */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["f" /* MUDDLE */]]};}],"The Colorless":[function(numPlayers){return{maxHP:9*numPlayers,move:3,attack:2,range:0,specialOne:[{type:"element",use:__WEBPACK_IMPORTED_MODULE_15__elements__["c" /* DARK */],action:"Summon Night Demon"},Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["e" /* INVISIBLE */],null,["Self"])],specialTwo:[{type:"element",use:__WEBPACK_IMPORTED_MODULE_15__elements__["g" /* LIGHT */],action:"Summon Sun Demon"},Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["b" /* HEAL */],"4",["Self"]),"sheld 1"],immunities:[__WEBPACK_IMPORTED_MODULE_16__statusEffects__["l" /* WOUND */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["c" /* DISARM */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["k" /* STUN */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["f" /* MUDDLE */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["b" /* CURSE */]]};},function(numPlayers){return{maxHP:10*numPlayers,move:3,attack:3,range:0,specialOne:[{type:"element",use:__WEBPACK_IMPORTED_MODULE_15__elements__["c" /* DARK */],action:"Summon Night Demon"},Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["e" /* INVISIBLE */],null,["Self"])],specialTwo:[{type:"element",use:__WEBPACK_IMPORTED_MODULE_15__elements__["g" /* LIGHT */],action:"Summon Sun Demon"},Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["b" /* HEAL */],"4",["Self"]),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* SHIELD */],"1")],immunities:[__WEBPACK_IMPORTED_MODULE_16__statusEffects__["l" /* WOUND */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["c" /* DISARM */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["k" /* STUN */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["f" /* MUDDLE */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["b" /* CURSE */]]};},function(numPlayers){return{maxHP:11*numPlayers,move:4,attack:3,range:0,specialOne:[{type:"element",use:__WEBPACK_IMPORTED_MODULE_15__elements__["c" /* DARK */],action:"Summon Night Demon"},Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["e" /* INVISIBLE */],null,["Self"])],specialTwo:[{type:"element",use:__WEBPACK_IMPORTED_MODULE_15__elements__["g" /* LIGHT */],action:"Summon Sun Demon"},Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["b" /* HEAL */],"5",["Self"]),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* SHIELD */],"1")],immunities:[__WEBPACK_IMPORTED_MODULE_16__statusEffects__["l" /* WOUND */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["c" /* DISARM */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["k" /* STUN */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["f" /* MUDDLE */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["b" /* CURSE */]]};},function(numPlayers){return{maxHP:12*numPlayers,move:4,attack:4,range:0,specialOne:[{type:"element",use:__WEBPACK_IMPORTED_MODULE_15__elements__["c" /* DARK */],action:"Summon Night Demon"},Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["e" /* INVISIBLE */],null,["Self"])],specialTwo:[{type:"element",use:__WEBPACK_IMPORTED_MODULE_15__elements__["g" /* LIGHT */],action:"Summon Sun Demon"},Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["b" /* HEAL */],"5",["Self"]),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* SHIELD */],"1")],immunities:[__WEBPACK_IMPORTED_MODULE_16__statusEffects__["l" /* WOUND */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["c" /* DISARM */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["k" /* STUN */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["f" /* MUDDLE */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["b" /* CURSE */]]};},function(numPlayers){return{maxHP:14*numPlayers,move:4,attack:4,range:0,specialOne:[{type:"element",use:__WEBPACK_IMPORTED_MODULE_15__elements__["c" /* DARK */],action:"Summon Night Demon"},Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["e" /* INVISIBLE */],null,["Self"])],specialTwo:[{type:"element",use:__WEBPACK_IMPORTED_MODULE_15__elements__["g" /* LIGHT */],action:"Summon Sun Demon"},Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["b" /* HEAL */],"6",["Self"]),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* SHIELD */],"1")],immunities:[__WEBPACK_IMPORTED_MODULE_16__statusEffects__["l" /* WOUND */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["c" /* DISARM */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["k" /* STUN */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["f" /* MUDDLE */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["b" /* CURSE */]]};},function(numPlayers){return{maxHP:15*numPlayers,move:4,attack:5,range:0,specialOne:[{type:"element",use:__WEBPACK_IMPORTED_MODULE_15__elements__["c" /* DARK */],action:"Summon Night Demon"},Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["e" /* INVISIBLE */],null,["Self"])],specialTwo:[{type:"element",use:__WEBPACK_IMPORTED_MODULE_15__elements__["g" /* LIGHT */],action:"Summon Sun Demon"},Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["b" /* HEAL */],"6",["Self"]),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* SHIELD */],"1")],immunities:[__WEBPACK_IMPORTED_MODULE_16__statusEffects__["l" /* WOUND */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["c" /* DISARM */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["k" /* STUN */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["f" /* MUDDLE */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["b" /* CURSE */]]};},function(numPlayers){return{maxHP:17*numPlayers,move:4,attack:6,range:0,specialOne:[{type:"element",use:__WEBPACK_IMPORTED_MODULE_15__elements__["c" /* DARK */],action:"Summon Night Demon"},Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["e" /* INVISIBLE */],null,["Self"])],specialTwo:[{type:"element",use:__WEBPACK_IMPORTED_MODULE_15__elements__["g" /* LIGHT */],action:"Summon Sun Demon"},Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["b" /* HEAL */],"7",["Self"]),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* SHIELD */],"1")],immunities:[__WEBPACK_IMPORTED_MODULE_16__statusEffects__["l" /* WOUND */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["c" /* DISARM */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["k" /* STUN */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["f" /* MUDDLE */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["b" /* CURSE */]]};},function(numPlayers){return{maxHP:19*numPlayers,move:5,attack:7,range:0,specialOne:[{type:"element",use:__WEBPACK_IMPORTED_MODULE_15__elements__["c" /* DARK */],action:"Summon Night Demon"},Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["e" /* INVISIBLE */],null,["Self"])],specialTwo:[{type:"element",use:__WEBPACK_IMPORTED_MODULE_15__elements__["g" /* LIGHT */],action:"Summon Sun Demon"},Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["b" /* HEAL */],"7",["Self"]),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* SHIELD */],"1")],immunities:[__WEBPACK_IMPORTED_MODULE_16__statusEffects__["l" /* WOUND */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["c" /* DISARM */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["k" /* STUN */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["f" /* MUDDLE */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["b" /* CURSE */]]};}],"Dark Rider":[function(numPlayers){return{maxHP:9*numPlayers,move:2,attack:"3+X",range:0,specialOne:["move +2, attack +0"],specialTwo:["move +0, Summon Imp, attack -1"],extra:["X = Hexes moved"],immunities:[__WEBPACK_IMPORTED_MODULE_16__statusEffects__["g" /* POISON */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["d" /* IMMOBILIZE */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["c" /* DISARM */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["k" /* STUN */]]};},function(numPlayers){return{maxHP:10*numPlayers,move:3,attack:"3+X",range:0,specialOne:["move +2, attack +0"],specialTwo:["move +0, Summon Imp, attack -1"],extra:["X = Hexes moved"],immunities:[__WEBPACK_IMPORTED_MODULE_16__statusEffects__["g" /* POISON */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["d" /* IMMOBILIZE */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["c" /* DISARM */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["k" /* STUN */]]};},function(numPlayers){return{maxHP:12*numPlayers,move:3,attack:"3+X",range:0,specialOne:["move +2, attack +0"],specialTwo:["move +0, Summon Imp, attack -1"],extra:["X = Hexes moved"],immunities:[__WEBPACK_IMPORTED_MODULE_16__statusEffects__["g" /* POISON */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["d" /* IMMOBILIZE */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["c" /* DISARM */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["k" /* STUN */]]};},function(numPlayers){return{maxHP:13*numPlayers,move:3,attack:"4+X",range:0,specialOne:["move +2, attack +0"],specialTwo:["move +0, Summon Imp, attack -1"],extra:["X = Hexes moved"],immunities:[__WEBPACK_IMPORTED_MODULE_16__statusEffects__["g" /* POISON */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["d" /* IMMOBILIZE */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["c" /* DISARM */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["k" /* STUN */]]};},function(numPlayers){return{maxHP:15*numPlayers,move:3,attack:"4+X",range:0,specialOne:["move +2, attack +0"],specialTwo:["move +0, Summon Imp, attack -1"],extra:["X = Hexes moved"],immunities:[__WEBPACK_IMPORTED_MODULE_16__statusEffects__["g" /* POISON */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["d" /* IMMOBILIZE */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["c" /* DISARM */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["k" /* STUN */]]};},function(numPlayers){return{maxHP:16*numPlayers,move:3,attack:"5+X",range:0,specialOne:["move +2, attack +0"],specialTwo:["move +0, Summon Imp, attack -1"],extra:["X = Hexes moved"],immunities:[__WEBPACK_IMPORTED_MODULE_16__statusEffects__["g" /* POISON */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["d" /* IMMOBILIZE */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["c" /* DISARM */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["k" /* STUN */]]};},function(numPlayers){return{maxHP:16*numPlayers,move:4,attack:"5+X",range:0,specialOne:["move +2, attack +0"],specialTwo:["move +0, Summon Imp, attack -1"],extra:["X = Hexes moved"],immunities:[__WEBPACK_IMPORTED_MODULE_16__statusEffects__["g" /* POISON */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["d" /* IMMOBILIZE */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["c" /* DISARM */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["k" /* STUN */]]};},function(numPlayers){return{maxHP:18*numPlayers,move:4,attack:"6+X",range:0,specialOne:["move +2, attack +0"],specialTwo:["move +0, Summon Imp, attack -1"],extra:["X = Hexes moved"],immunities:[__WEBPACK_IMPORTED_MODULE_16__statusEffects__["g" /* POISON */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["d" /* IMMOBILIZE */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["c" /* DISARM */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["k" /* STUN */]]};}],"Elder Drake":[function(numPlayers){return{maxHP:11*numPlayers,attack:3,range:0,specialOne:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"+0",[],__WEBPACK_IMPORTED_MODULE_10__elderDrakeSpecial1Area_svg___default.a)],specialTwo:["Move and summon 2 Zephyrs"],immunities:[__WEBPACK_IMPORTED_MODULE_16__statusEffects__["g" /* POISON */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["l" /* WOUND */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["d" /* IMMOBILIZE */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["c" /* DISARM */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["k" /* STUN */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["i" /* PUSH */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["h" /* PULL */]]};},function(numPlayers){return{maxHP:12*numPlayers,attack:4,range:0,specialOne:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"+0",[],__WEBPACK_IMPORTED_MODULE_10__elderDrakeSpecial1Area_svg___default.a)],specialTwo:["Move and summon 2 Zephyrs"],immunities:[__WEBPACK_IMPORTED_MODULE_16__statusEffects__["g" /* POISON */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["l" /* WOUND */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["d" /* IMMOBILIZE */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["c" /* DISARM */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["k" /* STUN */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["i" /* PUSH */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["h" /* PULL */]]};},function(numPlayers){return{maxHP:15*numPlayers,attack:4,range:0,specialOne:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"+0",[],__WEBPACK_IMPORTED_MODULE_10__elderDrakeSpecial1Area_svg___default.a)],specialTwo:["Move and summon 2 Zephyrs"],immunities:[__WEBPACK_IMPORTED_MODULE_16__statusEffects__["g" /* POISON */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["l" /* WOUND */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["d" /* IMMOBILIZE */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["c" /* DISARM */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["k" /* STUN */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["i" /* PUSH */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["h" /* PULL */]]};},function(numPlayers){return{maxHP:16*numPlayers,attack:5,range:0,specialOne:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"+0",[],__WEBPACK_IMPORTED_MODULE_10__elderDrakeSpecial1Area_svg___default.a)],specialTwo:["Move and summon 2 Zephyrs"],immunities:[__WEBPACK_IMPORTED_MODULE_16__statusEffects__["g" /* POISON */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["l" /* WOUND */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["d" /* IMMOBILIZE */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["c" /* DISARM */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["k" /* STUN */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["i" /* PUSH */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["h" /* PULL */]]};},function(numPlayers){return{maxHP:20*numPlayers,attack:5,range:0,specialOne:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"+0",[],__WEBPACK_IMPORTED_MODULE_10__elderDrakeSpecial1Area_svg___default.a)],specialTwo:["Move and summon 2 Zephyrs"],immunities:[__WEBPACK_IMPORTED_MODULE_16__statusEffects__["g" /* POISON */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["l" /* WOUND */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["d" /* IMMOBILIZE */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["c" /* DISARM */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["k" /* STUN */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["i" /* PUSH */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["h" /* PULL */]]};},function(numPlayers){return{maxHP:22*numPlayers,attack:6,range:0,specialOne:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"+0",[],__WEBPACK_IMPORTED_MODULE_10__elderDrakeSpecial1Area_svg___default.a)],specialTwo:["Move and summon 2 Zephyrs"],immunities:[__WEBPACK_IMPORTED_MODULE_16__statusEffects__["g" /* POISON */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["l" /* WOUND */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["d" /* IMMOBILIZE */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["c" /* DISARM */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["k" /* STUN */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["i" /* PUSH */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["h" /* PULL */]]};},function(numPlayers){return{maxHP:27*numPlayers,attack:6,range:0,specialOne:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"+0",[],__WEBPACK_IMPORTED_MODULE_10__elderDrakeSpecial1Area_svg___default.a)],specialTwo:["Move and summon 2 Zephyrs"],immunities:[__WEBPACK_IMPORTED_MODULE_16__statusEffects__["g" /* POISON */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["l" /* WOUND */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["d" /* IMMOBILIZE */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["c" /* DISARM */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["k" /* STUN */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["i" /* PUSH */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["h" /* PULL */]]};},function(numPlayers){return{maxHP:29*numPlayers,attack:7,range:0,specialOne:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"+0",[],__WEBPACK_IMPORTED_MODULE_10__elderDrakeSpecial1Area_svg___default.a)],specialTwo:["Move and summon 2 Zephyrs"],immunities:[__WEBPACK_IMPORTED_MODULE_16__statusEffects__["g" /* POISON */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["l" /* WOUND */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["d" /* IMMOBILIZE */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["c" /* DISARM */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["k" /* STUN */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["h" /* PULL */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["i" /* PUSH */]]};}],"The Gloom":[function(numPlayers){return{maxHP:20*numPlayers,move:2,attack:5,range:0,specialOne:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["c" /* MOVE */],"+9"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"+9")],specialTwo:["Teleport",Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"+1"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["e" /* RANGE */],"5"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["g" /* POISON */]),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["l" /* WOUND */]),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["k" /* STUN */])],immunities:[__WEBPACK_IMPORTED_MODULE_16__statusEffects__["g" /* POISON */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["l" /* WOUND */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["d" /* IMMOBILIZE */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["c" /* DISARM */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["k" /* STUN */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["f" /* MUDDLE */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["b" /* CURSE */]]};},function(numPlayers){return{maxHP:25*numPlayers,move:2,attack:5,range:0,specialOne:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["c" /* MOVE */],"+9"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"+9")],specialTwo:["Teleport",Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"+1"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["e" /* RANGE */],"5"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["g" /* POISON */]),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["l" /* WOUND */]),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["k" /* STUN */])],immunities:[__WEBPACK_IMPORTED_MODULE_16__statusEffects__["g" /* POISON */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["l" /* WOUND */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["d" /* IMMOBILIZE */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["c" /* DISARM */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["k" /* STUN */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["f" /* MUDDLE */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["b" /* CURSE */]]};},function(numPlayers){return{maxHP:29*numPlayers,move:2,attack:6,range:0,specialOne:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["c" /* MOVE */],"+9"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"+9")],specialTwo:["Teleport",Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"+1"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["e" /* RANGE */],"5"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["g" /* POISON */]),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["l" /* WOUND */]),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["k" /* STUN */])],immunities:[__WEBPACK_IMPORTED_MODULE_16__statusEffects__["g" /* POISON */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["l" /* WOUND */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["d" /* IMMOBILIZE */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["c" /* DISARM */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["k" /* STUN */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["f" /* MUDDLE */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["b" /* CURSE */]]};},function(numPlayers){return{maxHP:35*numPlayers,move:2,attack:6,range:0,specialOne:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["c" /* MOVE */],"+9"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"+9")],specialTwo:["Teleport",Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"+1"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["e" /* RANGE */],"5"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["g" /* POISON */]),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["l" /* WOUND */]),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["k" /* STUN */])],immunities:[__WEBPACK_IMPORTED_MODULE_16__statusEffects__["g" /* POISON */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["l" /* WOUND */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["d" /* IMMOBILIZE */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["c" /* DISARM */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["k" /* STUN */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["f" /* MUDDLE */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["b" /* CURSE */]]};},function(numPlayers){return{maxHP:39*numPlayers,move:3,attack:7,range:0,specialOne:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["c" /* MOVE */],"+9"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"+9")],specialTwo:["Teleport",Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"+1"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["e" /* RANGE */],"5"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["g" /* POISON */]),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["l" /* WOUND */]),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["k" /* STUN */])],immunities:[__WEBPACK_IMPORTED_MODULE_16__statusEffects__["g" /* POISON */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["l" /* WOUND */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["d" /* IMMOBILIZE */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["c" /* DISARM */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["k" /* STUN */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["f" /* MUDDLE */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["b" /* CURSE */]]};},function(numPlayers){return{maxHP:46*numPlayers,move:3,attack:7,range:0,specialOne:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["c" /* MOVE */],"+9"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"+9")],specialTwo:["Teleport",Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"+1"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["e" /* RANGE */],"5"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["g" /* POISON */]),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["l" /* WOUND */]),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["k" /* STUN */])],immunities:[__WEBPACK_IMPORTED_MODULE_16__statusEffects__["g" /* POISON */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["l" /* WOUND */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["d" /* IMMOBILIZE */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["c" /* DISARM */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["k" /* STUN */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["f" /* MUDDLE */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["b" /* CURSE */]]};},function(numPlayers){return{maxHP:50*numPlayers,move:3,attack:8,range:0,specialOne:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["c" /* MOVE */],"+9"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"+9")],specialTwo:["Teleport",Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"+1"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["e" /* RANGE */],"5"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["g" /* POISON */]),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["l" /* WOUND */]),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["k" /* STUN */])],immunities:[__WEBPACK_IMPORTED_MODULE_16__statusEffects__["g" /* POISON */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["l" /* WOUND */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["d" /* IMMOBILIZE */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["c" /* DISARM */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["k" /* STUN */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["f" /* MUDDLE */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["b" /* CURSE */]]};},function(numPlayers){return{maxHP:56*numPlayers,move:3,attack:9,range:0,specialOne:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["c" /* MOVE */],"+9"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"+9")],specialTwo:["Teleport",Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"+1"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["e" /* RANGE */],"5"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["g" /* POISON */]),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["l" /* WOUND */]),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_16__statusEffects__["k" /* STUN */])],immunities:[__WEBPACK_IMPORTED_MODULE_16__statusEffects__["g" /* POISON */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["l" /* WOUND */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["d" /* IMMOBILIZE */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["c" /* DISARM */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["k" /* STUN */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["f" /* MUDDLE */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["b" /* CURSE */]]};}],"Inox Bodyguard":[function(numPlayers){return{maxHP:6*numPlayers,move:2,attack:numPlayers,range:0,specialOne:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["c" /* MOVE */],"-1"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"-1",[],__WEBPACK_IMPORTED_MODULE_11__inoxBodyguardSpecial1Area_svg___default.a)],specialTwo:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["c" /* MOVE */],"+0"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"+0"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["f" /* RETALIATE */],"3")],immunities:[__WEBPACK_IMPORTED_MODULE_16__statusEffects__["g" /* POISON */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["c" /* DISARM */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["k" /* STUN */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["f" /* MUDDLE */]]};},function(numPlayers){return{maxHP:7*numPlayers,move:2,attack:1+numPlayers,range:0,specialOne:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["c" /* MOVE */],"-1"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"-1",[],__WEBPACK_IMPORTED_MODULE_11__inoxBodyguardSpecial1Area_svg___default.a)],specialTwo:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["c" /* MOVE */],"+0"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"+0"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["f" /* RETALIATE */],"3")],immunities:[__WEBPACK_IMPORTED_MODULE_16__statusEffects__["g" /* POISON */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["c" /* DISARM */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["k" /* STUN */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["f" /* MUDDLE */]]};},function(numPlayers){return{maxHP:9*numPlayers,move:2,attack:1+numPlayers,range:0,specialOne:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["c" /* MOVE */],"-1"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"-1",[],__WEBPACK_IMPORTED_MODULE_11__inoxBodyguardSpecial1Area_svg___default.a)],specialTwo:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["c" /* MOVE */],"+0"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"+0"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["f" /* RETALIATE */],"3")],immunities:[__WEBPACK_IMPORTED_MODULE_16__statusEffects__["g" /* POISON */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["c" /* DISARM */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["k" /* STUN */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["f" /* MUDDLE */]]};},function(numPlayers){return{maxHP:10*numPlayers,move:3,attack:2+numPlayers,range:0,specialOne:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["c" /* MOVE */],"-1"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"-1",[],__WEBPACK_IMPORTED_MODULE_11__inoxBodyguardSpecial1Area_svg___default.a)],specialTwo:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["c" /* MOVE */],"+0"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"+0"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["f" /* RETALIATE */],"4")],immunities:[__WEBPACK_IMPORTED_MODULE_16__statusEffects__["g" /* POISON */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["c" /* DISARM */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["k" /* STUN */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["f" /* MUDDLE */]]};},function(numPlayers){return{maxHP:11*numPlayers,move:3,attack:2+numPlayers,range:0,specialOne:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["c" /* MOVE */],"-1"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"-1",[],__WEBPACK_IMPORTED_MODULE_11__inoxBodyguardSpecial1Area_svg___default.a)],specialTwo:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["c" /* MOVE */],"+0"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"+0"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["f" /* RETALIATE */],"4")],immunities:[__WEBPACK_IMPORTED_MODULE_16__statusEffects__["g" /* POISON */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["c" /* DISARM */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["k" /* STUN */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["f" /* MUDDLE */]]};},function(numPlayers){return{maxHP:13*numPlayers,move:3,attack:3+numPlayers,range:0,specialOne:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["c" /* MOVE */],"-1"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"-1",[],__WEBPACK_IMPORTED_MODULE_11__inoxBodyguardSpecial1Area_svg___default.a)],specialTwo:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["c" /* MOVE */],"+0"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"+0"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["f" /* RETALIATE */],"5")],immunities:[__WEBPACK_IMPORTED_MODULE_16__statusEffects__["g" /* POISON */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["c" /* DISARM */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["k" /* STUN */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["f" /* MUDDLE */]]};},function(numPlayers){return{maxHP:15*numPlayers,move:4,attack:3+numPlayers,range:0,specialOne:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["c" /* MOVE */],"-1"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"-1",[],__WEBPACK_IMPORTED_MODULE_11__inoxBodyguardSpecial1Area_svg___default.a)],specialTwo:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["c" /* MOVE */],"+0"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"+0"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["f" /* RETALIATE */],"5")],immunities:[__WEBPACK_IMPORTED_MODULE_16__statusEffects__["g" /* POISON */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["c" /* DISARM */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["k" /* STUN */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["f" /* MUDDLE */]]};},function(numPlayers){return{maxHP:17*numPlayers,move:4,attack:4+numPlayers,range:0,specialOne:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["c" /* MOVE */],"-1"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"-1",[],__WEBPACK_IMPORTED_MODULE_11__inoxBodyguardSpecial1Area_svg___default.a)],specialTwo:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["c" /* MOVE */],"+0"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"+0"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["f" /* RETALIATE */],"5")],immunities:[__WEBPACK_IMPORTED_MODULE_16__statusEffects__["g" /* POISON */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["c" /* DISARM */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["k" /* STUN */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["f" /* MUDDLE */]]};}],"Jekserah":[function(numPlayers){return{maxHP:6*numPlayers,move:2,attack:2,range:0,specialOne:["Summon Living Bones",Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"-1",["Target all adjacent enemies"])],specialTwo:["Summon Living Corpse",Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["c" /* MOVE */],"-1"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"+2")],immunities:[__WEBPACK_IMPORTED_MODULE_16__statusEffects__["l" /* WOUND */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["c" /* DISARM */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["k" /* STUN */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["b" /* CURSE */]]};},function(numPlayers){return{maxHP:7*numPlayers,move:2,attack:3,range:0,specialOne:["Summon Living Bones",Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"-1",["Target all adjacent enemies"])],specialTwo:["Summon Living Corpse",Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["c" /* MOVE */],"-1"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"+2")],immunities:[__WEBPACK_IMPORTED_MODULE_16__statusEffects__["l" /* WOUND */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["c" /* DISARM */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["k" /* STUN */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["b" /* CURSE */]]};},function(numPlayers){return{maxHP:9*numPlayers,move:3,attack:3,range:0,specialOne:["Summon Living Bones",Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"-1",["Target all adjacent enemies"])],specialTwo:["Summon Living Corpse",Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["c" /* MOVE */],"-1"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"+2")],immunities:[__WEBPACK_IMPORTED_MODULE_16__statusEffects__["l" /* WOUND */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["c" /* DISARM */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["k" /* STUN */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["b" /* CURSE */]]};},function(numPlayers){return{maxHP:12*numPlayers,move:4,attack:4,range:0,specialOne:["Summon Living Bones",Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"-1",["Target all adjacent enemies"])],specialTwo:["Summon Living Corpse",Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["c" /* MOVE */],"-1"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"+2")],immunities:[__WEBPACK_IMPORTED_MODULE_16__statusEffects__["l" /* WOUND */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["c" /* DISARM */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["k" /* STUN */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["b" /* CURSE */]]};},function(numPlayers){return{maxHP:13*numPlayers,move:4,attack:5,range:0,specialOne:["Summon Living Bones",Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"-1",["Target all adjacent enemies"])],specialTwo:["Summon Living Corpse",Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["c" /* MOVE */],"-1"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"+2")],immunities:[__WEBPACK_IMPORTED_MODULE_16__statusEffects__["l" /* WOUND */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["c" /* DISARM */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["k" /* STUN */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["b" /* CURSE */]]};},function(numPlayers){return{maxHP:15*numPlayers,move:5,attack:5,range:0,specialOne:["Summon Living Bones",Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"-1",["Target all adjacent enemies"])],specialTwo:["Summon Living Corpse",Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["c" /* MOVE */],"-1"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"+2")],immunities:[__WEBPACK_IMPORTED_MODULE_16__statusEffects__["l" /* WOUND */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["c" /* DISARM */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["k" /* STUN */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["b" /* CURSE */]]};},function(numPlayers){return{maxHP:18*numPlayers,move:5,attack:5,range:0,specialOne:["Summon Living Bones",Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"-1",["Target all adjacent enemies"])],specialTwo:["Summon Living Corpse",Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["c" /* MOVE */],"-1"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"+2")],immunities:[__WEBPACK_IMPORTED_MODULE_16__statusEffects__["l" /* WOUND */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["c" /* DISARM */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["k" /* STUN */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["b" /* CURSE */]]};},function(numPlayers){return{maxHP:22*numPlayers,move:5,attack:5,range:0,specialOne:["Summon Living Bones",Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"-1",["Target all adjacent enemies"])],specialTwo:["Summon Living Corpse",Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["c" /* MOVE */],"-1"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"+2")],immunities:[__WEBPACK_IMPORTED_MODULE_16__statusEffects__["l" /* WOUND */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["c" /* DISARM */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["k" /* STUN */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["b" /* CURSE */]]};}],"Merciless Overseer":[function(numPlayers){return{maxHP:6*numPlayers,move:2,attack:"V",range:0,specialOne:["All Scouts act again"],specialTwo:["Summon Vermling Scout"],immunities:[__WEBPACK_IMPORTED_MODULE_16__statusEffects__["l" /* WOUND */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["k" /* STUN */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["b" /* CURSE */]],extra:["V = Number of Scouts present"]};},function(numPlayers){return{maxHP:8*numPlayers,move:2,attack:"V",range:0,specialOne:["All Scouts act again"],specialTwo:["Summon Vermling Scout"],immunities:[__WEBPACK_IMPORTED_MODULE_16__statusEffects__["l" /* WOUND */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["k" /* STUN */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["b" /* CURSE */]],extra:["V = Number of Scouts present"]};},function(numPlayers){return{maxHP:9*numPlayers,move:3,attack:"V",range:0,specialOne:["All Scouts act again"],specialTwo:["Summon Vermling Scout"],immunities:[__WEBPACK_IMPORTED_MODULE_16__statusEffects__["l" /* WOUND */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["k" /* STUN */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["b" /* CURSE */]],extra:["V = Number of Scouts present"]};},function(numPlayers){return{maxHP:11*numPlayers,move:3,attack:"V",range:0,specialOne:["All Scouts act again"],specialTwo:["Summon Vermling Scout"],immunities:[__WEBPACK_IMPORTED_MODULE_16__statusEffects__["l" /* WOUND */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["k" /* STUN */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["b" /* CURSE */]],extra:["V = Number of Scouts present"]};},function(numPlayers){return{maxHP:12*numPlayers,move:4,attack:"V",range:0,specialOne:["All Scouts act again"],specialTwo:["Summon Vermling Scout"],immunities:[__WEBPACK_IMPORTED_MODULE_16__statusEffects__["l" /* WOUND */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["k" /* STUN */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["b" /* CURSE */]],extra:["V = Number of Scouts present"]};},function(numPlayers){return{maxHP:14*numPlayers,move:4,attack:"V",range:0,specialOne:["All Scouts act again"],specialTwo:["Summon Vermling Scout"],immunities:[__WEBPACK_IMPORTED_MODULE_16__statusEffects__["l" /* WOUND */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["k" /* STUN */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["b" /* CURSE */]],extra:["V = Number of Scouts present"]};},function(numPlayers){return{maxHP:16*numPlayers,move:4,attack:"V",range:0,specialOne:["All Scouts act again"],specialTwo:["Summon Vermling Scout"],immunities:[__WEBPACK_IMPORTED_MODULE_16__statusEffects__["l" /* WOUND */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["k" /* STUN */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["b" /* CURSE */]],extra:["V = Number of Scouts present"]};},function(numPlayers){return{maxHP:19*numPlayers,move:4,attack:"V",range:0,specialOne:["All Scouts act again"],specialTwo:["Summon Vermling Scout"],immunities:[__WEBPACK_IMPORTED_MODULE_16__statusEffects__["l" /* WOUND */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["k" /* STUN */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["b" /* CURSE */]],extra:["V = Number of Scouts present"]};}],"Prime Demon":[function(numPlayers){return{maxHP:8*numPlayers,move:3,attack:4,range:0,specialOne:["Throne moves","Summon Demon",Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["c" /* MOVE */],"+2"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"-1")],specialTwo:["Throne moves","Summon Demon",Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["c" /* MOVE */],"+2"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"-1")],immunities:[__WEBPACK_IMPORTED_MODULE_16__statusEffects__["g" /* POISON */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["l" /* WOUND */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["d" /* IMMOBILIZE */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["c" /* DISARM */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["k" /* STUN */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["f" /* MUDDLE */]]};},function(numPlayers){return{maxHP:9*numPlayers,move:4,attack:4,range:0,specialOne:["Throne moves","Summon Demon",Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["c" /* MOVE */],"+2"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"-1")],specialTwo:["Throne moves","Summon Demon",Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["c" /* MOVE */],"+2"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"-1")],immunities:[__WEBPACK_IMPORTED_MODULE_16__statusEffects__["g" /* POISON */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["l" /* WOUND */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["d" /* IMMOBILIZE */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["c" /* DISARM */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["k" /* STUN */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["f" /* MUDDLE */]]};},function(numPlayers){return{maxHP:10*numPlayers,move:4,attack:5,range:0,specialOne:["Throne moves","Summon Demon",Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["c" /* MOVE */],"+2"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"-1")],specialTwo:["Throne moves","Summon Demon",Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["c" /* MOVE */],"+2"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"-1")],immunities:[__WEBPACK_IMPORTED_MODULE_16__statusEffects__["g" /* POISON */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["l" /* WOUND */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["d" /* IMMOBILIZE */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["c" /* DISARM */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["k" /* STUN */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["f" /* MUDDLE */]]};},function(numPlayers){return{maxHP:12*numPlayers,move:4,attack:6,range:0,specialOne:["Throne moves","Summon Demon",Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["c" /* MOVE */],"+2"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"-1")],specialTwo:["Throne moves","Summon Demon",Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["c" /* MOVE */],"+2"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"-1")],immunities:[__WEBPACK_IMPORTED_MODULE_16__statusEffects__["g" /* POISON */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["l" /* WOUND */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["d" /* IMMOBILIZE */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["c" /* DISARM */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["k" /* STUN */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["f" /* MUDDLE */]]};},function(numPlayers){return{maxHP:14*numPlayers,move:5,attack:6,range:0,specialOne:["Throne moves","Summon Demon",Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["c" /* MOVE */],"+2"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"-1")],specialTwo:["Throne moves","Summon Demon",Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["c" /* MOVE */],"+2"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"-1")],immunities:[__WEBPACK_IMPORTED_MODULE_16__statusEffects__["g" /* POISON */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["l" /* WOUND */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["d" /* IMMOBILIZE */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["c" /* DISARM */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["k" /* STUN */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["f" /* MUDDLE */]]};},function(numPlayers){return{maxHP:16*numPlayers,move:5,attack:7,range:0,specialOne:["Throne moves","Summon Demon",Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["c" /* MOVE */],"+2"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"-1")],specialTwo:["Throne moves","Summon Demon",Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["c" /* MOVE */],"+2"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"-1")],immunities:[__WEBPACK_IMPORTED_MODULE_16__statusEffects__["g" /* POISON */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["l" /* WOUND */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["d" /* IMMOBILIZE */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["c" /* DISARM */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["k" /* STUN */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["f" /* MUDDLE */]]};},function(numPlayers){return{maxHP:20*numPlayers,move:5,attack:7,range:0,specialOne:["Throne moves","Summon Demon",Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["c" /* MOVE */],"+2"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"-1")],specialTwo:["Throne moves","Summon Demon",Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["c" /* MOVE */],"+2"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"-1")],immunities:[__WEBPACK_IMPORTED_MODULE_16__statusEffects__["g" /* POISON */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["l" /* WOUND */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["d" /* IMMOBILIZE */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["c" /* DISARM */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["k" /* STUN */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["f" /* MUDDLE */]]};},function(numPlayers){return{maxHP:22*numPlayers,move:5,attack:8,range:0,specialOne:["Throne moves","Summon Demon",Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["c" /* MOVE */],"+2"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"-1")],specialTwo:["Throne moves","Summon Demon",Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["c" /* MOVE */],"+2"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"-1")],immunities:[__WEBPACK_IMPORTED_MODULE_16__statusEffects__["g" /* POISON */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["l" /* WOUND */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["d" /* IMMOBILIZE */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["c" /* DISARM */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["k" /* STUN */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["f" /* MUDDLE */]]};}],"The Sightless Eye":[function(numPlayers){return{maxHP:7*numPlayers,attack:5,range:3,specialOne:["Summon Deep Terror",Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"-3",[],__WEBPACK_IMPORTED_MODULE_12__sightlessEyeSpecial1Area_svg___default.a)],specialTwo:["Summon Deep Terror",Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"-2",[],__WEBPACK_IMPORTED_MODULE_13__sightlessEyeSpecial2Area_svg___default.a)],immunities:[__WEBPACK_IMPORTED_MODULE_16__statusEffects__["c" /* DISARM */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["k" /* STUN */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["f" /* MUDDLE */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["b" /* CURSE */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["i" /* PUSH */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["h" /* PULL */]]};},function(numPlayers){return{maxHP:8*numPlayers,attack:6,range:3,specialOne:["Summon Deep Terror",Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"-3",[],__WEBPACK_IMPORTED_MODULE_12__sightlessEyeSpecial1Area_svg___default.a)],specialTwo:["Summon Deep Terror",Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"-2",[],__WEBPACK_IMPORTED_MODULE_13__sightlessEyeSpecial2Area_svg___default.a)],immunities:[__WEBPACK_IMPORTED_MODULE_16__statusEffects__["c" /* DISARM */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["k" /* STUN */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["f" /* MUDDLE */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["b" /* CURSE */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["i" /* PUSH */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["h" /* PULL */]]};},function(numPlayers){return{maxHP:10*numPlayers,attack:6,range:3,specialOne:["Summon Deep Terror",Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"-3",[],__WEBPACK_IMPORTED_MODULE_12__sightlessEyeSpecial1Area_svg___default.a)],specialTwo:["Summon Deep Terror",Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"-2",[],__WEBPACK_IMPORTED_MODULE_13__sightlessEyeSpecial2Area_svg___default.a)],immunities:[__WEBPACK_IMPORTED_MODULE_16__statusEffects__["c" /* DISARM */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["k" /* STUN */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["f" /* MUDDLE */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["b" /* CURSE */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["i" /* PUSH */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["h" /* PULL */]]};},function(numPlayers){return{maxHP:11*numPlayers,attack:7,range:3,specialOne:["Summon Deep Terror",Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"-3",[],__WEBPACK_IMPORTED_MODULE_12__sightlessEyeSpecial1Area_svg___default.a)],specialTwo:["Summon Deep Terror",Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"-2",[],__WEBPACK_IMPORTED_MODULE_13__sightlessEyeSpecial2Area_svg___default.a)],immunities:[__WEBPACK_IMPORTED_MODULE_16__statusEffects__["c" /* DISARM */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["k" /* STUN */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["f" /* MUDDLE */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["b" /* CURSE */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["i" /* PUSH */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["h" /* PULL */]]};},function(numPlayers){return{maxHP:14*numPlayers,attack:7,range:3,specialOne:["Summon Deep Terror",Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"-3",[],__WEBPACK_IMPORTED_MODULE_12__sightlessEyeSpecial1Area_svg___default.a)],specialTwo:["Summon Deep Terror",Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"-2",[],__WEBPACK_IMPORTED_MODULE_13__sightlessEyeSpecial2Area_svg___default.a)],immunities:[__WEBPACK_IMPORTED_MODULE_16__statusEffects__["c" /* DISARM */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["k" /* STUN */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["f" /* MUDDLE */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["b" /* CURSE */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["i" /* PUSH */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["h" /* PULL */]]};},function(numPlayers){return{maxHP:15*numPlayers,attack:8,range:3,specialOne:["Summon Deep Terror",Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"-3",[],__WEBPACK_IMPORTED_MODULE_12__sightlessEyeSpecial1Area_svg___default.a)],specialTwo:["Summon Deep Terror",Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"-2",[],__WEBPACK_IMPORTED_MODULE_13__sightlessEyeSpecial2Area_svg___default.a)],immunities:[__WEBPACK_IMPORTED_MODULE_16__statusEffects__["c" /* DISARM */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["k" /* STUN */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["f" /* MUDDLE */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["b" /* CURSE */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["i" /* PUSH */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["h" /* PULL */]]};},function(numPlayers){return{maxHP:18*numPlayers,attack:8,range:3,specialOne:["Summon Deep Terror",Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"-3",[],__WEBPACK_IMPORTED_MODULE_12__sightlessEyeSpecial1Area_svg___default.a)],specialTwo:["Summon Deep Terror",Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"-2",[],__WEBPACK_IMPORTED_MODULE_13__sightlessEyeSpecial2Area_svg___default.a)],immunities:[__WEBPACK_IMPORTED_MODULE_16__statusEffects__["c" /* DISARM */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["k" /* STUN */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["f" /* MUDDLE */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["b" /* CURSE */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["i" /* PUSH */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["h" /* PULL */]]};},function(numPlayers){return{maxHP:20*numPlayers,attack:9,range:3,specialOne:["Summon Deep Terror",Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"-3",[],__WEBPACK_IMPORTED_MODULE_12__sightlessEyeSpecial1Area_svg___default.a)],specialTwo:["Summon Deep Terror",Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"-2",[],__WEBPACK_IMPORTED_MODULE_13__sightlessEyeSpecial2Area_svg___default.a)],immunities:[__WEBPACK_IMPORTED_MODULE_16__statusEffects__["c" /* DISARM */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["k" /* STUN */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["f" /* MUDDLE */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["b" /* CURSE */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["i" /* PUSH */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["h" /* PULL */]]};}],"Winged Horror":[function(numPlayers){return{maxHP:6*numPlayers,move:3,attack:3,range:0,specialOne:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"-1",["Target all adjacent enemies"]),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"+0",[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["e" /* RANGE */],"3")]),"Hatch eggs"],specialTwo:["Summon "+numPlayers+" eggs",Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["c" /* MOVE */],"-1"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"+0")],immunities:[__WEBPACK_IMPORTED_MODULE_16__statusEffects__["g" /* POISON */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["c" /* DISARM */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["k" /* STUN */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["f" /* MUDDLE */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["b" /* CURSE */]]};},function(numPlayers){return{maxHP:7*numPlayers,move:4,attack:3,range:0,specialOne:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"-1",["Target all adjacent enemies"]),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"+0",[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["e" /* RANGE */],"3")]),"Hatch eggs"],specialTwo:["Summon "+numPlayers+" eggs",Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["c" /* MOVE */],"-1"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"+0")],immunities:[__WEBPACK_IMPORTED_MODULE_16__statusEffects__["g" /* POISON */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["c" /* DISARM */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["k" /* STUN */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["f" /* MUDDLE */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["b" /* CURSE */]]};},function(numPlayers){return{maxHP:8*numPlayers,move:4,attack:4,range:0,specialOne:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"-1",["Target all adjacent enemies"]),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"+0",[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["e" /* RANGE */],"3")]),"Hatch eggs"],specialTwo:["Summon "+numPlayers+" eggs",Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["c" /* MOVE */],"-1"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"+0")],immunities:[__WEBPACK_IMPORTED_MODULE_16__statusEffects__["g" /* POISON */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["c" /* DISARM */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["k" /* STUN */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["f" /* MUDDLE */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["b" /* CURSE */]]};},function(numPlayers){return{maxHP:10*numPlayers,move:4,attack:4,range:0,specialOne:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"-1",["Target all adjacent enemies"]),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"+0",[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["e" /* RANGE */],"3")]),"Hatch eggs"],specialTwo:["Summon "+numPlayers+" eggs",Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["c" /* MOVE */],"-1"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"+0")],immunities:[__WEBPACK_IMPORTED_MODULE_16__statusEffects__["g" /* POISON */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["c" /* DISARM */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["k" /* STUN */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["f" /* MUDDLE */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["b" /* CURSE */]]};},function(numPlayers){return{maxHP:12*numPlayers,move:5,attack:4,range:0,specialOne:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"-1",["Target all adjacent enemies"]),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"+0",[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["e" /* RANGE */],"3")]),"Hatch eggs"],specialTwo:["Summon "+numPlayers+" eggs",Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["c" /* MOVE */],"-1"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"+0")],immunities:[__WEBPACK_IMPORTED_MODULE_16__statusEffects__["g" /* POISON */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["c" /* DISARM */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["k" /* STUN */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["f" /* MUDDLE */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["b" /* CURSE */]]};},function(numPlayers){return{maxHP:14*numPlayers,move:5,attack:5,range:0,specialOne:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"-1",["Target all adjacent enemies"]),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"+0",[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["e" /* RANGE */],"3")]),"Hatch eggs"],specialTwo:["Summon "+numPlayers+" eggs",Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["c" /* MOVE */],"-1"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"+0")],immunities:[__WEBPACK_IMPORTED_MODULE_16__statusEffects__["g" /* POISON */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["c" /* DISARM */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["k" /* STUN */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["f" /* MUDDLE */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["b" /* CURSE */]]};},function(numPlayers){return{maxHP:17*numPlayers,move:5,attack:5,range:0,specialOne:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"-1",["Target all adjacent enemies"]),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"+0",[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["e" /* RANGE */],"3")]),"Hatch eggs"],specialTwo:["Summon "+numPlayers+" eggs",Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["c" /* MOVE */],"-1"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"+0")],immunities:[__WEBPACK_IMPORTED_MODULE_16__statusEffects__["g" /* POISON */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["c" /* DISARM */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["k" /* STUN */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["f" /* MUDDLE */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["b" /* CURSE */]]};},function(numPlayers){return{maxHP:20*numPlayers,move:5,attack:5,range:0,specialOne:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"-1",["Target all adjacent enemies"]),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"+0",[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["e" /* RANGE */],"3")]),"Hatch eggs"],specialTwo:["Summon "+numPlayers+" eggs",Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["c" /* MOVE */],"-1"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"+0")],immunities:[__WEBPACK_IMPORTED_MODULE_16__statusEffects__["g" /* POISON */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["c" /* DISARM */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["k" /* STUN */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["f" /* MUDDLE */],__WEBPACK_IMPORTED_MODULE_16__statusEffects__["b" /* CURSE */]]};}]};var BOSS_CARDS=[{initiative:85,actions:["Special 1"],endAction:__WEBPACK_IMPORTED_MODULE_14__cards__["a" /* END_ACTIONS */].SHUFFLE},{initiative:73,actions:["Special 1"]},{initiative:52,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["c" /* MOVE */],"-1"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"-1",[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["e" /* RANGE */],"3"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["h" /* TARGET */],"2")])]},{initiative:11,actions:["Special 2"]},{initiative:17,actions:["Special 2"],endAction:__WEBPACK_IMPORTED_MODULE_14__cards__["a" /* END_ACTIONS */].SHUFFLE},{initiative:36,actions:[Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["c" /* MOVE */],"+0"),Object(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* action */])(__WEBPACK_IMPORTED_MODULE_17__actions__["a" /* ATTACK */],"+0")]},{initiative:79,actions:["Special 1"]},{initiative:14,actions:["Special 2"]}];var BOSS_LIST=Object.keys(BOSS_STATS);

/***/ }),
/* 10 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getIcon;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__elements__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__bonuses__ = __webpack_require__(156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__statusEffects__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions_index__ = __webpack_require__(17);
function getIcon(name){return Object(__WEBPACK_IMPORTED_MODULE_0__elements__["h" /* iconForElement */])(name)||Object(__WEBPACK_IMPORTED_MODULE_2__statusEffects__["m" /* iconForStatusEffect */])(name)||Object(__WEBPACK_IMPORTED_MODULE_1__bonuses__["a" /* iconForBonus */])(name)||Object(__WEBPACK_IMPORTED_MODULE_3__actions_index__["j" /* iconForAction */])(name);}

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var asap = __webpack_require__(26);

function noop() {}

// States:
//
// 0 - pending
// 1 - fulfilled with _value
// 2 - rejected with _value
// 3 - adopted the state of another promise, _value
//
// once the state is no longer pending (0) it is immutable

// All `_` prefixed properties will be reduced to `_{random number}`
// at build time to obfuscate them and discourage their use.
// We don't use symbols or Object.defineProperty to fully hide them
// because the performance isn't good enough.


// to avoid using try/catch inside critical functions, we
// extract them to here.
var LAST_ERROR = null;
var IS_ERROR = {};
function getThen(obj) {
  try {
    return obj.then;
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}

function tryCallOne(fn, a) {
  try {
    return fn(a);
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}
function tryCallTwo(fn, a, b) {
  try {
    fn(a, b);
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}

module.exports = Promise;

function Promise(fn) {
  if (typeof this !== 'object') {
    throw new TypeError('Promises must be constructed via new');
  }
  if (typeof fn !== 'function') {
    throw new TypeError('Promise constructor\'s argument is not a function');
  }
  this._75 = 0;
  this._83 = 0;
  this._18 = null;
  this._38 = null;
  if (fn === noop) return;
  doResolve(fn, this);
}
Promise._47 = null;
Promise._71 = null;
Promise._44 = noop;

Promise.prototype.then = function(onFulfilled, onRejected) {
  if (this.constructor !== Promise) {
    return safeThen(this, onFulfilled, onRejected);
  }
  var res = new Promise(noop);
  handle(this, new Handler(onFulfilled, onRejected, res));
  return res;
};

function safeThen(self, onFulfilled, onRejected) {
  return new self.constructor(function (resolve, reject) {
    var res = new Promise(noop);
    res.then(resolve, reject);
    handle(self, new Handler(onFulfilled, onRejected, res));
  });
}
function handle(self, deferred) {
  while (self._83 === 3) {
    self = self._18;
  }
  if (Promise._47) {
    Promise._47(self);
  }
  if (self._83 === 0) {
    if (self._75 === 0) {
      self._75 = 1;
      self._38 = deferred;
      return;
    }
    if (self._75 === 1) {
      self._75 = 2;
      self._38 = [self._38, deferred];
      return;
    }
    self._38.push(deferred);
    return;
  }
  handleResolved(self, deferred);
}

function handleResolved(self, deferred) {
  asap(function() {
    var cb = self._83 === 1 ? deferred.onFulfilled : deferred.onRejected;
    if (cb === null) {
      if (self._83 === 1) {
        resolve(deferred.promise, self._18);
      } else {
        reject(deferred.promise, self._18);
      }
      return;
    }
    var ret = tryCallOne(cb, self._18);
    if (ret === IS_ERROR) {
      reject(deferred.promise, LAST_ERROR);
    } else {
      resolve(deferred.promise, ret);
    }
  });
}
function resolve(self, newValue) {
  // Promise Resolution Procedure: https://github.com/promises-aplus/promises-spec#the-promise-resolution-procedure
  if (newValue === self) {
    return reject(
      self,
      new TypeError('A promise cannot be resolved with itself.')
    );
  }
  if (
    newValue &&
    (typeof newValue === 'object' || typeof newValue === 'function')
  ) {
    var then = getThen(newValue);
    if (then === IS_ERROR) {
      return reject(self, LAST_ERROR);
    }
    if (
      then === self.then &&
      newValue instanceof Promise
    ) {
      self._83 = 3;
      self._18 = newValue;
      finale(self);
      return;
    } else if (typeof then === 'function') {
      doResolve(then.bind(newValue), self);
      return;
    }
  }
  self._83 = 1;
  self._18 = newValue;
  finale(self);
}

function reject(self, newValue) {
  self._83 = 2;
  self._18 = newValue;
  if (Promise._71) {
    Promise._71(self, newValue);
  }
  finale(self);
}
function finale(self) {
  if (self._75 === 1) {
    handle(self, self._38);
    self._38 = null;
  }
  if (self._75 === 2) {
    for (var i = 0; i < self._38.length; i++) {
      handle(self, self._38[i]);
    }
    self._38 = null;
  }
}

function Handler(onFulfilled, onRejected, promise){
  this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
  this.onRejected = typeof onRejected === 'function' ? onRejected : null;
  this.promise = promise;
}

/**
 * Take a potentially misbehaving resolver function and make sure
 * onFulfilled and onRejected are only called once.
 *
 * Makes no guarantees about asynchrony.
 */
function doResolve(fn, promise) {
  var done = false;
  var res = tryCallTwo(fn, function (value) {
    if (done) return;
    done = true;
    resolve(promise, value);
  }, function (reason) {
    if (done) return;
    done = true;
    reject(promise, reason);
  });
  if (!done && res === IS_ERROR) {
    done = true;
    reject(promise, LAST_ERROR);
  }
}


/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var emptyObject = {};

if (false) {
  Object.freeze(emptyObject);
}

module.exports = emptyObject;

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function checkDCE() {
  /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */
  if (
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' ||
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function'
  ) {
    return;
  }
  if (false) {
    // This branch is unreachable because this function is only called
    // in production, but the condition is true only in development.
    // Therefore if the branch is still here, dead code elimination wasn't
    // properly applied.
    // Don't change the message. React DevTools relies on it. Also make sure
    // this message doesn't occur elsewhere in this function, or it will cause
    // a false positive.
    throw new Error('^_^');
  }
  try {
    // Verify that the code above has been dead code eliminated (DCE'd).
    __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(checkDCE);
  } catch (err) {
    // DevTools shouldn't crash React, no matter what.
    // We should still report in case we break this code.
    console.error(err);
  }
}

if (true) {
  // DCE check should happen before ReactDOM bundle executes so that
  // DevTools can report bad minification during injection.
  checkDCE();
  module.exports = __webpack_require__(31);
} else {
  module.exports = require('./cjs/react-dom.development.js');
}


/***/ }),
/* 14 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 15 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ANY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AIR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return DARK; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return EARTH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return FIRE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return ICE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return LIGHT; });
/* unused harmony export INERT */
/* unused harmony export WANING */
/* unused harmony export STRONG */
/* unused harmony export ELEMENTS */
/* harmony export (immutable) */ __webpack_exports__["h"] = iconForElement;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__any_element_svg__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__any_element_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__any_element_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__air_svg__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__air_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__air_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__dark_svg__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__dark_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__dark_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__earth_svg__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__earth_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__earth_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__fire_svg__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__fire_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__fire_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ice_svg__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ice_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__ice_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__light_svg__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__light_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__light_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__use_element_svg__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__use_element_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__use_element_svg__);
/* unused harmony reexport useElementIcon */
var _elementIcons;function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var ANY="any";var AIR="air";var DARK="dark";var EARTH="earth";var FIRE="fire";var ICE="ice";var LIGHT="light";var INERT="inert";var WANING="waning";var STRONG="strong";var elementIcons=(_elementIcons={},_defineProperty(_elementIcons,FIRE,__WEBPACK_IMPORTED_MODULE_4__fire_svg___default.a),_defineProperty(_elementIcons,ICE,__WEBPACK_IMPORTED_MODULE_5__ice_svg___default.a),_defineProperty(_elementIcons,AIR,__WEBPACK_IMPORTED_MODULE_1__air_svg___default.a),_defineProperty(_elementIcons,EARTH,__WEBPACK_IMPORTED_MODULE_3__earth_svg___default.a),_defineProperty(_elementIcons,LIGHT,__WEBPACK_IMPORTED_MODULE_6__light_svg___default.a),_defineProperty(_elementIcons,DARK,__WEBPACK_IMPORTED_MODULE_2__dark_svg___default.a),_elementIcons);var ELEMENTS=Object.keys(elementIcons);function iconForElement(name){return Object.assign({},elementIcons,_defineProperty({},ANY,__WEBPACK_IMPORTED_MODULE_0__any_element_svg___default.a))[name];}

/***/ }),
/* 16 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BLESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return CURSE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return DISARM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return IMMOBILIZE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return INVISIBLE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return MUDDLE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return POISON; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return STRENGTHEN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return STUN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return WOUND; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return PUSH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return PULL; });
/* unused harmony export STATUS_EFFECTS */
/* unused harmony export newStatusEffectTracker */
/* unused harmony export ALL_STATUS_EFFECTS */
/* harmony export (immutable) */ __webpack_exports__["m"] = iconForStatusEffect;
/* unused harmony export push */
/* unused harmony export pull */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__curse_svg__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__curse_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__curse_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__bless_svg__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__bless_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__bless_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__disarm_svg__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__disarm_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__disarm_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__immobilize_svg__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__immobilize_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__immobilize_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__invisible_svg__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__invisible_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__invisible_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__muddle_svg__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__muddle_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__muddle_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__poison_svg__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__poison_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__poison_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__strengthen_svg__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__strengthen_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__strengthen_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__stun_svg__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__stun_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__stun_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__wound_svg__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__wound_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__wound_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__push_svg__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__push_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__push_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__pull_svg__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__pull_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__pull_svg__);
var _statusEffectIcons,_Object$assign;function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var BLESS="BLESS";var CURSE="CURSE";var DISARM="DISARM";var IMMOBILIZE="IMMOBILIZE";var INVISIBLE="INVISIBLE";var MUDDLE="MUDDLE";var POISON="POISON";var STRENGTHEN="STRENGTHEN";var STUN="STUN";var WOUND="WOUND";var PUSH="PUSH";var PULL="PULL";var statusEffectIcons=(_statusEffectIcons={},_defineProperty(_statusEffectIcons,POISON,__WEBPACK_IMPORTED_MODULE_6__poison_svg___default.a),_defineProperty(_statusEffectIcons,WOUND,__WEBPACK_IMPORTED_MODULE_9__wound_svg___default.a),_defineProperty(_statusEffectIcons,IMMOBILIZE,__WEBPACK_IMPORTED_MODULE_3__immobilize_svg___default.a),_defineProperty(_statusEffectIcons,DISARM,__WEBPACK_IMPORTED_MODULE_2__disarm_svg___default.a),_defineProperty(_statusEffectIcons,STUN,__WEBPACK_IMPORTED_MODULE_8__stun_svg___default.a),_defineProperty(_statusEffectIcons,MUDDLE,__WEBPACK_IMPORTED_MODULE_5__muddle_svg___default.a),_defineProperty(_statusEffectIcons,INVISIBLE,__WEBPACK_IMPORTED_MODULE_4__invisible_svg___default.a),_defineProperty(_statusEffectIcons,STRENGTHEN,__WEBPACK_IMPORTED_MODULE_7__strengthen_svg___default.a),_statusEffectIcons);var STATUS_EFFECTS=Object.keys(statusEffectIcons);function newStatusEffectTracker(){return STATUS_EFFECTS.reduce(function(acc,s){acc[s]=false;return acc;},{});}var allStatusEffectIcons=Object.assign({},statusEffectIcons,(_Object$assign={},_defineProperty(_Object$assign,PUSH,__WEBPACK_IMPORTED_MODULE_10__push_svg___default.a),_defineProperty(_Object$assign,PULL,__WEBPACK_IMPORTED_MODULE_11__pull_svg___default.a),_defineProperty(_Object$assign,CURSE,__WEBPACK_IMPORTED_MODULE_0__curse_svg___default.a),_defineProperty(_Object$assign,BLESS,__WEBPACK_IMPORTED_MODULE_1__bless_svg___default.a),_Object$assign));var ALL_STATUS_EFFECTS=Object.keys(allStatusEffectIcons);function iconForStatusEffect(name){return allStatusEffectIcons[name];}function push(value){return{type:PUSH,value:value};}function pull(value){return{type:PULL,value:value};}

/***/ }),
/* 17 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ATTACK; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return HEAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return MOVE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return RANGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return RETALIATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return SHIELD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return TARGET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return PIERCE; });
/* unused harmony export PUSH */
/* unused harmony export PULL */
/* unused harmony export CURSE */
/* unused harmony export BLESS */
/* harmony export (immutable) */ __webpack_exports__["i"] = action;
/* harmony export (immutable) */ __webpack_exports__["j"] = iconForAction;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__attack_svg__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__attack_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__attack_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__heal_svg__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__heal_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__heal_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__move_svg__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__move_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__move_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__pierce_svg__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__pierce_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__pierce_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__range_svg__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__range_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__range_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__retaliate_svg__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__retaliate_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__retaliate_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__shield_svg__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__shield_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__shield_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__target_svg__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__target_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__target_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__push_svg__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__push_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__push_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__pull_svg__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__pull_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__pull_svg__);
var _icons;function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var ATTACK="Attack";var HEAL="Heal";var MOVE="Move";var RANGE="Range";var RETALIATE="Retaliate";var SHIELD="Shield";var TARGET="Target";var PIERCE="PIERCE";var PUSH="PUSH";var PULL="PULL";var CURSE="CURSE";var BLESS="BLESS";function action(type,modifier,subActions,image){return{type:type,modifier:modifier,subActions:subActions||[],image:image};}var icons=(_icons={},_defineProperty(_icons,ATTACK,__WEBPACK_IMPORTED_MODULE_0__attack_svg___default.a),_defineProperty(_icons,HEAL,__WEBPACK_IMPORTED_MODULE_1__heal_svg___default.a),_defineProperty(_icons,MOVE,__WEBPACK_IMPORTED_MODULE_2__move_svg___default.a),_defineProperty(_icons,PIERCE,__WEBPACK_IMPORTED_MODULE_3__pierce_svg___default.a),_defineProperty(_icons,RANGE,__WEBPACK_IMPORTED_MODULE_4__range_svg___default.a),_defineProperty(_icons,RETALIATE,__WEBPACK_IMPORTED_MODULE_5__retaliate_svg___default.a),_defineProperty(_icons,SHIELD,__WEBPACK_IMPORTED_MODULE_6__shield_svg___default.a),_defineProperty(_icons,TARGET,__WEBPACK_IMPORTED_MODULE_7__target_svg___default.a),_defineProperty(_icons,PUSH,__WEBPACK_IMPORTED_MODULE_8__push_svg___default.a),_defineProperty(_icons,PULL,__WEBPACK_IMPORTED_MODULE_9__pull_svg___default.a),_icons);function iconForAction(actionName){return icons[actionName];}

/***/ }),
/* 18 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ancientArtillery_png__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ancientArtillery_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__ancientArtillery_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__banditArcher_png__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__banditArcher_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__banditArcher_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__banditGuard_png__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__banditGuard_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__banditGuard_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__blackImp_png__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__blackImp_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__blackImp_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__caveBear_png__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__caveBear_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__caveBear_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__cityArcher_png__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__cityArcher_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__cityArcher_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__cityGuard_png__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__cityGuard_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__cityGuard_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__cultist_png__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__cultist_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__cultist_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__deepTerror_png__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__deepTerror_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__deepTerror_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__earthDemon_png__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__earthDemon_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__earthDemon_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__flameDemon_png__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__flameDemon_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__flameDemon_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__frostDemon_png__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__frostDemon_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__frostDemon_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__forestImp_png__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__forestImp_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__forestImp_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__giantViper_png__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__giantViper_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__giantViper_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__harrowerInfester_png__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__harrowerInfester_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__harrowerInfester_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__hound_png__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__hound_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__hound_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__inoxArcher_png__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__inoxArcher_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__inoxArcher_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__inoxGuard_png__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__inoxGuard_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__inoxGuard_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__inoxShaman_png__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__inoxShaman_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__inoxShaman_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__livingBones_png__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__livingBones_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__livingBones_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__livingCorpse_png__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__livingCorpse_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__livingCorpse_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__livingSpirit_png__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__livingSpirit_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__livingSpirit_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__lurker_png__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__lurker_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22__lurker_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__nightDemon_png__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__nightDemon_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23__nightDemon_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__ooze_png__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__ooze_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24__ooze_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__rendingDrake_png__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__rendingDrake_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25__rendingDrake_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__savvasLavaflow_png__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__savvasLavaflow_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26__savvasLavaflow_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__savvasIcestorm_png__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__savvasIcestorm_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27__savvasIcestorm_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__spittingDrake_png__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__spittingDrake_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28__spittingDrake_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__stoneGolem_png__ = __webpack_require__(134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__stoneGolem_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_29__stoneGolem_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__sunDemon_png__ = __webpack_require__(135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__sunDemon_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_30__sunDemon_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__vermlingScout_png__ = __webpack_require__(136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__vermlingScout_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_31__vermlingScout_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__vermlingShaman_png__ = __webpack_require__(137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__vermlingShaman_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_32__vermlingShaman_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__windDemon_png__ = __webpack_require__(138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__windDemon_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_33__windDemon_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__bosses_banditCommander_jpg__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__bosses_banditCommander_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_34__bosses_banditCommander_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__bosses_captainOfTheGuard_jpg__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__bosses_captainOfTheGuard_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_35__bosses_captainOfTheGuard_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__bosses_darkRider_jpg__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__bosses_darkRider_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_36__bosses_darkRider_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__bosses_elderDrake_jpg__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__bosses_elderDrake_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_37__bosses_elderDrake_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__bosses_inoxBodyguard_jpg__ = __webpack_require__(143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__bosses_inoxBodyguard_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_38__bosses_inoxBodyguard_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__bosses_jekserah_jpg__ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__bosses_jekserah_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_39__bosses_jekserah_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__bosses_mercilessOverseer_jpg__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__bosses_mercilessOverseer_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_40__bosses_mercilessOverseer_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__bosses_primeDemon_jpg__ = __webpack_require__(146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__bosses_primeDemon_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_41__bosses_primeDemon_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__bosses_sightlessEye_jpg__ = __webpack_require__(147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__bosses_sightlessEye_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_42__bosses_sightlessEye_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__bosses_theBetrayer_jpg__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__bosses_theBetrayer_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_43__bosses_theBetrayer_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__bosses_theColorless_jpg__ = __webpack_require__(149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__bosses_theColorless_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_44__bosses_theColorless_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__bosses_theGloom_jpg__ = __webpack_require__(150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__bosses_theGloom_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_45__bosses_theGloom_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46__bosses_wingedHorror_jpg__ = __webpack_require__(151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46__bosses_wingedHorror_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_46__bosses_wingedHorror_jpg__);
var monsterImagesList={"Ancient Artillery":__WEBPACK_IMPORTED_MODULE_0__ancientArtillery_png___default.a,"Bandit Archer":__WEBPACK_IMPORTED_MODULE_1__banditArcher_png___default.a,"Bandit Guard":__WEBPACK_IMPORTED_MODULE_2__banditGuard_png___default.a,"Black Imp":__WEBPACK_IMPORTED_MODULE_3__blackImp_png___default.a,"Cave Bear":__WEBPACK_IMPORTED_MODULE_4__caveBear_png___default.a,"City Archer":__WEBPACK_IMPORTED_MODULE_5__cityArcher_png___default.a,"City Guard":__WEBPACK_IMPORTED_MODULE_6__cityGuard_png___default.a,"Cultist":__WEBPACK_IMPORTED_MODULE_7__cultist_png___default.a,"Deep Terror":__WEBPACK_IMPORTED_MODULE_8__deepTerror_png___default.a,"Earth Demon":__WEBPACK_IMPORTED_MODULE_9__earthDemon_png___default.a,"Flame Demon":__WEBPACK_IMPORTED_MODULE_10__flameDemon_png___default.a,"Frost Demon":__WEBPACK_IMPORTED_MODULE_11__frostDemon_png___default.a,"Forest Imp":__WEBPACK_IMPORTED_MODULE_12__forestImp_png___default.a,"Giant Viper":__WEBPACK_IMPORTED_MODULE_13__giantViper_png___default.a,"Harrower Infester":__WEBPACK_IMPORTED_MODULE_14__harrowerInfester_png___default.a,"Hound":__WEBPACK_IMPORTED_MODULE_15__hound_png___default.a,"Inox Archer":__WEBPACK_IMPORTED_MODULE_16__inoxArcher_png___default.a,"Inox Guard":__WEBPACK_IMPORTED_MODULE_17__inoxGuard_png___default.a,"Inox Shaman":__WEBPACK_IMPORTED_MODULE_18__inoxShaman_png___default.a,"Living Bones":__WEBPACK_IMPORTED_MODULE_19__livingBones_png___default.a,"Living Corpse":__WEBPACK_IMPORTED_MODULE_20__livingCorpse_png___default.a,"Living Spirit":__WEBPACK_IMPORTED_MODULE_21__livingSpirit_png___default.a,"Lurker":__WEBPACK_IMPORTED_MODULE_22__lurker_png___default.a,"Night Demon":__WEBPACK_IMPORTED_MODULE_23__nightDemon_png___default.a,"Ooze":__WEBPACK_IMPORTED_MODULE_24__ooze_png___default.a,"Rending Drake":__WEBPACK_IMPORTED_MODULE_25__rendingDrake_png___default.a,"Savvas Lavaflow":__WEBPACK_IMPORTED_MODULE_26__savvasLavaflow_png___default.a,"Savvas Icestorm":__WEBPACK_IMPORTED_MODULE_27__savvasIcestorm_png___default.a,"Spitting Drake":__WEBPACK_IMPORTED_MODULE_28__spittingDrake_png___default.a,"Stone Golem":__WEBPACK_IMPORTED_MODULE_29__stoneGolem_png___default.a,"Sun Demon":__WEBPACK_IMPORTED_MODULE_30__sunDemon_png___default.a,"Vermling Scout":__WEBPACK_IMPORTED_MODULE_31__vermlingScout_png___default.a,"Vermling Shaman":__WEBPACK_IMPORTED_MODULE_32__vermlingShaman_png___default.a,"Wind Demon":__WEBPACK_IMPORTED_MODULE_33__windDemon_png___default.a,"Bandit Commander":__WEBPACK_IMPORTED_MODULE_34__bosses_banditCommander_jpg___default.a,"Captain of the Guard":__WEBPACK_IMPORTED_MODULE_35__bosses_captainOfTheGuard_jpg___default.a,"Dark Rider":__WEBPACK_IMPORTED_MODULE_36__bosses_darkRider_jpg___default.a,"Elder Drake":__WEBPACK_IMPORTED_MODULE_37__bosses_elderDrake_jpg___default.a,"Inox Bodyguard":__WEBPACK_IMPORTED_MODULE_38__bosses_inoxBodyguard_jpg___default.a,"Jekserah":__WEBPACK_IMPORTED_MODULE_39__bosses_jekserah_jpg___default.a,"Merciless Overseer":__WEBPACK_IMPORTED_MODULE_40__bosses_mercilessOverseer_jpg___default.a,"Prime Demon":__WEBPACK_IMPORTED_MODULE_41__bosses_primeDemon_jpg___default.a,"The Sightless Eye":__WEBPACK_IMPORTED_MODULE_42__bosses_sightlessEye_jpg___default.a,"The Betrayer":__WEBPACK_IMPORTED_MODULE_43__bosses_theBetrayer_jpg___default.a,"The Colorless":__WEBPACK_IMPORTED_MODULE_44__bosses_theColorless_jpg___default.a,"The Gloom":__WEBPACK_IMPORTED_MODULE_45__bosses_theGloom_jpg___default.a,"Winged Horror":__WEBPACK_IMPORTED_MODULE_46__bosses_wingedHorror_jpg___default.a};/* harmony default export */ __webpack_exports__["a"] = (monsterImagesList);

/***/ }),
/* 19 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ATTACK; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return MOVEMENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return RANGE; });
/* unused harmony export HEALTH */
/* unused harmony export STATS */
/* harmony export (immutable) */ __webpack_exports__["d"] = iconForStat;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__attack_svg__ = __webpack_require__(152);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__attack_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__attack_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__movement_svg__ = __webpack_require__(153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__movement_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__movement_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__range_svg__ = __webpack_require__(154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__range_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__range_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__health_svg__ = __webpack_require__(155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__health_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__health_svg__);
var _statIcons;function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var ATTACK="attack";var MOVEMENT="movement";var RANGE="range";var HEALTH="health";var statIcons=(_statIcons={},_defineProperty(_statIcons,ATTACK,__WEBPACK_IMPORTED_MODULE_0__attack_svg___default.a),_defineProperty(_statIcons,MOVEMENT,__WEBPACK_IMPORTED_MODULE_1__movement_svg___default.a),_defineProperty(_statIcons,RANGE,__WEBPACK_IMPORTED_MODULE_2__range_svg___default.a),_defineProperty(_statIcons,HEALTH,__WEBPACK_IMPORTED_MODULE_3__health_svg___default.a),_statIcons);var STATS=Object.keys(statIcons);function iconForStat(name){return statIcons[name];}

/***/ }),
/* 20 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reactstrap__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_icons__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__MonsterContainer_css__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__MonsterContainer_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__MonsterContainer_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var StatusPopover=function(_React$Component){_inherits(StatusPopover,_React$Component);function StatusPopover(props){_classCallCheck(this,StatusPopover);var _this=_possibleConstructorReturn(this,(StatusPopover.__proto__||Object.getPrototypeOf(StatusPopover)).call(this,props));_this.toggle=_this.toggle.bind(_this);_this.state={popoverOpen:false};return _this;}_createClass(StatusPopover,[{key:'toggle',value:function toggle(){this.setState({popoverOpen:!this.state.popoverOpen});}},{key:'render',value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["a" /* Button */],{color:'info',size:'sm',id:this.props.id,onClick:this.toggle},this.props.text),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["u" /* Popover */],{placement:this.props.placement,isOpen:this.state.popoverOpen,target:this.props.id,toggle:this.toggle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["w" /* PopoverHeader */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["y" /* Row */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["e" /* Col */],{md:'6'},'Set Statuses'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["e" /* Col */],{md:'6',className:'text-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["a" /* Button */],{size:'sm',onClick:function onClick(){_this2.props.clearStatuses(_this2.props.monsterNumber);_this2.toggle();}},'Clear')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["v" /* PopoverBody */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["a" /* Button */],{onClick:function onClick(){_this2.props.toggleStatus(_this2.props.monsterNumber,"poison");},className:this.props.statusList.poison?"btn btn-secondary":"btn btn-outline-secondary"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'img-fluid MonsterTracker--StatusEffectIcon',src:Object(__WEBPACK_IMPORTED_MODULE_2__lib_icons__["a" /* getIcon */])("POISON"),alt:'poison'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["a" /* Button */],{onClick:function onClick(){_this2.props.toggleStatus(_this2.props.monsterNumber,"muddle");},className:this.props.statusList.muddle?"btn btn-secondary":"btn btn-outline-secondary"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'img-fluid MonsterTracker--StatusEffectIcon',src:Object(__WEBPACK_IMPORTED_MODULE_2__lib_icons__["a" /* getIcon */])("MUDDLE"),alt:'muddle'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["a" /* Button */],{onClick:function onClick(){_this2.props.toggleStatus(_this2.props.monsterNumber,"wound");},className:this.props.statusList.wound?"btn btn-secondary":"btn btn-outline-secondary"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'img-fluid MonsterTracker--StatusEffectIcon',src:Object(__WEBPACK_IMPORTED_MODULE_2__lib_icons__["a" /* getIcon */])("WOUND"),alt:'wound'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["a" /* Button */],{onClick:function onClick(){_this2.props.toggleStatus(_this2.props.monsterNumber,"immobilize");},className:this.props.statusList.immobilize?"btn btn-secondary":"btn btn-outline-secondary"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'img-fluid MonsterTracker--StatusEffectIcon',src:Object(__WEBPACK_IMPORTED_MODULE_2__lib_icons__["a" /* getIcon */])("IMMOBILIZE"),alt:'immobilize'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["a" /* Button */],{onClick:function onClick(){_this2.props.toggleStatus(_this2.props.monsterNumber,"disarm");},className:this.props.statusList.disarm?"btn btn-secondary":"btn btn-outline-secondary"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'img-fluid MonsterTracker--StatusEffectIcon',src:Object(__WEBPACK_IMPORTED_MODULE_2__lib_icons__["a" /* getIcon */])("DISARM"),alt:'disarm'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["a" /* Button */],{onClick:function onClick(){_this2.props.toggleStatus(_this2.props.monsterNumber,"stun");},className:this.props.statusList.stun?"btn btn-secondary":"btn btn-outline-secondary"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'img-fluid MonsterTracker--StatusEffectIcon',src:Object(__WEBPACK_IMPORTED_MODULE_2__lib_icons__["a" /* getIcon */])("STUN"),alt:'stun'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["a" /* Button */],{onClick:function onClick(){_this2.props.toggleStatus(_this2.props.monsterNumber,"invisible");},className:this.props.statusList.invisible?"btn btn-secondary":"btn btn-outline-secondary"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'img-fluid MonsterTracker--StatusEffectIcon',src:Object(__WEBPACK_IMPORTED_MODULE_2__lib_icons__["a" /* getIcon */])("INVISIBLE"),alt:'invisible'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["a" /* Button */],{onClick:function onClick(){_this2.props.toggleStatus(_this2.props.monsterNumber,"strengthen");},className:this.props.statusList.strengthen?"btn btn-secondary":"btn btn-outline-secondary"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'img-fluid MonsterTracker--StatusEffectIcon',src:Object(__WEBPACK_IMPORTED_MODULE_2__lib_icons__["a" /* getIcon */])("STRENGTHEN"),alt:'strengthen'})))));}}]);return StatusPopover;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (StatusPopover);

/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
function _interopRequireDefault(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(exports,"__esModule",{value:!0});var _Reveal=__webpack_require__(162);Object.defineProperty(exports,"default",{enumerable:!0,get:function(){return _interopRequireDefault(_Reveal).default}});var _Fade=__webpack_require__(22);Object.defineProperty(exports,"Fade",{enumerable:!0,get:function(){return _interopRequireDefault(_Fade).default}});var _Bounce=__webpack_require__(164);Object.defineProperty(exports,"Bounce",{enumerable:!0,get:function(){return _interopRequireDefault(_Bounce).default}});var _Roll=__webpack_require__(165);Object.defineProperty(exports,"Roll",{enumerable:!0,get:function(){return _interopRequireDefault(_Roll).default}});var _Slide=__webpack_require__(166);Object.defineProperty(exports,"Slide",{enumerable:!0,get:function(){return _interopRequireDefault(_Slide).default}});var _Flip=__webpack_require__(167);Object.defineProperty(exports,"Flip",{enumerable:!0,get:function(){return _interopRequireDefault(_Flip).default}}),Object.defineProperty(exports,"Reveal",{enumerable:!0,get:function(){return _interopRequireDefault(_Reveal).default}});var _Rotate=__webpack_require__(168);Object.defineProperty(exports,"Rotate",{enumerable:!0,get:function(){return _interopRequireDefault(_Rotate).default}});var _LightSpeed=__webpack_require__(169);Object.defineProperty(exports,"LightSpeed",{enumerable:!0,get:function(){return _interopRequireDefault(_LightSpeed).default}});var _Zoom=__webpack_require__(170);Object.defineProperty(exports,"Zoom",{enumerable:!0,get:function(){return _interopRequireDefault(_Zoom).default}});

/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
function _interopRequireDefault(o){return o&&o.__esModule?o:{default:o}}function _objectWithoutProperties(o,e){var r={};for(var t in o)e.indexOf(t)>=0||Object.prototype.hasOwnProperty.call(o,t)&&(r[t]=o[t]);return r}function make(o,e){var r=e.distance,t=e.left,p=e.right,a=e.up,l=e.down,i=e.top,u=e.bottom,n=e.big,s=e.mirror,d=e.opposite,_=(r?r.toString():0)+((t?1:0)|(p?2:0)|(i||l?4:0)|(u||a?8:0)|(s?16:0)|(d?32:0)|(o?64:0)|(n?128:0));if(lookup.hasOwnProperty(_))return lookup[_];var f=t||p||a||l||i||u,y=void 0,b=void 0;if(f){if(!s!=!(o&&d)){var v=[p,t,u,i,l,a];t=v[0],p=v[1],i=v[2],u=v[3],a=v[4],l=v[5]}var c=r||(n?"2000px":"100%");y=t?"-"+c:p?c:"0",b=l||i?"-"+c:a||u?c:"0"}return lookup[_]=(0,_globals.animation)((o?"to":"from")+" {opacity: 0;"+(f?" transform: translate3d("+y+", "+b+", 0);":"")+"}\n     "+(o?"from":"to")+" {opacity: 1;transform: none;} "),lookup[_]}function Fade(){var o=arguments.length>0&&void 0!==arguments[0]?arguments[0]:_globals.defaults,e=arguments.length>1&&void 0!==arguments[1]&&arguments[1],r=o.children,t=(o.out,o.forever),p=o.timeout,a=o.duration,l=void 0===a?_globals.defaults.duration:a,i=o.delay,u=void 0===i?_globals.defaults.delay:i,n=o.count,s=void 0===n?_globals.defaults.count:n,d=_objectWithoutProperties(o,["children","out","forever","timeout","duration","delay","count"]),_={make:make,duration:void 0===p?l:p,delay:u,forever:t,count:s,style:{animationFillMode:"both"},reverse:d.left};return e?(0,_wrap2.default)(d,_,_,r):_}Object.defineProperty(exports,"__esModule",{value:!0});var _propTypes=__webpack_require__(1),_globals=__webpack_require__(2),_wrap=__webpack_require__(3),_wrap2=_interopRequireDefault(_wrap),propTypes={out:_propTypes.bool,left:_propTypes.bool,right:_propTypes.bool,top:_propTypes.bool,bottom:_propTypes.bool,big:_propTypes.bool,mirror:_propTypes.bool,opposite:_propTypes.bool,duration:_propTypes.number,timeout:_propTypes.number,distance:_propTypes.string,delay:_propTypes.number,count:_propTypes.number,forever:_propTypes.bool},lookup={};Fade.propTypes=propTypes,exports.default=Fade,module.exports=exports.default;

/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(24);
module.exports = __webpack_require__(29);


/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// @remove-on-eject-begin
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
// @remove-on-eject-end


if (typeof Promise === 'undefined') {
  // Rejection tracking prevents a common issue where React gets into an
  // inconsistent state due to an error, but it gets swallowed by a Promise,
  // and the user has no idea what causes React's erratic future behavior.
  __webpack_require__(25).enable();
  window.Promise = __webpack_require__(27);
}

// fetch() polyfill for making API calls.
__webpack_require__(28);

// Object.assign() is commonly used with React.
// It will use the native implementation if it's present and isn't buggy.
Object.assign = __webpack_require__(8);

// In tests, polyfill requestAnimationFrame since jsdom doesn't provide it yet.
// We don't polyfill it in the browser--this is user's responsibility.
if (false) {
  require('raf').polyfill(global);
}


/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Promise = __webpack_require__(11);

var DEFAULT_WHITELIST = [
  ReferenceError,
  TypeError,
  RangeError
];

var enabled = false;
exports.disable = disable;
function disable() {
  enabled = false;
  Promise._47 = null;
  Promise._71 = null;
}

exports.enable = enable;
function enable(options) {
  options = options || {};
  if (enabled) disable();
  enabled = true;
  var id = 0;
  var displayId = 0;
  var rejections = {};
  Promise._47 = function (promise) {
    if (
      promise._83 === 2 && // IS REJECTED
      rejections[promise._56]
    ) {
      if (rejections[promise._56].logged) {
        onHandled(promise._56);
      } else {
        clearTimeout(rejections[promise._56].timeout);
      }
      delete rejections[promise._56];
    }
  };
  Promise._71 = function (promise, err) {
    if (promise._75 === 0) { // not yet handled
      promise._56 = id++;
      rejections[promise._56] = {
        displayId: null,
        error: err,
        timeout: setTimeout(
          onUnhandled.bind(null, promise._56),
          // For reference errors and type errors, this almost always
          // means the programmer made a mistake, so log them after just
          // 100ms
          // otherwise, wait 2 seconds to see if they get handled
          matchWhitelist(err, DEFAULT_WHITELIST)
            ? 100
            : 2000
        ),
        logged: false
      };
    }
  };
  function onUnhandled(id) {
    if (
      options.allRejections ||
      matchWhitelist(
        rejections[id].error,
        options.whitelist || DEFAULT_WHITELIST
      )
    ) {
      rejections[id].displayId = displayId++;
      if (options.onUnhandled) {
        rejections[id].logged = true;
        options.onUnhandled(
          rejections[id].displayId,
          rejections[id].error
        );
      } else {
        rejections[id].logged = true;
        logError(
          rejections[id].displayId,
          rejections[id].error
        );
      }
    }
  }
  function onHandled(id) {
    if (rejections[id].logged) {
      if (options.onHandled) {
        options.onHandled(rejections[id].displayId, rejections[id].error);
      } else if (!rejections[id].onUnhandled) {
        console.warn(
          'Promise Rejection Handled (id: ' + rejections[id].displayId + '):'
        );
        console.warn(
          '  This means you can ignore any previous messages of the form "Possible Unhandled Promise Rejection" with id ' +
          rejections[id].displayId + '.'
        );
      }
    }
  }
}

function logError(id, error) {
  console.warn('Possible Unhandled Promise Rejection (id: ' + id + '):');
  var errStr = (error && (error.stack || error)) + '';
  errStr.split('\n').forEach(function (line) {
    console.warn('  ' + line);
  });
}

function matchWhitelist(error, list) {
  return list.some(function (cls) {
    return error instanceof cls;
  });
}

/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

// Use the fastest means possible to execute a task in its own turn, with
// priority over other events including IO, animation, reflow, and redraw
// events in browsers.
//
// An exception thrown by a task will permanently interrupt the processing of
// subsequent tasks. The higher level `asap` function ensures that if an
// exception is thrown by a task, that the task queue will continue flushing as
// soon as possible, but if you use `rawAsap` directly, you are responsible to
// either ensure that no exceptions are thrown from your task, or to manually
// call `rawAsap.requestFlush` if an exception is thrown.
module.exports = rawAsap;
function rawAsap(task) {
    if (!queue.length) {
        requestFlush();
        flushing = true;
    }
    // Equivalent to push, but avoids a function call.
    queue[queue.length] = task;
}

var queue = [];
// Once a flush has been requested, no further calls to `requestFlush` are
// necessary until the next `flush` completes.
var flushing = false;
// `requestFlush` is an implementation-specific method that attempts to kick
// off a `flush` event as quickly as possible. `flush` will attempt to exhaust
// the event queue before yielding to the browser's own event loop.
var requestFlush;
// The position of the next task to execute in the task queue. This is
// preserved between calls to `flush` so that it can be resumed if
// a task throws an exception.
var index = 0;
// If a task schedules additional tasks recursively, the task queue can grow
// unbounded. To prevent memory exhaustion, the task queue will periodically
// truncate already-completed tasks.
var capacity = 1024;

// The flush function processes all tasks that have been scheduled with
// `rawAsap` unless and until one of those tasks throws an exception.
// If a task throws an exception, `flush` ensures that its state will remain
// consistent and will resume where it left off when called again.
// However, `flush` does not make any arrangements to be called again if an
// exception is thrown.
function flush() {
    while (index < queue.length) {
        var currentIndex = index;
        // Advance the index before calling the task. This ensures that we will
        // begin flushing on the next task the task throws an error.
        index = index + 1;
        queue[currentIndex].call();
        // Prevent leaking memory for long chains of recursive calls to `asap`.
        // If we call `asap` within tasks scheduled by `asap`, the queue will
        // grow, but to avoid an O(n) walk for every task we execute, we don't
        // shift tasks off the queue after they have been executed.
        // Instead, we periodically shift 1024 tasks off the queue.
        if (index > capacity) {
            // Manually shift all values starting at the index back to the
            // beginning of the queue.
            for (var scan = 0, newLength = queue.length - index; scan < newLength; scan++) {
                queue[scan] = queue[scan + index];
            }
            queue.length -= index;
            index = 0;
        }
    }
    queue.length = 0;
    index = 0;
    flushing = false;
}

// `requestFlush` is implemented using a strategy based on data collected from
// every available SauceLabs Selenium web driver worker at time of writing.
// https://docs.google.com/spreadsheets/d/1mG-5UYGup5qxGdEMWkhP6BWCz053NUb2E1QoUTU16uA/edit#gid=783724593

// Safari 6 and 6.1 for desktop, iPad, and iPhone are the only browsers that
// have WebKitMutationObserver but not un-prefixed MutationObserver.
// Must use `global` or `self` instead of `window` to work in both frames and web
// workers. `global` is a provision of Browserify, Mr, Mrs, or Mop.

/* globals self */
var scope = typeof global !== "undefined" ? global : self;
var BrowserMutationObserver = scope.MutationObserver || scope.WebKitMutationObserver;

// MutationObservers are desirable because they have high priority and work
// reliably everywhere they are implemented.
// They are implemented in all modern browsers.
//
// - Android 4-4.3
// - Chrome 26-34
// - Firefox 14-29
// - Internet Explorer 11
// - iPad Safari 6-7.1
// - iPhone Safari 7-7.1
// - Safari 6-7
if (typeof BrowserMutationObserver === "function") {
    requestFlush = makeRequestCallFromMutationObserver(flush);

// MessageChannels are desirable because they give direct access to the HTML
// task queue, are implemented in Internet Explorer 10, Safari 5.0-1, and Opera
// 11-12, and in web workers in many engines.
// Although message channels yield to any queued rendering and IO tasks, they
// would be better than imposing the 4ms delay of timers.
// However, they do not work reliably in Internet Explorer or Safari.

// Internet Explorer 10 is the only browser that has setImmediate but does
// not have MutationObservers.
// Although setImmediate yields to the browser's renderer, it would be
// preferrable to falling back to setTimeout since it does not have
// the minimum 4ms penalty.
// Unfortunately there appears to be a bug in Internet Explorer 10 Mobile (and
// Desktop to a lesser extent) that renders both setImmediate and
// MessageChannel useless for the purposes of ASAP.
// https://github.com/kriskowal/q/issues/396

// Timers are implemented universally.
// We fall back to timers in workers in most engines, and in foreground
// contexts in the following browsers.
// However, note that even this simple case requires nuances to operate in a
// broad spectrum of browsers.
//
// - Firefox 3-13
// - Internet Explorer 6-9
// - iPad Safari 4.3
// - Lynx 2.8.7
} else {
    requestFlush = makeRequestCallFromTimer(flush);
}

// `requestFlush` requests that the high priority event queue be flushed as
// soon as possible.
// This is useful to prevent an error thrown in a task from stalling the event
// queue if the exception handled by Node.js’s
// `process.on("uncaughtException")` or by a domain.
rawAsap.requestFlush = requestFlush;

// To request a high priority event, we induce a mutation observer by toggling
// the text of a text node between "1" and "-1".
function makeRequestCallFromMutationObserver(callback) {
    var toggle = 1;
    var observer = new BrowserMutationObserver(callback);
    var node = document.createTextNode("");
    observer.observe(node, {characterData: true});
    return function requestCall() {
        toggle = -toggle;
        node.data = toggle;
    };
}

// The message channel technique was discovered by Malte Ubl and was the
// original foundation for this library.
// http://www.nonblocking.io/2011/06/windownexttick.html

// Safari 6.0.5 (at least) intermittently fails to create message ports on a
// page's first load. Thankfully, this version of Safari supports
// MutationObservers, so we don't need to fall back in that case.

// function makeRequestCallFromMessageChannel(callback) {
//     var channel = new MessageChannel();
//     channel.port1.onmessage = callback;
//     return function requestCall() {
//         channel.port2.postMessage(0);
//     };
// }

// For reasons explained above, we are also unable to use `setImmediate`
// under any circumstances.
// Even if we were, there is another bug in Internet Explorer 10.
// It is not sufficient to assign `setImmediate` to `requestFlush` because
// `setImmediate` must be called *by name* and therefore must be wrapped in a
// closure.
// Never forget.

// function makeRequestCallFromSetImmediate(callback) {
//     return function requestCall() {
//         setImmediate(callback);
//     };
// }

// Safari 6.0 has a problem where timers will get lost while the user is
// scrolling. This problem does not impact ASAP because Safari 6.0 supports
// mutation observers, so that implementation is used instead.
// However, if we ever elect to use timers in Safari, the prevalent work-around
// is to add a scroll event listener that calls for a flush.

// `setTimeout` does not call the passed callback if the delay is less than
// approximately 7 in web workers in Firefox 8 through 18, and sometimes not
// even then.

function makeRequestCallFromTimer(callback) {
    return function requestCall() {
        // We dispatch a timeout with a specified delay of 0 for engines that
        // can reliably accommodate that request. This will usually be snapped
        // to a 4 milisecond delay, but once we're flushing, there's no delay
        // between events.
        var timeoutHandle = setTimeout(handleTimer, 0);
        // However, since this timer gets frequently dropped in Firefox
        // workers, we enlist an interval handle that will try to fire
        // an event 20 times per second until it succeeds.
        var intervalHandle = setInterval(handleTimer, 50);

        function handleTimer() {
            // Whichever timer succeeds will cancel both timers and
            // execute the callback.
            clearTimeout(timeoutHandle);
            clearInterval(intervalHandle);
            callback();
        }
    };
}

// This is for `asap.js` only.
// Its name will be periodically randomized to break any code that depends on
// its existence.
rawAsap.makeRequestCallFromTimer = makeRequestCallFromTimer;

// ASAP was originally a nextTick shim included in Q. This was factored out
// into this ASAP package. It was later adapted to RSVP which made further
// amendments. These decisions, particularly to marginalize MessageChannel and
// to capture the MutationObserver implementation in a closure, were integrated
// back into ASAP proper.
// https://github.com/tildeio/rsvp.js/blob/cddf7232546a9cf858524b75cde6f9edf72620a7/lib/rsvp/asap.js

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(7)))

/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//This file contains the ES6 extensions to the core Promises/A+ API

var Promise = __webpack_require__(11);

module.exports = Promise;

/* Static Functions */

var TRUE = valuePromise(true);
var FALSE = valuePromise(false);
var NULL = valuePromise(null);
var UNDEFINED = valuePromise(undefined);
var ZERO = valuePromise(0);
var EMPTYSTRING = valuePromise('');

function valuePromise(value) {
  var p = new Promise(Promise._44);
  p._83 = 1;
  p._18 = value;
  return p;
}
Promise.resolve = function (value) {
  if (value instanceof Promise) return value;

  if (value === null) return NULL;
  if (value === undefined) return UNDEFINED;
  if (value === true) return TRUE;
  if (value === false) return FALSE;
  if (value === 0) return ZERO;
  if (value === '') return EMPTYSTRING;

  if (typeof value === 'object' || typeof value === 'function') {
    try {
      var then = value.then;
      if (typeof then === 'function') {
        return new Promise(then.bind(value));
      }
    } catch (ex) {
      return new Promise(function (resolve, reject) {
        reject(ex);
      });
    }
  }
  return valuePromise(value);
};

Promise.all = function (arr) {
  var args = Array.prototype.slice.call(arr);

  return new Promise(function (resolve, reject) {
    if (args.length === 0) return resolve([]);
    var remaining = args.length;
    function res(i, val) {
      if (val && (typeof val === 'object' || typeof val === 'function')) {
        if (val instanceof Promise && val.then === Promise.prototype.then) {
          while (val._83 === 3) {
            val = val._18;
          }
          if (val._83 === 1) return res(i, val._18);
          if (val._83 === 2) reject(val._18);
          val.then(function (val) {
            res(i, val);
          }, reject);
          return;
        } else {
          var then = val.then;
          if (typeof then === 'function') {
            var p = new Promise(then.bind(val));
            p.then(function (val) {
              res(i, val);
            }, reject);
            return;
          }
        }
      }
      args[i] = val;
      if (--remaining === 0) {
        resolve(args);
      }
    }
    for (var i = 0; i < args.length; i++) {
      res(i, args[i]);
    }
  });
};

Promise.reject = function (value) {
  return new Promise(function (resolve, reject) {
    reject(value);
  });
};

Promise.race = function (values) {
  return new Promise(function (resolve, reject) {
    values.forEach(function(value){
      Promise.resolve(value).then(resolve, reject);
    });
  });
};

/* Prototype Methods */

Promise.prototype['catch'] = function (onRejected) {
  return this.then(null, onRejected);
};


/***/ }),
/* 28 */
/***/ (function(module, exports) {

(function(self) {
  'use strict';

  if (self.fetch) {
    return
  }

  var support = {
    searchParams: 'URLSearchParams' in self,
    iterable: 'Symbol' in self && 'iterator' in Symbol,
    blob: 'FileReader' in self && 'Blob' in self && (function() {
      try {
        new Blob()
        return true
      } catch(e) {
        return false
      }
    })(),
    formData: 'FormData' in self,
    arrayBuffer: 'ArrayBuffer' in self
  }

  if (support.arrayBuffer) {
    var viewClasses = [
      '[object Int8Array]',
      '[object Uint8Array]',
      '[object Uint8ClampedArray]',
      '[object Int16Array]',
      '[object Uint16Array]',
      '[object Int32Array]',
      '[object Uint32Array]',
      '[object Float32Array]',
      '[object Float64Array]'
    ]

    var isDataView = function(obj) {
      return obj && DataView.prototype.isPrototypeOf(obj)
    }

    var isArrayBufferView = ArrayBuffer.isView || function(obj) {
      return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
    }
  }

  function normalizeName(name) {
    if (typeof name !== 'string') {
      name = String(name)
    }
    if (/[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(name)) {
      throw new TypeError('Invalid character in header field name')
    }
    return name.toLowerCase()
  }

  function normalizeValue(value) {
    if (typeof value !== 'string') {
      value = String(value)
    }
    return value
  }

  // Build a destructive iterator for the value list
  function iteratorFor(items) {
    var iterator = {
      next: function() {
        var value = items.shift()
        return {done: value === undefined, value: value}
      }
    }

    if (support.iterable) {
      iterator[Symbol.iterator] = function() {
        return iterator
      }
    }

    return iterator
  }

  function Headers(headers) {
    this.map = {}

    if (headers instanceof Headers) {
      headers.forEach(function(value, name) {
        this.append(name, value)
      }, this)
    } else if (Array.isArray(headers)) {
      headers.forEach(function(header) {
        this.append(header[0], header[1])
      }, this)
    } else if (headers) {
      Object.getOwnPropertyNames(headers).forEach(function(name) {
        this.append(name, headers[name])
      }, this)
    }
  }

  Headers.prototype.append = function(name, value) {
    name = normalizeName(name)
    value = normalizeValue(value)
    var oldValue = this.map[name]
    this.map[name] = oldValue ? oldValue+','+value : value
  }

  Headers.prototype['delete'] = function(name) {
    delete this.map[normalizeName(name)]
  }

  Headers.prototype.get = function(name) {
    name = normalizeName(name)
    return this.has(name) ? this.map[name] : null
  }

  Headers.prototype.has = function(name) {
    return this.map.hasOwnProperty(normalizeName(name))
  }

  Headers.prototype.set = function(name, value) {
    this.map[normalizeName(name)] = normalizeValue(value)
  }

  Headers.prototype.forEach = function(callback, thisArg) {
    for (var name in this.map) {
      if (this.map.hasOwnProperty(name)) {
        callback.call(thisArg, this.map[name], name, this)
      }
    }
  }

  Headers.prototype.keys = function() {
    var items = []
    this.forEach(function(value, name) { items.push(name) })
    return iteratorFor(items)
  }

  Headers.prototype.values = function() {
    var items = []
    this.forEach(function(value) { items.push(value) })
    return iteratorFor(items)
  }

  Headers.prototype.entries = function() {
    var items = []
    this.forEach(function(value, name) { items.push([name, value]) })
    return iteratorFor(items)
  }

  if (support.iterable) {
    Headers.prototype[Symbol.iterator] = Headers.prototype.entries
  }

  function consumed(body) {
    if (body.bodyUsed) {
      return Promise.reject(new TypeError('Already read'))
    }
    body.bodyUsed = true
  }

  function fileReaderReady(reader) {
    return new Promise(function(resolve, reject) {
      reader.onload = function() {
        resolve(reader.result)
      }
      reader.onerror = function() {
        reject(reader.error)
      }
    })
  }

  function readBlobAsArrayBuffer(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsArrayBuffer(blob)
    return promise
  }

  function readBlobAsText(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsText(blob)
    return promise
  }

  function readArrayBufferAsText(buf) {
    var view = new Uint8Array(buf)
    var chars = new Array(view.length)

    for (var i = 0; i < view.length; i++) {
      chars[i] = String.fromCharCode(view[i])
    }
    return chars.join('')
  }

  function bufferClone(buf) {
    if (buf.slice) {
      return buf.slice(0)
    } else {
      var view = new Uint8Array(buf.byteLength)
      view.set(new Uint8Array(buf))
      return view.buffer
    }
  }

  function Body() {
    this.bodyUsed = false

    this._initBody = function(body) {
      this._bodyInit = body
      if (!body) {
        this._bodyText = ''
      } else if (typeof body === 'string') {
        this._bodyText = body
      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
        this._bodyBlob = body
      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
        this._bodyFormData = body
      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
        this._bodyText = body.toString()
      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
        this._bodyArrayBuffer = bufferClone(body.buffer)
        // IE 10-11 can't handle a DataView body.
        this._bodyInit = new Blob([this._bodyArrayBuffer])
      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
        this._bodyArrayBuffer = bufferClone(body)
      } else {
        throw new Error('unsupported BodyInit type')
      }

      if (!this.headers.get('content-type')) {
        if (typeof body === 'string') {
          this.headers.set('content-type', 'text/plain;charset=UTF-8')
        } else if (this._bodyBlob && this._bodyBlob.type) {
          this.headers.set('content-type', this._bodyBlob.type)
        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8')
        }
      }
    }

    if (support.blob) {
      this.blob = function() {
        var rejected = consumed(this)
        if (rejected) {
          return rejected
        }

        if (this._bodyBlob) {
          return Promise.resolve(this._bodyBlob)
        } else if (this._bodyArrayBuffer) {
          return Promise.resolve(new Blob([this._bodyArrayBuffer]))
        } else if (this._bodyFormData) {
          throw new Error('could not read FormData body as blob')
        } else {
          return Promise.resolve(new Blob([this._bodyText]))
        }
      }

      this.arrayBuffer = function() {
        if (this._bodyArrayBuffer) {
          return consumed(this) || Promise.resolve(this._bodyArrayBuffer)
        } else {
          return this.blob().then(readBlobAsArrayBuffer)
        }
      }
    }

    this.text = function() {
      var rejected = consumed(this)
      if (rejected) {
        return rejected
      }

      if (this._bodyBlob) {
        return readBlobAsText(this._bodyBlob)
      } else if (this._bodyArrayBuffer) {
        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
      } else if (this._bodyFormData) {
        throw new Error('could not read FormData body as text')
      } else {
        return Promise.resolve(this._bodyText)
      }
    }

    if (support.formData) {
      this.formData = function() {
        return this.text().then(decode)
      }
    }

    this.json = function() {
      return this.text().then(JSON.parse)
    }

    return this
  }

  // HTTP methods whose capitalization should be normalized
  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT']

  function normalizeMethod(method) {
    var upcased = method.toUpperCase()
    return (methods.indexOf(upcased) > -1) ? upcased : method
  }

  function Request(input, options) {
    options = options || {}
    var body = options.body

    if (input instanceof Request) {
      if (input.bodyUsed) {
        throw new TypeError('Already read')
      }
      this.url = input.url
      this.credentials = input.credentials
      if (!options.headers) {
        this.headers = new Headers(input.headers)
      }
      this.method = input.method
      this.mode = input.mode
      if (!body && input._bodyInit != null) {
        body = input._bodyInit
        input.bodyUsed = true
      }
    } else {
      this.url = String(input)
    }

    this.credentials = options.credentials || this.credentials || 'omit'
    if (options.headers || !this.headers) {
      this.headers = new Headers(options.headers)
    }
    this.method = normalizeMethod(options.method || this.method || 'GET')
    this.mode = options.mode || this.mode || null
    this.referrer = null

    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
      throw new TypeError('Body not allowed for GET or HEAD requests')
    }
    this._initBody(body)
  }

  Request.prototype.clone = function() {
    return new Request(this, { body: this._bodyInit })
  }

  function decode(body) {
    var form = new FormData()
    body.trim().split('&').forEach(function(bytes) {
      if (bytes) {
        var split = bytes.split('=')
        var name = split.shift().replace(/\+/g, ' ')
        var value = split.join('=').replace(/\+/g, ' ')
        form.append(decodeURIComponent(name), decodeURIComponent(value))
      }
    })
    return form
  }

  function parseHeaders(rawHeaders) {
    var headers = new Headers()
    rawHeaders.split(/\r?\n/).forEach(function(line) {
      var parts = line.split(':')
      var key = parts.shift().trim()
      if (key) {
        var value = parts.join(':').trim()
        headers.append(key, value)
      }
    })
    return headers
  }

  Body.call(Request.prototype)

  function Response(bodyInit, options) {
    if (!options) {
      options = {}
    }

    this.type = 'default'
    this.status = 'status' in options ? options.status : 200
    this.ok = this.status >= 200 && this.status < 300
    this.statusText = 'statusText' in options ? options.statusText : 'OK'
    this.headers = new Headers(options.headers)
    this.url = options.url || ''
    this._initBody(bodyInit)
  }

  Body.call(Response.prototype)

  Response.prototype.clone = function() {
    return new Response(this._bodyInit, {
      status: this.status,
      statusText: this.statusText,
      headers: new Headers(this.headers),
      url: this.url
    })
  }

  Response.error = function() {
    var response = new Response(null, {status: 0, statusText: ''})
    response.type = 'error'
    return response
  }

  var redirectStatuses = [301, 302, 303, 307, 308]

  Response.redirect = function(url, status) {
    if (redirectStatuses.indexOf(status) === -1) {
      throw new RangeError('Invalid status code')
    }

    return new Response(null, {status: status, headers: {location: url}})
  }

  self.Headers = Headers
  self.Request = Request
  self.Response = Response

  self.fetch = function(input, init) {
    return new Promise(function(resolve, reject) {
      var request = new Request(input, init)
      var xhr = new XMLHttpRequest()

      xhr.onload = function() {
        var options = {
          status: xhr.status,
          statusText: xhr.statusText,
          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
        }
        options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL')
        var body = 'response' in xhr ? xhr.response : xhr.responseText
        resolve(new Response(body, options))
      }

      xhr.onerror = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.ontimeout = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.open(request.method, request.url, true)

      if (request.credentials === 'include') {
        xhr.withCredentials = true
      }

      if ('responseType' in xhr && support.blob) {
        xhr.responseType = 'blob'
      }

      request.headers.forEach(function(value, name) {
        xhr.setRequestHeader(name, value)
      })

      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit)
    })
  }
  self.fetch.polyfill = true
})(typeof self !== 'undefined' ? self : this);


/***/ }),
/* 29 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_bootstrap_dist_css_bootstrap_css__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_bootstrap_dist_css_bootstrap_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_bootstrap_dist_css_bootstrap_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__index_css__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__App__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__registerServiceWorker__ = __webpack_require__(176);
__WEBPACK_IMPORTED_MODULE_1_react_dom___default.a.render(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__App__["a" /* default */],null),document.getElementById('root'));Object(__WEBPACK_IMPORTED_MODULE_5__registerServiceWorker__["a" /* default */])();

/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.2.0
 * react.production.min.js
 *
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var m=__webpack_require__(8),n=__webpack_require__(12),p=__webpack_require__(5),q="function"===typeof Symbol&&Symbol["for"],r=q?Symbol["for"]("react.element"):60103,t=q?Symbol["for"]("react.call"):60104,u=q?Symbol["for"]("react.return"):60105,v=q?Symbol["for"]("react.portal"):60106,w=q?Symbol["for"]("react.fragment"):60107,x="function"===typeof Symbol&&Symbol.iterator;
function y(a){for(var b=arguments.length-1,e="Minified React error #"+a+"; visit http://facebook.github.io/react/docs/error-decoder.html?invariant\x3d"+a,c=0;c<b;c++)e+="\x26args[]\x3d"+encodeURIComponent(arguments[c+1]);b=Error(e+" for the full message or use the non-minified dev environment for full errors and additional helpful warnings.");b.name="Invariant Violation";b.framesToPop=1;throw b;}
var z={isMounted:function(){return!1},enqueueForceUpdate:function(){},enqueueReplaceState:function(){},enqueueSetState:function(){}};function A(a,b,e){this.props=a;this.context=b;this.refs=n;this.updater=e||z}A.prototype.isReactComponent={};A.prototype.setState=function(a,b){"object"!==typeof a&&"function"!==typeof a&&null!=a?y("85"):void 0;this.updater.enqueueSetState(this,a,b,"setState")};A.prototype.forceUpdate=function(a){this.updater.enqueueForceUpdate(this,a,"forceUpdate")};
function B(a,b,e){this.props=a;this.context=b;this.refs=n;this.updater=e||z}function C(){}C.prototype=A.prototype;var D=B.prototype=new C;D.constructor=B;m(D,A.prototype);D.isPureReactComponent=!0;function E(a,b,e){this.props=a;this.context=b;this.refs=n;this.updater=e||z}var F=E.prototype=new C;F.constructor=E;m(F,A.prototype);F.unstable_isAsyncReactComponent=!0;F.render=function(){return this.props.children};var G={current:null},H=Object.prototype.hasOwnProperty,I={key:!0,ref:!0,__self:!0,__source:!0};
function J(a,b,e){var c,d={},g=null,k=null;if(null!=b)for(c in void 0!==b.ref&&(k=b.ref),void 0!==b.key&&(g=""+b.key),b)H.call(b,c)&&!I.hasOwnProperty(c)&&(d[c]=b[c]);var f=arguments.length-2;if(1===f)d.children=e;else if(1<f){for(var h=Array(f),l=0;l<f;l++)h[l]=arguments[l+2];d.children=h}if(a&&a.defaultProps)for(c in f=a.defaultProps,f)void 0===d[c]&&(d[c]=f[c]);return{$$typeof:r,type:a,key:g,ref:k,props:d,_owner:G.current}}function K(a){return"object"===typeof a&&null!==a&&a.$$typeof===r}
function escape(a){var b={"\x3d":"\x3d0",":":"\x3d2"};return"$"+(""+a).replace(/[=:]/g,function(a){return b[a]})}var L=/\/+/g,M=[];function N(a,b,e,c){if(M.length){var d=M.pop();d.result=a;d.keyPrefix=b;d.func=e;d.context=c;d.count=0;return d}return{result:a,keyPrefix:b,func:e,context:c,count:0}}function O(a){a.result=null;a.keyPrefix=null;a.func=null;a.context=null;a.count=0;10>M.length&&M.push(a)}
function P(a,b,e,c){var d=typeof a;if("undefined"===d||"boolean"===d)a=null;var g=!1;if(null===a)g=!0;else switch(d){case "string":case "number":g=!0;break;case "object":switch(a.$$typeof){case r:case t:case u:case v:g=!0}}if(g)return e(c,a,""===b?"."+Q(a,0):b),1;g=0;b=""===b?".":b+":";if(Array.isArray(a))for(var k=0;k<a.length;k++){d=a[k];var f=b+Q(d,k);g+=P(d,f,e,c)}else if(null===a||"undefined"===typeof a?f=null:(f=x&&a[x]||a["@@iterator"],f="function"===typeof f?f:null),"function"===typeof f)for(a=
f.call(a),k=0;!(d=a.next()).done;)d=d.value,f=b+Q(d,k++),g+=P(d,f,e,c);else"object"===d&&(e=""+a,y("31","[object Object]"===e?"object with keys {"+Object.keys(a).join(", ")+"}":e,""));return g}function Q(a,b){return"object"===typeof a&&null!==a&&null!=a.key?escape(a.key):b.toString(36)}function R(a,b){a.func.call(a.context,b,a.count++)}
function S(a,b,e){var c=a.result,d=a.keyPrefix;a=a.func.call(a.context,b,a.count++);Array.isArray(a)?T(a,c,e,p.thatReturnsArgument):null!=a&&(K(a)&&(b=d+(!a.key||b&&b.key===a.key?"":(""+a.key).replace(L,"$\x26/")+"/")+e,a={$$typeof:r,type:a.type,key:b,ref:a.ref,props:a.props,_owner:a._owner}),c.push(a))}function T(a,b,e,c,d){var g="";null!=e&&(g=(""+e).replace(L,"$\x26/")+"/");b=N(b,g,c,d);null==a||P(a,"",S,b);O(b)}
var U={Children:{map:function(a,b,e){if(null==a)return a;var c=[];T(a,c,null,b,e);return c},forEach:function(a,b,e){if(null==a)return a;b=N(null,null,b,e);null==a||P(a,"",R,b);O(b)},count:function(a){return null==a?0:P(a,"",p.thatReturnsNull,null)},toArray:function(a){var b=[];T(a,b,null,p.thatReturnsArgument);return b},only:function(a){K(a)?void 0:y("143");return a}},Component:A,PureComponent:B,unstable_AsyncComponent:E,Fragment:w,createElement:J,cloneElement:function(a,b,e){var c=m({},a.props),
d=a.key,g=a.ref,k=a._owner;if(null!=b){void 0!==b.ref&&(g=b.ref,k=G.current);void 0!==b.key&&(d=""+b.key);if(a.type&&a.type.defaultProps)var f=a.type.defaultProps;for(h in b)H.call(b,h)&&!I.hasOwnProperty(h)&&(c[h]=void 0===b[h]&&void 0!==f?f[h]:b[h])}var h=arguments.length-2;if(1===h)c.children=e;else if(1<h){f=Array(h);for(var l=0;l<h;l++)f[l]=arguments[l+2];c.children=f}return{$$typeof:r,type:a.type,key:d,ref:g,props:c,_owner:k}},createFactory:function(a){var b=J.bind(null,a);b.type=a;return b},
isValidElement:K,version:"16.2.0",__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED:{ReactCurrentOwner:G,assign:m}},V=Object.freeze({default:U}),W=V&&U||V;module.exports=W["default"]?W["default"]:W;


/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.2.0
 * react-dom.production.min.js
 *
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

/*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/
var aa=__webpack_require__(0),l=__webpack_require__(32),B=__webpack_require__(8),C=__webpack_require__(5),ba=__webpack_require__(33),da=__webpack_require__(34),ea=__webpack_require__(35),fa=__webpack_require__(36),ia=__webpack_require__(39),D=__webpack_require__(12);
function E(a){for(var b=arguments.length-1,c="Minified React error #"+a+"; visit http://facebook.github.io/react/docs/error-decoder.html?invariant\x3d"+a,d=0;d<b;d++)c+="\x26args[]\x3d"+encodeURIComponent(arguments[d+1]);b=Error(c+" for the full message or use the non-minified dev environment for full errors and additional helpful warnings.");b.name="Invariant Violation";b.framesToPop=1;throw b;}aa?void 0:E("227");
var oa={children:!0,dangerouslySetInnerHTML:!0,defaultValue:!0,defaultChecked:!0,innerHTML:!0,suppressContentEditableWarning:!0,suppressHydrationWarning:!0,style:!0};function pa(a,b){return(a&b)===b}
var ta={MUST_USE_PROPERTY:1,HAS_BOOLEAN_VALUE:4,HAS_NUMERIC_VALUE:8,HAS_POSITIVE_NUMERIC_VALUE:24,HAS_OVERLOADED_BOOLEAN_VALUE:32,HAS_STRING_BOOLEAN_VALUE:64,injectDOMPropertyConfig:function(a){var b=ta,c=a.Properties||{},d=a.DOMAttributeNamespaces||{},e=a.DOMAttributeNames||{};a=a.DOMMutationMethods||{};for(var f in c){ua.hasOwnProperty(f)?E("48",f):void 0;var g=f.toLowerCase(),h=c[f];g={attributeName:g,attributeNamespace:null,propertyName:f,mutationMethod:null,mustUseProperty:pa(h,b.MUST_USE_PROPERTY),
hasBooleanValue:pa(h,b.HAS_BOOLEAN_VALUE),hasNumericValue:pa(h,b.HAS_NUMERIC_VALUE),hasPositiveNumericValue:pa(h,b.HAS_POSITIVE_NUMERIC_VALUE),hasOverloadedBooleanValue:pa(h,b.HAS_OVERLOADED_BOOLEAN_VALUE),hasStringBooleanValue:pa(h,b.HAS_STRING_BOOLEAN_VALUE)};1>=g.hasBooleanValue+g.hasNumericValue+g.hasOverloadedBooleanValue?void 0:E("50",f);e.hasOwnProperty(f)&&(g.attributeName=e[f]);d.hasOwnProperty(f)&&(g.attributeNamespace=d[f]);a.hasOwnProperty(f)&&(g.mutationMethod=a[f]);ua[f]=g}}},ua={};
function va(a,b){if(oa.hasOwnProperty(a)||2<a.length&&("o"===a[0]||"O"===a[0])&&("n"===a[1]||"N"===a[1]))return!1;if(null===b)return!0;switch(typeof b){case "boolean":return oa.hasOwnProperty(a)?a=!0:(b=wa(a))?a=b.hasBooleanValue||b.hasStringBooleanValue||b.hasOverloadedBooleanValue:(a=a.toLowerCase().slice(0,5),a="data-"===a||"aria-"===a),a;case "undefined":case "number":case "string":case "object":return!0;default:return!1}}function wa(a){return ua.hasOwnProperty(a)?ua[a]:null}
var xa=ta,ya=xa.MUST_USE_PROPERTY,K=xa.HAS_BOOLEAN_VALUE,za=xa.HAS_NUMERIC_VALUE,Aa=xa.HAS_POSITIVE_NUMERIC_VALUE,Ba=xa.HAS_OVERLOADED_BOOLEAN_VALUE,Ca=xa.HAS_STRING_BOOLEAN_VALUE,Da={Properties:{allowFullScreen:K,async:K,autoFocus:K,autoPlay:K,capture:Ba,checked:ya|K,cols:Aa,contentEditable:Ca,controls:K,"default":K,defer:K,disabled:K,download:Ba,draggable:Ca,formNoValidate:K,hidden:K,loop:K,multiple:ya|K,muted:ya|K,noValidate:K,open:K,playsInline:K,readOnly:K,required:K,reversed:K,rows:Aa,rowSpan:za,
scoped:K,seamless:K,selected:ya|K,size:Aa,start:za,span:Aa,spellCheck:Ca,style:0,tabIndex:0,itemScope:K,acceptCharset:0,className:0,htmlFor:0,httpEquiv:0,value:Ca},DOMAttributeNames:{acceptCharset:"accept-charset",className:"class",htmlFor:"for",httpEquiv:"http-equiv"},DOMMutationMethods:{value:function(a,b){if(null==b)return a.removeAttribute("value");"number"!==a.type||!1===a.hasAttribute("value")?a.setAttribute("value",""+b):a.validity&&!a.validity.badInput&&a.ownerDocument.activeElement!==a&&
a.setAttribute("value",""+b)}}},Ea=xa.HAS_STRING_BOOLEAN_VALUE,M={xlink:"http://www.w3.org/1999/xlink",xml:"http://www.w3.org/XML/1998/namespace"},Ga={Properties:{autoReverse:Ea,externalResourcesRequired:Ea,preserveAlpha:Ea},DOMAttributeNames:{autoReverse:"autoReverse",externalResourcesRequired:"externalResourcesRequired",preserveAlpha:"preserveAlpha"},DOMAttributeNamespaces:{xlinkActuate:M.xlink,xlinkArcrole:M.xlink,xlinkHref:M.xlink,xlinkRole:M.xlink,xlinkShow:M.xlink,xlinkTitle:M.xlink,xlinkType:M.xlink,
xmlBase:M.xml,xmlLang:M.xml,xmlSpace:M.xml}},Ha=/[\-\:]([a-z])/g;function Ia(a){return a[1].toUpperCase()}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode x-height xlink:actuate xlink:arcrole xlink:href xlink:role xlink:show xlink:title xlink:type xml:base xmlns:xlink xml:lang xml:space".split(" ").forEach(function(a){var b=a.replace(Ha,
Ia);Ga.Properties[b]=0;Ga.DOMAttributeNames[b]=a});xa.injectDOMPropertyConfig(Da);xa.injectDOMPropertyConfig(Ga);
var P={_caughtError:null,_hasCaughtError:!1,_rethrowError:null,_hasRethrowError:!1,injection:{injectErrorUtils:function(a){"function"!==typeof a.invokeGuardedCallback?E("197"):void 0;Ja=a.invokeGuardedCallback}},invokeGuardedCallback:function(a,b,c,d,e,f,g,h,k){Ja.apply(P,arguments)},invokeGuardedCallbackAndCatchFirstError:function(a,b,c,d,e,f,g,h,k){P.invokeGuardedCallback.apply(this,arguments);if(P.hasCaughtError()){var q=P.clearCaughtError();P._hasRethrowError||(P._hasRethrowError=!0,P._rethrowError=
q)}},rethrowCaughtError:function(){return Ka.apply(P,arguments)},hasCaughtError:function(){return P._hasCaughtError},clearCaughtError:function(){if(P._hasCaughtError){var a=P._caughtError;P._caughtError=null;P._hasCaughtError=!1;return a}E("198")}};function Ja(a,b,c,d,e,f,g,h,k){P._hasCaughtError=!1;P._caughtError=null;var q=Array.prototype.slice.call(arguments,3);try{b.apply(c,q)}catch(v){P._caughtError=v,P._hasCaughtError=!0}}
function Ka(){if(P._hasRethrowError){var a=P._rethrowError;P._rethrowError=null;P._hasRethrowError=!1;throw a;}}var La=null,Ma={};
function Na(){if(La)for(var a in Ma){var b=Ma[a],c=La.indexOf(a);-1<c?void 0:E("96",a);if(!Oa[c]){b.extractEvents?void 0:E("97",a);Oa[c]=b;c=b.eventTypes;for(var d in c){var e=void 0;var f=c[d],g=b,h=d;Pa.hasOwnProperty(h)?E("99",h):void 0;Pa[h]=f;var k=f.phasedRegistrationNames;if(k){for(e in k)k.hasOwnProperty(e)&&Qa(k[e],g,h);e=!0}else f.registrationName?(Qa(f.registrationName,g,h),e=!0):e=!1;e?void 0:E("98",d,a)}}}}
function Qa(a,b,c){Ra[a]?E("100",a):void 0;Ra[a]=b;Sa[a]=b.eventTypes[c].dependencies}var Oa=[],Pa={},Ra={},Sa={};function Ta(a){La?E("101"):void 0;La=Array.prototype.slice.call(a);Na()}function Ua(a){var b=!1,c;for(c in a)if(a.hasOwnProperty(c)){var d=a[c];Ma.hasOwnProperty(c)&&Ma[c]===d||(Ma[c]?E("102",c):void 0,Ma[c]=d,b=!0)}b&&Na()}
var Va=Object.freeze({plugins:Oa,eventNameDispatchConfigs:Pa,registrationNameModules:Ra,registrationNameDependencies:Sa,possibleRegistrationNames:null,injectEventPluginOrder:Ta,injectEventPluginsByName:Ua}),Wa=null,Xa=null,Ya=null;function Za(a,b,c,d){b=a.type||"unknown-event";a.currentTarget=Ya(d);P.invokeGuardedCallbackAndCatchFirstError(b,c,void 0,a);a.currentTarget=null}
function $a(a,b){null==b?E("30"):void 0;if(null==a)return b;if(Array.isArray(a)){if(Array.isArray(b))return a.push.apply(a,b),a;a.push(b);return a}return Array.isArray(b)?[a].concat(b):[a,b]}function ab(a,b,c){Array.isArray(a)?a.forEach(b,c):a&&b.call(c,a)}var bb=null;
function cb(a,b){if(a){var c=a._dispatchListeners,d=a._dispatchInstances;if(Array.isArray(c))for(var e=0;e<c.length&&!a.isPropagationStopped();e++)Za(a,b,c[e],d[e]);else c&&Za(a,b,c,d);a._dispatchListeners=null;a._dispatchInstances=null;a.isPersistent()||a.constructor.release(a)}}function db(a){return cb(a,!0)}function gb(a){return cb(a,!1)}var hb={injectEventPluginOrder:Ta,injectEventPluginsByName:Ua};
function ib(a,b){var c=a.stateNode;if(!c)return null;var d=Wa(c);if(!d)return null;c=d[b];a:switch(b){case "onClick":case "onClickCapture":case "onDoubleClick":case "onDoubleClickCapture":case "onMouseDown":case "onMouseDownCapture":case "onMouseMove":case "onMouseMoveCapture":case "onMouseUp":case "onMouseUpCapture":(d=!d.disabled)||(a=a.type,d=!("button"===a||"input"===a||"select"===a||"textarea"===a));a=!d;break a;default:a=!1}if(a)return null;c&&"function"!==typeof c?E("231",b,typeof c):void 0;
return c}function jb(a,b,c,d){for(var e,f=0;f<Oa.length;f++){var g=Oa[f];g&&(g=g.extractEvents(a,b,c,d))&&(e=$a(e,g))}return e}function kb(a){a&&(bb=$a(bb,a))}function lb(a){var b=bb;bb=null;b&&(a?ab(b,db):ab(b,gb),bb?E("95"):void 0,P.rethrowCaughtError())}var mb=Object.freeze({injection:hb,getListener:ib,extractEvents:jb,enqueueEvents:kb,processEventQueue:lb}),nb=Math.random().toString(36).slice(2),Q="__reactInternalInstance$"+nb,ob="__reactEventHandlers$"+nb;
function pb(a){if(a[Q])return a[Q];for(var b=[];!a[Q];)if(b.push(a),a.parentNode)a=a.parentNode;else return null;var c=void 0,d=a[Q];if(5===d.tag||6===d.tag)return d;for(;a&&(d=a[Q]);a=b.pop())c=d;return c}function qb(a){if(5===a.tag||6===a.tag)return a.stateNode;E("33")}function rb(a){return a[ob]||null}
var sb=Object.freeze({precacheFiberNode:function(a,b){b[Q]=a},getClosestInstanceFromNode:pb,getInstanceFromNode:function(a){a=a[Q];return!a||5!==a.tag&&6!==a.tag?null:a},getNodeFromInstance:qb,getFiberCurrentPropsFromNode:rb,updateFiberProps:function(a,b){a[ob]=b}});function tb(a){do a=a["return"];while(a&&5!==a.tag);return a?a:null}function ub(a,b,c){for(var d=[];a;)d.push(a),a=tb(a);for(a=d.length;0<a--;)b(d[a],"captured",c);for(a=0;a<d.length;a++)b(d[a],"bubbled",c)}
function vb(a,b,c){if(b=ib(a,c.dispatchConfig.phasedRegistrationNames[b]))c._dispatchListeners=$a(c._dispatchListeners,b),c._dispatchInstances=$a(c._dispatchInstances,a)}function wb(a){a&&a.dispatchConfig.phasedRegistrationNames&&ub(a._targetInst,vb,a)}function xb(a){if(a&&a.dispatchConfig.phasedRegistrationNames){var b=a._targetInst;b=b?tb(b):null;ub(b,vb,a)}}
function yb(a,b,c){a&&c&&c.dispatchConfig.registrationName&&(b=ib(a,c.dispatchConfig.registrationName))&&(c._dispatchListeners=$a(c._dispatchListeners,b),c._dispatchInstances=$a(c._dispatchInstances,a))}function zb(a){a&&a.dispatchConfig.registrationName&&yb(a._targetInst,null,a)}function Ab(a){ab(a,wb)}
function Bb(a,b,c,d){if(c&&d)a:{var e=c;for(var f=d,g=0,h=e;h;h=tb(h))g++;h=0;for(var k=f;k;k=tb(k))h++;for(;0<g-h;)e=tb(e),g--;for(;0<h-g;)f=tb(f),h--;for(;g--;){if(e===f||e===f.alternate)break a;e=tb(e);f=tb(f)}e=null}else e=null;f=e;for(e=[];c&&c!==f;){g=c.alternate;if(null!==g&&g===f)break;e.push(c);c=tb(c)}for(c=[];d&&d!==f;){g=d.alternate;if(null!==g&&g===f)break;c.push(d);d=tb(d)}for(d=0;d<e.length;d++)yb(e[d],"bubbled",a);for(a=c.length;0<a--;)yb(c[a],"captured",b)}
var Cb=Object.freeze({accumulateTwoPhaseDispatches:Ab,accumulateTwoPhaseDispatchesSkipTarget:function(a){ab(a,xb)},accumulateEnterLeaveDispatches:Bb,accumulateDirectDispatches:function(a){ab(a,zb)}}),Db=null;function Eb(){!Db&&l.canUseDOM&&(Db="textContent"in document.documentElement?"textContent":"innerText");return Db}var S={_root:null,_startText:null,_fallbackText:null};
function Fb(){if(S._fallbackText)return S._fallbackText;var a,b=S._startText,c=b.length,d,e=Gb(),f=e.length;for(a=0;a<c&&b[a]===e[a];a++);var g=c-a;for(d=1;d<=g&&b[c-d]===e[f-d];d++);S._fallbackText=e.slice(a,1<d?1-d:void 0);return S._fallbackText}function Gb(){return"value"in S._root?S._root.value:S._root[Eb()]}
var Hb="dispatchConfig _targetInst nativeEvent isDefaultPrevented isPropagationStopped _dispatchListeners _dispatchInstances".split(" "),Ib={type:null,target:null,currentTarget:C.thatReturnsNull,eventPhase:null,bubbles:null,cancelable:null,timeStamp:function(a){return a.timeStamp||Date.now()},defaultPrevented:null,isTrusted:null};
function T(a,b,c,d){this.dispatchConfig=a;this._targetInst=b;this.nativeEvent=c;a=this.constructor.Interface;for(var e in a)a.hasOwnProperty(e)&&((b=a[e])?this[e]=b(c):"target"===e?this.target=d:this[e]=c[e]);this.isDefaultPrevented=(null!=c.defaultPrevented?c.defaultPrevented:!1===c.returnValue)?C.thatReturnsTrue:C.thatReturnsFalse;this.isPropagationStopped=C.thatReturnsFalse;return this}
B(T.prototype,{preventDefault:function(){this.defaultPrevented=!0;var a=this.nativeEvent;a&&(a.preventDefault?a.preventDefault():"unknown"!==typeof a.returnValue&&(a.returnValue=!1),this.isDefaultPrevented=C.thatReturnsTrue)},stopPropagation:function(){var a=this.nativeEvent;a&&(a.stopPropagation?a.stopPropagation():"unknown"!==typeof a.cancelBubble&&(a.cancelBubble=!0),this.isPropagationStopped=C.thatReturnsTrue)},persist:function(){this.isPersistent=C.thatReturnsTrue},isPersistent:C.thatReturnsFalse,
destructor:function(){var a=this.constructor.Interface,b;for(b in a)this[b]=null;for(a=0;a<Hb.length;a++)this[Hb[a]]=null}});T.Interface=Ib;T.augmentClass=function(a,b){function c(){}c.prototype=this.prototype;var d=new c;B(d,a.prototype);a.prototype=d;a.prototype.constructor=a;a.Interface=B({},this.Interface,b);a.augmentClass=this.augmentClass;Jb(a)};Jb(T);function Kb(a,b,c,d){if(this.eventPool.length){var e=this.eventPool.pop();this.call(e,a,b,c,d);return e}return new this(a,b,c,d)}
function Lb(a){a instanceof this?void 0:E("223");a.destructor();10>this.eventPool.length&&this.eventPool.push(a)}function Jb(a){a.eventPool=[];a.getPooled=Kb;a.release=Lb}function Mb(a,b,c,d){return T.call(this,a,b,c,d)}T.augmentClass(Mb,{data:null});function Nb(a,b,c,d){return T.call(this,a,b,c,d)}T.augmentClass(Nb,{data:null});var Pb=[9,13,27,32],Vb=l.canUseDOM&&"CompositionEvent"in window,Wb=null;l.canUseDOM&&"documentMode"in document&&(Wb=document.documentMode);var Xb;
if(Xb=l.canUseDOM&&"TextEvent"in window&&!Wb){var Yb=window.opera;Xb=!("object"===typeof Yb&&"function"===typeof Yb.version&&12>=parseInt(Yb.version(),10))}
var Zb=Xb,$b=l.canUseDOM&&(!Vb||Wb&&8<Wb&&11>=Wb),ac=String.fromCharCode(32),bc={beforeInput:{phasedRegistrationNames:{bubbled:"onBeforeInput",captured:"onBeforeInputCapture"},dependencies:["topCompositionEnd","topKeyPress","topTextInput","topPaste"]},compositionEnd:{phasedRegistrationNames:{bubbled:"onCompositionEnd",captured:"onCompositionEndCapture"},dependencies:"topBlur topCompositionEnd topKeyDown topKeyPress topKeyUp topMouseDown".split(" ")},compositionStart:{phasedRegistrationNames:{bubbled:"onCompositionStart",
captured:"onCompositionStartCapture"},dependencies:"topBlur topCompositionStart topKeyDown topKeyPress topKeyUp topMouseDown".split(" ")},compositionUpdate:{phasedRegistrationNames:{bubbled:"onCompositionUpdate",captured:"onCompositionUpdateCapture"},dependencies:"topBlur topCompositionUpdate topKeyDown topKeyPress topKeyUp topMouseDown".split(" ")}},cc=!1;
function dc(a,b){switch(a){case "topKeyUp":return-1!==Pb.indexOf(b.keyCode);case "topKeyDown":return 229!==b.keyCode;case "topKeyPress":case "topMouseDown":case "topBlur":return!0;default:return!1}}function ec(a){a=a.detail;return"object"===typeof a&&"data"in a?a.data:null}var fc=!1;function gc(a,b){switch(a){case "topCompositionEnd":return ec(b);case "topKeyPress":if(32!==b.which)return null;cc=!0;return ac;case "topTextInput":return a=b.data,a===ac&&cc?null:a;default:return null}}
function hc(a,b){if(fc)return"topCompositionEnd"===a||!Vb&&dc(a,b)?(a=Fb(),S._root=null,S._startText=null,S._fallbackText=null,fc=!1,a):null;switch(a){case "topPaste":return null;case "topKeyPress":if(!(b.ctrlKey||b.altKey||b.metaKey)||b.ctrlKey&&b.altKey){if(b.char&&1<b.char.length)return b.char;if(b.which)return String.fromCharCode(b.which)}return null;case "topCompositionEnd":return $b?null:b.data;default:return null}}
var ic={eventTypes:bc,extractEvents:function(a,b,c,d){var e;if(Vb)b:{switch(a){case "topCompositionStart":var f=bc.compositionStart;break b;case "topCompositionEnd":f=bc.compositionEnd;break b;case "topCompositionUpdate":f=bc.compositionUpdate;break b}f=void 0}else fc?dc(a,c)&&(f=bc.compositionEnd):"topKeyDown"===a&&229===c.keyCode&&(f=bc.compositionStart);f?($b&&(fc||f!==bc.compositionStart?f===bc.compositionEnd&&fc&&(e=Fb()):(S._root=d,S._startText=Gb(),fc=!0)),f=Mb.getPooled(f,b,c,d),e?f.data=
e:(e=ec(c),null!==e&&(f.data=e)),Ab(f),e=f):e=null;(a=Zb?gc(a,c):hc(a,c))?(b=Nb.getPooled(bc.beforeInput,b,c,d),b.data=a,Ab(b)):b=null;return[e,b]}},jc=null,kc=null,lc=null;function mc(a){if(a=Xa(a)){jc&&"function"===typeof jc.restoreControlledState?void 0:E("194");var b=Wa(a.stateNode);jc.restoreControlledState(a.stateNode,a.type,b)}}var nc={injectFiberControlledHostComponent:function(a){jc=a}};function oc(a){kc?lc?lc.push(a):lc=[a]:kc=a}
function pc(){if(kc){var a=kc,b=lc;lc=kc=null;mc(a);if(b)for(a=0;a<b.length;a++)mc(b[a])}}var qc=Object.freeze({injection:nc,enqueueStateRestore:oc,restoreStateIfNeeded:pc});function rc(a,b){return a(b)}var sc=!1;function tc(a,b){if(sc)return rc(a,b);sc=!0;try{return rc(a,b)}finally{sc=!1,pc()}}var uc={color:!0,date:!0,datetime:!0,"datetime-local":!0,email:!0,month:!0,number:!0,password:!0,range:!0,search:!0,tel:!0,text:!0,time:!0,url:!0,week:!0};
function vc(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return"input"===b?!!uc[a.type]:"textarea"===b?!0:!1}function wc(a){a=a.target||a.srcElement||window;a.correspondingUseElement&&(a=a.correspondingUseElement);return 3===a.nodeType?a.parentNode:a}var xc;l.canUseDOM&&(xc=document.implementation&&document.implementation.hasFeature&&!0!==document.implementation.hasFeature("",""));
function yc(a,b){if(!l.canUseDOM||b&&!("addEventListener"in document))return!1;b="on"+a;var c=b in document;c||(c=document.createElement("div"),c.setAttribute(b,"return;"),c="function"===typeof c[b]);!c&&xc&&"wheel"===a&&(c=document.implementation.hasFeature("Events.wheel","3.0"));return c}function zc(a){var b=a.type;return(a=a.nodeName)&&"input"===a.toLowerCase()&&("checkbox"===b||"radio"===b)}
function Ac(a){var b=zc(a)?"checked":"value",c=Object.getOwnPropertyDescriptor(a.constructor.prototype,b),d=""+a[b];if(!a.hasOwnProperty(b)&&"function"===typeof c.get&&"function"===typeof c.set)return Object.defineProperty(a,b,{enumerable:c.enumerable,configurable:!0,get:function(){return c.get.call(this)},set:function(a){d=""+a;c.set.call(this,a)}}),{getValue:function(){return d},setValue:function(a){d=""+a},stopTracking:function(){a._valueTracker=null;delete a[b]}}}
function Bc(a){a._valueTracker||(a._valueTracker=Ac(a))}function Cc(a){if(!a)return!1;var b=a._valueTracker;if(!b)return!0;var c=b.getValue();var d="";a&&(d=zc(a)?a.checked?"true":"false":a.value);a=d;return a!==c?(b.setValue(a),!0):!1}var Dc={change:{phasedRegistrationNames:{bubbled:"onChange",captured:"onChangeCapture"},dependencies:"topBlur topChange topClick topFocus topInput topKeyDown topKeyUp topSelectionChange".split(" ")}};
function Ec(a,b,c){a=T.getPooled(Dc.change,a,b,c);a.type="change";oc(c);Ab(a);return a}var Fc=null,Gc=null;function Hc(a){kb(a);lb(!1)}function Ic(a){var b=qb(a);if(Cc(b))return a}function Jc(a,b){if("topChange"===a)return b}var Kc=!1;l.canUseDOM&&(Kc=yc("input")&&(!document.documentMode||9<document.documentMode));function Lc(){Fc&&(Fc.detachEvent("onpropertychange",Mc),Gc=Fc=null)}function Mc(a){"value"===a.propertyName&&Ic(Gc)&&(a=Ec(Gc,a,wc(a)),tc(Hc,a))}
function Nc(a,b,c){"topFocus"===a?(Lc(),Fc=b,Gc=c,Fc.attachEvent("onpropertychange",Mc)):"topBlur"===a&&Lc()}function Oc(a){if("topSelectionChange"===a||"topKeyUp"===a||"topKeyDown"===a)return Ic(Gc)}function Pc(a,b){if("topClick"===a)return Ic(b)}function $c(a,b){if("topInput"===a||"topChange"===a)return Ic(b)}
var ad={eventTypes:Dc,_isInputEventSupported:Kc,extractEvents:function(a,b,c,d){var e=b?qb(b):window,f=e.nodeName&&e.nodeName.toLowerCase();if("select"===f||"input"===f&&"file"===e.type)var g=Jc;else if(vc(e))if(Kc)g=$c;else{g=Oc;var h=Nc}else f=e.nodeName,!f||"input"!==f.toLowerCase()||"checkbox"!==e.type&&"radio"!==e.type||(g=Pc);if(g&&(g=g(a,b)))return Ec(g,c,d);h&&h(a,e,b);"topBlur"===a&&null!=b&&(a=b._wrapperState||e._wrapperState)&&a.controlled&&"number"===e.type&&(a=""+e.value,e.getAttribute("value")!==
a&&e.setAttribute("value",a))}};function bd(a,b,c,d){return T.call(this,a,b,c,d)}T.augmentClass(bd,{view:null,detail:null});var cd={Alt:"altKey",Control:"ctrlKey",Meta:"metaKey",Shift:"shiftKey"};function dd(a){var b=this.nativeEvent;return b.getModifierState?b.getModifierState(a):(a=cd[a])?!!b[a]:!1}function ed(){return dd}function fd(a,b,c,d){return T.call(this,a,b,c,d)}
bd.augmentClass(fd,{screenX:null,screenY:null,clientX:null,clientY:null,pageX:null,pageY:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,getModifierState:ed,button:null,buttons:null,relatedTarget:function(a){return a.relatedTarget||(a.fromElement===a.srcElement?a.toElement:a.fromElement)}});
var gd={mouseEnter:{registrationName:"onMouseEnter",dependencies:["topMouseOut","topMouseOver"]},mouseLeave:{registrationName:"onMouseLeave",dependencies:["topMouseOut","topMouseOver"]}},hd={eventTypes:gd,extractEvents:function(a,b,c,d){if("topMouseOver"===a&&(c.relatedTarget||c.fromElement)||"topMouseOut"!==a&&"topMouseOver"!==a)return null;var e=d.window===d?d:(e=d.ownerDocument)?e.defaultView||e.parentWindow:window;"topMouseOut"===a?(a=b,b=(b=c.relatedTarget||c.toElement)?pb(b):null):a=null;if(a===
b)return null;var f=null==a?e:qb(a);e=null==b?e:qb(b);var g=fd.getPooled(gd.mouseLeave,a,c,d);g.type="mouseleave";g.target=f;g.relatedTarget=e;c=fd.getPooled(gd.mouseEnter,b,c,d);c.type="mouseenter";c.target=e;c.relatedTarget=f;Bb(g,c,a,b);return[g,c]}},id=aa.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner;function jd(a){a=a.type;return"string"===typeof a?a:"function"===typeof a?a.displayName||a.name:null}
function kd(a){var b=a;if(a.alternate)for(;b["return"];)b=b["return"];else{if(0!==(b.effectTag&2))return 1;for(;b["return"];)if(b=b["return"],0!==(b.effectTag&2))return 1}return 3===b.tag?2:3}function ld(a){return(a=a._reactInternalFiber)?2===kd(a):!1}function md(a){2!==kd(a)?E("188"):void 0}
function nd(a){var b=a.alternate;if(!b)return b=kd(a),3===b?E("188"):void 0,1===b?null:a;for(var c=a,d=b;;){var e=c["return"],f=e?e.alternate:null;if(!e||!f)break;if(e.child===f.child){for(var g=e.child;g;){if(g===c)return md(e),a;if(g===d)return md(e),b;g=g.sibling}E("188")}if(c["return"]!==d["return"])c=e,d=f;else{g=!1;for(var h=e.child;h;){if(h===c){g=!0;c=e;d=f;break}if(h===d){g=!0;d=e;c=f;break}h=h.sibling}if(!g){for(h=f.child;h;){if(h===c){g=!0;c=f;d=e;break}if(h===d){g=!0;d=f;c=e;break}h=h.sibling}g?
void 0:E("189")}}c.alternate!==d?E("190"):void 0}3!==c.tag?E("188"):void 0;return c.stateNode.current===c?a:b}function od(a){a=nd(a);if(!a)return null;for(var b=a;;){if(5===b.tag||6===b.tag)return b;if(b.child)b.child["return"]=b,b=b.child;else{if(b===a)break;for(;!b.sibling;){if(!b["return"]||b["return"]===a)return null;b=b["return"]}b.sibling["return"]=b["return"];b=b.sibling}}return null}
function pd(a){a=nd(a);if(!a)return null;for(var b=a;;){if(5===b.tag||6===b.tag)return b;if(b.child&&4!==b.tag)b.child["return"]=b,b=b.child;else{if(b===a)break;for(;!b.sibling;){if(!b["return"]||b["return"]===a)return null;b=b["return"]}b.sibling["return"]=b["return"];b=b.sibling}}return null}var qd=[];
function rd(a){var b=a.targetInst;do{if(!b){a.ancestors.push(b);break}var c;for(c=b;c["return"];)c=c["return"];c=3!==c.tag?null:c.stateNode.containerInfo;if(!c)break;a.ancestors.push(b);b=pb(c)}while(b);for(c=0;c<a.ancestors.length;c++)b=a.ancestors[c],sd(a.topLevelType,b,a.nativeEvent,wc(a.nativeEvent))}var td=!0,sd=void 0;function ud(a){td=!!a}function U(a,b,c){return c?ba.listen(c,b,vd.bind(null,a)):null}function wd(a,b,c){return c?ba.capture(c,b,vd.bind(null,a)):null}
function vd(a,b){if(td){var c=wc(b);c=pb(c);null===c||"number"!==typeof c.tag||2===kd(c)||(c=null);if(qd.length){var d=qd.pop();d.topLevelType=a;d.nativeEvent=b;d.targetInst=c;a=d}else a={topLevelType:a,nativeEvent:b,targetInst:c,ancestors:[]};try{tc(rd,a)}finally{a.topLevelType=null,a.nativeEvent=null,a.targetInst=null,a.ancestors.length=0,10>qd.length&&qd.push(a)}}}
var xd=Object.freeze({get _enabled(){return td},get _handleTopLevel(){return sd},setHandleTopLevel:function(a){sd=a},setEnabled:ud,isEnabled:function(){return td},trapBubbledEvent:U,trapCapturedEvent:wd,dispatchEvent:vd});function yd(a,b){var c={};c[a.toLowerCase()]=b.toLowerCase();c["Webkit"+a]="webkit"+b;c["Moz"+a]="moz"+b;c["ms"+a]="MS"+b;c["O"+a]="o"+b.toLowerCase();return c}
var zd={animationend:yd("Animation","AnimationEnd"),animationiteration:yd("Animation","AnimationIteration"),animationstart:yd("Animation","AnimationStart"),transitionend:yd("Transition","TransitionEnd")},Ad={},Bd={};l.canUseDOM&&(Bd=document.createElement("div").style,"AnimationEvent"in window||(delete zd.animationend.animation,delete zd.animationiteration.animation,delete zd.animationstart.animation),"TransitionEvent"in window||delete zd.transitionend.transition);
function Cd(a){if(Ad[a])return Ad[a];if(!zd[a])return a;var b=zd[a],c;for(c in b)if(b.hasOwnProperty(c)&&c in Bd)return Ad[a]=b[c];return""}
var Dd={topAbort:"abort",topAnimationEnd:Cd("animationend")||"animationend",topAnimationIteration:Cd("animationiteration")||"animationiteration",topAnimationStart:Cd("animationstart")||"animationstart",topBlur:"blur",topCancel:"cancel",topCanPlay:"canplay",topCanPlayThrough:"canplaythrough",topChange:"change",topClick:"click",topClose:"close",topCompositionEnd:"compositionend",topCompositionStart:"compositionstart",topCompositionUpdate:"compositionupdate",topContextMenu:"contextmenu",topCopy:"copy",
topCut:"cut",topDoubleClick:"dblclick",topDrag:"drag",topDragEnd:"dragend",topDragEnter:"dragenter",topDragExit:"dragexit",topDragLeave:"dragleave",topDragOver:"dragover",topDragStart:"dragstart",topDrop:"drop",topDurationChange:"durationchange",topEmptied:"emptied",topEncrypted:"encrypted",topEnded:"ended",topError:"error",topFocus:"focus",topInput:"input",topKeyDown:"keydown",topKeyPress:"keypress",topKeyUp:"keyup",topLoadedData:"loadeddata",topLoad:"load",topLoadedMetadata:"loadedmetadata",topLoadStart:"loadstart",
topMouseDown:"mousedown",topMouseMove:"mousemove",topMouseOut:"mouseout",topMouseOver:"mouseover",topMouseUp:"mouseup",topPaste:"paste",topPause:"pause",topPlay:"play",topPlaying:"playing",topProgress:"progress",topRateChange:"ratechange",topScroll:"scroll",topSeeked:"seeked",topSeeking:"seeking",topSelectionChange:"selectionchange",topStalled:"stalled",topSuspend:"suspend",topTextInput:"textInput",topTimeUpdate:"timeupdate",topToggle:"toggle",topTouchCancel:"touchcancel",topTouchEnd:"touchend",topTouchMove:"touchmove",
topTouchStart:"touchstart",topTransitionEnd:Cd("transitionend")||"transitionend",topVolumeChange:"volumechange",topWaiting:"waiting",topWheel:"wheel"},Ed={},Fd=0,Gd="_reactListenersID"+(""+Math.random()).slice(2);function Hd(a){Object.prototype.hasOwnProperty.call(a,Gd)||(a[Gd]=Fd++,Ed[a[Gd]]={});return Ed[a[Gd]]}function Id(a){for(;a&&a.firstChild;)a=a.firstChild;return a}
function Jd(a,b){var c=Id(a);a=0;for(var d;c;){if(3===c.nodeType){d=a+c.textContent.length;if(a<=b&&d>=b)return{node:c,offset:b-a};a=d}a:{for(;c;){if(c.nextSibling){c=c.nextSibling;break a}c=c.parentNode}c=void 0}c=Id(c)}}function Kd(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return b&&("input"===b&&"text"===a.type||"textarea"===b||"true"===a.contentEditable)}
var Ld=l.canUseDOM&&"documentMode"in document&&11>=document.documentMode,Md={select:{phasedRegistrationNames:{bubbled:"onSelect",captured:"onSelectCapture"},dependencies:"topBlur topContextMenu topFocus topKeyDown topKeyUp topMouseDown topMouseUp topSelectionChange".split(" ")}},Nd=null,Od=null,Pd=null,Qd=!1;
function Rd(a,b){if(Qd||null==Nd||Nd!==da())return null;var c=Nd;"selectionStart"in c&&Kd(c)?c={start:c.selectionStart,end:c.selectionEnd}:window.getSelection?(c=window.getSelection(),c={anchorNode:c.anchorNode,anchorOffset:c.anchorOffset,focusNode:c.focusNode,focusOffset:c.focusOffset}):c=void 0;return Pd&&ea(Pd,c)?null:(Pd=c,a=T.getPooled(Md.select,Od,a,b),a.type="select",a.target=Nd,Ab(a),a)}
var Sd={eventTypes:Md,extractEvents:function(a,b,c,d){var e=d.window===d?d.document:9===d.nodeType?d:d.ownerDocument,f;if(!(f=!e)){a:{e=Hd(e);f=Sa.onSelect;for(var g=0;g<f.length;g++){var h=f[g];if(!e.hasOwnProperty(h)||!e[h]){e=!1;break a}}e=!0}f=!e}if(f)return null;e=b?qb(b):window;switch(a){case "topFocus":if(vc(e)||"true"===e.contentEditable)Nd=e,Od=b,Pd=null;break;case "topBlur":Pd=Od=Nd=null;break;case "topMouseDown":Qd=!0;break;case "topContextMenu":case "topMouseUp":return Qd=!1,Rd(c,d);case "topSelectionChange":if(Ld)break;
case "topKeyDown":case "topKeyUp":return Rd(c,d)}return null}};function Td(a,b,c,d){return T.call(this,a,b,c,d)}T.augmentClass(Td,{animationName:null,elapsedTime:null,pseudoElement:null});function Ud(a,b,c,d){return T.call(this,a,b,c,d)}T.augmentClass(Ud,{clipboardData:function(a){return"clipboardData"in a?a.clipboardData:window.clipboardData}});function Vd(a,b,c,d){return T.call(this,a,b,c,d)}bd.augmentClass(Vd,{relatedTarget:null});
function Wd(a){var b=a.keyCode;"charCode"in a?(a=a.charCode,0===a&&13===b&&(a=13)):a=b;return 32<=a||13===a?a:0}
var Xd={Esc:"Escape",Spacebar:" ",Left:"ArrowLeft",Up:"ArrowUp",Right:"ArrowRight",Down:"ArrowDown",Del:"Delete",Win:"OS",Menu:"ContextMenu",Apps:"ContextMenu",Scroll:"ScrollLock",MozPrintableKey:"Unidentified"},Yd={8:"Backspace",9:"Tab",12:"Clear",13:"Enter",16:"Shift",17:"Control",18:"Alt",19:"Pause",20:"CapsLock",27:"Escape",32:" ",33:"PageUp",34:"PageDown",35:"End",36:"Home",37:"ArrowLeft",38:"ArrowUp",39:"ArrowRight",40:"ArrowDown",45:"Insert",46:"Delete",112:"F1",113:"F2",114:"F3",115:"F4",
116:"F5",117:"F6",118:"F7",119:"F8",120:"F9",121:"F10",122:"F11",123:"F12",144:"NumLock",145:"ScrollLock",224:"Meta"};function Zd(a,b,c,d){return T.call(this,a,b,c,d)}
bd.augmentClass(Zd,{key:function(a){if(a.key){var b=Xd[a.key]||a.key;if("Unidentified"!==b)return b}return"keypress"===a.type?(a=Wd(a),13===a?"Enter":String.fromCharCode(a)):"keydown"===a.type||"keyup"===a.type?Yd[a.keyCode]||"Unidentified":""},location:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,repeat:null,locale:null,getModifierState:ed,charCode:function(a){return"keypress"===a.type?Wd(a):0},keyCode:function(a){return"keydown"===a.type||"keyup"===a.type?a.keyCode:0},which:function(a){return"keypress"===
a.type?Wd(a):"keydown"===a.type||"keyup"===a.type?a.keyCode:0}});function $d(a,b,c,d){return T.call(this,a,b,c,d)}fd.augmentClass($d,{dataTransfer:null});function ae(a,b,c,d){return T.call(this,a,b,c,d)}bd.augmentClass(ae,{touches:null,targetTouches:null,changedTouches:null,altKey:null,metaKey:null,ctrlKey:null,shiftKey:null,getModifierState:ed});function be(a,b,c,d){return T.call(this,a,b,c,d)}T.augmentClass(be,{propertyName:null,elapsedTime:null,pseudoElement:null});
function ce(a,b,c,d){return T.call(this,a,b,c,d)}fd.augmentClass(ce,{deltaX:function(a){return"deltaX"in a?a.deltaX:"wheelDeltaX"in a?-a.wheelDeltaX:0},deltaY:function(a){return"deltaY"in a?a.deltaY:"wheelDeltaY"in a?-a.wheelDeltaY:"wheelDelta"in a?-a.wheelDelta:0},deltaZ:null,deltaMode:null});var de={},ee={};
"abort animationEnd animationIteration animationStart blur cancel canPlay canPlayThrough click close contextMenu copy cut doubleClick drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error focus input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing progress rateChange reset scroll seeked seeking stalled submit suspend timeUpdate toggle touchCancel touchEnd touchMove touchStart transitionEnd volumeChange waiting wheel".split(" ").forEach(function(a){var b=a[0].toUpperCase()+
a.slice(1),c="on"+b;b="top"+b;c={phasedRegistrationNames:{bubbled:c,captured:c+"Capture"},dependencies:[b]};de[a]=c;ee[b]=c});
var fe={eventTypes:de,extractEvents:function(a,b,c,d){var e=ee[a];if(!e)return null;switch(a){case "topKeyPress":if(0===Wd(c))return null;case "topKeyDown":case "topKeyUp":a=Zd;break;case "topBlur":case "topFocus":a=Vd;break;case "topClick":if(2===c.button)return null;case "topDoubleClick":case "topMouseDown":case "topMouseMove":case "topMouseUp":case "topMouseOut":case "topMouseOver":case "topContextMenu":a=fd;break;case "topDrag":case "topDragEnd":case "topDragEnter":case "topDragExit":case "topDragLeave":case "topDragOver":case "topDragStart":case "topDrop":a=
$d;break;case "topTouchCancel":case "topTouchEnd":case "topTouchMove":case "topTouchStart":a=ae;break;case "topAnimationEnd":case "topAnimationIteration":case "topAnimationStart":a=Td;break;case "topTransitionEnd":a=be;break;case "topScroll":a=bd;break;case "topWheel":a=ce;break;case "topCopy":case "topCut":case "topPaste":a=Ud;break;default:a=T}b=a.getPooled(e,b,c,d);Ab(b);return b}};sd=function(a,b,c,d){a=jb(a,b,c,d);kb(a);lb(!1)};hb.injectEventPluginOrder("ResponderEventPlugin SimpleEventPlugin TapEventPlugin EnterLeaveEventPlugin ChangeEventPlugin SelectEventPlugin BeforeInputEventPlugin".split(" "));
Wa=sb.getFiberCurrentPropsFromNode;Xa=sb.getInstanceFromNode;Ya=sb.getNodeFromInstance;hb.injectEventPluginsByName({SimpleEventPlugin:fe,EnterLeaveEventPlugin:hd,ChangeEventPlugin:ad,SelectEventPlugin:Sd,BeforeInputEventPlugin:ic});var ge=[],he=-1;function V(a){0>he||(a.current=ge[he],ge[he]=null,he--)}function W(a,b){he++;ge[he]=a.current;a.current=b}new Set;var ie={current:D},X={current:!1},je=D;function ke(a){return le(a)?je:ie.current}
function me(a,b){var c=a.type.contextTypes;if(!c)return D;var d=a.stateNode;if(d&&d.__reactInternalMemoizedUnmaskedChildContext===b)return d.__reactInternalMemoizedMaskedChildContext;var e={},f;for(f in c)e[f]=b[f];d&&(a=a.stateNode,a.__reactInternalMemoizedUnmaskedChildContext=b,a.__reactInternalMemoizedMaskedChildContext=e);return e}function le(a){return 2===a.tag&&null!=a.type.childContextTypes}function ne(a){le(a)&&(V(X,a),V(ie,a))}
function oe(a,b,c){null!=ie.cursor?E("168"):void 0;W(ie,b,a);W(X,c,a)}function pe(a,b){var c=a.stateNode,d=a.type.childContextTypes;if("function"!==typeof c.getChildContext)return b;c=c.getChildContext();for(var e in c)e in d?void 0:E("108",jd(a)||"Unknown",e);return B({},b,c)}function qe(a){if(!le(a))return!1;var b=a.stateNode;b=b&&b.__reactInternalMemoizedMergedChildContext||D;je=ie.current;W(ie,b,a);W(X,X.current,a);return!0}
function re(a,b){var c=a.stateNode;c?void 0:E("169");if(b){var d=pe(a,je);c.__reactInternalMemoizedMergedChildContext=d;V(X,a);V(ie,a);W(ie,d,a)}else V(X,a);W(X,b,a)}
function Y(a,b,c){this.tag=a;this.key=b;this.stateNode=this.type=null;this.sibling=this.child=this["return"]=null;this.index=0;this.memoizedState=this.updateQueue=this.memoizedProps=this.pendingProps=this.ref=null;this.internalContextTag=c;this.effectTag=0;this.lastEffect=this.firstEffect=this.nextEffect=null;this.expirationTime=0;this.alternate=null}
function se(a,b,c){var d=a.alternate;null===d?(d=new Y(a.tag,a.key,a.internalContextTag),d.type=a.type,d.stateNode=a.stateNode,d.alternate=a,a.alternate=d):(d.effectTag=0,d.nextEffect=null,d.firstEffect=null,d.lastEffect=null);d.expirationTime=c;d.pendingProps=b;d.child=a.child;d.memoizedProps=a.memoizedProps;d.memoizedState=a.memoizedState;d.updateQueue=a.updateQueue;d.sibling=a.sibling;d.index=a.index;d.ref=a.ref;return d}
function te(a,b,c){var d=void 0,e=a.type,f=a.key;"function"===typeof e?(d=e.prototype&&e.prototype.isReactComponent?new Y(2,f,b):new Y(0,f,b),d.type=e,d.pendingProps=a.props):"string"===typeof e?(d=new Y(5,f,b),d.type=e,d.pendingProps=a.props):"object"===typeof e&&null!==e&&"number"===typeof e.tag?(d=e,d.pendingProps=a.props):E("130",null==e?e:typeof e,"");d.expirationTime=c;return d}function ue(a,b,c,d){b=new Y(10,d,b);b.pendingProps=a;b.expirationTime=c;return b}
function ve(a,b,c){b=new Y(6,null,b);b.pendingProps=a;b.expirationTime=c;return b}function we(a,b,c){b=new Y(7,a.key,b);b.type=a.handler;b.pendingProps=a;b.expirationTime=c;return b}function xe(a,b,c){a=new Y(9,null,b);a.expirationTime=c;return a}function ye(a,b,c){b=new Y(4,a.key,b);b.pendingProps=a.children||[];b.expirationTime=c;b.stateNode={containerInfo:a.containerInfo,pendingChildren:null,implementation:a.implementation};return b}var ze=null,Ae=null;
function Be(a){return function(b){try{return a(b)}catch(c){}}}function Ce(a){if("undefined"===typeof __REACT_DEVTOOLS_GLOBAL_HOOK__)return!1;var b=__REACT_DEVTOOLS_GLOBAL_HOOK__;if(b.isDisabled||!b.supportsFiber)return!0;try{var c=b.inject(a);ze=Be(function(a){return b.onCommitFiberRoot(c,a)});Ae=Be(function(a){return b.onCommitFiberUnmount(c,a)})}catch(d){}return!0}function De(a){"function"===typeof ze&&ze(a)}function Ee(a){"function"===typeof Ae&&Ae(a)}
function Fe(a){return{baseState:a,expirationTime:0,first:null,last:null,callbackList:null,hasForceUpdate:!1,isInitialized:!1}}function Ge(a,b){null===a.last?a.first=a.last=b:(a.last.next=b,a.last=b);if(0===a.expirationTime||a.expirationTime>b.expirationTime)a.expirationTime=b.expirationTime}
function He(a,b){var c=a.alternate,d=a.updateQueue;null===d&&(d=a.updateQueue=Fe(null));null!==c?(a=c.updateQueue,null===a&&(a=c.updateQueue=Fe(null))):a=null;a=a!==d?a:null;null===a?Ge(d,b):null===d.last||null===a.last?(Ge(d,b),Ge(a,b)):(Ge(d,b),a.last=b)}function Ie(a,b,c,d){a=a.partialState;return"function"===typeof a?a.call(b,c,d):a}
function Je(a,b,c,d,e,f){null!==a&&a.updateQueue===c&&(c=b.updateQueue={baseState:c.baseState,expirationTime:c.expirationTime,first:c.first,last:c.last,isInitialized:c.isInitialized,callbackList:null,hasForceUpdate:!1});c.expirationTime=0;c.isInitialized?a=c.baseState:(a=c.baseState=b.memoizedState,c.isInitialized=!0);for(var g=!0,h=c.first,k=!1;null!==h;){var q=h.expirationTime;if(q>f){var v=c.expirationTime;if(0===v||v>q)c.expirationTime=q;k||(k=!0,c.baseState=a)}else{k||(c.first=h.next,null===
c.first&&(c.last=null));if(h.isReplace)a=Ie(h,d,a,e),g=!0;else if(q=Ie(h,d,a,e))a=g?B({},a,q):B(a,q),g=!1;h.isForced&&(c.hasForceUpdate=!0);null!==h.callback&&(q=c.callbackList,null===q&&(q=c.callbackList=[]),q.push(h))}h=h.next}null!==c.callbackList?b.effectTag|=32:null!==c.first||c.hasForceUpdate||(b.updateQueue=null);k||(c.baseState=a);return a}
function Ke(a,b){var c=a.callbackList;if(null!==c)for(a.callbackList=null,a=0;a<c.length;a++){var d=c[a],e=d.callback;d.callback=null;"function"!==typeof e?E("191",e):void 0;e.call(b)}}
function Le(a,b,c,d){function e(a,b){b.updater=f;a.stateNode=b;b._reactInternalFiber=a}var f={isMounted:ld,enqueueSetState:function(c,d,e){c=c._reactInternalFiber;e=void 0===e?null:e;var g=b(c);He(c,{expirationTime:g,partialState:d,callback:e,isReplace:!1,isForced:!1,nextCallback:null,next:null});a(c,g)},enqueueReplaceState:function(c,d,e){c=c._reactInternalFiber;e=void 0===e?null:e;var g=b(c);He(c,{expirationTime:g,partialState:d,callback:e,isReplace:!0,isForced:!1,nextCallback:null,next:null});
a(c,g)},enqueueForceUpdate:function(c,d){c=c._reactInternalFiber;d=void 0===d?null:d;var e=b(c);He(c,{expirationTime:e,partialState:null,callback:d,isReplace:!1,isForced:!0,nextCallback:null,next:null});a(c,e)}};return{adoptClassInstance:e,constructClassInstance:function(a,b){var c=a.type,d=ke(a),f=2===a.tag&&null!=a.type.contextTypes,g=f?me(a,d):D;b=new c(b,g);e(a,b);f&&(a=a.stateNode,a.__reactInternalMemoizedUnmaskedChildContext=d,a.__reactInternalMemoizedMaskedChildContext=g);return b},mountClassInstance:function(a,
b){var c=a.alternate,d=a.stateNode,e=d.state||null,g=a.pendingProps;g?void 0:E("158");var h=ke(a);d.props=g;d.state=a.memoizedState=e;d.refs=D;d.context=me(a,h);null!=a.type&&null!=a.type.prototype&&!0===a.type.prototype.unstable_isAsyncReactComponent&&(a.internalContextTag|=1);"function"===typeof d.componentWillMount&&(e=d.state,d.componentWillMount(),e!==d.state&&f.enqueueReplaceState(d,d.state,null),e=a.updateQueue,null!==e&&(d.state=Je(c,a,e,d,g,b)));"function"===typeof d.componentDidMount&&(a.effectTag|=
4)},updateClassInstance:function(a,b,e){var g=b.stateNode;g.props=b.memoizedProps;g.state=b.memoizedState;var h=b.memoizedProps,k=b.pendingProps;k||(k=h,null==k?E("159"):void 0);var u=g.context,z=ke(b);z=me(b,z);"function"!==typeof g.componentWillReceiveProps||h===k&&u===z||(u=g.state,g.componentWillReceiveProps(k,z),g.state!==u&&f.enqueueReplaceState(g,g.state,null));u=b.memoizedState;e=null!==b.updateQueue?Je(a,b,b.updateQueue,g,k,e):u;if(!(h!==k||u!==e||X.current||null!==b.updateQueue&&b.updateQueue.hasForceUpdate))return"function"!==
typeof g.componentDidUpdate||h===a.memoizedProps&&u===a.memoizedState||(b.effectTag|=4),!1;var G=k;if(null===h||null!==b.updateQueue&&b.updateQueue.hasForceUpdate)G=!0;else{var I=b.stateNode,L=b.type;G="function"===typeof I.shouldComponentUpdate?I.shouldComponentUpdate(G,e,z):L.prototype&&L.prototype.isPureReactComponent?!ea(h,G)||!ea(u,e):!0}G?("function"===typeof g.componentWillUpdate&&g.componentWillUpdate(k,e,z),"function"===typeof g.componentDidUpdate&&(b.effectTag|=4)):("function"!==typeof g.componentDidUpdate||
h===a.memoizedProps&&u===a.memoizedState||(b.effectTag|=4),c(b,k),d(b,e));g.props=k;g.state=e;g.context=z;return G}}}var Qe="function"===typeof Symbol&&Symbol["for"],Re=Qe?Symbol["for"]("react.element"):60103,Se=Qe?Symbol["for"]("react.call"):60104,Te=Qe?Symbol["for"]("react.return"):60105,Ue=Qe?Symbol["for"]("react.portal"):60106,Ve=Qe?Symbol["for"]("react.fragment"):60107,We="function"===typeof Symbol&&Symbol.iterator;
function Xe(a){if(null===a||"undefined"===typeof a)return null;a=We&&a[We]||a["@@iterator"];return"function"===typeof a?a:null}var Ye=Array.isArray;
function Ze(a,b){var c=b.ref;if(null!==c&&"function"!==typeof c){if(b._owner){b=b._owner;var d=void 0;b&&(2!==b.tag?E("110"):void 0,d=b.stateNode);d?void 0:E("147",c);var e=""+c;if(null!==a&&null!==a.ref&&a.ref._stringRef===e)return a.ref;a=function(a){var b=d.refs===D?d.refs={}:d.refs;null===a?delete b[e]:b[e]=a};a._stringRef=e;return a}"string"!==typeof c?E("148"):void 0;b._owner?void 0:E("149",c)}return c}
function $e(a,b){"textarea"!==a.type&&E("31","[object Object]"===Object.prototype.toString.call(b)?"object with keys {"+Object.keys(b).join(", ")+"}":b,"")}
function af(a){function b(b,c){if(a){var d=b.lastEffect;null!==d?(d.nextEffect=c,b.lastEffect=c):b.firstEffect=b.lastEffect=c;c.nextEffect=null;c.effectTag=8}}function c(c,d){if(!a)return null;for(;null!==d;)b(c,d),d=d.sibling;return null}function d(a,b){for(a=new Map;null!==b;)null!==b.key?a.set(b.key,b):a.set(b.index,b),b=b.sibling;return a}function e(a,b,c){a=se(a,b,c);a.index=0;a.sibling=null;return a}function f(b,c,d){b.index=d;if(!a)return c;d=b.alternate;if(null!==d)return d=d.index,d<c?(b.effectTag=
2,c):d;b.effectTag=2;return c}function g(b){a&&null===b.alternate&&(b.effectTag=2);return b}function h(a,b,c,d){if(null===b||6!==b.tag)return b=ve(c,a.internalContextTag,d),b["return"]=a,b;b=e(b,c,d);b["return"]=a;return b}function k(a,b,c,d){if(null!==b&&b.type===c.type)return d=e(b,c.props,d),d.ref=Ze(b,c),d["return"]=a,d;d=te(c,a.internalContextTag,d);d.ref=Ze(b,c);d["return"]=a;return d}function q(a,b,c,d){if(null===b||7!==b.tag)return b=we(c,a.internalContextTag,d),b["return"]=a,b;b=e(b,c,d);
b["return"]=a;return b}function v(a,b,c,d){if(null===b||9!==b.tag)return b=xe(c,a.internalContextTag,d),b.type=c.value,b["return"]=a,b;b=e(b,null,d);b.type=c.value;b["return"]=a;return b}function y(a,b,c,d){if(null===b||4!==b.tag||b.stateNode.containerInfo!==c.containerInfo||b.stateNode.implementation!==c.implementation)return b=ye(c,a.internalContextTag,d),b["return"]=a,b;b=e(b,c.children||[],d);b["return"]=a;return b}function u(a,b,c,d,f){if(null===b||10!==b.tag)return b=ue(c,a.internalContextTag,
d,f),b["return"]=a,b;b=e(b,c,d);b["return"]=a;return b}function z(a,b,c){if("string"===typeof b||"number"===typeof b)return b=ve(""+b,a.internalContextTag,c),b["return"]=a,b;if("object"===typeof b&&null!==b){switch(b.$$typeof){case Re:if(b.type===Ve)return b=ue(b.props.children,a.internalContextTag,c,b.key),b["return"]=a,b;c=te(b,a.internalContextTag,c);c.ref=Ze(null,b);c["return"]=a;return c;case Se:return b=we(b,a.internalContextTag,c),b["return"]=a,b;case Te:return c=xe(b,a.internalContextTag,
c),c.type=b.value,c["return"]=a,c;case Ue:return b=ye(b,a.internalContextTag,c),b["return"]=a,b}if(Ye(b)||Xe(b))return b=ue(b,a.internalContextTag,c,null),b["return"]=a,b;$e(a,b)}return null}function G(a,b,c,d){var e=null!==b?b.key:null;if("string"===typeof c||"number"===typeof c)return null!==e?null:h(a,b,""+c,d);if("object"===typeof c&&null!==c){switch(c.$$typeof){case Re:return c.key===e?c.type===Ve?u(a,b,c.props.children,d,e):k(a,b,c,d):null;case Se:return c.key===e?q(a,b,c,d):null;case Te:return null===
e?v(a,b,c,d):null;case Ue:return c.key===e?y(a,b,c,d):null}if(Ye(c)||Xe(c))return null!==e?null:u(a,b,c,d,null);$e(a,c)}return null}function I(a,b,c,d,e){if("string"===typeof d||"number"===typeof d)return a=a.get(c)||null,h(b,a,""+d,e);if("object"===typeof d&&null!==d){switch(d.$$typeof){case Re:return a=a.get(null===d.key?c:d.key)||null,d.type===Ve?u(b,a,d.props.children,e,d.key):k(b,a,d,e);case Se:return a=a.get(null===d.key?c:d.key)||null,q(b,a,d,e);case Te:return a=a.get(c)||null,v(b,a,d,e);case Ue:return a=
a.get(null===d.key?c:d.key)||null,y(b,a,d,e)}if(Ye(d)||Xe(d))return a=a.get(c)||null,u(b,a,d,e,null);$e(b,d)}return null}function L(e,g,m,A){for(var h=null,r=null,n=g,w=g=0,k=null;null!==n&&w<m.length;w++){n.index>w?(k=n,n=null):k=n.sibling;var x=G(e,n,m[w],A);if(null===x){null===n&&(n=k);break}a&&n&&null===x.alternate&&b(e,n);g=f(x,g,w);null===r?h=x:r.sibling=x;r=x;n=k}if(w===m.length)return c(e,n),h;if(null===n){for(;w<m.length;w++)if(n=z(e,m[w],A))g=f(n,g,w),null===r?h=n:r.sibling=n,r=n;return h}for(n=
d(e,n);w<m.length;w++)if(k=I(n,e,w,m[w],A)){if(a&&null!==k.alternate)n["delete"](null===k.key?w:k.key);g=f(k,g,w);null===r?h=k:r.sibling=k;r=k}a&&n.forEach(function(a){return b(e,a)});return h}function N(e,g,m,A){var h=Xe(m);"function"!==typeof h?E("150"):void 0;m=h.call(m);null==m?E("151"):void 0;for(var r=h=null,n=g,w=g=0,k=null,x=m.next();null!==n&&!x.done;w++,x=m.next()){n.index>w?(k=n,n=null):k=n.sibling;var J=G(e,n,x.value,A);if(null===J){n||(n=k);break}a&&n&&null===J.alternate&&b(e,n);g=f(J,
g,w);null===r?h=J:r.sibling=J;r=J;n=k}if(x.done)return c(e,n),h;if(null===n){for(;!x.done;w++,x=m.next())x=z(e,x.value,A),null!==x&&(g=f(x,g,w),null===r?h=x:r.sibling=x,r=x);return h}for(n=d(e,n);!x.done;w++,x=m.next())if(x=I(n,e,w,x.value,A),null!==x){if(a&&null!==x.alternate)n["delete"](null===x.key?w:x.key);g=f(x,g,w);null===r?h=x:r.sibling=x;r=x}a&&n.forEach(function(a){return b(e,a)});return h}return function(a,d,f,h){"object"===typeof f&&null!==f&&f.type===Ve&&null===f.key&&(f=f.props.children);
var m="object"===typeof f&&null!==f;if(m)switch(f.$$typeof){case Re:a:{var r=f.key;for(m=d;null!==m;){if(m.key===r)if(10===m.tag?f.type===Ve:m.type===f.type){c(a,m.sibling);d=e(m,f.type===Ve?f.props.children:f.props,h);d.ref=Ze(m,f);d["return"]=a;a=d;break a}else{c(a,m);break}else b(a,m);m=m.sibling}f.type===Ve?(d=ue(f.props.children,a.internalContextTag,h,f.key),d["return"]=a,a=d):(h=te(f,a.internalContextTag,h),h.ref=Ze(d,f),h["return"]=a,a=h)}return g(a);case Se:a:{for(m=f.key;null!==d;){if(d.key===
m)if(7===d.tag){c(a,d.sibling);d=e(d,f,h);d["return"]=a;a=d;break a}else{c(a,d);break}else b(a,d);d=d.sibling}d=we(f,a.internalContextTag,h);d["return"]=a;a=d}return g(a);case Te:a:{if(null!==d)if(9===d.tag){c(a,d.sibling);d=e(d,null,h);d.type=f.value;d["return"]=a;a=d;break a}else c(a,d);d=xe(f,a.internalContextTag,h);d.type=f.value;d["return"]=a;a=d}return g(a);case Ue:a:{for(m=f.key;null!==d;){if(d.key===m)if(4===d.tag&&d.stateNode.containerInfo===f.containerInfo&&d.stateNode.implementation===
f.implementation){c(a,d.sibling);d=e(d,f.children||[],h);d["return"]=a;a=d;break a}else{c(a,d);break}else b(a,d);d=d.sibling}d=ye(f,a.internalContextTag,h);d["return"]=a;a=d}return g(a)}if("string"===typeof f||"number"===typeof f)return f=""+f,null!==d&&6===d.tag?(c(a,d.sibling),d=e(d,f,h)):(c(a,d),d=ve(f,a.internalContextTag,h)),d["return"]=a,a=d,g(a);if(Ye(f))return L(a,d,f,h);if(Xe(f))return N(a,d,f,h);m&&$e(a,f);if("undefined"===typeof f)switch(a.tag){case 2:case 1:h=a.type,E("152",h.displayName||
h.name||"Component")}return c(a,d)}}var bf=af(!0),cf=af(!1);
function df(a,b,c,d,e){function f(a,b,c){var d=b.expirationTime;b.child=null===a?cf(b,null,c,d):bf(b,a.child,c,d)}function g(a,b){var c=b.ref;null===c||a&&a.ref===c||(b.effectTag|=128)}function h(a,b,c,d){g(a,b);if(!c)return d&&re(b,!1),q(a,b);c=b.stateNode;id.current=b;var e=c.render();b.effectTag|=1;f(a,b,e);b.memoizedState=c.state;b.memoizedProps=c.props;d&&re(b,!0);return b.child}function k(a){var b=a.stateNode;b.pendingContext?oe(a,b.pendingContext,b.pendingContext!==b.context):b.context&&oe(a,
b.context,!1);I(a,b.containerInfo)}function q(a,b){null!==a&&b.child!==a.child?E("153"):void 0;if(null!==b.child){a=b.child;var c=se(a,a.pendingProps,a.expirationTime);b.child=c;for(c["return"]=b;null!==a.sibling;)a=a.sibling,c=c.sibling=se(a,a.pendingProps,a.expirationTime),c["return"]=b;c.sibling=null}return b.child}function v(a,b){switch(b.tag){case 3:k(b);break;case 2:qe(b);break;case 4:I(b,b.stateNode.containerInfo)}return null}var y=a.shouldSetTextContent,u=a.useSyncScheduling,z=a.shouldDeprioritizeSubtree,
G=b.pushHostContext,I=b.pushHostContainer,L=c.enterHydrationState,N=c.resetHydrationState,J=c.tryToClaimNextHydratableInstance;a=Le(d,e,function(a,b){a.memoizedProps=b},function(a,b){a.memoizedState=b});var w=a.adoptClassInstance,m=a.constructClassInstance,A=a.mountClassInstance,Ob=a.updateClassInstance;return{beginWork:function(a,b,c){if(0===b.expirationTime||b.expirationTime>c)return v(a,b);switch(b.tag){case 0:null!==a?E("155"):void 0;var d=b.type,e=b.pendingProps,r=ke(b);r=me(b,r);d=d(e,r);b.effectTag|=
1;"object"===typeof d&&null!==d&&"function"===typeof d.render?(b.tag=2,e=qe(b),w(b,d),A(b,c),b=h(a,b,!0,e)):(b.tag=1,f(a,b,d),b.memoizedProps=e,b=b.child);return b;case 1:a:{e=b.type;c=b.pendingProps;d=b.memoizedProps;if(X.current)null===c&&(c=d);else if(null===c||d===c){b=q(a,b);break a}d=ke(b);d=me(b,d);e=e(c,d);b.effectTag|=1;f(a,b,e);b.memoizedProps=c;b=b.child}return b;case 2:return e=qe(b),d=void 0,null===a?b.stateNode?E("153"):(m(b,b.pendingProps),A(b,c),d=!0):d=Ob(a,b,c),h(a,b,d,e);case 3:return k(b),
e=b.updateQueue,null!==e?(d=b.memoizedState,e=Je(a,b,e,null,null,c),d===e?(N(),b=q(a,b)):(d=e.element,r=b.stateNode,(null===a||null===a.child)&&r.hydrate&&L(b)?(b.effectTag|=2,b.child=cf(b,null,d,c)):(N(),f(a,b,d)),b.memoizedState=e,b=b.child)):(N(),b=q(a,b)),b;case 5:G(b);null===a&&J(b);e=b.type;var n=b.memoizedProps;d=b.pendingProps;null===d&&(d=n,null===d?E("154"):void 0);r=null!==a?a.memoizedProps:null;X.current||null!==d&&n!==d?(n=d.children,y(e,d)?n=null:r&&y(e,r)&&(b.effectTag|=16),g(a,b),
2147483647!==c&&!u&&z(e,d)?(b.expirationTime=2147483647,b=null):(f(a,b,n),b.memoizedProps=d,b=b.child)):b=q(a,b);return b;case 6:return null===a&&J(b),a=b.pendingProps,null===a&&(a=b.memoizedProps),b.memoizedProps=a,null;case 8:b.tag=7;case 7:e=b.pendingProps;if(X.current)null===e&&(e=a&&a.memoizedProps,null===e?E("154"):void 0);else if(null===e||b.memoizedProps===e)e=b.memoizedProps;d=e.children;b.stateNode=null===a?cf(b,b.stateNode,d,c):bf(b,b.stateNode,d,c);b.memoizedProps=e;return b.stateNode;
case 9:return null;case 4:a:{I(b,b.stateNode.containerInfo);e=b.pendingProps;if(X.current)null===e&&(e=a&&a.memoizedProps,null==e?E("154"):void 0);else if(null===e||b.memoizedProps===e){b=q(a,b);break a}null===a?b.child=bf(b,null,e,c):f(a,b,e);b.memoizedProps=e;b=b.child}return b;case 10:a:{c=b.pendingProps;if(X.current)null===c&&(c=b.memoizedProps);else if(null===c||b.memoizedProps===c){b=q(a,b);break a}f(a,b,c);b.memoizedProps=c;b=b.child}return b;default:E("156")}},beginFailedWork:function(a,b,
c){switch(b.tag){case 2:qe(b);break;case 3:k(b);break;default:E("157")}b.effectTag|=64;null===a?b.child=null:b.child!==a.child&&(b.child=a.child);if(0===b.expirationTime||b.expirationTime>c)return v(a,b);b.firstEffect=null;b.lastEffect=null;b.child=null===a?cf(b,null,null,c):bf(b,a.child,null,c);2===b.tag&&(a=b.stateNode,b.memoizedProps=a.props,b.memoizedState=a.state);return b.child}}}
function ef(a,b,c){function d(a){a.effectTag|=4}var e=a.createInstance,f=a.createTextInstance,g=a.appendInitialChild,h=a.finalizeInitialChildren,k=a.prepareUpdate,q=a.persistence,v=b.getRootHostContainer,y=b.popHostContext,u=b.getHostContext,z=b.popHostContainer,G=c.prepareToHydrateHostInstance,I=c.prepareToHydrateHostTextInstance,L=c.popHydrationState,N=void 0,J=void 0,w=void 0;a.mutation?(N=function(){},J=function(a,b,c){(b.updateQueue=c)&&d(b)},w=function(a,b,c,e){c!==e&&d(b)}):q?E("235"):E("236");
return{completeWork:function(a,b,c){var m=b.pendingProps;if(null===m)m=b.memoizedProps;else if(2147483647!==b.expirationTime||2147483647===c)b.pendingProps=null;switch(b.tag){case 1:return null;case 2:return ne(b),null;case 3:z(b);V(X,b);V(ie,b);m=b.stateNode;m.pendingContext&&(m.context=m.pendingContext,m.pendingContext=null);if(null===a||null===a.child)L(b),b.effectTag&=-3;N(b);return null;case 5:y(b);c=v();var A=b.type;if(null!==a&&null!=b.stateNode){var p=a.memoizedProps,q=b.stateNode,x=u();q=
k(q,A,p,m,c,x);J(a,b,q,A,p,m,c);a.ref!==b.ref&&(b.effectTag|=128)}else{if(!m)return null===b.stateNode?E("166"):void 0,null;a=u();if(L(b))G(b,c,a)&&d(b);else{a=e(A,m,c,a,b);a:for(p=b.child;null!==p;){if(5===p.tag||6===p.tag)g(a,p.stateNode);else if(4!==p.tag&&null!==p.child){p.child["return"]=p;p=p.child;continue}if(p===b)break;for(;null===p.sibling;){if(null===p["return"]||p["return"]===b)break a;p=p["return"]}p.sibling["return"]=p["return"];p=p.sibling}h(a,A,m,c)&&d(b);b.stateNode=a}null!==b.ref&&
(b.effectTag|=128)}return null;case 6:if(a&&null!=b.stateNode)w(a,b,a.memoizedProps,m);else{if("string"!==typeof m)return null===b.stateNode?E("166"):void 0,null;a=v();c=u();L(b)?I(b)&&d(b):b.stateNode=f(m,a,c,b)}return null;case 7:(m=b.memoizedProps)?void 0:E("165");b.tag=8;A=[];a:for((p=b.stateNode)&&(p["return"]=b);null!==p;){if(5===p.tag||6===p.tag||4===p.tag)E("247");else if(9===p.tag)A.push(p.type);else if(null!==p.child){p.child["return"]=p;p=p.child;continue}for(;null===p.sibling;){if(null===
p["return"]||p["return"]===b)break a;p=p["return"]}p.sibling["return"]=p["return"];p=p.sibling}p=m.handler;m=p(m.props,A);b.child=bf(b,null!==a?a.child:null,m,c);return b.child;case 8:return b.tag=7,null;case 9:return null;case 10:return null;case 4:return z(b),N(b),null;case 0:E("167");default:E("156")}}}}
function ff(a,b){function c(a){var c=a.ref;if(null!==c)try{c(null)}catch(A){b(a,A)}}function d(a){"function"===typeof Ee&&Ee(a);switch(a.tag){case 2:c(a);var d=a.stateNode;if("function"===typeof d.componentWillUnmount)try{d.props=a.memoizedProps,d.state=a.memoizedState,d.componentWillUnmount()}catch(A){b(a,A)}break;case 5:c(a);break;case 7:e(a.stateNode);break;case 4:k&&g(a)}}function e(a){for(var b=a;;)if(d(b),null===b.child||k&&4===b.tag){if(b===a)break;for(;null===b.sibling;){if(null===b["return"]||
b["return"]===a)return;b=b["return"]}b.sibling["return"]=b["return"];b=b.sibling}else b.child["return"]=b,b=b.child}function f(a){return 5===a.tag||3===a.tag||4===a.tag}function g(a){for(var b=a,c=!1,f=void 0,g=void 0;;){if(!c){c=b["return"];a:for(;;){null===c?E("160"):void 0;switch(c.tag){case 5:f=c.stateNode;g=!1;break a;case 3:f=c.stateNode.containerInfo;g=!0;break a;case 4:f=c.stateNode.containerInfo;g=!0;break a}c=c["return"]}c=!0}if(5===b.tag||6===b.tag)e(b),g?J(f,b.stateNode):N(f,b.stateNode);
else if(4===b.tag?f=b.stateNode.containerInfo:d(b),null!==b.child){b.child["return"]=b;b=b.child;continue}if(b===a)break;for(;null===b.sibling;){if(null===b["return"]||b["return"]===a)return;b=b["return"];4===b.tag&&(c=!1)}b.sibling["return"]=b["return"];b=b.sibling}}var h=a.getPublicInstance,k=a.mutation;a=a.persistence;k||(a?E("235"):E("236"));var q=k.commitMount,v=k.commitUpdate,y=k.resetTextContent,u=k.commitTextUpdate,z=k.appendChild,G=k.appendChildToContainer,I=k.insertBefore,L=k.insertInContainerBefore,
N=k.removeChild,J=k.removeChildFromContainer;return{commitResetTextContent:function(a){y(a.stateNode)},commitPlacement:function(a){a:{for(var b=a["return"];null!==b;){if(f(b)){var c=b;break a}b=b["return"]}E("160");c=void 0}var d=b=void 0;switch(c.tag){case 5:b=c.stateNode;d=!1;break;case 3:b=c.stateNode.containerInfo;d=!0;break;case 4:b=c.stateNode.containerInfo;d=!0;break;default:E("161")}c.effectTag&16&&(y(b),c.effectTag&=-17);a:b:for(c=a;;){for(;null===c.sibling;){if(null===c["return"]||f(c["return"])){c=
null;break a}c=c["return"]}c.sibling["return"]=c["return"];for(c=c.sibling;5!==c.tag&&6!==c.tag;){if(c.effectTag&2)continue b;if(null===c.child||4===c.tag)continue b;else c.child["return"]=c,c=c.child}if(!(c.effectTag&2)){c=c.stateNode;break a}}for(var e=a;;){if(5===e.tag||6===e.tag)c?d?L(b,e.stateNode,c):I(b,e.stateNode,c):d?G(b,e.stateNode):z(b,e.stateNode);else if(4!==e.tag&&null!==e.child){e.child["return"]=e;e=e.child;continue}if(e===a)break;for(;null===e.sibling;){if(null===e["return"]||e["return"]===
a)return;e=e["return"]}e.sibling["return"]=e["return"];e=e.sibling}},commitDeletion:function(a){g(a);a["return"]=null;a.child=null;a.alternate&&(a.alternate.child=null,a.alternate["return"]=null)},commitWork:function(a,b){switch(b.tag){case 2:break;case 5:var c=b.stateNode;if(null!=c){var d=b.memoizedProps;a=null!==a?a.memoizedProps:d;var e=b.type,f=b.updateQueue;b.updateQueue=null;null!==f&&v(c,f,e,a,d,b)}break;case 6:null===b.stateNode?E("162"):void 0;c=b.memoizedProps;u(b.stateNode,null!==a?a.memoizedProps:
c,c);break;case 3:break;default:E("163")}},commitLifeCycles:function(a,b){switch(b.tag){case 2:var c=b.stateNode;if(b.effectTag&4)if(null===a)c.props=b.memoizedProps,c.state=b.memoizedState,c.componentDidMount();else{var d=a.memoizedProps;a=a.memoizedState;c.props=b.memoizedProps;c.state=b.memoizedState;c.componentDidUpdate(d,a)}b=b.updateQueue;null!==b&&Ke(b,c);break;case 3:c=b.updateQueue;null!==c&&Ke(c,null!==b.child?b.child.stateNode:null);break;case 5:c=b.stateNode;null===a&&b.effectTag&4&&q(c,
b.type,b.memoizedProps,b);break;case 6:break;case 4:break;default:E("163")}},commitAttachRef:function(a){var b=a.ref;if(null!==b){var c=a.stateNode;switch(a.tag){case 5:b(h(c));break;default:b(c)}}},commitDetachRef:function(a){a=a.ref;null!==a&&a(null)}}}var gf={};
function hf(a){function b(a){a===gf?E("174"):void 0;return a}var c=a.getChildHostContext,d=a.getRootHostContext,e={current:gf},f={current:gf},g={current:gf};return{getHostContext:function(){return b(e.current)},getRootHostContainer:function(){return b(g.current)},popHostContainer:function(a){V(e,a);V(f,a);V(g,a)},popHostContext:function(a){f.current===a&&(V(e,a),V(f,a))},pushHostContainer:function(a,b){W(g,b,a);b=d(b);W(f,a,a);W(e,b,a)},pushHostContext:function(a){var d=b(g.current),h=b(e.current);
d=c(h,a.type,d);h!==d&&(W(f,a,a),W(e,d,a))},resetHostContainer:function(){e.current=gf;g.current=gf}}}
function jf(a){function b(a,b){var c=new Y(5,null,0);c.type="DELETED";c.stateNode=b;c["return"]=a;c.effectTag=8;null!==a.lastEffect?(a.lastEffect.nextEffect=c,a.lastEffect=c):a.firstEffect=a.lastEffect=c}function c(a,b){switch(a.tag){case 5:return b=f(b,a.type,a.pendingProps),null!==b?(a.stateNode=b,!0):!1;case 6:return b=g(b,a.pendingProps),null!==b?(a.stateNode=b,!0):!1;default:return!1}}function d(a){for(a=a["return"];null!==a&&5!==a.tag&&3!==a.tag;)a=a["return"];y=a}var e=a.shouldSetTextContent;
a=a.hydration;if(!a)return{enterHydrationState:function(){return!1},resetHydrationState:function(){},tryToClaimNextHydratableInstance:function(){},prepareToHydrateHostInstance:function(){E("175")},prepareToHydrateHostTextInstance:function(){E("176")},popHydrationState:function(){return!1}};var f=a.canHydrateInstance,g=a.canHydrateTextInstance,h=a.getNextHydratableSibling,k=a.getFirstHydratableChild,q=a.hydrateInstance,v=a.hydrateTextInstance,y=null,u=null,z=!1;return{enterHydrationState:function(a){u=
k(a.stateNode.containerInfo);y=a;return z=!0},resetHydrationState:function(){u=y=null;z=!1},tryToClaimNextHydratableInstance:function(a){if(z){var d=u;if(d){if(!c(a,d)){d=h(d);if(!d||!c(a,d)){a.effectTag|=2;z=!1;y=a;return}b(y,u)}y=a;u=k(d)}else a.effectTag|=2,z=!1,y=a}},prepareToHydrateHostInstance:function(a,b,c){b=q(a.stateNode,a.type,a.memoizedProps,b,c,a);a.updateQueue=b;return null!==b?!0:!1},prepareToHydrateHostTextInstance:function(a){return v(a.stateNode,a.memoizedProps,a)},popHydrationState:function(a){if(a!==
y)return!1;if(!z)return d(a),z=!0,!1;var c=a.type;if(5!==a.tag||"head"!==c&&"body"!==c&&!e(c,a.memoizedProps))for(c=u;c;)b(a,c),c=h(c);d(a);u=y?h(a.stateNode):null;return!0}}}
function kf(a){function b(a){Qb=ja=!0;var b=a.stateNode;b.current===a?E("177"):void 0;b.isReadyForCommit=!1;id.current=null;if(1<a.effectTag)if(null!==a.lastEffect){a.lastEffect.nextEffect=a;var c=a.firstEffect}else c=a;else c=a.firstEffect;yg();for(t=c;null!==t;){var d=!1,e=void 0;try{for(;null!==t;){var f=t.effectTag;f&16&&zg(t);if(f&128){var g=t.alternate;null!==g&&Ag(g)}switch(f&-242){case 2:Ne(t);t.effectTag&=-3;break;case 6:Ne(t);t.effectTag&=-3;Oe(t.alternate,t);break;case 4:Oe(t.alternate,
t);break;case 8:Sc=!0,Bg(t),Sc=!1}t=t.nextEffect}}catch(Tc){d=!0,e=Tc}d&&(null===t?E("178"):void 0,h(t,e),null!==t&&(t=t.nextEffect))}Cg();b.current=a;for(t=c;null!==t;){c=!1;d=void 0;try{for(;null!==t;){var k=t.effectTag;k&36&&Dg(t.alternate,t);k&128&&Eg(t);if(k&64)switch(e=t,f=void 0,null!==R&&(f=R.get(e),R["delete"](e),null==f&&null!==e.alternate&&(e=e.alternate,f=R.get(e),R["delete"](e))),null==f?E("184"):void 0,e.tag){case 2:e.stateNode.componentDidCatch(f.error,{componentStack:f.componentStack});
break;case 3:null===ca&&(ca=f.error);break;default:E("157")}var Qc=t.nextEffect;t.nextEffect=null;t=Qc}}catch(Tc){c=!0,d=Tc}c&&(null===t?E("178"):void 0,h(t,d),null!==t&&(t=t.nextEffect))}ja=Qb=!1;"function"===typeof De&&De(a.stateNode);ha&&(ha.forEach(G),ha=null);null!==ca&&(a=ca,ca=null,Ob(a));b=b.current.expirationTime;0===b&&(qa=R=null);return b}function c(a){for(;;){var b=Fg(a.alternate,a,H),c=a["return"],d=a.sibling;var e=a;if(2147483647===H||2147483647!==e.expirationTime){if(2!==e.tag&&3!==
e.tag)var f=0;else f=e.updateQueue,f=null===f?0:f.expirationTime;for(var g=e.child;null!==g;)0!==g.expirationTime&&(0===f||f>g.expirationTime)&&(f=g.expirationTime),g=g.sibling;e.expirationTime=f}if(null!==b)return b;null!==c&&(null===c.firstEffect&&(c.firstEffect=a.firstEffect),null!==a.lastEffect&&(null!==c.lastEffect&&(c.lastEffect.nextEffect=a.firstEffect),c.lastEffect=a.lastEffect),1<a.effectTag&&(null!==c.lastEffect?c.lastEffect.nextEffect=a:c.firstEffect=a,c.lastEffect=a));if(null!==d)return d;
if(null!==c)a=c;else{a.stateNode.isReadyForCommit=!0;break}}return null}function d(a){var b=rg(a.alternate,a,H);null===b&&(b=c(a));id.current=null;return b}function e(a){var b=Gg(a.alternate,a,H);null===b&&(b=c(a));id.current=null;return b}function f(a){if(null!==R){if(!(0===H||H>a))if(H<=Uc)for(;null!==F;)F=k(F)?e(F):d(F);else for(;null!==F&&!A();)F=k(F)?e(F):d(F)}else if(!(0===H||H>a))if(H<=Uc)for(;null!==F;)F=d(F);else for(;null!==F&&!A();)F=d(F)}function g(a,b){ja?E("243"):void 0;ja=!0;a.isReadyForCommit=
!1;if(a!==ra||b!==H||null===F){for(;-1<he;)ge[he]=null,he--;je=D;ie.current=D;X.current=!1;x();ra=a;H=b;F=se(ra.current,null,b)}var c=!1,d=null;try{f(b)}catch(Rc){c=!0,d=Rc}for(;c;){if(eb){ca=d;break}var g=F;if(null===g)eb=!0;else{var k=h(g,d);null===k?E("183"):void 0;if(!eb){try{c=k;d=b;for(k=c;null!==g;){switch(g.tag){case 2:ne(g);break;case 5:qg(g);break;case 3:p(g);break;case 4:p(g)}if(g===k||g.alternate===k)break;g=g["return"]}F=e(c);f(d)}catch(Rc){c=!0;d=Rc;continue}break}}}b=ca;eb=ja=!1;ca=
null;null!==b&&Ob(b);return a.isReadyForCommit?a.current.alternate:null}function h(a,b){var c=id.current=null,d=!1,e=!1,f=null;if(3===a.tag)c=a,q(a)&&(eb=!0);else for(var g=a["return"];null!==g&&null===c;){2===g.tag?"function"===typeof g.stateNode.componentDidCatch&&(d=!0,f=jd(g),c=g,e=!0):3===g.tag&&(c=g);if(q(g)){if(Sc||null!==ha&&(ha.has(g)||null!==g.alternate&&ha.has(g.alternate)))return null;c=null;e=!1}g=g["return"]}if(null!==c){null===qa&&(qa=new Set);qa.add(c);var h="";g=a;do{a:switch(g.tag){case 0:case 1:case 2:case 5:var k=
g._debugOwner,Qc=g._debugSource;var m=jd(g);var n=null;k&&(n=jd(k));k=Qc;m="\n    in "+(m||"Unknown")+(k?" (at "+k.fileName.replace(/^.*[\\\/]/,"")+":"+k.lineNumber+")":n?" (created by "+n+")":"");break a;default:m=""}h+=m;g=g["return"]}while(g);g=h;a=jd(a);null===R&&(R=new Map);b={componentName:a,componentStack:g,error:b,errorBoundary:d?c.stateNode:null,errorBoundaryFound:d,errorBoundaryName:f,willRetry:e};R.set(c,b);try{var p=b.error;p&&p.suppressReactErrorLogging||console.error(p)}catch(Vc){Vc&&
Vc.suppressReactErrorLogging||console.error(Vc)}Qb?(null===ha&&(ha=new Set),ha.add(c)):G(c);return c}null===ca&&(ca=b);return null}function k(a){return null!==R&&(R.has(a)||null!==a.alternate&&R.has(a.alternate))}function q(a){return null!==qa&&(qa.has(a)||null!==a.alternate&&qa.has(a.alternate))}function v(){return 20*(((I()+100)/20|0)+1)}function y(a){return 0!==ka?ka:ja?Qb?1:H:!Hg||a.internalContextTag&1?v():1}function u(a,b){return z(a,b,!1)}function z(a,b){for(;null!==a;){if(0===a.expirationTime||
a.expirationTime>b)a.expirationTime=b;null!==a.alternate&&(0===a.alternate.expirationTime||a.alternate.expirationTime>b)&&(a.alternate.expirationTime=b);if(null===a["return"])if(3===a.tag){var c=a.stateNode;!ja&&c===ra&&b<H&&(F=ra=null,H=0);var d=c,e=b;Rb>Ig&&E("185");if(null===d.nextScheduledRoot)d.remainingExpirationTime=e,null===O?(sa=O=d,d.nextScheduledRoot=d):(O=O.nextScheduledRoot=d,O.nextScheduledRoot=sa);else{var f=d.remainingExpirationTime;if(0===f||e<f)d.remainingExpirationTime=e}Fa||(la?
Sb&&(ma=d,na=1,m(ma,na)):1===e?w(1,null):L(e));!ja&&c===ra&&b<H&&(F=ra=null,H=0)}else break;a=a["return"]}}function G(a){z(a,1,!0)}function I(){return Uc=((Wc()-Pe)/10|0)+2}function L(a){if(0!==Tb){if(a>Tb)return;Jg(Xc)}var b=Wc()-Pe;Tb=a;Xc=Kg(J,{timeout:10*(a-2)-b})}function N(){var a=0,b=null;if(null!==O)for(var c=O,d=sa;null!==d;){var e=d.remainingExpirationTime;if(0===e){null===c||null===O?E("244"):void 0;if(d===d.nextScheduledRoot){sa=O=d.nextScheduledRoot=null;break}else if(d===sa)sa=e=d.nextScheduledRoot,
O.nextScheduledRoot=e,d.nextScheduledRoot=null;else if(d===O){O=c;O.nextScheduledRoot=sa;d.nextScheduledRoot=null;break}else c.nextScheduledRoot=d.nextScheduledRoot,d.nextScheduledRoot=null;d=c.nextScheduledRoot}else{if(0===a||e<a)a=e,b=d;if(d===O)break;c=d;d=d.nextScheduledRoot}}c=ma;null!==c&&c===b?Rb++:Rb=0;ma=b;na=a}function J(a){w(0,a)}function w(a,b){fb=b;for(N();null!==ma&&0!==na&&(0===a||na<=a)&&!Yc;)m(ma,na),N();null!==fb&&(Tb=0,Xc=-1);0!==na&&L(na);fb=null;Yc=!1;Rb=0;if(Ub)throw a=Zc,Zc=
null,Ub=!1,a;}function m(a,c){Fa?E("245"):void 0;Fa=!0;if(c<=I()){var d=a.finishedWork;null!==d?(a.finishedWork=null,a.remainingExpirationTime=b(d)):(a.finishedWork=null,d=g(a,c),null!==d&&(a.remainingExpirationTime=b(d)))}else d=a.finishedWork,null!==d?(a.finishedWork=null,a.remainingExpirationTime=b(d)):(a.finishedWork=null,d=g(a,c),null!==d&&(A()?a.finishedWork=d:a.remainingExpirationTime=b(d)));Fa=!1}function A(){return null===fb||fb.timeRemaining()>Lg?!1:Yc=!0}function Ob(a){null===ma?E("246"):
void 0;ma.remainingExpirationTime=0;Ub||(Ub=!0,Zc=a)}var r=hf(a),n=jf(a),p=r.popHostContainer,qg=r.popHostContext,x=r.resetHostContainer,Me=df(a,r,n,u,y),rg=Me.beginWork,Gg=Me.beginFailedWork,Fg=ef(a,r,n).completeWork;r=ff(a,h);var zg=r.commitResetTextContent,Ne=r.commitPlacement,Bg=r.commitDeletion,Oe=r.commitWork,Dg=r.commitLifeCycles,Eg=r.commitAttachRef,Ag=r.commitDetachRef,Wc=a.now,Kg=a.scheduleDeferredCallback,Jg=a.cancelDeferredCallback,Hg=a.useSyncScheduling,yg=a.prepareForCommit,Cg=a.resetAfterCommit,
Pe=Wc(),Uc=2,ka=0,ja=!1,F=null,ra=null,H=0,t=null,R=null,qa=null,ha=null,ca=null,eb=!1,Qb=!1,Sc=!1,sa=null,O=null,Tb=0,Xc=-1,Fa=!1,ma=null,na=0,Yc=!1,Ub=!1,Zc=null,fb=null,la=!1,Sb=!1,Ig=1E3,Rb=0,Lg=1;return{computeAsyncExpiration:v,computeExpirationForFiber:y,scheduleWork:u,batchedUpdates:function(a,b){var c=la;la=!0;try{return a(b)}finally{(la=c)||Fa||w(1,null)}},unbatchedUpdates:function(a){if(la&&!Sb){Sb=!0;try{return a()}finally{Sb=!1}}return a()},flushSync:function(a){var b=la;la=!0;try{a:{var c=
ka;ka=1;try{var d=a();break a}finally{ka=c}d=void 0}return d}finally{la=b,Fa?E("187"):void 0,w(1,null)}},deferredUpdates:function(a){var b=ka;ka=v();try{return a()}finally{ka=b}}}}
function lf(a){function b(a){a=od(a);return null===a?null:a.stateNode}var c=a.getPublicInstance;a=kf(a);var d=a.computeAsyncExpiration,e=a.computeExpirationForFiber,f=a.scheduleWork;return{createContainer:function(a,b){var c=new Y(3,null,0);a={current:c,containerInfo:a,pendingChildren:null,remainingExpirationTime:0,isReadyForCommit:!1,finishedWork:null,context:null,pendingContext:null,hydrate:b,nextScheduledRoot:null};return c.stateNode=a},updateContainer:function(a,b,c,q){var g=b.current;if(c){c=
c._reactInternalFiber;var h;b:{2===kd(c)&&2===c.tag?void 0:E("170");for(h=c;3!==h.tag;){if(le(h)){h=h.stateNode.__reactInternalMemoizedMergedChildContext;break b}(h=h["return"])?void 0:E("171")}h=h.stateNode.context}c=le(c)?pe(c,h):h}else c=D;null===b.context?b.context=c:b.pendingContext=c;b=q;b=void 0===b?null:b;q=null!=a&&null!=a.type&&null!=a.type.prototype&&!0===a.type.prototype.unstable_isAsyncReactComponent?d():e(g);He(g,{expirationTime:q,partialState:{element:a},callback:b,isReplace:!1,isForced:!1,
nextCallback:null,next:null});f(g,q)},batchedUpdates:a.batchedUpdates,unbatchedUpdates:a.unbatchedUpdates,deferredUpdates:a.deferredUpdates,flushSync:a.flushSync,getPublicRootInstance:function(a){a=a.current;if(!a.child)return null;switch(a.child.tag){case 5:return c(a.child.stateNode);default:return a.child.stateNode}},findHostInstance:b,findHostInstanceWithNoPortals:function(a){a=pd(a);return null===a?null:a.stateNode},injectIntoDevTools:function(a){var c=a.findFiberByHostInstance;return Ce(B({},
a,{findHostInstanceByFiber:function(a){return b(a)},findFiberByHostInstance:function(a){return c?c(a):null}}))}}}var mf=Object.freeze({default:lf}),nf=mf&&lf||mf,of=nf["default"]?nf["default"]:nf;function pf(a,b,c){var d=3<arguments.length&&void 0!==arguments[3]?arguments[3]:null;return{$$typeof:Ue,key:null==d?null:""+d,children:a,containerInfo:b,implementation:c}}var qf="object"===typeof performance&&"function"===typeof performance.now,rf=void 0;rf=qf?function(){return performance.now()}:function(){return Date.now()};
var sf=void 0,tf=void 0;
if(l.canUseDOM)if("function"!==typeof requestIdleCallback||"function"!==typeof cancelIdleCallback){var uf=null,vf=!1,wf=-1,xf=!1,yf=0,zf=33,Af=33,Bf;Bf=qf?{didTimeout:!1,timeRemaining:function(){var a=yf-performance.now();return 0<a?a:0}}:{didTimeout:!1,timeRemaining:function(){var a=yf-Date.now();return 0<a?a:0}};var Cf="__reactIdleCallback$"+Math.random().toString(36).slice(2);window.addEventListener("message",function(a){if(a.source===window&&a.data===Cf){vf=!1;a=rf();if(0>=yf-a)if(-1!==wf&&wf<=
a)Bf.didTimeout=!0;else{xf||(xf=!0,requestAnimationFrame(Df));return}else Bf.didTimeout=!1;wf=-1;a=uf;uf=null;null!==a&&a(Bf)}},!1);var Df=function(a){xf=!1;var b=a-yf+Af;b<Af&&zf<Af?(8>b&&(b=8),Af=b<zf?zf:b):zf=b;yf=a+Af;vf||(vf=!0,window.postMessage(Cf,"*"))};sf=function(a,b){uf=a;null!=b&&"number"===typeof b.timeout&&(wf=rf()+b.timeout);xf||(xf=!0,requestAnimationFrame(Df));return 0};tf=function(){uf=null;vf=!1;wf=-1}}else sf=window.requestIdleCallback,tf=window.cancelIdleCallback;else sf=function(a){return setTimeout(function(){a({timeRemaining:function(){return Infinity}})})},
tf=function(a){clearTimeout(a)};var Ef=/^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/,Ff={},Gf={};
function Hf(a){if(Gf.hasOwnProperty(a))return!0;if(Ff.hasOwnProperty(a))return!1;if(Ef.test(a))return Gf[a]=!0;Ff[a]=!0;return!1}
function If(a,b,c){var d=wa(b);if(d&&va(b,c)){var e=d.mutationMethod;e?e(a,c):null==c||d.hasBooleanValue&&!c||d.hasNumericValue&&isNaN(c)||d.hasPositiveNumericValue&&1>c||d.hasOverloadedBooleanValue&&!1===c?Jf(a,b):d.mustUseProperty?a[d.propertyName]=c:(b=d.attributeName,(e=d.attributeNamespace)?a.setAttributeNS(e,b,""+c):d.hasBooleanValue||d.hasOverloadedBooleanValue&&!0===c?a.setAttribute(b,""):a.setAttribute(b,""+c))}else Kf(a,b,va(b,c)?c:null)}
function Kf(a,b,c){Hf(b)&&(null==c?a.removeAttribute(b):a.setAttribute(b,""+c))}function Jf(a,b){var c=wa(b);c?(b=c.mutationMethod)?b(a,void 0):c.mustUseProperty?a[c.propertyName]=c.hasBooleanValue?!1:"":a.removeAttribute(c.attributeName):a.removeAttribute(b)}
function Lf(a,b){var c=b.value,d=b.checked;return B({type:void 0,step:void 0,min:void 0,max:void 0},b,{defaultChecked:void 0,defaultValue:void 0,value:null!=c?c:a._wrapperState.initialValue,checked:null!=d?d:a._wrapperState.initialChecked})}function Mf(a,b){var c=b.defaultValue;a._wrapperState={initialChecked:null!=b.checked?b.checked:b.defaultChecked,initialValue:null!=b.value?b.value:c,controlled:"checkbox"===b.type||"radio"===b.type?null!=b.checked:null!=b.value}}
function Nf(a,b){b=b.checked;null!=b&&If(a,"checked",b)}function Of(a,b){Nf(a,b);var c=b.value;if(null!=c)if(0===c&&""===a.value)a.value="0";else if("number"===b.type){if(b=parseFloat(a.value)||0,c!=b||c==b&&a.value!=c)a.value=""+c}else a.value!==""+c&&(a.value=""+c);else null==b.value&&null!=b.defaultValue&&a.defaultValue!==""+b.defaultValue&&(a.defaultValue=""+b.defaultValue),null==b.checked&&null!=b.defaultChecked&&(a.defaultChecked=!!b.defaultChecked)}
function Pf(a,b){switch(b.type){case "submit":case "reset":break;case "color":case "date":case "datetime":case "datetime-local":case "month":case "time":case "week":a.value="";a.value=a.defaultValue;break;default:a.value=a.value}b=a.name;""!==b&&(a.name="");a.defaultChecked=!a.defaultChecked;a.defaultChecked=!a.defaultChecked;""!==b&&(a.name=b)}function Qf(a){var b="";aa.Children.forEach(a,function(a){null==a||"string"!==typeof a&&"number"!==typeof a||(b+=a)});return b}
function Rf(a,b){a=B({children:void 0},b);if(b=Qf(b.children))a.children=b;return a}function Sf(a,b,c,d){a=a.options;if(b){b={};for(var e=0;e<c.length;e++)b["$"+c[e]]=!0;for(c=0;c<a.length;c++)e=b.hasOwnProperty("$"+a[c].value),a[c].selected!==e&&(a[c].selected=e),e&&d&&(a[c].defaultSelected=!0)}else{c=""+c;b=null;for(e=0;e<a.length;e++){if(a[e].value===c){a[e].selected=!0;d&&(a[e].defaultSelected=!0);return}null!==b||a[e].disabled||(b=a[e])}null!==b&&(b.selected=!0)}}
function Tf(a,b){var c=b.value;a._wrapperState={initialValue:null!=c?c:b.defaultValue,wasMultiple:!!b.multiple}}function Uf(a,b){null!=b.dangerouslySetInnerHTML?E("91"):void 0;return B({},b,{value:void 0,defaultValue:void 0,children:""+a._wrapperState.initialValue})}function Vf(a,b){var c=b.value;null==c&&(c=b.defaultValue,b=b.children,null!=b&&(null!=c?E("92"):void 0,Array.isArray(b)&&(1>=b.length?void 0:E("93"),b=b[0]),c=""+b),null==c&&(c=""));a._wrapperState={initialValue:""+c}}
function Wf(a,b){var c=b.value;null!=c&&(c=""+c,c!==a.value&&(a.value=c),null==b.defaultValue&&(a.defaultValue=c));null!=b.defaultValue&&(a.defaultValue=b.defaultValue)}function Xf(a){var b=a.textContent;b===a._wrapperState.initialValue&&(a.value=b)}var Yf={html:"http://www.w3.org/1999/xhtml",mathml:"http://www.w3.org/1998/Math/MathML",svg:"http://www.w3.org/2000/svg"};
function Zf(a){switch(a){case "svg":return"http://www.w3.org/2000/svg";case "math":return"http://www.w3.org/1998/Math/MathML";default:return"http://www.w3.org/1999/xhtml"}}function $f(a,b){return null==a||"http://www.w3.org/1999/xhtml"===a?Zf(b):"http://www.w3.org/2000/svg"===a&&"foreignObject"===b?"http://www.w3.org/1999/xhtml":a}
var ag=void 0,bg=function(a){return"undefined"!==typeof MSApp&&MSApp.execUnsafeLocalFunction?function(b,c,d,e){MSApp.execUnsafeLocalFunction(function(){return a(b,c,d,e)})}:a}(function(a,b){if(a.namespaceURI!==Yf.svg||"innerHTML"in a)a.innerHTML=b;else{ag=ag||document.createElement("div");ag.innerHTML="\x3csvg\x3e"+b+"\x3c/svg\x3e";for(b=ag.firstChild;a.firstChild;)a.removeChild(a.firstChild);for(;b.firstChild;)a.appendChild(b.firstChild)}});
function cg(a,b){if(b){var c=a.firstChild;if(c&&c===a.lastChild&&3===c.nodeType){c.nodeValue=b;return}}a.textContent=b}
var dg={animationIterationCount:!0,borderImageOutset:!0,borderImageSlice:!0,borderImageWidth:!0,boxFlex:!0,boxFlexGroup:!0,boxOrdinalGroup:!0,columnCount:!0,columns:!0,flex:!0,flexGrow:!0,flexPositive:!0,flexShrink:!0,flexNegative:!0,flexOrder:!0,gridRow:!0,gridRowEnd:!0,gridRowSpan:!0,gridRowStart:!0,gridColumn:!0,gridColumnEnd:!0,gridColumnSpan:!0,gridColumnStart:!0,fontWeight:!0,lineClamp:!0,lineHeight:!0,opacity:!0,order:!0,orphans:!0,tabSize:!0,widows:!0,zIndex:!0,zoom:!0,fillOpacity:!0,floodOpacity:!0,
stopOpacity:!0,strokeDasharray:!0,strokeDashoffset:!0,strokeMiterlimit:!0,strokeOpacity:!0,strokeWidth:!0},eg=["Webkit","ms","Moz","O"];Object.keys(dg).forEach(function(a){eg.forEach(function(b){b=b+a.charAt(0).toUpperCase()+a.substring(1);dg[b]=dg[a]})});
function fg(a,b){a=a.style;for(var c in b)if(b.hasOwnProperty(c)){var d=0===c.indexOf("--");var e=c;var f=b[c];e=null==f||"boolean"===typeof f||""===f?"":d||"number"!==typeof f||0===f||dg.hasOwnProperty(e)&&dg[e]?(""+f).trim():f+"px";"float"===c&&(c="cssFloat");d?a.setProperty(c,e):a[c]=e}}var gg=B({menuitem:!0},{area:!0,base:!0,br:!0,col:!0,embed:!0,hr:!0,img:!0,input:!0,keygen:!0,link:!0,meta:!0,param:!0,source:!0,track:!0,wbr:!0});
function hg(a,b,c){b&&(gg[a]&&(null!=b.children||null!=b.dangerouslySetInnerHTML?E("137",a,c()):void 0),null!=b.dangerouslySetInnerHTML&&(null!=b.children?E("60"):void 0,"object"===typeof b.dangerouslySetInnerHTML&&"__html"in b.dangerouslySetInnerHTML?void 0:E("61")),null!=b.style&&"object"!==typeof b.style?E("62",c()):void 0)}
function ig(a,b){if(-1===a.indexOf("-"))return"string"===typeof b.is;switch(a){case "annotation-xml":case "color-profile":case "font-face":case "font-face-src":case "font-face-uri":case "font-face-format":case "font-face-name":case "missing-glyph":return!1;default:return!0}}var jg=Yf.html,kg=C.thatReturns("");
function lg(a,b){a=9===a.nodeType||11===a.nodeType?a:a.ownerDocument;var c=Hd(a);b=Sa[b];for(var d=0;d<b.length;d++){var e=b[d];c.hasOwnProperty(e)&&c[e]||("topScroll"===e?wd("topScroll","scroll",a):"topFocus"===e||"topBlur"===e?(wd("topFocus","focus",a),wd("topBlur","blur",a),c.topBlur=!0,c.topFocus=!0):"topCancel"===e?(yc("cancel",!0)&&wd("topCancel","cancel",a),c.topCancel=!0):"topClose"===e?(yc("close",!0)&&wd("topClose","close",a),c.topClose=!0):Dd.hasOwnProperty(e)&&U(e,Dd[e],a),c[e]=!0)}}
var mg={topAbort:"abort",topCanPlay:"canplay",topCanPlayThrough:"canplaythrough",topDurationChange:"durationchange",topEmptied:"emptied",topEncrypted:"encrypted",topEnded:"ended",topError:"error",topLoadedData:"loadeddata",topLoadedMetadata:"loadedmetadata",topLoadStart:"loadstart",topPause:"pause",topPlay:"play",topPlaying:"playing",topProgress:"progress",topRateChange:"ratechange",topSeeked:"seeked",topSeeking:"seeking",topStalled:"stalled",topSuspend:"suspend",topTimeUpdate:"timeupdate",topVolumeChange:"volumechange",
topWaiting:"waiting"};function ng(a,b,c,d){c=9===c.nodeType?c:c.ownerDocument;d===jg&&(d=Zf(a));d===jg?"script"===a?(a=c.createElement("div"),a.innerHTML="\x3cscript\x3e\x3c/script\x3e",a=a.removeChild(a.firstChild)):a="string"===typeof b.is?c.createElement(a,{is:b.is}):c.createElement(a):a=c.createElementNS(d,a);return a}function og(a,b){return(9===b.nodeType?b:b.ownerDocument).createTextNode(a)}
function pg(a,b,c,d){var e=ig(b,c);switch(b){case "iframe":case "object":U("topLoad","load",a);var f=c;break;case "video":case "audio":for(f in mg)mg.hasOwnProperty(f)&&U(f,mg[f],a);f=c;break;case "source":U("topError","error",a);f=c;break;case "img":case "image":U("topError","error",a);U("topLoad","load",a);f=c;break;case "form":U("topReset","reset",a);U("topSubmit","submit",a);f=c;break;case "details":U("topToggle","toggle",a);f=c;break;case "input":Mf(a,c);f=Lf(a,c);U("topInvalid","invalid",a);
lg(d,"onChange");break;case "option":f=Rf(a,c);break;case "select":Tf(a,c);f=B({},c,{value:void 0});U("topInvalid","invalid",a);lg(d,"onChange");break;case "textarea":Vf(a,c);f=Uf(a,c);U("topInvalid","invalid",a);lg(d,"onChange");break;default:f=c}hg(b,f,kg);var g=f,h;for(h in g)if(g.hasOwnProperty(h)){var k=g[h];"style"===h?fg(a,k,kg):"dangerouslySetInnerHTML"===h?(k=k?k.__html:void 0,null!=k&&bg(a,k)):"children"===h?"string"===typeof k?("textarea"!==b||""!==k)&&cg(a,k):"number"===typeof k&&cg(a,
""+k):"suppressContentEditableWarning"!==h&&"suppressHydrationWarning"!==h&&"autoFocus"!==h&&(Ra.hasOwnProperty(h)?null!=k&&lg(d,h):e?Kf(a,h,k):null!=k&&If(a,h,k))}switch(b){case "input":Bc(a);Pf(a,c);break;case "textarea":Bc(a);Xf(a,c);break;case "option":null!=c.value&&a.setAttribute("value",c.value);break;case "select":a.multiple=!!c.multiple;b=c.value;null!=b?Sf(a,!!c.multiple,b,!1):null!=c.defaultValue&&Sf(a,!!c.multiple,c.defaultValue,!0);break;default:"function"===typeof f.onClick&&(a.onclick=
C)}}
function sg(a,b,c,d,e){var f=null;switch(b){case "input":c=Lf(a,c);d=Lf(a,d);f=[];break;case "option":c=Rf(a,c);d=Rf(a,d);f=[];break;case "select":c=B({},c,{value:void 0});d=B({},d,{value:void 0});f=[];break;case "textarea":c=Uf(a,c);d=Uf(a,d);f=[];break;default:"function"!==typeof c.onClick&&"function"===typeof d.onClick&&(a.onclick=C)}hg(b,d,kg);var g,h;a=null;for(g in c)if(!d.hasOwnProperty(g)&&c.hasOwnProperty(g)&&null!=c[g])if("style"===g)for(h in b=c[g],b)b.hasOwnProperty(h)&&(a||(a={}),a[h]=
"");else"dangerouslySetInnerHTML"!==g&&"children"!==g&&"suppressContentEditableWarning"!==g&&"suppressHydrationWarning"!==g&&"autoFocus"!==g&&(Ra.hasOwnProperty(g)?f||(f=[]):(f=f||[]).push(g,null));for(g in d){var k=d[g];b=null!=c?c[g]:void 0;if(d.hasOwnProperty(g)&&k!==b&&(null!=k||null!=b))if("style"===g)if(b){for(h in b)!b.hasOwnProperty(h)||k&&k.hasOwnProperty(h)||(a||(a={}),a[h]="");for(h in k)k.hasOwnProperty(h)&&b[h]!==k[h]&&(a||(a={}),a[h]=k[h])}else a||(f||(f=[]),f.push(g,a)),a=k;else"dangerouslySetInnerHTML"===
g?(k=k?k.__html:void 0,b=b?b.__html:void 0,null!=k&&b!==k&&(f=f||[]).push(g,""+k)):"children"===g?b===k||"string"!==typeof k&&"number"!==typeof k||(f=f||[]).push(g,""+k):"suppressContentEditableWarning"!==g&&"suppressHydrationWarning"!==g&&(Ra.hasOwnProperty(g)?(null!=k&&lg(e,g),f||b===k||(f=[])):(f=f||[]).push(g,k))}a&&(f=f||[]).push("style",a);return f}
function tg(a,b,c,d,e){"input"===c&&"radio"===e.type&&null!=e.name&&Nf(a,e);ig(c,d);d=ig(c,e);for(var f=0;f<b.length;f+=2){var g=b[f],h=b[f+1];"style"===g?fg(a,h,kg):"dangerouslySetInnerHTML"===g?bg(a,h):"children"===g?cg(a,h):d?null!=h?Kf(a,g,h):a.removeAttribute(g):null!=h?If(a,g,h):Jf(a,g)}switch(c){case "input":Of(a,e);break;case "textarea":Wf(a,e);break;case "select":a._wrapperState.initialValue=void 0,b=a._wrapperState.wasMultiple,a._wrapperState.wasMultiple=!!e.multiple,c=e.value,null!=c?Sf(a,
!!e.multiple,c,!1):b!==!!e.multiple&&(null!=e.defaultValue?Sf(a,!!e.multiple,e.defaultValue,!0):Sf(a,!!e.multiple,e.multiple?[]:"",!1))}}
function ug(a,b,c,d,e){switch(b){case "iframe":case "object":U("topLoad","load",a);break;case "video":case "audio":for(var f in mg)mg.hasOwnProperty(f)&&U(f,mg[f],a);break;case "source":U("topError","error",a);break;case "img":case "image":U("topError","error",a);U("topLoad","load",a);break;case "form":U("topReset","reset",a);U("topSubmit","submit",a);break;case "details":U("topToggle","toggle",a);break;case "input":Mf(a,c);U("topInvalid","invalid",a);lg(e,"onChange");break;case "select":Tf(a,c);
U("topInvalid","invalid",a);lg(e,"onChange");break;case "textarea":Vf(a,c),U("topInvalid","invalid",a),lg(e,"onChange")}hg(b,c,kg);d=null;for(var g in c)c.hasOwnProperty(g)&&(f=c[g],"children"===g?"string"===typeof f?a.textContent!==f&&(d=["children",f]):"number"===typeof f&&a.textContent!==""+f&&(d=["children",""+f]):Ra.hasOwnProperty(g)&&null!=f&&lg(e,g));switch(b){case "input":Bc(a);Pf(a,c);break;case "textarea":Bc(a);Xf(a,c);break;case "select":case "option":break;default:"function"===typeof c.onClick&&
(a.onclick=C)}return d}function vg(a,b){return a.nodeValue!==b}
var wg=Object.freeze({createElement:ng,createTextNode:og,setInitialProperties:pg,diffProperties:sg,updateProperties:tg,diffHydratedProperties:ug,diffHydratedText:vg,warnForUnmatchedText:function(){},warnForDeletedHydratableElement:function(){},warnForDeletedHydratableText:function(){},warnForInsertedHydratedElement:function(){},warnForInsertedHydratedText:function(){},restoreControlledState:function(a,b,c){switch(b){case "input":Of(a,c);b=c.name;if("radio"===c.type&&null!=b){for(c=a;c.parentNode;)c=
c.parentNode;c=c.querySelectorAll("input[name\x3d"+JSON.stringify(""+b)+'][type\x3d"radio"]');for(b=0;b<c.length;b++){var d=c[b];if(d!==a&&d.form===a.form){var e=rb(d);e?void 0:E("90");Cc(d);Of(d,e)}}}break;case "textarea":Wf(a,c);break;case "select":b=c.value,null!=b&&Sf(a,!!c.multiple,b,!1)}}});nc.injectFiberControlledHostComponent(wg);var xg=null,Mg=null;function Ng(a){return!(!a||1!==a.nodeType&&9!==a.nodeType&&11!==a.nodeType&&(8!==a.nodeType||" react-mount-point-unstable "!==a.nodeValue))}
function Og(a){a=a?9===a.nodeType?a.documentElement:a.firstChild:null;return!(!a||1!==a.nodeType||!a.hasAttribute("data-reactroot"))}
var Z=of({getRootHostContext:function(a){var b=a.nodeType;switch(b){case 9:case 11:a=(a=a.documentElement)?a.namespaceURI:$f(null,"");break;default:b=8===b?a.parentNode:a,a=b.namespaceURI||null,b=b.tagName,a=$f(a,b)}return a},getChildHostContext:function(a,b){return $f(a,b)},getPublicInstance:function(a){return a},prepareForCommit:function(){xg=td;var a=da();if(Kd(a)){if("selectionStart"in a)var b={start:a.selectionStart,end:a.selectionEnd};else a:{var c=window.getSelection&&window.getSelection();
if(c&&0!==c.rangeCount){b=c.anchorNode;var d=c.anchorOffset,e=c.focusNode;c=c.focusOffset;try{b.nodeType,e.nodeType}catch(z){b=null;break a}var f=0,g=-1,h=-1,k=0,q=0,v=a,y=null;b:for(;;){for(var u;;){v!==b||0!==d&&3!==v.nodeType||(g=f+d);v!==e||0!==c&&3!==v.nodeType||(h=f+c);3===v.nodeType&&(f+=v.nodeValue.length);if(null===(u=v.firstChild))break;y=v;v=u}for(;;){if(v===a)break b;y===b&&++k===d&&(g=f);y===e&&++q===c&&(h=f);if(null!==(u=v.nextSibling))break;v=y;y=v.parentNode}v=u}b=-1===g||-1===h?null:
{start:g,end:h}}else b=null}b=b||{start:0,end:0}}else b=null;Mg={focusedElem:a,selectionRange:b};ud(!1)},resetAfterCommit:function(){var a=Mg,b=da(),c=a.focusedElem,d=a.selectionRange;if(b!==c&&fa(document.documentElement,c)){if(Kd(c))if(b=d.start,a=d.end,void 0===a&&(a=b),"selectionStart"in c)c.selectionStart=b,c.selectionEnd=Math.min(a,c.value.length);else if(window.getSelection){b=window.getSelection();var e=c[Eb()].length;a=Math.min(d.start,e);d=void 0===d.end?a:Math.min(d.end,e);!b.extend&&a>
d&&(e=d,d=a,a=e);e=Jd(c,a);var f=Jd(c,d);if(e&&f&&(1!==b.rangeCount||b.anchorNode!==e.node||b.anchorOffset!==e.offset||b.focusNode!==f.node||b.focusOffset!==f.offset)){var g=document.createRange();g.setStart(e.node,e.offset);b.removeAllRanges();a>d?(b.addRange(g),b.extend(f.node,f.offset)):(g.setEnd(f.node,f.offset),b.addRange(g))}}b=[];for(a=c;a=a.parentNode;)1===a.nodeType&&b.push({element:a,left:a.scrollLeft,top:a.scrollTop});ia(c);for(c=0;c<b.length;c++)a=b[c],a.element.scrollLeft=a.left,a.element.scrollTop=
a.top}Mg=null;ud(xg);xg=null},createInstance:function(a,b,c,d,e){a=ng(a,b,c,d);a[Q]=e;a[ob]=b;return a},appendInitialChild:function(a,b){a.appendChild(b)},finalizeInitialChildren:function(a,b,c,d){pg(a,b,c,d);a:{switch(b){case "button":case "input":case "select":case "textarea":a=!!c.autoFocus;break a}a=!1}return a},prepareUpdate:function(a,b,c,d,e){return sg(a,b,c,d,e)},shouldSetTextContent:function(a,b){return"textarea"===a||"string"===typeof b.children||"number"===typeof b.children||"object"===
typeof b.dangerouslySetInnerHTML&&null!==b.dangerouslySetInnerHTML&&"string"===typeof b.dangerouslySetInnerHTML.__html},shouldDeprioritizeSubtree:function(a,b){return!!b.hidden},createTextInstance:function(a,b,c,d){a=og(a,b);a[Q]=d;return a},now:rf,mutation:{commitMount:function(a){a.focus()},commitUpdate:function(a,b,c,d,e){a[ob]=e;tg(a,b,c,d,e)},resetTextContent:function(a){a.textContent=""},commitTextUpdate:function(a,b,c){a.nodeValue=c},appendChild:function(a,b){a.appendChild(b)},appendChildToContainer:function(a,
b){8===a.nodeType?a.parentNode.insertBefore(b,a):a.appendChild(b)},insertBefore:function(a,b,c){a.insertBefore(b,c)},insertInContainerBefore:function(a,b,c){8===a.nodeType?a.parentNode.insertBefore(b,c):a.insertBefore(b,c)},removeChild:function(a,b){a.removeChild(b)},removeChildFromContainer:function(a,b){8===a.nodeType?a.parentNode.removeChild(b):a.removeChild(b)}},hydration:{canHydrateInstance:function(a,b){return 1!==a.nodeType||b.toLowerCase()!==a.nodeName.toLowerCase()?null:a},canHydrateTextInstance:function(a,
b){return""===b||3!==a.nodeType?null:a},getNextHydratableSibling:function(a){for(a=a.nextSibling;a&&1!==a.nodeType&&3!==a.nodeType;)a=a.nextSibling;return a},getFirstHydratableChild:function(a){for(a=a.firstChild;a&&1!==a.nodeType&&3!==a.nodeType;)a=a.nextSibling;return a},hydrateInstance:function(a,b,c,d,e,f){a[Q]=f;a[ob]=c;return ug(a,b,c,e,d)},hydrateTextInstance:function(a,b,c){a[Q]=c;return vg(a,b)},didNotMatchHydratedContainerTextInstance:function(){},didNotMatchHydratedTextInstance:function(){},
didNotHydrateContainerInstance:function(){},didNotHydrateInstance:function(){},didNotFindHydratableContainerInstance:function(){},didNotFindHydratableContainerTextInstance:function(){},didNotFindHydratableInstance:function(){},didNotFindHydratableTextInstance:function(){}},scheduleDeferredCallback:sf,cancelDeferredCallback:tf,useSyncScheduling:!0});rc=Z.batchedUpdates;
function Pg(a,b,c,d,e){Ng(c)?void 0:E("200");var f=c._reactRootContainer;if(f)Z.updateContainer(b,f,a,e);else{d=d||Og(c);if(!d)for(f=void 0;f=c.lastChild;)c.removeChild(f);var g=Z.createContainer(c,d);f=c._reactRootContainer=g;Z.unbatchedUpdates(function(){Z.updateContainer(b,g,a,e)})}return Z.getPublicRootInstance(f)}function Qg(a,b){var c=2<arguments.length&&void 0!==arguments[2]?arguments[2]:null;Ng(b)?void 0:E("200");return pf(a,b,null,c)}
function Rg(a,b){this._reactRootContainer=Z.createContainer(a,b)}Rg.prototype.render=function(a,b){Z.updateContainer(a,this._reactRootContainer,null,b)};Rg.prototype.unmount=function(a){Z.updateContainer(null,this._reactRootContainer,null,a)};
var Sg={createPortal:Qg,findDOMNode:function(a){if(null==a)return null;if(1===a.nodeType)return a;var b=a._reactInternalFiber;if(b)return Z.findHostInstance(b);"function"===typeof a.render?E("188"):E("213",Object.keys(a))},hydrate:function(a,b,c){return Pg(null,a,b,!0,c)},render:function(a,b,c){return Pg(null,a,b,!1,c)},unstable_renderSubtreeIntoContainer:function(a,b,c,d){null==a||void 0===a._reactInternalFiber?E("38"):void 0;return Pg(a,b,c,!1,d)},unmountComponentAtNode:function(a){Ng(a)?void 0:
E("40");return a._reactRootContainer?(Z.unbatchedUpdates(function(){Pg(null,null,a,!1,function(){a._reactRootContainer=null})}),!0):!1},unstable_createPortal:Qg,unstable_batchedUpdates:tc,unstable_deferredUpdates:Z.deferredUpdates,flushSync:Z.flushSync,__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED:{EventPluginHub:mb,EventPluginRegistry:Va,EventPropagators:Cb,ReactControlledComponent:qc,ReactDOMComponentTree:sb,ReactDOMEventListener:xd}};
Z.injectIntoDevTools({findFiberByHostInstance:pb,bundleType:0,version:"16.2.0",rendererPackageName:"react-dom"});var Tg=Object.freeze({default:Sg}),Ug=Tg&&Sg||Tg;module.exports=Ug["default"]?Ug["default"]:Ug;


/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

/**
 * Simple, lightweight module assisting with the detection and context of
 * Worker. Helps avoid circular dependencies and allows code to reason about
 * whether or not they are in a Worker, even if they never include the main
 * `ReactWorker` dependency.
 */
var ExecutionEnvironment = {

  canUseDOM: canUseDOM,

  canUseWorkers: typeof Worker !== 'undefined',

  canUseEventListeners: canUseDOM && !!(window.addEventListener || window.attachEvent),

  canUseViewport: canUseDOM && !!window.screen,

  isInWorker: !canUseDOM // For now, this is true - might change in the future.

};

module.exports = ExecutionEnvironment;

/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

var emptyFunction = __webpack_require__(5);

/**
 * Upstream version of event listener. Does not take into account specific
 * nature of platform.
 */
var EventListener = {
  /**
   * Listen to DOM events during the bubble phase.
   *
   * @param {DOMEventTarget} target DOM element to register listener on.
   * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
   * @param {function} callback Callback function.
   * @return {object} Object with a `remove` method.
   */
  listen: function listen(target, eventType, callback) {
    if (target.addEventListener) {
      target.addEventListener(eventType, callback, false);
      return {
        remove: function remove() {
          target.removeEventListener(eventType, callback, false);
        }
      };
    } else if (target.attachEvent) {
      target.attachEvent('on' + eventType, callback);
      return {
        remove: function remove() {
          target.detachEvent('on' + eventType, callback);
        }
      };
    }
  },

  /**
   * Listen to DOM events during the capture phase.
   *
   * @param {DOMEventTarget} target DOM element to register listener on.
   * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
   * @param {function} callback Callback function.
   * @return {object} Object with a `remove` method.
   */
  capture: function capture(target, eventType, callback) {
    if (target.addEventListener) {
      target.addEventListener(eventType, callback, true);
      return {
        remove: function remove() {
          target.removeEventListener(eventType, callback, true);
        }
      };
    } else {
      if (false) {
        console.error('Attempted to listen to events during the capture phase on a ' + 'browser that does not support the capture phase. Your application ' + 'will not receive some events.');
      }
      return {
        remove: emptyFunction
      };
    }
  },

  registerDefault: function registerDefault() {}
};

module.exports = EventListener;

/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

/* eslint-disable fb-www/typeof-undefined */

/**
 * Same as document.activeElement but wraps in a try-catch block. In IE it is
 * not safe to call document.activeElement if there is nothing focused.
 *
 * The activeElement will be null only if the document or document body is not
 * yet defined.
 *
 * @param {?DOMDocument} doc Defaults to current document.
 * @return {?DOMElement}
 */
function getActiveElement(doc) /*?DOMElement*/{
  doc = doc || (typeof document !== 'undefined' ? document : undefined);
  if (typeof doc === 'undefined') {
    return null;
  }
  try {
    return doc.activeElement || doc.body;
  } catch (e) {
    return doc.body;
  }
}

module.exports = getActiveElement;

/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 * 
 */

/*eslint-disable no-self-compare */



var hasOwnProperty = Object.prototype.hasOwnProperty;

/**
 * inlined Object.is polyfill to avoid requiring consumers ship their own
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
 */
function is(x, y) {
  // SameValue algorithm
  if (x === y) {
    // Steps 1-5, 7-10
    // Steps 6.b-6.e: +0 != -0
    // Added the nonzero y check to make Flow happy, but it is redundant
    return x !== 0 || y !== 0 || 1 / x === 1 / y;
  } else {
    // Step 6.a: NaN == NaN
    return x !== x && y !== y;
  }
}

/**
 * Performs equality by iterating through keys on an object and returning false
 * when any key has values which are not strictly equal between the arguments.
 * Returns true when the values of all keys are strictly equal.
 */
function shallowEqual(objA, objB) {
  if (is(objA, objB)) {
    return true;
  }

  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) {
    return false;
  }

  // Test for A's keys different from B.
  for (var i = 0; i < keysA.length; i++) {
    if (!hasOwnProperty.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
      return false;
    }
  }

  return true;
}

module.exports = shallowEqual;

/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

var isTextNode = __webpack_require__(37);

/*eslint-disable no-bitwise */

/**
 * Checks if a given DOM node contains or is another DOM node.
 */
function containsNode(outerNode, innerNode) {
  if (!outerNode || !innerNode) {
    return false;
  } else if (outerNode === innerNode) {
    return true;
  } else if (isTextNode(outerNode)) {
    return false;
  } else if (isTextNode(innerNode)) {
    return containsNode(outerNode, innerNode.parentNode);
  } else if ('contains' in outerNode) {
    return outerNode.contains(innerNode);
  } else if (outerNode.compareDocumentPosition) {
    return !!(outerNode.compareDocumentPosition(innerNode) & 16);
  } else {
    return false;
  }
}

module.exports = containsNode;

/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

var isNode = __webpack_require__(38);

/**
 * @param {*} object The object to check.
 * @return {boolean} Whether or not the object is a DOM text node.
 */
function isTextNode(object) {
  return isNode(object) && object.nodeType == 3;
}

module.exports = isTextNode;

/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

/**
 * @param {*} object The object to check.
 * @return {boolean} Whether or not the object is a DOM node.
 */
function isNode(object) {
  var doc = object ? object.ownerDocument || object : document;
  var defaultView = doc.defaultView || window;
  return !!(object && (typeof defaultView.Node === 'function' ? object instanceof defaultView.Node : typeof object === 'object' && typeof object.nodeType === 'number' && typeof object.nodeName === 'string'));
}

module.exports = isNode;

/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * @param {DOMElement} node input/textarea to focus
 */

function focusNode(node) {
  // IE8 can throw "Can't move focus to the control because it is invisible,
  // not enabled, or of a type that does not accept the focus." for all kinds of
  // reasons that are too expensive and fragile to test.
  try {
    node.focus();
  } catch (e) {}
}

module.exports = focusNode;

/***/ }),
/* 40 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 41 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 42 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_MainArea__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_NavigationBar__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_sidebar__ = __webpack_require__(173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_sidebar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_sidebar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_reactstrap__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lib_monsters_index__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__lib_scenarioList__ = __webpack_require__(175);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// console.log(SCENARIO_DEFINITIONS);
var App=function(_Component){_inherits(App,_Component);function App(props){_classCallCheck(this,App);var _this=_possibleConstructorReturn(this,(App.__proto__||Object.getPrototypeOf(App)).call(this,props));_this.onSetSidebarOpen=function(open){_this.setState({sidebarOpen:open});};_this.toggleSidebar=function(){_this.setState({sidebarOpen:!_this.state.sidebarOpen});};_this.setScenarioLevel=function(level){_this.setState({scenarioLevelValue:level});};_this.setScenarioNumber=function(scenarioNumber){_this.setState({scenarioNumberValue:scenarioNumber});};_this.loadScenario=function(){_this.setState({scenarioLevel:_this.state.scenarioLevelValue,scenarioMonsterObjs:[]},function(){var scenarioEntry=__WEBPACK_IMPORTED_MODULE_6__lib_scenarioList__["a" /* SCENARIO_DEFINITIONS */][_this.state.scenarioNumberValue-1];// console.log(scenarioEntry);
var scenarioName=scenarioEntry.name;var scenarioMonsters=scenarioEntry.decks.map(function(deckItem){return deckItem.name;});console.log("scenario name: "+scenarioName);console.log("scenario monsters: "+scenarioMonsters);var newScenarioMonsterObj=[];scenarioMonsters.map(function(monster){newScenarioMonsterObj.push({monsterType:monster,monsterLevel:_this.state.scenarioLevel});return null;});_this.setState({scenarioMonsterObjs:newScenarioMonsterObj,scenarioLoaded:true,scenarioName:scenarioName});});};_this.addMonster=function(monster){var level=arguments.length>1&&arguments[1]!==undefined?arguments[1]:_this.state.scenarioLevel;var index=_this.state.scenarioMonsterObjs.findIndex(function(monsterelement){return monsterelement.monsterType===monster;});if(_this.state.scenarioLoaded===false){_this.setState({scenarioLoaded:true});}//if new monster, add
if(index===-1){var newScenarioMonsterObj={monsterType:monster,monsterLevel:level};_this.setState({scenarioMonsterObjs:[].concat(_toConsumableArray(_this.state.scenarioMonsterObjs),[newScenarioMonsterObj])});console.log("added monster");}else{var _index=_this.state.scenarioMonsterObjs.findIndex(function(monsterelement){return monsterelement.monsterType===monster;});var newScenarioMonsterObjs=_this.state.scenarioMonsterObjs;newScenarioMonsterObjs.splice(_index,1);_this.setState({scenarioMonsterObjs:newScenarioMonsterObjs},function(){var newScenarioMonsterObjs2=_this.state.scenarioMonsterObjs;newScenarioMonsterObjs2.push({monsterType:monster,monsterLevel:level});_this.setState({scenarioMonsterObjs:newScenarioMonsterObjs2});console.log("updated monster level");});}};_this.removeMonster=function(monster){var index=_this.state.scenarioMonsterObjs.findIndex(function(monsterelement){return monsterelement.monsterType===monster;});var newScenarioMonsterObjs=_this.state.scenarioMonsterObjs;newScenarioMonsterObjs.splice(index,1);_this.setState({scenarioMonsterObjs:newScenarioMonsterObjs});console.log("removed monster");};_this.state={sidebarOpen:false,scenarioLevel:0,scenarioNumber:1,scenarioLevelValue:0,scenarioNumberValue:1,scenarioName:"",scenarioLoaded:false,scenarioMonsterObjs:[],// sidebar
scenarioNumberValid:true,monsterList:Object.keys(__WEBPACK_IMPORTED_MODULE_5__lib_monsters_index__["b" /* MONSTERS */]),selectedMonster:"",selectedMonsterLevel:0};_this.onSetSidebarOpen=_this.onSetSidebarOpen.bind(_this);_this.toggleSidebar=_this.toggleSidebar.bind(_this);_this.setScenarioLevel=_this.setScenarioLevel.bind(_this);_this.setScenarioNumber=_this.setScenarioNumber.bind(_this);_this.loadScenario=_this.loadScenario.bind(_this);_this.addMonster=_this.addMonster.bind(_this);_this.removeMonster=_this.removeMonster.bind(_this);// sidebar
_this.handleScenarioLevelChange=_this.handleScenarioLevelChange.bind(_this);_this.handleScenarioNumberChange=_this.handleScenarioNumberChange.bind(_this);_this.handleMonsterSelectChange=_this.handleMonsterSelectChange.bind(_this);_this.handleSelectMonsterLevelChange=_this.handleSelectMonsterLevelChange.bind(_this);return _this;}//sidebar
_createClass(App,[{key:'handleScenarioLevelChange',value:function handleScenarioLevelChange(event){this.setState({scenarioLevelValue:event.target.value});this.setScenarioLevel(event.target.value);}},{key:'handleScenarioNumberChange',value:function handleScenarioNumberChange(event){if(event.target.value>=1&&event.target.value<=95){this.setState({scenarioNumberValue:event.target.value,scenarioNumberValid:true});this.setScenarioNumber(event.target.value);}else{this.setState({scenarioNumberValid:false});}}},{key:'handleMonsterSelectChange',value:function handleMonsterSelectChange(event){this.setState({selectedMonster:event.target.value});}},{key:'handleSelectMonsterLevelChange',value:function handleSelectMonsterLevelChange(event){this.setState({selectedMonsterLevel:event.target.value});}},{key:'render',value:function render(){var _this2=this;var sidebarContent=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_reactstrap__["g" /* Container */],{style:{backgroundColor:"#FFFFFF",height:"100%",minHeight:"100vh",paddingTop:"20px"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',{style:{fontFamily:"PirataOne"}},'Options'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_reactstrap__["j" /* FormGroup */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_reactstrap__["m" /* Label */],{'for':'scenarioNumberInput',style:{fontFamily:"HighTower"}},'Scenario Number'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_reactstrap__["k" /* Input */],{placeholder:'Scenario Number',id:'scenarioNumberInput',type:'number',onChange:this.handleScenarioNumberChange,valid:this.state.scenarioNumberValid}),this.state.scenarioNumberValid===false?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_reactstrap__["i" /* FormFeedback */],null,'Invalid Scenario Number'):null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_reactstrap__["m" /* Label */],{'for':'scenarioLevelInput',style:{fontFamily:"HighTower"}},'Scenario Level'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_reactstrap__["k" /* Input */],{id:'scenarioLevelInput',type:'select',defaultValue:'0',onChange:this.handleScenarioLevelChange},[0,1,2,3,4,5,6,7].map(function(number){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{key:number,value:number},number);})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_reactstrap__["a" /* Button */],{color:'primary',size:'medium',onClick:this.loadScenario},'Load Scenario')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',{style:{fontFamily:"PirataOne"}},'Add Monster'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_reactstrap__["j" /* FormGroup */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_reactstrap__["m" /* Label */],{'for':'selectMonster',style:{fontFamily:"HighTower"}},'Select Monster'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_reactstrap__["k" /* Input */],{type:'select',id:'selectMonster',onChange:this.handleMonsterSelectChange,defaultValue:''},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'',disabled:true},'Monster Type'),this.state.monsterList.map(function(monster){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{key:monster,value:monster},monster);}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_reactstrap__["h" /* Form */],{inline:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_reactstrap__["j" /* FormGroup */],{className:'mb-2 mr-sm-2 mb-sm-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_reactstrap__["m" /* Label */],{'for':'selectMonsterLevel',style:{fontFamily:"PirataOne"},className:'mr-sm-2'},'Monster Level: '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_reactstrap__["k" /* Input */],{type:'select',id:'selectMonsterLevel',onChange:this.handleSelectMonsterLevelChange,defaultValue:this.state.scenarioLevelValue},[0,1,2,3,4,5,6,7].map(function(number){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{key:number,value:number},number);})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_reactstrap__["a" /* Button */],{color:'primary',size:'medium',onClick:function onClick(){_this2.addMonster(_this2.state.selectedMonster,_this2.state.selectedMonsterLevel);}},'Add Monster')));return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_sidebar___default.a,{sidebar:sidebarContent,open:this.state.sidebarOpen,onSetOpen:this.onSetSidebarOpen,children:'',style:{padding:"5px"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_NavigationBar__["a" /* default */],{toggleSidebar:this.toggleSidebar,scenarioLoaded:this.state.scenarioLoaded,scenarioLevel:this.state.scenarioLevel,scenarioNumber:this.state.scenarioNumber,scenarioName:this.state.scenarioName}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__components_MainArea__["a" /* default */],{toggleSidebar:this.toggleSidebar,scenarioLoaded:this.state.scenarioLoaded,scenarioLevel:this.state.scenarioLevel,scenarioNumber:this.state.scenarioNumber,scenarioName:this.state.scenarioName,monstersObjList:this.state.scenarioMonsterObjs,removeMonster:this.removeMonster})));}}]);return App;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (App);

/***/ }),
/* 43 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reactstrap__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MainArea_css__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MainArea_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__MainArea_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__MonsterContainer__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__BossContainer__ = __webpack_require__(171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__MonsterContainer_css__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__MonsterContainer_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__MonsterContainer_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// import {MONSTERS, BOSS_STATS} from '../lib/monsters/index';
// import {SCENARIO_DEFINITIONS} from '../lib/scenarioList';
// console.log(MONSTERS);
// console.log(BOSS_STATS);
// console.log(BOSS_STATS["The Colorless"][3](4));
// console.log(MONSTERS["Harrower Infester"].stats[5].elite)
// console.log(SCENARIO_DEFINITIONS);
var MainArea=function(_Component){_inherits(MainArea,_Component);function MainArea(){_classCallCheck(this,MainArea);return _possibleConstructorReturn(this,(MainArea.__proto__||Object.getPrototypeOf(MainArea)).apply(this,arguments));}_createClass(MainArea,[{key:'render',value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{paddingTop:"10px"}},!this.props.scenarioLoaded?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["g" /* Container */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["l" /* Jumbotron */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h1',{className:'display-3',style:{fontFamily:"PirataOne"}},'Gloomhaven Monster Tracker'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'lead',style:{fontFamily:"HighTower"}},'This app replaces the monster stat cards and damage/status tokens for the monsters.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr',{className:'my-2'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{style:{fontFamily:"HighTower"}},'Load a scenario, or add monsters to get started!'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'lead'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["a" /* Button */],{color:'primary',onClick:this.props.toggleSidebar},'Open Menu')))):null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["g" /* Container */],{fluid:true},this.props.monstersObjList!=null?this.props.monstersObjList.map(function(monster){if(monster.monsterType.includes("Boss")===false){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["y" /* Row */],{key:monster.monsterType},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["e" /* Col */],{md:'12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__MonsterContainer__["a" /* default */],{monsterType:monster.monsterType,level:monster.monsterLevel,removeMonster:_this2.props.removeMonster})));}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["y" /* Row */],{key:monster.monsterType.replace("Boss: ","")},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["e" /* Col */],{md:'12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__BossContainer__["a" /* default */],{monsterType:monster.monsterType.replace("Boss: ",""),level:monster.monsterLevel,removeMonster:_this2.props.removeMonster})));}}):null));}}]);return MainArea;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (MainArea);

/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var emptyFunction = __webpack_require__(5);
var invariant = __webpack_require__(45);
var ReactPropTypesSecret = __webpack_require__(46);

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    invariant(
      false,
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim
  };

  ReactPropTypes.checkPropTypes = emptyFunction;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var validateFormat = function validateFormat(format) {};

if (false) {
  validateFormat = function validateFormat(format) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  };
}

function invariant(condition, format, a, b, c, d, e, f) {
  validateFormat(format);

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(format.replace(/%s/g, function () {
        return args[argIndex++];
      }));
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
}

module.exports = invariant;

/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2016 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;

	function classNames () {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg)) {
				classes.push(classNames.apply(null, arg));
			} else if (argType === 'object') {
				for (var key in arg) {
					if (hasOwn.call(arg, key) && arg[key]) {
						classes.push(key);
					}
				}
			}
		}

		return classes.join(' ');
	}

	if (typeof module !== 'undefined' && module.exports) {
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
			return classNames;
		}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {
		window.classNames = classNames;
	}
}());


/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 * Lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright JS Foundation and other contributors <https://js.foundation/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    nullTag = '[object Null]',
    proxyTag = '[object Proxy]',
    undefinedTag = '[object Undefined]';

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var Symbol = root.Symbol,
    symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? getRawTag(value)
    : objectToString(value);
}

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  if (!isObject(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = baseGetTag(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

module.exports = isFunction;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(7)))

/***/ }),
/* 49 */
/***/ (function(module, exports) {

/**
 * lodash 3.0.2 (Custom Build) <https://lodash.com/>
 * Build: `lodash modern modularize exports="npm" -o ./`
 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */

/**
 * Checks if `value` is the [language type](https://es5.github.io/#x8) of `Object`.
 * (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(1);
 * // => false
 */
function isObject(value) {
  // Avoid a V8 JIT bug in Chrome 19-20.
  // See https://code.google.com/p/v8/issues/detail?id=2291 for more details.
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

module.exports = isObject;


/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Arrow = exports.Popper = exports.Target = exports.Manager = undefined;

var _Manager2 = __webpack_require__(51);

var _Manager3 = _interopRequireDefault(_Manager2);

var _Target2 = __webpack_require__(52);

var _Target3 = _interopRequireDefault(_Target2);

var _Popper2 = __webpack_require__(53);

var _Popper3 = _interopRequireDefault(_Popper2);

var _Arrow2 = __webpack_require__(55);

var _Arrow3 = _interopRequireDefault(_Arrow2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.Manager = _Manager3.default;
exports.Target = _Target3.default;
exports.Popper = _Popper3.default;
exports.Arrow = _Arrow3.default;

/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Manager = function (_Component) {
  _inherits(Manager, _Component);

  function Manager() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Manager);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Manager.__proto__ || Object.getPrototypeOf(Manager)).call.apply(_ref, [this].concat(args))), _this), _this._setTargetNode = function (node) {
      _this._targetNode = node;
    }, _this._getTargetNode = function () {
      return _this._targetNode;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Manager, [{
    key: 'getChildContext',
    value: function getChildContext() {
      return {
        popperManager: {
          setTargetNode: this._setTargetNode,
          getTargetNode: this._getTargetNode
        }
      };
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          tag = _props.tag,
          children = _props.children,
          restProps = _objectWithoutProperties(_props, ['tag', 'children']);

      if (tag !== false) {
        return (0, _react.createElement)(tag, restProps, children);
      } else {
        return children;
      }
    }
  }]);

  return Manager;
}(_react.Component);

Manager.childContextTypes = {
  popperManager: _propTypes2.default.object.isRequired
};
Manager.propTypes = {
  tag: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.bool])
};
Manager.defaultProps = {
  tag: 'div'
};
exports.default = Manager;

/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var Target = function Target(props, context) {
  var _props$component = props.component,
      component = _props$component === undefined ? 'div' : _props$component,
      innerRef = props.innerRef,
      children = props.children,
      restProps = _objectWithoutProperties(props, ['component', 'innerRef', 'children']);

  var popperManager = context.popperManager;

  var targetRef = function targetRef(node) {
    popperManager.setTargetNode(node);
    if (typeof innerRef === 'function') {
      innerRef(node);
    }
  };

  if (typeof children === 'function') {
    var targetProps = { ref: targetRef };
    return children({ targetProps: targetProps, restProps: restProps });
  }

  var componentProps = _extends({}, restProps);

  if (typeof component === 'string') {
    componentProps.ref = targetRef;
  } else {
    componentProps.innerRef = targetRef;
  }

  return (0, _react.createElement)(component, componentProps, children);
};

Target.contextTypes = {
  popperManager: _propTypes2.default.object.isRequired
};

Target.propTypes = {
  component: _propTypes2.default.oneOfType([_propTypes2.default.node, _propTypes2.default.func]),
  innerRef: _propTypes2.default.func,
  children: _propTypes2.default.oneOfType([_propTypes2.default.node, _propTypes2.default.func])
};

exports.default = Target;

/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _popper = __webpack_require__(54);

var _popper2 = _interopRequireDefault(_popper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Popper = function (_Component) {
  _inherits(Popper, _Component);

  function Popper() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Popper);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Popper.__proto__ || Object.getPrototypeOf(Popper)).call.apply(_ref, [this].concat(args))), _this), _this.state = {}, _this._setArrowNode = function (node) {
      _this._arrowNode = node;
    }, _this._getTargetNode = function () {
      return _this.context.popperManager.getTargetNode();
    }, _this._getOffsets = function (data) {
      return Object.keys(data.offsets).map(function (key) {
        return data.offsets[key];
      });
    }, _this._isDataDirty = function (data) {
      if (_this.state.data) {
        return JSON.stringify(_this._getOffsets(_this.state.data)) !== JSON.stringify(_this._getOffsets(data));
      } else {
        return true;
      }
    }, _this._updateStateModifier = {
      enabled: true,
      order: 900,
      fn: function fn(data) {
        if (_this._isDataDirty(data)) {
          _this.setState({ data: data });
        }
        return data;
      }
    }, _this._getPopperStyle = function () {
      var data = _this.state.data;

      // If Popper isn't instantiated, hide the popperElement
      // to avoid flash of unstyled content

      if (!data) {
        return {
          position: 'absolute',
          pointerEvents: 'none',
          opacity: 0
        };
      }

      var _data$offsets$popper = data.offsets.popper,
          top = _data$offsets$popper.top,
          left = _data$offsets$popper.left,
          position = _data$offsets$popper.position;


      return _extends({
        position: position
      }, data.styles);
    }, _this._getPopperPlacement = function () {
      return _this.state.data ? _this.state.data.placement : undefined;
    }, _this._getPopperHide = function () {
      return !!_this.state.data && _this.state.data.hide ? '' : undefined;
    }, _this._getArrowStyle = function () {
      if (!_this.state.data || !_this.state.data.offsets.arrow) {
        return {};
      } else {
        var _this$state$data$offs = _this.state.data.offsets.arrow,
            top = _this$state$data$offs.top,
            left = _this$state$data$offs.left;

        return { top: top, left: left };
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Popper, [{
    key: 'getChildContext',
    value: function getChildContext() {
      return {
        popper: {
          setArrowNode: this._setArrowNode,
          getArrowStyle: this._getArrowStyle
        }
      };
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(lastProps) {
      if (lastProps.placement !== this.props.placement || lastProps.eventsEnabled !== this.props.eventsEnabled) {
        this._destroyPopper();
        this._createPopper();
      }

      if (lastProps.children !== this.props.children) {
        this._popper.scheduleUpdate();
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this._destroyPopper();
    }
  }, {
    key: '_createPopper',
    value: function _createPopper() {
      var _props = this.props,
          placement = _props.placement,
          eventsEnabled = _props.eventsEnabled;

      var modifiers = _extends({}, this.props.modifiers, {
        applyStyle: { enabled: false },
        updateState: this._updateStateModifier
      });

      if (this._arrowNode) {
        modifiers.arrow = {
          element: this._arrowNode
        };
      }

      this._popper = new _popper2.default(this._getTargetNode(), this._node, {
        placement: placement,
        eventsEnabled: eventsEnabled,
        modifiers: modifiers
      });

      // schedule an update to make sure everything gets positioned correctly
      // after being instantiated
      this._popper.scheduleUpdate();
    }
  }, {
    key: '_destroyPopper',
    value: function _destroyPopper() {
      if (this._popper) {
        this._popper.destroy();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props2 = this.props,
          component = _props2.component,
          innerRef = _props2.innerRef,
          placement = _props2.placement,
          eventsEnabled = _props2.eventsEnabled,
          modifiers = _props2.modifiers,
          children = _props2.children,
          restProps = _objectWithoutProperties(_props2, ['component', 'innerRef', 'placement', 'eventsEnabled', 'modifiers', 'children']);

      var popperRef = function popperRef(node) {
        _this2._node = node;
        if (node) {
          _this2._createPopper();
        } else {
          _this2._destroyPopper();
        }
        if (typeof innerRef === 'function') {
          innerRef(node);
        }
      };
      var popperStyle = this._getPopperStyle();
      var popperPlacement = this._getPopperPlacement();
      var popperHide = this._getPopperHide();

      if (typeof children === 'function') {
        var _popperProps;

        var popperProps = (_popperProps = {
          ref: popperRef,
          style: popperStyle
        }, _defineProperty(_popperProps, 'data-placement', popperPlacement), _defineProperty(_popperProps, 'data-x-out-of-boundaries', popperHide), _popperProps);

        return children({
          popperProps: popperProps,
          restProps: restProps,
          scheduleUpdate: function scheduleUpdate() {
            // _createPopper will scheduleUpdate,
            // so calling this before this._popper exists
            // can be a noop.
            _this2._popper && _this2._popper.scheduleUpdate();
          }
        });
      }

      var componentProps = _extends({}, restProps, {
        style: _extends({}, restProps.style, popperStyle),
        'data-placement': popperPlacement,
        'data-x-out-of-boundaries': popperHide
      });

      if (typeof component === 'string') {
        componentProps.ref = popperRef;
      } else {
        componentProps.innerRef = popperRef;
      }

      return (0, _react.createElement)(component, componentProps, children);
    }
  }]);

  return Popper;
}(_react.Component);

Popper.contextTypes = {
  popperManager: _propTypes2.default.object.isRequired
};
Popper.childContextTypes = {
  popper: _propTypes2.default.object.isRequired
};
Popper.propTypes = {
  component: _propTypes2.default.oneOfType([_propTypes2.default.node, _propTypes2.default.func]),
  innerRef: _propTypes2.default.func,
  placement: _propTypes2.default.oneOf(_popper2.default.placements),
  eventsEnabled: _propTypes2.default.bool,
  modifiers: _propTypes2.default.object,
  children: _propTypes2.default.oneOfType([_propTypes2.default.node, _propTypes2.default.func])
};
Popper.defaultProps = {
  component: 'div',
  placement: 'bottom',
  eventsEnabled: true,
  modifiers: {}
};
exports.default = Popper;

/***/ }),
/* 54 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(global) {/**!
 * @fileOverview Kickass library to create and place poppers near their reference elements.
 * @version 1.12.9
 * @license
 * Copyright (c) 2016 Federico Zivolo and contributors
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */
var isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined';
var longerTimeoutBrowsers = ['Edge', 'Trident', 'Firefox'];
var timeoutDuration = 0;
for (var i = 0; i < longerTimeoutBrowsers.length; i += 1) {
  if (isBrowser && navigator.userAgent.indexOf(longerTimeoutBrowsers[i]) >= 0) {
    timeoutDuration = 1;
    break;
  }
}

function microtaskDebounce(fn) {
  var called = false;
  return function () {
    if (called) {
      return;
    }
    called = true;
    window.Promise.resolve().then(function () {
      called = false;
      fn();
    });
  };
}

function taskDebounce(fn) {
  var scheduled = false;
  return function () {
    if (!scheduled) {
      scheduled = true;
      setTimeout(function () {
        scheduled = false;
        fn();
      }, timeoutDuration);
    }
  };
}

var supportsMicroTasks = isBrowser && window.Promise;

/**
* Create a debounced version of a method, that's asynchronously deferred
* but called in the minimum time possible.
*
* @method
* @memberof Popper.Utils
* @argument {Function} fn
* @returns {Function}
*/
var debounce = supportsMicroTasks ? microtaskDebounce : taskDebounce;

/**
 * Check if the given variable is a function
 * @method
 * @memberof Popper.Utils
 * @argument {Any} functionToCheck - variable to check
 * @returns {Boolean} answer to: is a function?
 */
function isFunction(functionToCheck) {
  var getType = {};
  return functionToCheck && getType.toString.call(functionToCheck) === '[object Function]';
}

/**
 * Get CSS computed property of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Eement} element
 * @argument {String} property
 */
function getStyleComputedProperty(element, property) {
  if (element.nodeType !== 1) {
    return [];
  }
  // NOTE: 1 DOM access here
  var css = getComputedStyle(element, null);
  return property ? css[property] : css;
}

/**
 * Returns the parentNode or the host of the element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} parent
 */
function getParentNode(element) {
  if (element.nodeName === 'HTML') {
    return element;
  }
  return element.parentNode || element.host;
}

/**
 * Returns the scrolling parent of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} scroll parent
 */
function getScrollParent(element) {
  // Return body, `getScroll` will take care to get the correct `scrollTop` from it
  if (!element) {
    return document.body;
  }

  switch (element.nodeName) {
    case 'HTML':
    case 'BODY':
      return element.ownerDocument.body;
    case '#document':
      return element.body;
  }

  // Firefox want us to check `-x` and `-y` variations as well

  var _getStyleComputedProp = getStyleComputedProperty(element),
      overflow = _getStyleComputedProp.overflow,
      overflowX = _getStyleComputedProp.overflowX,
      overflowY = _getStyleComputedProp.overflowY;

  if (/(auto|scroll)/.test(overflow + overflowY + overflowX)) {
    return element;
  }

  return getScrollParent(getParentNode(element));
}

/**
 * Returns the offset parent of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} offset parent
 */
function getOffsetParent(element) {
  // NOTE: 1 DOM access here
  var offsetParent = element && element.offsetParent;
  var nodeName = offsetParent && offsetParent.nodeName;

  if (!nodeName || nodeName === 'BODY' || nodeName === 'HTML') {
    if (element) {
      return element.ownerDocument.documentElement;
    }

    return document.documentElement;
  }

  // .offsetParent will return the closest TD or TABLE in case
  // no offsetParent is present, I hate this job...
  if (['TD', 'TABLE'].indexOf(offsetParent.nodeName) !== -1 && getStyleComputedProperty(offsetParent, 'position') === 'static') {
    return getOffsetParent(offsetParent);
  }

  return offsetParent;
}

function isOffsetContainer(element) {
  var nodeName = element.nodeName;

  if (nodeName === 'BODY') {
    return false;
  }
  return nodeName === 'HTML' || getOffsetParent(element.firstElementChild) === element;
}

/**
 * Finds the root node (document, shadowDOM root) of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} node
 * @returns {Element} root node
 */
function getRoot(node) {
  if (node.parentNode !== null) {
    return getRoot(node.parentNode);
  }

  return node;
}

/**
 * Finds the offset parent common to the two provided nodes
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element1
 * @argument {Element} element2
 * @returns {Element} common offset parent
 */
function findCommonOffsetParent(element1, element2) {
  // This check is needed to avoid errors in case one of the elements isn't defined for any reason
  if (!element1 || !element1.nodeType || !element2 || !element2.nodeType) {
    return document.documentElement;
  }

  // Here we make sure to give as "start" the element that comes first in the DOM
  var order = element1.compareDocumentPosition(element2) & Node.DOCUMENT_POSITION_FOLLOWING;
  var start = order ? element1 : element2;
  var end = order ? element2 : element1;

  // Get common ancestor container
  var range = document.createRange();
  range.setStart(start, 0);
  range.setEnd(end, 0);
  var commonAncestorContainer = range.commonAncestorContainer;

  // Both nodes are inside #document

  if (element1 !== commonAncestorContainer && element2 !== commonAncestorContainer || start.contains(end)) {
    if (isOffsetContainer(commonAncestorContainer)) {
      return commonAncestorContainer;
    }

    return getOffsetParent(commonAncestorContainer);
  }

  // one of the nodes is inside shadowDOM, find which one
  var element1root = getRoot(element1);
  if (element1root.host) {
    return findCommonOffsetParent(element1root.host, element2);
  } else {
    return findCommonOffsetParent(element1, getRoot(element2).host);
  }
}

/**
 * Gets the scroll value of the given element in the given side (top and left)
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @argument {String} side `top` or `left`
 * @returns {number} amount of scrolled pixels
 */
function getScroll(element) {
  var side = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'top';

  var upperSide = side === 'top' ? 'scrollTop' : 'scrollLeft';
  var nodeName = element.nodeName;

  if (nodeName === 'BODY' || nodeName === 'HTML') {
    var html = element.ownerDocument.documentElement;
    var scrollingElement = element.ownerDocument.scrollingElement || html;
    return scrollingElement[upperSide];
  }

  return element[upperSide];
}

/*
 * Sum or subtract the element scroll values (left and top) from a given rect object
 * @method
 * @memberof Popper.Utils
 * @param {Object} rect - Rect object you want to change
 * @param {HTMLElement} element - The element from the function reads the scroll values
 * @param {Boolean} subtract - set to true if you want to subtract the scroll values
 * @return {Object} rect - The modifier rect object
 */
function includeScroll(rect, element) {
  var subtract = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  var scrollTop = getScroll(element, 'top');
  var scrollLeft = getScroll(element, 'left');
  var modifier = subtract ? -1 : 1;
  rect.top += scrollTop * modifier;
  rect.bottom += scrollTop * modifier;
  rect.left += scrollLeft * modifier;
  rect.right += scrollLeft * modifier;
  return rect;
}

/*
 * Helper to detect borders of a given element
 * @method
 * @memberof Popper.Utils
 * @param {CSSStyleDeclaration} styles
 * Result of `getStyleComputedProperty` on the given element
 * @param {String} axis - `x` or `y`
 * @return {number} borders - The borders size of the given axis
 */

function getBordersSize(styles, axis) {
  var sideA = axis === 'x' ? 'Left' : 'Top';
  var sideB = sideA === 'Left' ? 'Right' : 'Bottom';

  return parseFloat(styles['border' + sideA + 'Width'], 10) + parseFloat(styles['border' + sideB + 'Width'], 10);
}

/**
 * Tells if you are running Internet Explorer 10
 * @method
 * @memberof Popper.Utils
 * @returns {Boolean} isIE10
 */
var isIE10 = undefined;

var isIE10$1 = function () {
  if (isIE10 === undefined) {
    isIE10 = navigator.appVersion.indexOf('MSIE 10') !== -1;
  }
  return isIE10;
};

function getSize(axis, body, html, computedStyle) {
  return Math.max(body['offset' + axis], body['scroll' + axis], html['client' + axis], html['offset' + axis], html['scroll' + axis], isIE10$1() ? html['offset' + axis] + computedStyle['margin' + (axis === 'Height' ? 'Top' : 'Left')] + computedStyle['margin' + (axis === 'Height' ? 'Bottom' : 'Right')] : 0);
}

function getWindowSizes() {
  var body = document.body;
  var html = document.documentElement;
  var computedStyle = isIE10$1() && getComputedStyle(html);

  return {
    height: getSize('Height', body, html, computedStyle),
    width: getSize('Width', body, html, computedStyle)
  };
}

var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();





var defineProperty = function (obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

/**
 * Given element offsets, generate an output similar to getBoundingClientRect
 * @method
 * @memberof Popper.Utils
 * @argument {Object} offsets
 * @returns {Object} ClientRect like output
 */
function getClientRect(offsets) {
  return _extends({}, offsets, {
    right: offsets.left + offsets.width,
    bottom: offsets.top + offsets.height
  });
}

/**
 * Get bounding client rect of given element
 * @method
 * @memberof Popper.Utils
 * @param {HTMLElement} element
 * @return {Object} client rect
 */
function getBoundingClientRect(element) {
  var rect = {};

  // IE10 10 FIX: Please, don't ask, the element isn't
  // considered in DOM in some circumstances...
  // This isn't reproducible in IE10 compatibility mode of IE11
  if (isIE10$1()) {
    try {
      rect = element.getBoundingClientRect();
      var scrollTop = getScroll(element, 'top');
      var scrollLeft = getScroll(element, 'left');
      rect.top += scrollTop;
      rect.left += scrollLeft;
      rect.bottom += scrollTop;
      rect.right += scrollLeft;
    } catch (err) {}
  } else {
    rect = element.getBoundingClientRect();
  }

  var result = {
    left: rect.left,
    top: rect.top,
    width: rect.right - rect.left,
    height: rect.bottom - rect.top
  };

  // subtract scrollbar size from sizes
  var sizes = element.nodeName === 'HTML' ? getWindowSizes() : {};
  var width = sizes.width || element.clientWidth || result.right - result.left;
  var height = sizes.height || element.clientHeight || result.bottom - result.top;

  var horizScrollbar = element.offsetWidth - width;
  var vertScrollbar = element.offsetHeight - height;

  // if an hypothetical scrollbar is detected, we must be sure it's not a `border`
  // we make this check conditional for performance reasons
  if (horizScrollbar || vertScrollbar) {
    var styles = getStyleComputedProperty(element);
    horizScrollbar -= getBordersSize(styles, 'x');
    vertScrollbar -= getBordersSize(styles, 'y');

    result.width -= horizScrollbar;
    result.height -= vertScrollbar;
  }

  return getClientRect(result);
}

function getOffsetRectRelativeToArbitraryNode(children, parent) {
  var isIE10 = isIE10$1();
  var isHTML = parent.nodeName === 'HTML';
  var childrenRect = getBoundingClientRect(children);
  var parentRect = getBoundingClientRect(parent);
  var scrollParent = getScrollParent(children);

  var styles = getStyleComputedProperty(parent);
  var borderTopWidth = parseFloat(styles.borderTopWidth, 10);
  var borderLeftWidth = parseFloat(styles.borderLeftWidth, 10);

  var offsets = getClientRect({
    top: childrenRect.top - parentRect.top - borderTopWidth,
    left: childrenRect.left - parentRect.left - borderLeftWidth,
    width: childrenRect.width,
    height: childrenRect.height
  });
  offsets.marginTop = 0;
  offsets.marginLeft = 0;

  // Subtract margins of documentElement in case it's being used as parent
  // we do this only on HTML because it's the only element that behaves
  // differently when margins are applied to it. The margins are included in
  // the box of the documentElement, in the other cases not.
  if (!isIE10 && isHTML) {
    var marginTop = parseFloat(styles.marginTop, 10);
    var marginLeft = parseFloat(styles.marginLeft, 10);

    offsets.top -= borderTopWidth - marginTop;
    offsets.bottom -= borderTopWidth - marginTop;
    offsets.left -= borderLeftWidth - marginLeft;
    offsets.right -= borderLeftWidth - marginLeft;

    // Attach marginTop and marginLeft because in some circumstances we may need them
    offsets.marginTop = marginTop;
    offsets.marginLeft = marginLeft;
  }

  if (isIE10 ? parent.contains(scrollParent) : parent === scrollParent && scrollParent.nodeName !== 'BODY') {
    offsets = includeScroll(offsets, parent);
  }

  return offsets;
}

function getViewportOffsetRectRelativeToArtbitraryNode(element) {
  var html = element.ownerDocument.documentElement;
  var relativeOffset = getOffsetRectRelativeToArbitraryNode(element, html);
  var width = Math.max(html.clientWidth, window.innerWidth || 0);
  var height = Math.max(html.clientHeight, window.innerHeight || 0);

  var scrollTop = getScroll(html);
  var scrollLeft = getScroll(html, 'left');

  var offset = {
    top: scrollTop - relativeOffset.top + relativeOffset.marginTop,
    left: scrollLeft - relativeOffset.left + relativeOffset.marginLeft,
    width: width,
    height: height
  };

  return getClientRect(offset);
}

/**
 * Check if the given element is fixed or is inside a fixed parent
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @argument {Element} customContainer
 * @returns {Boolean} answer to "isFixed?"
 */
function isFixed(element) {
  var nodeName = element.nodeName;
  if (nodeName === 'BODY' || nodeName === 'HTML') {
    return false;
  }
  if (getStyleComputedProperty(element, 'position') === 'fixed') {
    return true;
  }
  return isFixed(getParentNode(element));
}

/**
 * Computed the boundaries limits and return them
 * @method
 * @memberof Popper.Utils
 * @param {HTMLElement} popper
 * @param {HTMLElement} reference
 * @param {number} padding
 * @param {HTMLElement} boundariesElement - Element used to define the boundaries
 * @returns {Object} Coordinates of the boundaries
 */
function getBoundaries(popper, reference, padding, boundariesElement) {
  // NOTE: 1 DOM access here
  var boundaries = { top: 0, left: 0 };
  var offsetParent = findCommonOffsetParent(popper, reference);

  // Handle viewport case
  if (boundariesElement === 'viewport') {
    boundaries = getViewportOffsetRectRelativeToArtbitraryNode(offsetParent);
  } else {
    // Handle other cases based on DOM element used as boundaries
    var boundariesNode = void 0;
    if (boundariesElement === 'scrollParent') {
      boundariesNode = getScrollParent(getParentNode(reference));
      if (boundariesNode.nodeName === 'BODY') {
        boundariesNode = popper.ownerDocument.documentElement;
      }
    } else if (boundariesElement === 'window') {
      boundariesNode = popper.ownerDocument.documentElement;
    } else {
      boundariesNode = boundariesElement;
    }

    var offsets = getOffsetRectRelativeToArbitraryNode(boundariesNode, offsetParent);

    // In case of HTML, we need a different computation
    if (boundariesNode.nodeName === 'HTML' && !isFixed(offsetParent)) {
      var _getWindowSizes = getWindowSizes(),
          height = _getWindowSizes.height,
          width = _getWindowSizes.width;

      boundaries.top += offsets.top - offsets.marginTop;
      boundaries.bottom = height + offsets.top;
      boundaries.left += offsets.left - offsets.marginLeft;
      boundaries.right = width + offsets.left;
    } else {
      // for all the other DOM elements, this one is good
      boundaries = offsets;
    }
  }

  // Add paddings
  boundaries.left += padding;
  boundaries.top += padding;
  boundaries.right -= padding;
  boundaries.bottom -= padding;

  return boundaries;
}

function getArea(_ref) {
  var width = _ref.width,
      height = _ref.height;

  return width * height;
}

/**
 * Utility used to transform the `auto` placement to the placement with more
 * available space.
 * @method
 * @memberof Popper.Utils
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function computeAutoPlacement(placement, refRect, popper, reference, boundariesElement) {
  var padding = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 0;

  if (placement.indexOf('auto') === -1) {
    return placement;
  }

  var boundaries = getBoundaries(popper, reference, padding, boundariesElement);

  var rects = {
    top: {
      width: boundaries.width,
      height: refRect.top - boundaries.top
    },
    right: {
      width: boundaries.right - refRect.right,
      height: boundaries.height
    },
    bottom: {
      width: boundaries.width,
      height: boundaries.bottom - refRect.bottom
    },
    left: {
      width: refRect.left - boundaries.left,
      height: boundaries.height
    }
  };

  var sortedAreas = Object.keys(rects).map(function (key) {
    return _extends({
      key: key
    }, rects[key], {
      area: getArea(rects[key])
    });
  }).sort(function (a, b) {
    return b.area - a.area;
  });

  var filteredAreas = sortedAreas.filter(function (_ref2) {
    var width = _ref2.width,
        height = _ref2.height;
    return width >= popper.clientWidth && height >= popper.clientHeight;
  });

  var computedPlacement = filteredAreas.length > 0 ? filteredAreas[0].key : sortedAreas[0].key;

  var variation = placement.split('-')[1];

  return computedPlacement + (variation ? '-' + variation : '');
}

/**
 * Get offsets to the reference element
 * @method
 * @memberof Popper.Utils
 * @param {Object} state
 * @param {Element} popper - the popper element
 * @param {Element} reference - the reference element (the popper will be relative to this)
 * @returns {Object} An object containing the offsets which will be applied to the popper
 */
function getReferenceOffsets(state, popper, reference) {
  var commonOffsetParent = findCommonOffsetParent(popper, reference);
  return getOffsetRectRelativeToArbitraryNode(reference, commonOffsetParent);
}

/**
 * Get the outer sizes of the given element (offset size + margins)
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Object} object containing width and height properties
 */
function getOuterSizes(element) {
  var styles = getComputedStyle(element);
  var x = parseFloat(styles.marginTop) + parseFloat(styles.marginBottom);
  var y = parseFloat(styles.marginLeft) + parseFloat(styles.marginRight);
  var result = {
    width: element.offsetWidth + y,
    height: element.offsetHeight + x
  };
  return result;
}

/**
 * Get the opposite placement of the given one
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement
 * @returns {String} flipped placement
 */
function getOppositePlacement(placement) {
  var hash = { left: 'right', right: 'left', bottom: 'top', top: 'bottom' };
  return placement.replace(/left|right|bottom|top/g, function (matched) {
    return hash[matched];
  });
}

/**
 * Get offsets to the popper
 * @method
 * @memberof Popper.Utils
 * @param {Object} position - CSS position the Popper will get applied
 * @param {HTMLElement} popper - the popper element
 * @param {Object} referenceOffsets - the reference offsets (the popper will be relative to this)
 * @param {String} placement - one of the valid placement options
 * @returns {Object} popperOffsets - An object containing the offsets which will be applied to the popper
 */
function getPopperOffsets(popper, referenceOffsets, placement) {
  placement = placement.split('-')[0];

  // Get popper node sizes
  var popperRect = getOuterSizes(popper);

  // Add position, width and height to our offsets object
  var popperOffsets = {
    width: popperRect.width,
    height: popperRect.height
  };

  // depending by the popper placement we have to compute its offsets slightly differently
  var isHoriz = ['right', 'left'].indexOf(placement) !== -1;
  var mainSide = isHoriz ? 'top' : 'left';
  var secondarySide = isHoriz ? 'left' : 'top';
  var measurement = isHoriz ? 'height' : 'width';
  var secondaryMeasurement = !isHoriz ? 'height' : 'width';

  popperOffsets[mainSide] = referenceOffsets[mainSide] + referenceOffsets[measurement] / 2 - popperRect[measurement] / 2;
  if (placement === secondarySide) {
    popperOffsets[secondarySide] = referenceOffsets[secondarySide] - popperRect[secondaryMeasurement];
  } else {
    popperOffsets[secondarySide] = referenceOffsets[getOppositePlacement(secondarySide)];
  }

  return popperOffsets;
}

/**
 * Mimics the `find` method of Array
 * @method
 * @memberof Popper.Utils
 * @argument {Array} arr
 * @argument prop
 * @argument value
 * @returns index or -1
 */
function find(arr, check) {
  // use native find if supported
  if (Array.prototype.find) {
    return arr.find(check);
  }

  // use `filter` to obtain the same behavior of `find`
  return arr.filter(check)[0];
}

/**
 * Return the index of the matching object
 * @method
 * @memberof Popper.Utils
 * @argument {Array} arr
 * @argument prop
 * @argument value
 * @returns index or -1
 */
function findIndex(arr, prop, value) {
  // use native findIndex if supported
  if (Array.prototype.findIndex) {
    return arr.findIndex(function (cur) {
      return cur[prop] === value;
    });
  }

  // use `find` + `indexOf` if `findIndex` isn't supported
  var match = find(arr, function (obj) {
    return obj[prop] === value;
  });
  return arr.indexOf(match);
}

/**
 * Loop trough the list of modifiers and run them in order,
 * each of them will then edit the data object.
 * @method
 * @memberof Popper.Utils
 * @param {dataObject} data
 * @param {Array} modifiers
 * @param {String} ends - Optional modifier name used as stopper
 * @returns {dataObject}
 */
function runModifiers(modifiers, data, ends) {
  var modifiersToRun = ends === undefined ? modifiers : modifiers.slice(0, findIndex(modifiers, 'name', ends));

  modifiersToRun.forEach(function (modifier) {
    if (modifier['function']) {
      // eslint-disable-line dot-notation
      console.warn('`modifier.function` is deprecated, use `modifier.fn`!');
    }
    var fn = modifier['function'] || modifier.fn; // eslint-disable-line dot-notation
    if (modifier.enabled && isFunction(fn)) {
      // Add properties to offsets to make them a complete clientRect object
      // we do this before each modifier to make sure the previous one doesn't
      // mess with these values
      data.offsets.popper = getClientRect(data.offsets.popper);
      data.offsets.reference = getClientRect(data.offsets.reference);

      data = fn(data, modifier);
    }
  });

  return data;
}

/**
 * Updates the position of the popper, computing the new offsets and applying
 * the new style.<br />
 * Prefer `scheduleUpdate` over `update` because of performance reasons.
 * @method
 * @memberof Popper
 */
function update() {
  // if popper is destroyed, don't perform any further update
  if (this.state.isDestroyed) {
    return;
  }

  var data = {
    instance: this,
    styles: {},
    arrowStyles: {},
    attributes: {},
    flipped: false,
    offsets: {}
  };

  // compute reference element offsets
  data.offsets.reference = getReferenceOffsets(this.state, this.popper, this.reference);

  // compute auto placement, store placement inside the data object,
  // modifiers will be able to edit `placement` if needed
  // and refer to originalPlacement to know the original value
  data.placement = computeAutoPlacement(this.options.placement, data.offsets.reference, this.popper, this.reference, this.options.modifiers.flip.boundariesElement, this.options.modifiers.flip.padding);

  // store the computed placement inside `originalPlacement`
  data.originalPlacement = data.placement;

  // compute the popper offsets
  data.offsets.popper = getPopperOffsets(this.popper, data.offsets.reference, data.placement);
  data.offsets.popper.position = 'absolute';

  // run the modifiers
  data = runModifiers(this.modifiers, data);

  // the first `update` will call `onCreate` callback
  // the other ones will call `onUpdate` callback
  if (!this.state.isCreated) {
    this.state.isCreated = true;
    this.options.onCreate(data);
  } else {
    this.options.onUpdate(data);
  }
}

/**
 * Helper used to know if the given modifier is enabled.
 * @method
 * @memberof Popper.Utils
 * @returns {Boolean}
 */
function isModifierEnabled(modifiers, modifierName) {
  return modifiers.some(function (_ref) {
    var name = _ref.name,
        enabled = _ref.enabled;
    return enabled && name === modifierName;
  });
}

/**
 * Get the prefixed supported property name
 * @method
 * @memberof Popper.Utils
 * @argument {String} property (camelCase)
 * @returns {String} prefixed property (camelCase or PascalCase, depending on the vendor prefix)
 */
function getSupportedPropertyName(property) {
  var prefixes = [false, 'ms', 'Webkit', 'Moz', 'O'];
  var upperProp = property.charAt(0).toUpperCase() + property.slice(1);

  for (var i = 0; i < prefixes.length - 1; i++) {
    var prefix = prefixes[i];
    var toCheck = prefix ? '' + prefix + upperProp : property;
    if (typeof document.body.style[toCheck] !== 'undefined') {
      return toCheck;
    }
  }
  return null;
}

/**
 * Destroy the popper
 * @method
 * @memberof Popper
 */
function destroy() {
  this.state.isDestroyed = true;

  // touch DOM only if `applyStyle` modifier is enabled
  if (isModifierEnabled(this.modifiers, 'applyStyle')) {
    this.popper.removeAttribute('x-placement');
    this.popper.style.left = '';
    this.popper.style.position = '';
    this.popper.style.top = '';
    this.popper.style[getSupportedPropertyName('transform')] = '';
  }

  this.disableEventListeners();

  // remove the popper if user explicity asked for the deletion on destroy
  // do not use `remove` because IE11 doesn't support it
  if (this.options.removeOnDestroy) {
    this.popper.parentNode.removeChild(this.popper);
  }
  return this;
}

/**
 * Get the window associated with the element
 * @argument {Element} element
 * @returns {Window}
 */
function getWindow(element) {
  var ownerDocument = element.ownerDocument;
  return ownerDocument ? ownerDocument.defaultView : window;
}

function attachToScrollParents(scrollParent, event, callback, scrollParents) {
  var isBody = scrollParent.nodeName === 'BODY';
  var target = isBody ? scrollParent.ownerDocument.defaultView : scrollParent;
  target.addEventListener(event, callback, { passive: true });

  if (!isBody) {
    attachToScrollParents(getScrollParent(target.parentNode), event, callback, scrollParents);
  }
  scrollParents.push(target);
}

/**
 * Setup needed event listeners used to update the popper position
 * @method
 * @memberof Popper.Utils
 * @private
 */
function setupEventListeners(reference, options, state, updateBound) {
  // Resize event listener on window
  state.updateBound = updateBound;
  getWindow(reference).addEventListener('resize', state.updateBound, { passive: true });

  // Scroll event listener on scroll parents
  var scrollElement = getScrollParent(reference);
  attachToScrollParents(scrollElement, 'scroll', state.updateBound, state.scrollParents);
  state.scrollElement = scrollElement;
  state.eventsEnabled = true;

  return state;
}

/**
 * It will add resize/scroll events and start recalculating
 * position of the popper element when they are triggered.
 * @method
 * @memberof Popper
 */
function enableEventListeners() {
  if (!this.state.eventsEnabled) {
    this.state = setupEventListeners(this.reference, this.options, this.state, this.scheduleUpdate);
  }
}

/**
 * Remove event listeners used to update the popper position
 * @method
 * @memberof Popper.Utils
 * @private
 */
function removeEventListeners(reference, state) {
  // Remove resize event listener on window
  getWindow(reference).removeEventListener('resize', state.updateBound);

  // Remove scroll event listener on scroll parents
  state.scrollParents.forEach(function (target) {
    target.removeEventListener('scroll', state.updateBound);
  });

  // Reset state
  state.updateBound = null;
  state.scrollParents = [];
  state.scrollElement = null;
  state.eventsEnabled = false;
  return state;
}

/**
 * It will remove resize/scroll events and won't recalculate popper position
 * when they are triggered. It also won't trigger onUpdate callback anymore,
 * unless you call `update` method manually.
 * @method
 * @memberof Popper
 */
function disableEventListeners() {
  if (this.state.eventsEnabled) {
    cancelAnimationFrame(this.scheduleUpdate);
    this.state = removeEventListeners(this.reference, this.state);
  }
}

/**
 * Tells if a given input is a number
 * @method
 * @memberof Popper.Utils
 * @param {*} input to check
 * @return {Boolean}
 */
function isNumeric(n) {
  return n !== '' && !isNaN(parseFloat(n)) && isFinite(n);
}

/**
 * Set the style to the given popper
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element - Element to apply the style to
 * @argument {Object} styles
 * Object with a list of properties and values which will be applied to the element
 */
function setStyles(element, styles) {
  Object.keys(styles).forEach(function (prop) {
    var unit = '';
    // add unit if the value is numeric and is one of the following
    if (['width', 'height', 'top', 'right', 'bottom', 'left'].indexOf(prop) !== -1 && isNumeric(styles[prop])) {
      unit = 'px';
    }
    element.style[prop] = styles[prop] + unit;
  });
}

/**
 * Set the attributes to the given popper
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element - Element to apply the attributes to
 * @argument {Object} styles
 * Object with a list of properties and values which will be applied to the element
 */
function setAttributes(element, attributes) {
  Object.keys(attributes).forEach(function (prop) {
    var value = attributes[prop];
    if (value !== false) {
      element.setAttribute(prop, attributes[prop]);
    } else {
      element.removeAttribute(prop);
    }
  });
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} data.styles - List of style properties - values to apply to popper element
 * @argument {Object} data.attributes - List of attribute properties - values to apply to popper element
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The same data object
 */
function applyStyle(data) {
  // any property present in `data.styles` will be applied to the popper,
  // in this way we can make the 3rd party modifiers add custom styles to it
  // Be aware, modifiers could override the properties defined in the previous
  // lines of this modifier!
  setStyles(data.instance.popper, data.styles);

  // any property present in `data.attributes` will be applied to the popper,
  // they will be set as HTML attributes of the element
  setAttributes(data.instance.popper, data.attributes);

  // if arrowElement is defined and arrowStyles has some properties
  if (data.arrowElement && Object.keys(data.arrowStyles).length) {
    setStyles(data.arrowElement, data.arrowStyles);
  }

  return data;
}

/**
 * Set the x-placement attribute before everything else because it could be used
 * to add margins to the popper margins needs to be calculated to get the
 * correct popper offsets.
 * @method
 * @memberof Popper.modifiers
 * @param {HTMLElement} reference - The reference element used to position the popper
 * @param {HTMLElement} popper - The HTML element used as popper.
 * @param {Object} options - Popper.js options
 */
function applyStyleOnLoad(reference, popper, options, modifierOptions, state) {
  // compute reference element offsets
  var referenceOffsets = getReferenceOffsets(state, popper, reference);

  // compute auto placement, store placement inside the data object,
  // modifiers will be able to edit `placement` if needed
  // and refer to originalPlacement to know the original value
  var placement = computeAutoPlacement(options.placement, referenceOffsets, popper, reference, options.modifiers.flip.boundariesElement, options.modifiers.flip.padding);

  popper.setAttribute('x-placement', placement);

  // Apply `position` to popper before anything else because
  // without the position applied we can't guarantee correct computations
  setStyles(popper, { position: 'absolute' });

  return options;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function computeStyle(data, options) {
  var x = options.x,
      y = options.y;
  var popper = data.offsets.popper;

  // Remove this legacy support in Popper.js v2

  var legacyGpuAccelerationOption = find(data.instance.modifiers, function (modifier) {
    return modifier.name === 'applyStyle';
  }).gpuAcceleration;
  if (legacyGpuAccelerationOption !== undefined) {
    console.warn('WARNING: `gpuAcceleration` option moved to `computeStyle` modifier and will not be supported in future versions of Popper.js!');
  }
  var gpuAcceleration = legacyGpuAccelerationOption !== undefined ? legacyGpuAccelerationOption : options.gpuAcceleration;

  var offsetParent = getOffsetParent(data.instance.popper);
  var offsetParentRect = getBoundingClientRect(offsetParent);

  // Styles
  var styles = {
    position: popper.position
  };

  // floor sides to avoid blurry text
  var offsets = {
    left: Math.floor(popper.left),
    top: Math.floor(popper.top),
    bottom: Math.floor(popper.bottom),
    right: Math.floor(popper.right)
  };

  var sideA = x === 'bottom' ? 'top' : 'bottom';
  var sideB = y === 'right' ? 'left' : 'right';

  // if gpuAcceleration is set to `true` and transform is supported,
  //  we use `translate3d` to apply the position to the popper we
  // automatically use the supported prefixed version if needed
  var prefixedProperty = getSupportedPropertyName('transform');

  // now, let's make a step back and look at this code closely (wtf?)
  // If the content of the popper grows once it's been positioned, it
  // may happen that the popper gets misplaced because of the new content
  // overflowing its reference element
  // To avoid this problem, we provide two options (x and y), which allow
  // the consumer to define the offset origin.
  // If we position a popper on top of a reference element, we can set
  // `x` to `top` to make the popper grow towards its top instead of
  // its bottom.
  var left = void 0,
      top = void 0;
  if (sideA === 'bottom') {
    top = -offsetParentRect.height + offsets.bottom;
  } else {
    top = offsets.top;
  }
  if (sideB === 'right') {
    left = -offsetParentRect.width + offsets.right;
  } else {
    left = offsets.left;
  }
  if (gpuAcceleration && prefixedProperty) {
    styles[prefixedProperty] = 'translate3d(' + left + 'px, ' + top + 'px, 0)';
    styles[sideA] = 0;
    styles[sideB] = 0;
    styles.willChange = 'transform';
  } else {
    // othwerise, we use the standard `top`, `left`, `bottom` and `right` properties
    var invertTop = sideA === 'bottom' ? -1 : 1;
    var invertLeft = sideB === 'right' ? -1 : 1;
    styles[sideA] = top * invertTop;
    styles[sideB] = left * invertLeft;
    styles.willChange = sideA + ', ' + sideB;
  }

  // Attributes
  var attributes = {
    'x-placement': data.placement
  };

  // Update `data` attributes, styles and arrowStyles
  data.attributes = _extends({}, attributes, data.attributes);
  data.styles = _extends({}, styles, data.styles);
  data.arrowStyles = _extends({}, data.offsets.arrow, data.arrowStyles);

  return data;
}

/**
 * Helper used to know if the given modifier depends from another one.<br />
 * It checks if the needed modifier is listed and enabled.
 * @method
 * @memberof Popper.Utils
 * @param {Array} modifiers - list of modifiers
 * @param {String} requestingName - name of requesting modifier
 * @param {String} requestedName - name of requested modifier
 * @returns {Boolean}
 */
function isModifierRequired(modifiers, requestingName, requestedName) {
  var requesting = find(modifiers, function (_ref) {
    var name = _ref.name;
    return name === requestingName;
  });

  var isRequired = !!requesting && modifiers.some(function (modifier) {
    return modifier.name === requestedName && modifier.enabled && modifier.order < requesting.order;
  });

  if (!isRequired) {
    var _requesting = '`' + requestingName + '`';
    var requested = '`' + requestedName + '`';
    console.warn(requested + ' modifier is required by ' + _requesting + ' modifier in order to work, be sure to include it before ' + _requesting + '!');
  }
  return isRequired;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function arrow(data, options) {
  var _data$offsets$arrow;

  // arrow depends on keepTogether in order to work
  if (!isModifierRequired(data.instance.modifiers, 'arrow', 'keepTogether')) {
    return data;
  }

  var arrowElement = options.element;

  // if arrowElement is a string, suppose it's a CSS selector
  if (typeof arrowElement === 'string') {
    arrowElement = data.instance.popper.querySelector(arrowElement);

    // if arrowElement is not found, don't run the modifier
    if (!arrowElement) {
      return data;
    }
  } else {
    // if the arrowElement isn't a query selector we must check that the
    // provided DOM node is child of its popper node
    if (!data.instance.popper.contains(arrowElement)) {
      console.warn('WARNING: `arrow.element` must be child of its popper element!');
      return data;
    }
  }

  var placement = data.placement.split('-')[0];
  var _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var isVertical = ['left', 'right'].indexOf(placement) !== -1;

  var len = isVertical ? 'height' : 'width';
  var sideCapitalized = isVertical ? 'Top' : 'Left';
  var side = sideCapitalized.toLowerCase();
  var altSide = isVertical ? 'left' : 'top';
  var opSide = isVertical ? 'bottom' : 'right';
  var arrowElementSize = getOuterSizes(arrowElement)[len];

  //
  // extends keepTogether behavior making sure the popper and its
  // reference have enough pixels in conjuction
  //

  // top/left side
  if (reference[opSide] - arrowElementSize < popper[side]) {
    data.offsets.popper[side] -= popper[side] - (reference[opSide] - arrowElementSize);
  }
  // bottom/right side
  if (reference[side] + arrowElementSize > popper[opSide]) {
    data.offsets.popper[side] += reference[side] + arrowElementSize - popper[opSide];
  }
  data.offsets.popper = getClientRect(data.offsets.popper);

  // compute center of the popper
  var center = reference[side] + reference[len] / 2 - arrowElementSize / 2;

  // Compute the sideValue using the updated popper offsets
  // take popper margin in account because we don't have this info available
  var css = getStyleComputedProperty(data.instance.popper);
  var popperMarginSide = parseFloat(css['margin' + sideCapitalized], 10);
  var popperBorderSide = parseFloat(css['border' + sideCapitalized + 'Width'], 10);
  var sideValue = center - data.offsets.popper[side] - popperMarginSide - popperBorderSide;

  // prevent arrowElement from being placed not contiguously to its popper
  sideValue = Math.max(Math.min(popper[len] - arrowElementSize, sideValue), 0);

  data.arrowElement = arrowElement;
  data.offsets.arrow = (_data$offsets$arrow = {}, defineProperty(_data$offsets$arrow, side, Math.round(sideValue)), defineProperty(_data$offsets$arrow, altSide, ''), _data$offsets$arrow);

  return data;
}

/**
 * Get the opposite placement variation of the given one
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement variation
 * @returns {String} flipped placement variation
 */
function getOppositeVariation(variation) {
  if (variation === 'end') {
    return 'start';
  } else if (variation === 'start') {
    return 'end';
  }
  return variation;
}

/**
 * List of accepted placements to use as values of the `placement` option.<br />
 * Valid placements are:
 * - `auto`
 * - `top`
 * - `right`
 * - `bottom`
 * - `left`
 *
 * Each placement can have a variation from this list:
 * - `-start`
 * - `-end`
 *
 * Variations are interpreted easily if you think of them as the left to right
 * written languages. Horizontally (`top` and `bottom`), `start` is left and `end`
 * is right.<br />
 * Vertically (`left` and `right`), `start` is top and `end` is bottom.
 *
 * Some valid examples are:
 * - `top-end` (on top of reference, right aligned)
 * - `right-start` (on right of reference, top aligned)
 * - `bottom` (on bottom, centered)
 * - `auto-right` (on the side with more space available, alignment depends by placement)
 *
 * @static
 * @type {Array}
 * @enum {String}
 * @readonly
 * @method placements
 * @memberof Popper
 */
var placements = ['auto-start', 'auto', 'auto-end', 'top-start', 'top', 'top-end', 'right-start', 'right', 'right-end', 'bottom-end', 'bottom', 'bottom-start', 'left-end', 'left', 'left-start'];

// Get rid of `auto` `auto-start` and `auto-end`
var validPlacements = placements.slice(3);

/**
 * Given an initial placement, returns all the subsequent placements
 * clockwise (or counter-clockwise).
 *
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement - A valid placement (it accepts variations)
 * @argument {Boolean} counter - Set to true to walk the placements counterclockwise
 * @returns {Array} placements including their variations
 */
function clockwise(placement) {
  var counter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  var index = validPlacements.indexOf(placement);
  var arr = validPlacements.slice(index + 1).concat(validPlacements.slice(0, index));
  return counter ? arr.reverse() : arr;
}

var BEHAVIORS = {
  FLIP: 'flip',
  CLOCKWISE: 'clockwise',
  COUNTERCLOCKWISE: 'counterclockwise'
};

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function flip(data, options) {
  // if `inner` modifier is enabled, we can't use the `flip` modifier
  if (isModifierEnabled(data.instance.modifiers, 'inner')) {
    return data;
  }

  if (data.flipped && data.placement === data.originalPlacement) {
    // seems like flip is trying to loop, probably there's not enough space on any of the flippable sides
    return data;
  }

  var boundaries = getBoundaries(data.instance.popper, data.instance.reference, options.padding, options.boundariesElement);

  var placement = data.placement.split('-')[0];
  var placementOpposite = getOppositePlacement(placement);
  var variation = data.placement.split('-')[1] || '';

  var flipOrder = [];

  switch (options.behavior) {
    case BEHAVIORS.FLIP:
      flipOrder = [placement, placementOpposite];
      break;
    case BEHAVIORS.CLOCKWISE:
      flipOrder = clockwise(placement);
      break;
    case BEHAVIORS.COUNTERCLOCKWISE:
      flipOrder = clockwise(placement, true);
      break;
    default:
      flipOrder = options.behavior;
  }

  flipOrder.forEach(function (step, index) {
    if (placement !== step || flipOrder.length === index + 1) {
      return data;
    }

    placement = data.placement.split('-')[0];
    placementOpposite = getOppositePlacement(placement);

    var popperOffsets = data.offsets.popper;
    var refOffsets = data.offsets.reference;

    // using floor because the reference offsets may contain decimals we are not going to consider here
    var floor = Math.floor;
    var overlapsRef = placement === 'left' && floor(popperOffsets.right) > floor(refOffsets.left) || placement === 'right' && floor(popperOffsets.left) < floor(refOffsets.right) || placement === 'top' && floor(popperOffsets.bottom) > floor(refOffsets.top) || placement === 'bottom' && floor(popperOffsets.top) < floor(refOffsets.bottom);

    var overflowsLeft = floor(popperOffsets.left) < floor(boundaries.left);
    var overflowsRight = floor(popperOffsets.right) > floor(boundaries.right);
    var overflowsTop = floor(popperOffsets.top) < floor(boundaries.top);
    var overflowsBottom = floor(popperOffsets.bottom) > floor(boundaries.bottom);

    var overflowsBoundaries = placement === 'left' && overflowsLeft || placement === 'right' && overflowsRight || placement === 'top' && overflowsTop || placement === 'bottom' && overflowsBottom;

    // flip the variation if required
    var isVertical = ['top', 'bottom'].indexOf(placement) !== -1;
    var flippedVariation = !!options.flipVariations && (isVertical && variation === 'start' && overflowsLeft || isVertical && variation === 'end' && overflowsRight || !isVertical && variation === 'start' && overflowsTop || !isVertical && variation === 'end' && overflowsBottom);

    if (overlapsRef || overflowsBoundaries || flippedVariation) {
      // this boolean to detect any flip loop
      data.flipped = true;

      if (overlapsRef || overflowsBoundaries) {
        placement = flipOrder[index + 1];
      }

      if (flippedVariation) {
        variation = getOppositeVariation(variation);
      }

      data.placement = placement + (variation ? '-' + variation : '');

      // this object contains `position`, we want to preserve it along with
      // any additional property we may add in the future
      data.offsets.popper = _extends({}, data.offsets.popper, getPopperOffsets(data.instance.popper, data.offsets.reference, data.placement));

      data = runModifiers(data.instance.modifiers, data, 'flip');
    }
  });
  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function keepTogether(data) {
  var _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var placement = data.placement.split('-')[0];
  var floor = Math.floor;
  var isVertical = ['top', 'bottom'].indexOf(placement) !== -1;
  var side = isVertical ? 'right' : 'bottom';
  var opSide = isVertical ? 'left' : 'top';
  var measurement = isVertical ? 'width' : 'height';

  if (popper[side] < floor(reference[opSide])) {
    data.offsets.popper[opSide] = floor(reference[opSide]) - popper[measurement];
  }
  if (popper[opSide] > floor(reference[side])) {
    data.offsets.popper[opSide] = floor(reference[side]);
  }

  return data;
}

/**
 * Converts a string containing value + unit into a px value number
 * @function
 * @memberof {modifiers~offset}
 * @private
 * @argument {String} str - Value + unit string
 * @argument {String} measurement - `height` or `width`
 * @argument {Object} popperOffsets
 * @argument {Object} referenceOffsets
 * @returns {Number|String}
 * Value in pixels, or original string if no values were extracted
 */
function toValue(str, measurement, popperOffsets, referenceOffsets) {
  // separate value from unit
  var split = str.match(/((?:\-|\+)?\d*\.?\d*)(.*)/);
  var value = +split[1];
  var unit = split[2];

  // If it's not a number it's an operator, I guess
  if (!value) {
    return str;
  }

  if (unit.indexOf('%') === 0) {
    var element = void 0;
    switch (unit) {
      case '%p':
        element = popperOffsets;
        break;
      case '%':
      case '%r':
      default:
        element = referenceOffsets;
    }

    var rect = getClientRect(element);
    return rect[measurement] / 100 * value;
  } else if (unit === 'vh' || unit === 'vw') {
    // if is a vh or vw, we calculate the size based on the viewport
    var size = void 0;
    if (unit === 'vh') {
      size = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
    } else {
      size = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
    }
    return size / 100 * value;
  } else {
    // if is an explicit pixel unit, we get rid of the unit and keep the value
    // if is an implicit unit, it's px, and we return just the value
    return value;
  }
}

/**
 * Parse an `offset` string to extrapolate `x` and `y` numeric offsets.
 * @function
 * @memberof {modifiers~offset}
 * @private
 * @argument {String} offset
 * @argument {Object} popperOffsets
 * @argument {Object} referenceOffsets
 * @argument {String} basePlacement
 * @returns {Array} a two cells array with x and y offsets in numbers
 */
function parseOffset(offset, popperOffsets, referenceOffsets, basePlacement) {
  var offsets = [0, 0];

  // Use height if placement is left or right and index is 0 otherwise use width
  // in this way the first offset will use an axis and the second one
  // will use the other one
  var useHeight = ['right', 'left'].indexOf(basePlacement) !== -1;

  // Split the offset string to obtain a list of values and operands
  // The regex addresses values with the plus or minus sign in front (+10, -20, etc)
  var fragments = offset.split(/(\+|\-)/).map(function (frag) {
    return frag.trim();
  });

  // Detect if the offset string contains a pair of values or a single one
  // they could be separated by comma or space
  var divider = fragments.indexOf(find(fragments, function (frag) {
    return frag.search(/,|\s/) !== -1;
  }));

  if (fragments[divider] && fragments[divider].indexOf(',') === -1) {
    console.warn('Offsets separated by white space(s) are deprecated, use a comma (,) instead.');
  }

  // If divider is found, we divide the list of values and operands to divide
  // them by ofset X and Y.
  var splitRegex = /\s*,\s*|\s+/;
  var ops = divider !== -1 ? [fragments.slice(0, divider).concat([fragments[divider].split(splitRegex)[0]]), [fragments[divider].split(splitRegex)[1]].concat(fragments.slice(divider + 1))] : [fragments];

  // Convert the values with units to absolute pixels to allow our computations
  ops = ops.map(function (op, index) {
    // Most of the units rely on the orientation of the popper
    var measurement = (index === 1 ? !useHeight : useHeight) ? 'height' : 'width';
    var mergeWithPrevious = false;
    return op
    // This aggregates any `+` or `-` sign that aren't considered operators
    // e.g.: 10 + +5 => [10, +, +5]
    .reduce(function (a, b) {
      if (a[a.length - 1] === '' && ['+', '-'].indexOf(b) !== -1) {
        a[a.length - 1] = b;
        mergeWithPrevious = true;
        return a;
      } else if (mergeWithPrevious) {
        a[a.length - 1] += b;
        mergeWithPrevious = false;
        return a;
      } else {
        return a.concat(b);
      }
    }, [])
    // Here we convert the string values into number values (in px)
    .map(function (str) {
      return toValue(str, measurement, popperOffsets, referenceOffsets);
    });
  });

  // Loop trough the offsets arrays and execute the operations
  ops.forEach(function (op, index) {
    op.forEach(function (frag, index2) {
      if (isNumeric(frag)) {
        offsets[index] += frag * (op[index2 - 1] === '-' ? -1 : 1);
      }
    });
  });
  return offsets;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @argument {Number|String} options.offset=0
 * The offset value as described in the modifier description
 * @returns {Object} The data object, properly modified
 */
function offset(data, _ref) {
  var offset = _ref.offset;
  var placement = data.placement,
      _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var basePlacement = placement.split('-')[0];

  var offsets = void 0;
  if (isNumeric(+offset)) {
    offsets = [+offset, 0];
  } else {
    offsets = parseOffset(offset, popper, reference, basePlacement);
  }

  if (basePlacement === 'left') {
    popper.top += offsets[0];
    popper.left -= offsets[1];
  } else if (basePlacement === 'right') {
    popper.top += offsets[0];
    popper.left += offsets[1];
  } else if (basePlacement === 'top') {
    popper.left += offsets[0];
    popper.top -= offsets[1];
  } else if (basePlacement === 'bottom') {
    popper.left += offsets[0];
    popper.top += offsets[1];
  }

  data.popper = popper;
  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function preventOverflow(data, options) {
  var boundariesElement = options.boundariesElement || getOffsetParent(data.instance.popper);

  // If offsetParent is the reference element, we really want to
  // go one step up and use the next offsetParent as reference to
  // avoid to make this modifier completely useless and look like broken
  if (data.instance.reference === boundariesElement) {
    boundariesElement = getOffsetParent(boundariesElement);
  }

  var boundaries = getBoundaries(data.instance.popper, data.instance.reference, options.padding, boundariesElement);
  options.boundaries = boundaries;

  var order = options.priority;
  var popper = data.offsets.popper;

  var check = {
    primary: function primary(placement) {
      var value = popper[placement];
      if (popper[placement] < boundaries[placement] && !options.escapeWithReference) {
        value = Math.max(popper[placement], boundaries[placement]);
      }
      return defineProperty({}, placement, value);
    },
    secondary: function secondary(placement) {
      var mainSide = placement === 'right' ? 'left' : 'top';
      var value = popper[mainSide];
      if (popper[placement] > boundaries[placement] && !options.escapeWithReference) {
        value = Math.min(popper[mainSide], boundaries[placement] - (placement === 'right' ? popper.width : popper.height));
      }
      return defineProperty({}, mainSide, value);
    }
  };

  order.forEach(function (placement) {
    var side = ['left', 'top'].indexOf(placement) !== -1 ? 'primary' : 'secondary';
    popper = _extends({}, popper, check[side](placement));
  });

  data.offsets.popper = popper;

  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function shift(data) {
  var placement = data.placement;
  var basePlacement = placement.split('-')[0];
  var shiftvariation = placement.split('-')[1];

  // if shift shiftvariation is specified, run the modifier
  if (shiftvariation) {
    var _data$offsets = data.offsets,
        reference = _data$offsets.reference,
        popper = _data$offsets.popper;

    var isVertical = ['bottom', 'top'].indexOf(basePlacement) !== -1;
    var side = isVertical ? 'left' : 'top';
    var measurement = isVertical ? 'width' : 'height';

    var shiftOffsets = {
      start: defineProperty({}, side, reference[side]),
      end: defineProperty({}, side, reference[side] + reference[measurement] - popper[measurement])
    };

    data.offsets.popper = _extends({}, popper, shiftOffsets[shiftvariation]);
  }

  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function hide(data) {
  if (!isModifierRequired(data.instance.modifiers, 'hide', 'preventOverflow')) {
    return data;
  }

  var refRect = data.offsets.reference;
  var bound = find(data.instance.modifiers, function (modifier) {
    return modifier.name === 'preventOverflow';
  }).boundaries;

  if (refRect.bottom < bound.top || refRect.left > bound.right || refRect.top > bound.bottom || refRect.right < bound.left) {
    // Avoid unnecessary DOM access if visibility hasn't changed
    if (data.hide === true) {
      return data;
    }

    data.hide = true;
    data.attributes['x-out-of-boundaries'] = '';
  } else {
    // Avoid unnecessary DOM access if visibility hasn't changed
    if (data.hide === false) {
      return data;
    }

    data.hide = false;
    data.attributes['x-out-of-boundaries'] = false;
  }

  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function inner(data) {
  var placement = data.placement;
  var basePlacement = placement.split('-')[0];
  var _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var isHoriz = ['left', 'right'].indexOf(basePlacement) !== -1;

  var subtractLength = ['top', 'left'].indexOf(basePlacement) === -1;

  popper[isHoriz ? 'left' : 'top'] = reference[basePlacement] - (subtractLength ? popper[isHoriz ? 'width' : 'height'] : 0);

  data.placement = getOppositePlacement(placement);
  data.offsets.popper = getClientRect(popper);

  return data;
}

/**
 * Modifier function, each modifier can have a function of this type assigned
 * to its `fn` property.<br />
 * These functions will be called on each update, this means that you must
 * make sure they are performant enough to avoid performance bottlenecks.
 *
 * @function ModifierFn
 * @argument {dataObject} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {dataObject} The data object, properly modified
 */

/**
 * Modifiers are plugins used to alter the behavior of your poppers.<br />
 * Popper.js uses a set of 9 modifiers to provide all the basic functionalities
 * needed by the library.
 *
 * Usually you don't want to override the `order`, `fn` and `onLoad` props.
 * All the other properties are configurations that could be tweaked.
 * @namespace modifiers
 */
var modifiers = {
  /**
   * Modifier used to shift the popper on the start or end of its reference
   * element.<br />
   * It will read the variation of the `placement` property.<br />
   * It can be one either `-end` or `-start`.
   * @memberof modifiers
   * @inner
   */
  shift: {
    /** @prop {number} order=100 - Index used to define the order of execution */
    order: 100,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: shift
  },

  /**
   * The `offset` modifier can shift your popper on both its axis.
   *
   * It accepts the following units:
   * - `px` or unitless, interpreted as pixels
   * - `%` or `%r`, percentage relative to the length of the reference element
   * - `%p`, percentage relative to the length of the popper element
   * - `vw`, CSS viewport width unit
   * - `vh`, CSS viewport height unit
   *
   * For length is intended the main axis relative to the placement of the popper.<br />
   * This means that if the placement is `top` or `bottom`, the length will be the
   * `width`. In case of `left` or `right`, it will be the height.
   *
   * You can provide a single value (as `Number` or `String`), or a pair of values
   * as `String` divided by a comma or one (or more) white spaces.<br />
   * The latter is a deprecated method because it leads to confusion and will be
   * removed in v2.<br />
   * Additionally, it accepts additions and subtractions between different units.
   * Note that multiplications and divisions aren't supported.
   *
   * Valid examples are:
   * ```
   * 10
   * '10%'
   * '10, 10'
   * '10%, 10'
   * '10 + 10%'
   * '10 - 5vh + 3%'
   * '-10px + 5vh, 5px - 6%'
   * ```
   * > **NB**: If you desire to apply offsets to your poppers in a way that may make them overlap
   * > with their reference element, unfortunately, you will have to disable the `flip` modifier.
   * > More on this [reading this issue](https://github.com/FezVrasta/popper.js/issues/373)
   *
   * @memberof modifiers
   * @inner
   */
  offset: {
    /** @prop {number} order=200 - Index used to define the order of execution */
    order: 200,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: offset,
    /** @prop {Number|String} offset=0
     * The offset value as described in the modifier description
     */
    offset: 0
  },

  /**
   * Modifier used to prevent the popper from being positioned outside the boundary.
   *
   * An scenario exists where the reference itself is not within the boundaries.<br />
   * We can say it has "escaped the boundaries" — or just "escaped".<br />
   * In this case we need to decide whether the popper should either:
   *
   * - detach from the reference and remain "trapped" in the boundaries, or
   * - if it should ignore the boundary and "escape with its reference"
   *
   * When `escapeWithReference` is set to`true` and reference is completely
   * outside its boundaries, the popper will overflow (or completely leave)
   * the boundaries in order to remain attached to the edge of the reference.
   *
   * @memberof modifiers
   * @inner
   */
  preventOverflow: {
    /** @prop {number} order=300 - Index used to define the order of execution */
    order: 300,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: preventOverflow,
    /**
     * @prop {Array} [priority=['left','right','top','bottom']]
     * Popper will try to prevent overflow following these priorities by default,
     * then, it could overflow on the left and on top of the `boundariesElement`
     */
    priority: ['left', 'right', 'top', 'bottom'],
    /**
     * @prop {number} padding=5
     * Amount of pixel used to define a minimum distance between the boundaries
     * and the popper this makes sure the popper has always a little padding
     * between the edges of its container
     */
    padding: 5,
    /**
     * @prop {String|HTMLElement} boundariesElement='scrollParent'
     * Boundaries used by the modifier, can be `scrollParent`, `window`,
     * `viewport` or any DOM element.
     */
    boundariesElement: 'scrollParent'
  },

  /**
   * Modifier used to make sure the reference and its popper stay near eachothers
   * without leaving any gap between the two. Expecially useful when the arrow is
   * enabled and you want to assure it to point to its reference element.
   * It cares only about the first axis, you can still have poppers with margin
   * between the popper and its reference element.
   * @memberof modifiers
   * @inner
   */
  keepTogether: {
    /** @prop {number} order=400 - Index used to define the order of execution */
    order: 400,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: keepTogether
  },

  /**
   * This modifier is used to move the `arrowElement` of the popper to make
   * sure it is positioned between the reference element and its popper element.
   * It will read the outer size of the `arrowElement` node to detect how many
   * pixels of conjuction are needed.
   *
   * It has no effect if no `arrowElement` is provided.
   * @memberof modifiers
   * @inner
   */
  arrow: {
    /** @prop {number} order=500 - Index used to define the order of execution */
    order: 500,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: arrow,
    /** @prop {String|HTMLElement} element='[x-arrow]' - Selector or node used as arrow */
    element: '[x-arrow]'
  },

  /**
   * Modifier used to flip the popper's placement when it starts to overlap its
   * reference element.
   *
   * Requires the `preventOverflow` modifier before it in order to work.
   *
   * **NOTE:** this modifier will interrupt the current update cycle and will
   * restart it if it detects the need to flip the placement.
   * @memberof modifiers
   * @inner
   */
  flip: {
    /** @prop {number} order=600 - Index used to define the order of execution */
    order: 600,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: flip,
    /**
     * @prop {String|Array} behavior='flip'
     * The behavior used to change the popper's placement. It can be one of
     * `flip`, `clockwise`, `counterclockwise` or an array with a list of valid
     * placements (with optional variations).
     */
    behavior: 'flip',
    /**
     * @prop {number} padding=5
     * The popper will flip if it hits the edges of the `boundariesElement`
     */
    padding: 5,
    /**
     * @prop {String|HTMLElement} boundariesElement='viewport'
     * The element which will define the boundaries of the popper position,
     * the popper will never be placed outside of the defined boundaries
     * (except if keepTogether is enabled)
     */
    boundariesElement: 'viewport'
  },

  /**
   * Modifier used to make the popper flow toward the inner of the reference element.
   * By default, when this modifier is disabled, the popper will be placed outside
   * the reference element.
   * @memberof modifiers
   * @inner
   */
  inner: {
    /** @prop {number} order=700 - Index used to define the order of execution */
    order: 700,
    /** @prop {Boolean} enabled=false - Whether the modifier is enabled or not */
    enabled: false,
    /** @prop {ModifierFn} */
    fn: inner
  },

  /**
   * Modifier used to hide the popper when its reference element is outside of the
   * popper boundaries. It will set a `x-out-of-boundaries` attribute which can
   * be used to hide with a CSS selector the popper when its reference is
   * out of boundaries.
   *
   * Requires the `preventOverflow` modifier before it in order to work.
   * @memberof modifiers
   * @inner
   */
  hide: {
    /** @prop {number} order=800 - Index used to define the order of execution */
    order: 800,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: hide
  },

  /**
   * Computes the style that will be applied to the popper element to gets
   * properly positioned.
   *
   * Note that this modifier will not touch the DOM, it just prepares the styles
   * so that `applyStyle` modifier can apply it. This separation is useful
   * in case you need to replace `applyStyle` with a custom implementation.
   *
   * This modifier has `850` as `order` value to maintain backward compatibility
   * with previous versions of Popper.js. Expect the modifiers ordering method
   * to change in future major versions of the library.
   *
   * @memberof modifiers
   * @inner
   */
  computeStyle: {
    /** @prop {number} order=850 - Index used to define the order of execution */
    order: 850,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: computeStyle,
    /**
     * @prop {Boolean} gpuAcceleration=true
     * If true, it uses the CSS 3d transformation to position the popper.
     * Otherwise, it will use the `top` and `left` properties.
     */
    gpuAcceleration: true,
    /**
     * @prop {string} [x='bottom']
     * Where to anchor the X axis (`bottom` or `top`). AKA X offset origin.
     * Change this if your popper should grow in a direction different from `bottom`
     */
    x: 'bottom',
    /**
     * @prop {string} [x='left']
     * Where to anchor the Y axis (`left` or `right`). AKA Y offset origin.
     * Change this if your popper should grow in a direction different from `right`
     */
    y: 'right'
  },

  /**
   * Applies the computed styles to the popper element.
   *
   * All the DOM manipulations are limited to this modifier. This is useful in case
   * you want to integrate Popper.js inside a framework or view library and you
   * want to delegate all the DOM manipulations to it.
   *
   * Note that if you disable this modifier, you must make sure the popper element
   * has its position set to `absolute` before Popper.js can do its work!
   *
   * Just disable this modifier and define you own to achieve the desired effect.
   *
   * @memberof modifiers
   * @inner
   */
  applyStyle: {
    /** @prop {number} order=900 - Index used to define the order of execution */
    order: 900,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: applyStyle,
    /** @prop {Function} */
    onLoad: applyStyleOnLoad,
    /**
     * @deprecated since version 1.10.0, the property moved to `computeStyle` modifier
     * @prop {Boolean} gpuAcceleration=true
     * If true, it uses the CSS 3d transformation to position the popper.
     * Otherwise, it will use the `top` and `left` properties.
     */
    gpuAcceleration: undefined
  }
};

/**
 * The `dataObject` is an object containing all the informations used by Popper.js
 * this object get passed to modifiers and to the `onCreate` and `onUpdate` callbacks.
 * @name dataObject
 * @property {Object} data.instance The Popper.js instance
 * @property {String} data.placement Placement applied to popper
 * @property {String} data.originalPlacement Placement originally defined on init
 * @property {Boolean} data.flipped True if popper has been flipped by flip modifier
 * @property {Boolean} data.hide True if the reference element is out of boundaries, useful to know when to hide the popper.
 * @property {HTMLElement} data.arrowElement Node used as arrow by arrow modifier
 * @property {Object} data.styles Any CSS property defined here will be applied to the popper, it expects the JavaScript nomenclature (eg. `marginBottom`)
 * @property {Object} data.arrowStyles Any CSS property defined here will be applied to the popper arrow, it expects the JavaScript nomenclature (eg. `marginBottom`)
 * @property {Object} data.boundaries Offsets of the popper boundaries
 * @property {Object} data.offsets The measurements of popper, reference and arrow elements.
 * @property {Object} data.offsets.popper `top`, `left`, `width`, `height` values
 * @property {Object} data.offsets.reference `top`, `left`, `width`, `height` values
 * @property {Object} data.offsets.arrow] `top` and `left` offsets, only one of them will be different from 0
 */

/**
 * Default options provided to Popper.js constructor.<br />
 * These can be overriden using the `options` argument of Popper.js.<br />
 * To override an option, simply pass as 3rd argument an object with the same
 * structure of this object, example:
 * ```
 * new Popper(ref, pop, {
 *   modifiers: {
 *     preventOverflow: { enabled: false }
 *   }
 * })
 * ```
 * @type {Object}
 * @static
 * @memberof Popper
 */
var Defaults = {
  /**
   * Popper's placement
   * @prop {Popper.placements} placement='bottom'
   */
  placement: 'bottom',

  /**
   * Whether events (resize, scroll) are initially enabled
   * @prop {Boolean} eventsEnabled=true
   */
  eventsEnabled: true,

  /**
   * Set to true if you want to automatically remove the popper when
   * you call the `destroy` method.
   * @prop {Boolean} removeOnDestroy=false
   */
  removeOnDestroy: false,

  /**
   * Callback called when the popper is created.<br />
   * By default, is set to no-op.<br />
   * Access Popper.js instance with `data.instance`.
   * @prop {onCreate}
   */
  onCreate: function onCreate() {},

  /**
   * Callback called when the popper is updated, this callback is not called
   * on the initialization/creation of the popper, but only on subsequent
   * updates.<br />
   * By default, is set to no-op.<br />
   * Access Popper.js instance with `data.instance`.
   * @prop {onUpdate}
   */
  onUpdate: function onUpdate() {},

  /**
   * List of modifiers used to modify the offsets before they are applied to the popper.
   * They provide most of the functionalities of Popper.js
   * @prop {modifiers}
   */
  modifiers: modifiers
};

/**
 * @callback onCreate
 * @param {dataObject} data
 */

/**
 * @callback onUpdate
 * @param {dataObject} data
 */

// Utils
// Methods
var Popper = function () {
  /**
   * Create a new Popper.js instance
   * @class Popper
   * @param {HTMLElement|referenceObject} reference - The reference element used to position the popper
   * @param {HTMLElement} popper - The HTML element used as popper.
   * @param {Object} options - Your custom options to override the ones defined in [Defaults](#defaults)
   * @return {Object} instance - The generated Popper.js instance
   */
  function Popper(reference, popper) {
    var _this = this;

    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    classCallCheck(this, Popper);

    this.scheduleUpdate = function () {
      return requestAnimationFrame(_this.update);
    };

    // make update() debounced, so that it only runs at most once-per-tick
    this.update = debounce(this.update.bind(this));

    // with {} we create a new object with the options inside it
    this.options = _extends({}, Popper.Defaults, options);

    // init state
    this.state = {
      isDestroyed: false,
      isCreated: false,
      scrollParents: []
    };

    // get reference and popper elements (allow jQuery wrappers)
    this.reference = reference && reference.jquery ? reference[0] : reference;
    this.popper = popper && popper.jquery ? popper[0] : popper;

    // Deep merge modifiers options
    this.options.modifiers = {};
    Object.keys(_extends({}, Popper.Defaults.modifiers, options.modifiers)).forEach(function (name) {
      _this.options.modifiers[name] = _extends({}, Popper.Defaults.modifiers[name] || {}, options.modifiers ? options.modifiers[name] : {});
    });

    // Refactoring modifiers' list (Object => Array)
    this.modifiers = Object.keys(this.options.modifiers).map(function (name) {
      return _extends({
        name: name
      }, _this.options.modifiers[name]);
    })
    // sort the modifiers by order
    .sort(function (a, b) {
      return a.order - b.order;
    });

    // modifiers have the ability to execute arbitrary code when Popper.js get inited
    // such code is executed in the same order of its modifier
    // they could add new properties to their options configuration
    // BE AWARE: don't add options to `options.modifiers.name` but to `modifierOptions`!
    this.modifiers.forEach(function (modifierOptions) {
      if (modifierOptions.enabled && isFunction(modifierOptions.onLoad)) {
        modifierOptions.onLoad(_this.reference, _this.popper, _this.options, modifierOptions, _this.state);
      }
    });

    // fire the first update to position the popper in the right place
    this.update();

    var eventsEnabled = this.options.eventsEnabled;
    if (eventsEnabled) {
      // setup event listeners, they will take care of update the position in specific situations
      this.enableEventListeners();
    }

    this.state.eventsEnabled = eventsEnabled;
  }

  // We can't use class properties because they don't get listed in the
  // class prototype and break stuff like Sinon stubs


  createClass(Popper, [{
    key: 'update',
    value: function update$$1() {
      return update.call(this);
    }
  }, {
    key: 'destroy',
    value: function destroy$$1() {
      return destroy.call(this);
    }
  }, {
    key: 'enableEventListeners',
    value: function enableEventListeners$$1() {
      return enableEventListeners.call(this);
    }
  }, {
    key: 'disableEventListeners',
    value: function disableEventListeners$$1() {
      return disableEventListeners.call(this);
    }

    /**
     * Schedule an update, it will run on the next UI update available
     * @method scheduleUpdate
     * @memberof Popper
     */


    /**
     * Collection of utilities useful when writing custom modifiers.
     * Starting from version 1.7, this method is available only if you
     * include `popper-utils.js` before `popper.js`.
     *
     * **DEPRECATION**: This way to access PopperUtils is deprecated
     * and will be removed in v2! Use the PopperUtils module directly instead.
     * Due to the high instability of the methods contained in Utils, we can't
     * guarantee them to follow semver. Use them at your own risk!
     * @static
     * @private
     * @type {Object}
     * @deprecated since version 1.8
     * @member Utils
     * @memberof Popper
     */

  }]);
  return Popper;
}();

/**
 * The `referenceObject` is an object that provides an interface compatible with Popper.js
 * and lets you use it as replacement of a real DOM node.<br />
 * You can use this method to position a popper relatively to a set of coordinates
 * in case you don't have a DOM node to use as reference.
 *
 * ```
 * new Popper(referenceObject, popperNode);
 * ```
 *
 * NB: This feature isn't supported in Internet Explorer 10
 * @name referenceObject
 * @property {Function} data.getBoundingClientRect
 * A function that returns a set of coordinates compatible with the native `getBoundingClientRect` method.
 * @property {number} data.clientWidth
 * An ES6 getter that will return the width of the virtual reference element.
 * @property {number} data.clientHeight
 * An ES6 getter that will return the height of the virtual reference element.
 */


Popper.Utils = (typeof window !== 'undefined' ? window : global).PopperUtils;
Popper.placements = placements;
Popper.Defaults = Defaults;

/* harmony default export */ __webpack_exports__["default"] = (Popper);
//# sourceMappingURL=popper.js.map

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(7)))

/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var Arrow = function Arrow(props, context) {
  var _props$component = props.component,
      component = _props$component === undefined ? 'span' : _props$component,
      innerRef = props.innerRef,
      children = props.children,
      restProps = _objectWithoutProperties(props, ['component', 'innerRef', 'children']);

  var popper = context.popper;

  var arrowRef = function arrowRef(node) {
    popper.setArrowNode(node);
    if (typeof innerRef === 'function') {
      innerRef(node);
    }
  };
  var arrowStyle = popper.getArrowStyle();

  if (typeof children === 'function') {
    var arrowProps = {
      ref: arrowRef,
      style: arrowStyle
    };
    return children({ arrowProps: arrowProps, restProps: restProps });
  }

  var componentProps = _extends({}, restProps, {
    style: _extends({}, arrowStyle, restProps.style)
  });

  if (typeof component === 'string') {
    componentProps.ref = arrowRef;
  } else {
    componentProps.innerRef = arrowRef;
  }

  return (0, _react.createElement)(component, componentProps, children);
};

Arrow.contextTypes = {
  popper: _propTypes2.default.object.isRequired
};

Arrow.propTypes = {
  component: _propTypes2.default.oneOfType([_propTypes2.default.node, _propTypes2.default.func]),
  innerRef: _propTypes2.default.func,
  children: _propTypes2.default.oneOfType([_propTypes2.default.node, _propTypes2.default.func])
};

exports.default = Arrow;

/***/ }),
/* 56 */
/***/ (function(module, exports) {

/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/** Used to match leading and trailing whitespace. */
var reTrim = /^\s+|\s+$/g;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && objectToString.call(value) == symbolTag);
}

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = value.replace(reTrim, '');
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

module.exports = toNumber;


/***/ }),
/* 57 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reactstrap__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_monsters_index__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_monsterImages_monsterImagesList__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib_stats__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lib_icons__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__MonsterContainer_css__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__MonsterContainer_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__MonsterContainer_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__StatusPopover__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_reveal__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_reveal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react_reveal__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// console.log(MONSTERS["Harrower Infester"].stats[5].elite.extra);
var MonsterContainer=function(_Component){_inherits(MonsterContainer,_Component);function MonsterContainer(props){_classCallCheck(this,MonsterContainer);// console.log(this.props);
var _this=_possibleConstructorReturn(this,(MonsterContainer.__proto__||Object.getPrototypeOf(MonsterContainer)).call(this,props));_this.toggleActive=function(monsterNumber){var newMonsterList=_this.state.monsterList;//reset for new monster
if(!newMonsterList[monsterNumber-1].active){newMonsterList[monsterNumber-1].currentHP=newMonsterList[monsterNumber-1].maxHP;newMonsterList[monsterNumber-1].rank="normal";newMonsterList[monsterNumber-1].statuses={"disarm":false,"immobilize":false,"wound":false,"muddle":false,"poison":false,"stun":false,"invisible":false,"strengthen":false};}newMonsterList[monsterNumber-1].active=!newMonsterList[monsterNumber-1].active;_this.setState({monsterList:newMonsterList});// console.log(this.props.monsterType + " " + monsterNumber + " set to " + newMonsterList[monsterNumber-1].active)
};_this.toggleRank=function(monsterNumber){var newMonsterList=_this.state.monsterList;if(newMonsterList[monsterNumber-1].rank==="normal"){newMonsterList[monsterNumber-1].rank="elite";newMonsterList[monsterNumber-1].maxHP=_this.state.maxHP[1];newMonsterList[monsterNumber-1].currentHP=newMonsterList[monsterNumber-1].maxHP;}else{newMonsterList[monsterNumber-1].rank="normal";newMonsterList[monsterNumber-1].maxHP=_this.state.maxHP[0];newMonsterList[monsterNumber-1].currentHP=newMonsterList[monsterNumber-1].maxHP;}_this.setState({monsterList:newMonsterList});console.log(_this.props.monsterType+" "+monsterNumber+" set to "+newMonsterList[monsterNumber-1].rank);};_this.toggleStatus=function(monsterNumber,status){var newMonsterList=_this.state.monsterList;newMonsterList[monsterNumber-1].statuses[status]=!newMonsterList[monsterNumber-1].statuses[status];_this.setState({monsterList:newMonsterList});console.log("set "+_this.props.monsterType+" "+monsterNumber+" "+status+" to "+newMonsterList[monsterNumber-1].statuses[status]);};_this.killMonster=function(monsterNumber){var newMonsterList=_this.state.monsterList;newMonsterList[monsterNumber-1].currentHP=0;newMonsterList[monsterNumber-1].active=false;_this.setState({monsterList:newMonsterList});console.log("killed "+_this.props.monsterType+" "+monsterNumber);};_this.changeHP=function(monsterNumber,hpChange){var newMonsterList=_this.state.monsterList;newMonsterList[monsterNumber-1].currentHP+=hpChange;if(newMonsterList[monsterNumber-1].currentHP>=newMonsterList[monsterNumber-1].maxHP){newMonsterList[monsterNumber-1].currentHP=newMonsterList[monsterNumber-1].maxHP;}if(newMonsterList[monsterNumber-1].currentHP<0){newMonsterList[monsterNumber-1].currentHP=0;}_this.setState({monsterList:newMonsterList});};_this.clearStatuses=function(monsterNumber){var newMonsterList=_this.state.monsterList;newMonsterList[monsterNumber-1].statuses={"disarm":false,"immobilize":false,"wound":false,"muddle":false,"poison":false,"stun":false,"invisible":false,"strengthen":false};_this.setState({monsterList:newMonsterList});};_this.state={maxHP:[__WEBPACK_IMPORTED_MODULE_2__lib_monsters_index__["b" /* MONSTERS */][_this.props.monsterType].stats[_this.props.level].normal.maxHP,__WEBPACK_IMPORTED_MODULE_2__lib_monsters_index__["b" /* MONSTERS */][_this.props.monsterType].stats[_this.props.level].elite.maxHP],move:[__WEBPACK_IMPORTED_MODULE_2__lib_monsters_index__["b" /* MONSTERS */][_this.props.monsterType].stats[_this.props.level].normal.move,__WEBPACK_IMPORTED_MODULE_2__lib_monsters_index__["b" /* MONSTERS */][_this.props.monsterType].stats[_this.props.level].elite.move],range:[__WEBPACK_IMPORTED_MODULE_2__lib_monsters_index__["b" /* MONSTERS */][_this.props.monsterType].stats[_this.props.level].normal.range,__WEBPACK_IMPORTED_MODULE_2__lib_monsters_index__["b" /* MONSTERS */][_this.props.monsterType].stats[_this.props.level].elite.range],attack:[__WEBPACK_IMPORTED_MODULE_2__lib_monsters_index__["b" /* MONSTERS */][_this.props.monsterType].stats[_this.props.level].normal.attack,__WEBPACK_IMPORTED_MODULE_2__lib_monsters_index__["b" /* MONSTERS */][_this.props.monsterType].stats[_this.props.level].elite.attack],extra:[__WEBPACK_IMPORTED_MODULE_2__lib_monsters_index__["b" /* MONSTERS */][_this.props.monsterType].stats[_this.props.level].normal.extra,__WEBPACK_IMPORTED_MODULE_2__lib_monsters_index__["b" /* MONSTERS */][_this.props.monsterType].stats[_this.props.level].elite.extra],tokenCount:__WEBPACK_IMPORTED_MODULE_2__lib_monsters_index__["b" /* MONSTERS */][_this.props.monsterType].tokenCount,monsterList:[],removePopoverOpen:false,collapseOpen:true};_this.toggleStatus=_this.toggleStatus.bind(_this);_this.clearStatuses=_this.clearStatuses.bind(_this);_this.togglePopover=_this.togglePopover.bind(_this);_this.toggleCollapse=_this.toggleCollapse.bind(_this);return _this;}_createClass(MonsterContainer,[{key:'componentWillMount',value:function componentWillMount(){for(var j=0;j<2;j++){if(this.state.range[j]===0){var range=this.state.range;range[j]="-";this.setState({range:range});}if(this.state.attack[j]===0){var attack=this.state.attack;attack[j]="-";this.setState({attack:attack});}if(this.state.move[j]===0){var move=this.state.move;move[j]="-";this.setState({move:move});}}var monsterList=[];for(var i=1;i<=this.state.tokenCount;i++){monsterList.push({"number":i,"active":false,"maxHP":this.state.maxHP[0],"currentHP":this.state.maxHP[0],"statuses":{"disarm":false,"immobilize":false,"wound":false,"muddle":false,"poison":false,"stun":false,"invisible":false,"strengthen":false},"rank":"normal"});}// console.log(monsterList);
this.setState({monsterList:monsterList});}},{key:'togglePopover',value:function togglePopover(){this.setState({removePopoverOpen:!this.state.removePopoverOpen});}},{key:'toggleCollapse',value:function toggleCollapse(){this.setState({collapseOpen:!this.state.collapseOpen});}},{key:'render',value:function render(){var _this2=this;var statsStyle={color:"#ffffff",backgroundColor:"#0F0F0F",borderColor:"#1b1e21"};var statsStyleElite={color:"#ffffff",backgroundColor:"#757303",borderColor:"#1b1e21"};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["b" /* Card */],{className:'text-white bg-dark'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["d" /* CardHeader */],{style:{fontFamily:"PirataOne"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["y" /* Row */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["e" /* Col */],{md:'4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'img-fluid rounded',style:{height:"30px",width:"30px",cursor:"pointer"},id:"thumbnail-"+this.props.monsterType.replace(/\s+/g,''),src:__WEBPACK_IMPORTED_MODULE_3__lib_monsterImages_monsterImagesList__["a" /* default */][this.props.monsterType],alt:this.props.monsterType,onClick:this.toggleCollapse}),' \xA0\xA0',this.props.monsterType,' : ',this.props.level)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["e" /* Col */],{md:'4',sm:'3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["y" /* Row */],null,!this.state.collapseOpen?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_reveal__["Fade"],{bottom:true,duration:300},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:statsStyle},'\xA0 HP: ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,this.state.maxHP[0]),', \xA0',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'img-fluid MonsterTracker--StatIcon',src:Object(__WEBPACK_IMPORTED_MODULE_4__lib_stats__["d" /* iconForStat */])(__WEBPACK_IMPORTED_MODULE_4__lib_stats__["a" /* ATTACK */]),alt:'attack'}),': ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,this.state.attack[0]),', \xA0',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'img-fluid MonsterTracker--StatIcon',src:Object(__WEBPACK_IMPORTED_MODULE_4__lib_stats__["d" /* iconForStat */])(__WEBPACK_IMPORTED_MODULE_4__lib_stats__["b" /* MOVEMENT */]),alt:'move'}),': ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,this.state.move[0]),', \xA0',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'img-fluid MonsterTracker--StatIcon',src:Object(__WEBPACK_IMPORTED_MODULE_4__lib_stats__["d" /* iconForStat */])(__WEBPACK_IMPORTED_MODULE_4__lib_stats__["c" /* RANGE */]),alt:'range'}),': ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,this.state.range[0]),' \xA0\xA0')):null,!this.state.collapseOpen?this.state.extra[0].map(function(item){if(Object(item)===item&&item.modifier!=null){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_reveal__["Fade"],{bottom:true,duration:300,key:item.type},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:statsStyle},item.type,' ',item.modifier,' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'img-fluid MonsterTracker--StatIcon',src:Object(__WEBPACK_IMPORTED_MODULE_5__lib_icons__["a" /* getIcon */])(item.type),alt:item.type}),' \xA0'));}else if(Object(item)===item){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_reveal__["Fade"],{bottom:true,duration:300,key:item.type},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:statsStyle},item.type,' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'img-fluid MonsterTracker--StatIcon',src:Object(__WEBPACK_IMPORTED_MODULE_5__lib_icons__["a" /* getIcon */])(item.type),alt:item.type}),' \xA0'));}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_reveal__["Fade"],{bottom:true,duration:300,key:item},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:statsStyle},item,' \xA0'));}}):null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["y" /* Row */],null,!this.state.collapseOpen?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_reveal__["Fade"],{bottom:true,duration:300},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:statsStyleElite},'\xA0 HP: ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,this.state.maxHP[1]),', \xA0',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'img-fluid MonsterTracker--StatIcon',src:Object(__WEBPACK_IMPORTED_MODULE_4__lib_stats__["d" /* iconForStat */])(__WEBPACK_IMPORTED_MODULE_4__lib_stats__["a" /* ATTACK */]),alt:'attack'}),': ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,this.state.attack[1]),', \xA0',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'img-fluid MonsterTracker--StatIcon',src:Object(__WEBPACK_IMPORTED_MODULE_4__lib_stats__["d" /* iconForStat */])(__WEBPACK_IMPORTED_MODULE_4__lib_stats__["b" /* MOVEMENT */]),alt:'move'}),': ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,this.state.move[1]),', \xA0',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'img-fluid MonsterTracker--StatIcon',src:Object(__WEBPACK_IMPORTED_MODULE_4__lib_stats__["d" /* iconForStat */])(__WEBPACK_IMPORTED_MODULE_4__lib_stats__["c" /* RANGE */]),alt:'range'}),': ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,this.state.range[1]),' \xA0\xA0')):null,!this.state.collapseOpen?this.state.extra[1].map(function(item){if(Object(item)===item&&item.modifier!=null){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_reveal__["Fade"],{bottom:true,duration:300,key:item.type},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:statsStyleElite},item.type,' ',item.modifier,' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'img-fluid MonsterTracker--StatIcon',src:Object(__WEBPACK_IMPORTED_MODULE_5__lib_icons__["a" /* getIcon */])(item.type),alt:item.type}),' \xA0'));}else if(Object(item)===item){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_reveal__["Fade"],{bottom:true,duration:300,key:item.type},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:statsStyleElite},item.type,' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'img-fluid MonsterTracker--StatIcon',src:Object(__WEBPACK_IMPORTED_MODULE_5__lib_icons__["a" /* getIcon */])(item.type),alt:item.type}),' \xA0'));}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_reveal__["Fade"],{bottom:true,duration:300,key:item},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:statsStyleElite},item,' \xA0'));}}):null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["e" /* Col */],{md:'4',sm:'5',className:'text-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,this.state.monsterList.map(function(monster,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["a" /* Button */],{key:i+1,size:'xs',onClick:function onClick(){_this2.toggleActive(i+1);},className:_this2.state.monsterList[i].active?"btn btn-secondary":"btn btn-outline-secondary"},i+1);}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["f" /* Collapse */],{isOpen:this.state.collapseOpen},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["g" /* Container */],{fluid:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["y" /* Row */],{className:'no-gutter'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["e" /* Col */],{sm:'2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'img-fluid rounded mx-auto d-block',id:"removeMonsterPopover-"+this.props.monsterType.replace(/\s+/g,''),src:__WEBPACK_IMPORTED_MODULE_3__lib_monsterImages_monsterImagesList__["a" /* default */][this.props.monsterType],alt:this.props.monsterType,onClick:this.togglePopover}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["u" /* Popover */],{placement:'auto',isOpen:this.state.removePopoverOpen,target:"removeMonsterPopover-"+this.props.monsterType.replace(/\s+/g,''),toggle:this.togglePopover},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["v" /* PopoverBody */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["a" /* Button */],{color:'danger',onClick:function onClick(){_this2.props.removeMonster(_this2.props.monsterType);}},'Remove monster type')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["e" /* Col */],{sm:'5'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["y" /* Row */],{className:'no-gutter'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["e" /* Col */],{md:'6'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["n" /* ListGroup */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["o" /* ListGroupItem */],{style:statsStyle},'HP: ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,this.state.maxHP[0])),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["o" /* ListGroupItem */],{style:statsStyle},'Attack ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'img-fluid MonsterTracker--StatIcon',src:Object(__WEBPACK_IMPORTED_MODULE_4__lib_stats__["d" /* iconForStat */])(__WEBPACK_IMPORTED_MODULE_4__lib_stats__["a" /* ATTACK */]),alt:'attack'}),': ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,this.state.attack[0])),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["o" /* ListGroupItem */],{style:statsStyle},'Move ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'img-fluid MonsterTracker--StatIcon',src:Object(__WEBPACK_IMPORTED_MODULE_4__lib_stats__["d" /* iconForStat */])(__WEBPACK_IMPORTED_MODULE_4__lib_stats__["b" /* MOVEMENT */]),alt:'movement'}),': ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,this.state.move[0])),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["o" /* ListGroupItem */],{style:statsStyle},'Range ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'img-fluid MonsterTracker--StatIcon',src:Object(__WEBPACK_IMPORTED_MODULE_4__lib_stats__["d" /* iconForStat */])(__WEBPACK_IMPORTED_MODULE_4__lib_stats__["c" /* RANGE */]),alt:'range'}),': ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,this.state.range[0])))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["e" /* Col */],{md:'6'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["n" /* ListGroup */],null,this.state.extra[0].map(function(item){if(Object(item)===item&&item.modifier!=null){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["o" /* ListGroupItem */],{key:item.type,style:statsStyle},item.type,' ',item.modifier,' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'img-fluid MonsterTracker--StatIcon',src:Object(__WEBPACK_IMPORTED_MODULE_5__lib_icons__["a" /* getIcon */])(item.type),alt:item.type}));}else if(Object(item)===item){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["o" /* ListGroupItem */],{key:item.type,style:statsStyle},item.type,' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'img-fluid MonsterTracker--StatIcon',src:Object(__WEBPACK_IMPORTED_MODULE_5__lib_icons__["a" /* getIcon */])(item.type),alt:item.type}));}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["o" /* ListGroupItem */],{key:item,style:statsStyle},item);}}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["e" /* Col */],{sm:'5'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["y" /* Row */],{className:'no-gutter'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["e" /* Col */],{md:'6'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["n" /* ListGroup */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["o" /* ListGroupItem */],{style:statsStyleElite},'HP: ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,this.state.maxHP[1])),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["o" /* ListGroupItem */],{style:statsStyleElite},'Attack ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'img-fluid MonsterTracker--StatIcon',src:Object(__WEBPACK_IMPORTED_MODULE_4__lib_stats__["d" /* iconForStat */])(__WEBPACK_IMPORTED_MODULE_4__lib_stats__["a" /* ATTACK */]),alt:'attack'}),': ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,this.state.attack[1])),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["o" /* ListGroupItem */],{style:statsStyleElite},'Move ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'img-fluid MonsterTracker--StatIcon',src:Object(__WEBPACK_IMPORTED_MODULE_4__lib_stats__["d" /* iconForStat */])(__WEBPACK_IMPORTED_MODULE_4__lib_stats__["b" /* MOVEMENT */]),alt:'movement'}),': ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,this.state.move[1])),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["o" /* ListGroupItem */],{style:statsStyleElite},'Range ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'img-fluid MonsterTracker--StatIcon',src:Object(__WEBPACK_IMPORTED_MODULE_4__lib_stats__["d" /* iconForStat */])(__WEBPACK_IMPORTED_MODULE_4__lib_stats__["c" /* RANGE */]),alt:'range'}),': ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,this.state.range[1])))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["e" /* Col */],{md:'6'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["n" /* ListGroup */],null,this.state.extra[1].map(function(item){if(Object(item)===item&&item.modifier!=null){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["o" /* ListGroupItem */],{key:item.type,style:statsStyleElite},item.type,' ',item.modifier,' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'img-fluid MonsterTracker--StatIcon',src:Object(__WEBPACK_IMPORTED_MODULE_5__lib_icons__["a" /* getIcon */])(item.type),alt:item.type}));}else if(Object(item)===item){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["o" /* ListGroupItem */],{key:item.type,style:statsStyleElite},item.type,' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'img-fluid MonsterTracker--StatIcon',src:Object(__WEBPACK_IMPORTED_MODULE_5__lib_icons__["a" /* getIcon */])(item.type),alt:item.type}));}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["o" /* ListGroupItem */],{key:item,style:statsStyleElite},item);}}))))))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["y" /* Row */],{className:'no-gutter'},this.state.monsterList.map(function(monster,i){if(_this2.state.monsterList[i].active){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["e" /* Col */],{md:'4',xs:'6',key:i+1},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["b" /* Card */],{className:_this2.state.monsterList[i].rank==="elite"?"card text-white bg-warning mb-3":"card bg-light mb-3"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["d" /* CardHeader */],{style:{fontFamily:"PirataOne"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["y" /* Row */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["e" /* Col */],{md:'7'},_this2.props.monsterType,' \xA0 ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('font',{size:'+2'},i+1))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["e" /* Col */],{md:'5'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["a" /* Button */],{color:'info',size:'sm',onClick:function onClick(){_this2.toggleRank(i+1);}},'Rank'),'\xA0',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["a" /* Button */],{color:'danger',size:'sm',onClick:function onClick(){_this2.killMonster(i+1);}},'Kill')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["c" /* CardBody */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["y" /* Row */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["e" /* Col */],{sm:'6',xs:'12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["x" /* Progress */],{style:{height:"30px"},color:'danger',value:_this2.state.monsterList[i].currentHP,max:_this2.state.monsterList[i].maxHP},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,_this2.state.monsterList[i].currentHP))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["e" /* Col */],{sm:'6',xs:'12',className:'text-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["a" /* Button */],{color:'danger',size:'sm',onClick:function onClick(){_this2.changeHP(i+1,-1);}},'-'),' \xA0\xA0',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__StatusPopover__["a" /* default */],{text:"S",placement:'auto',id:"Statuses-"+_this2.props.monsterType.replace(/\s+/g,'')+"-"+(i+1),toggleStatus:_this2.toggleStatus,clearStatuses:_this2.clearStatuses,statusList:_this2.state.monsterList[i].statuses,monsterType:_this2.props.monsterType,monsterNumber:i+1}),'\xA0\xA0',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["a" /* Button */],{color:'success',size:'sm',onClick:function onClick(){_this2.changeHP(i+1,1);}},'+'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["y" /* Row */],null,Object.keys(_this2.state.monsterList[i].statuses).map(function(status){if(_this2.state.monsterList[i].statuses[status]){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:status},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_reveal__["Fade"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'img-fluid MonsterTracker--StatusEffectIcon',src:Object(__WEBPACK_IMPORTED_MODULE_5__lib_icons__["a" /* getIcon */])(status.toUpperCase()),alt:status,onClick:function onClick(){_this2.toggleStatus(i+1,status);},style:{cursor:"pointer"}})));}else{return null;}})))));}else{return null;}})));}}]);return MonsterContainer;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (MonsterContainer);

/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/aoe-circle.0a6787b3.svg";

/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/aoe-circle-with-middle-black.7be792df.svg";

/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/aoe-circle-with-side-black.aeb051db.svg";

/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/aoe-triangle-2.12278694.svg";

/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/aoe-triangle-2-with-black.ad30957e.svg";

/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/aoe-triangle-3-with-corner-black.1f34cc03.svg";

/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/aoe-line-3-with-black.b39ca936.svg";

/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/aoe-line-4-with-black.502d737d.svg";

/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/aoe-line-6-with-black.a7f1b116.svg";

/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/aoe-4-with-black.8b2be9d7.svg";

/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/elderDrakeSpecial1Area.b81e97cb.svg";

/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/inoxBodyguardSpecial1Area.7c623f77.svg";

/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/sightlessEyeSpecial1Area.24f4acca.svg";

/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/sightlessEyeSpecial2Area.c723bd57.svg";

/***/ }),
/* 72 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export NUMBER_MODIFIERS */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return END_ACTIONS; });
/* unused harmony export iconForEndAction */
/* unused harmony export BASE_CARDS */
/* unused harmony export CURSE */
/* unused harmony export BLESS */
/* unused harmony export BASE_DECK */
/* unused harmony export shuffle */
/* unused harmony export needsShuffle */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__shuffle_svg__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__shuffle_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__shuffle_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__rolling_svg__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__rolling_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__rolling_svg__);
var _endActionIcons;function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var PLUS_ONE="+1";var PLUS_TWO="+2";var PLUS_THREE="+3";var PLUS_ZERO="+0";var MINUS_ONE="-1";var MINUS_TWO="-2";var NULL="null";var TIMES_TWO="x2";var NUMBER_MODIFIERS={PLUS_ONE:PLUS_ONE,PLUS_TWO:PLUS_TWO,PLUS_THREE:PLUS_THREE,PLUS_ZERO:PLUS_ZERO,MINUS_ONE:MINUS_ONE,MINUS_TWO:MINUS_TWO,NULL:NULL,TIMES_TWO:TIMES_TWO};var SHUFFLE="shuffle";var DISCARD="discard";var ROLLING="rolling";var END_ACTIONS={SHUFFLE:SHUFFLE,DISCARD:DISCARD,ROLLING:ROLLING};var endActionIcons=(_endActionIcons={},_defineProperty(_endActionIcons,SHUFFLE,__WEBPACK_IMPORTED_MODULE_0__shuffle_svg___default.a),_defineProperty(_endActionIcons,ROLLING,__WEBPACK_IMPORTED_MODULE_1__rolling_svg___default.a),_endActionIcons);function iconForEndAction(name){return endActionIcons[name];}var BASE_CARDS={PLUS_ZERO:{modifier:PLUS_ZERO},PLUS_ONE:{modifier:PLUS_ONE},PLUS_TWO:{modifier:PLUS_TWO},MINUS_ONE:{modifier:MINUS_ONE},MINUS_TWO:{modifier:MINUS_TWO},TIMES_TWO:{modifier:TIMES_TWO,endAction:SHUFFLE},NULL:{modifier:NULL,endAction:SHUFFLE}};var CURSE={modifier:NULL,endAction:DISCARD};var BLESS={modifier:TIMES_TWO,endAction:DISCARD};var BASE_DECK=[BASE_CARDS.PLUS_ZERO,BASE_CARDS.PLUS_ZERO,BASE_CARDS.PLUS_ZERO,BASE_CARDS.PLUS_ZERO,BASE_CARDS.PLUS_ZERO,BASE_CARDS.PLUS_ZERO,BASE_CARDS.PLUS_ONE,BASE_CARDS.PLUS_ONE,BASE_CARDS.PLUS_ONE,BASE_CARDS.PLUS_ONE,BASE_CARDS.PLUS_ONE,BASE_CARDS.MINUS_ONE,BASE_CARDS.MINUS_ONE,BASE_CARDS.MINUS_ONE,BASE_CARDS.MINUS_ONE,BASE_CARDS.MINUS_ONE,BASE_CARDS.PLUS_TWO,BASE_CARDS.MINUS_TWO,BASE_CARDS.TIMES_TWO,BASE_CARDS.NULL];// https://gist.github.com/guilhermepontes/17ae0cc71fa2b13ea8c20c94c5c35dc4#gistcomment-2271465
function shuffle(cards){return cards.map(function(a){return[Math.random(),a];}).sort(function(a,b){return a[0]-b[0];}).map(function(a){return a[1];});}function needsShuffle(_ref){var cards=_ref.cards,currentIndex=_ref.currentIndex;return cards.filter(function(_,i){return i<=currentIndex;}).some(function(c){return c.endAction===END_ACTIONS.SHUFFLE;});}

/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/shuffle.45f1850f.svg";

/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/rolling.8aa12f68.svg";

/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/any_element.34db005c.svg";

/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/air.fac591e3.svg";

/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/dark.39e1aa10.svg";

/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/earth.443bd9ff.svg";

/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/fire.673d53c2.svg";

/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/ice.06520bc7.svg";

/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/light.ef434304.svg";

/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/use_element.eb11cf13.svg";

/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/curse.9664421c.svg";

/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/bless.59479e31.svg";

/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/disarm.079d79cd.svg";

/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/immobilize.d10777f5.svg";

/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/invisible.94f6aac1.svg";

/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/muddle.96983af1.svg";

/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/poison.7d7f60b4.svg";

/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/strengthen.8acb9b8e.svg";

/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/stun.b82f281d.svg";

/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/wound.52753d3c.svg";

/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/push.c3799cf8.svg";

/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/pull.6149737b.svg";

/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/attack.a1598f5a.svg";

/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/heal.c963fe2e.svg";

/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/move.4bfeefc7.svg";

/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/pierce.588df0b3.svg";

/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/range.1ade028b.svg";

/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/retaliate.170dbe3a.svg";

/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/shield.bb5c34b1.svg";

/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/target.91304f4e.svg";

/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/push.c3799cf8.svg";

/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/pull.6149737b.svg";

/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/ancientArtillery.2c1f1db4.png";

/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/banditArcher.2a3260fe.png";

/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/banditGuard.98c0292d.png";

/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/blackImp.6ee792a9.png";

/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/caveBear.38b11b54.png";

/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/cityArcher.fac63f3b.png";

/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/cityGuard.2e335591.png";

/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/cultist.047d56fd.png";

/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/deepTerror.5bddf6a4.png";

/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/earthDemon.6c0593bf.png";

/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/flameDemon.1b4e33fa.png";

/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/frostDemon.a789b30c.png";

/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/forestImp.56627d17.png";

/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/giantViper.8a11bc3b.png";

/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/harrowerInfester.338f7600.png";

/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/hound.5be493ac.png";

/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/inoxArcher.bf5a0ba1.png";

/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/inoxGuard.d7b00219.png";

/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/inoxShaman.dda01d62.png";

/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/livingBones.8f2d5afd.png";

/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/livingCorpse.03241eda.png";

/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/livingSpirit.2f1ec306.png";

/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/lurker.e7db8f21.png";

/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/nightDemon.5e79fb21.png";

/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/ooze.937a6e0a.png";

/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/rendingDrake.0024619d.png";

/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/savvasLavaflow.dc1da176.png";

/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/savvasIcestorm.1c978932.png";

/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/spittingDrake.cb9a829b.png";

/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/stoneGolem.a5dddb71.png";

/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/sunDemon.f7e3c2a6.png";

/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/vermlingScout.421a6b04.png";

/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/vermlingShaman.78996f92.png";

/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/windDemon.98cbe640.png";

/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/banditCommander.ad6dafcb.jpg";

/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/captainOfTheGuard.89799fb4.jpg";

/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/darkRider.4a525e8d.jpg";

/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/elderDrake.e76d10a2.jpg";

/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/inoxBodyguard.3f86499a.jpg";

/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/jekserah.3e690e6e.jpg";

/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/mercilessOverseer.bb4c31a0.jpg";

/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/primeDemon.e2fa5871.jpg";

/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/sightlessEye.22c1481f.jpg";

/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/theBetrayer.768d5cdb.jpg";

/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/theColorless.1dc5530a.jpg";

/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/theGloom.adfb8f31.jpg";

/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/wingedHorror.650d71b3.jpg";

/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/attack.a1598f5a.svg";

/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/movement.4bfeefc7.svg";

/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/range.1ade028b.svg";

/***/ }),
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/health.c963fe2e.svg";

/***/ }),
/* 156 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export HEAL */
/* unused harmony export RETALIATE */
/* unused harmony export SHIELD */
/* unused harmony export PIERCE */
/* unused harmony export ADD_TARGET */
/* unused harmony export BONUSES */
/* harmony export (immutable) */ __webpack_exports__["a"] = iconForBonus;
/* unused harmony export pierce */
/* unused harmony export shield */
/* unused harmony export heal */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__heal_svg__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__heal_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__heal_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__retaliate_svg__ = __webpack_require__(158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__retaliate_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__retaliate_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shield_svg__ = __webpack_require__(159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shield_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__shield_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__pierce_svg__ = __webpack_require__(160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__pierce_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__pierce_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__add_target_svg__ = __webpack_require__(161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__add_target_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__add_target_svg__);
var _bonusIcons;function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var HEAL="heal";var RETALIATE="retaliate";var SHIELD="shield";var PIERCE="pierce";var ADD_TARGET="add_target";var bonusIcons=(_bonusIcons={},_defineProperty(_bonusIcons,HEAL,__WEBPACK_IMPORTED_MODULE_0__heal_svg___default.a),_defineProperty(_bonusIcons,RETALIATE,__WEBPACK_IMPORTED_MODULE_1__retaliate_svg___default.a),_defineProperty(_bonusIcons,SHIELD,__WEBPACK_IMPORTED_MODULE_2__shield_svg___default.a),_defineProperty(_bonusIcons,PIERCE,__WEBPACK_IMPORTED_MODULE_3__pierce_svg___default.a),_defineProperty(_bonusIcons,ADD_TARGET,__WEBPACK_IMPORTED_MODULE_4__add_target_svg___default.a),_bonusIcons);var BONUSES=Object.keys(bonusIcons);function iconForBonus(name){return bonusIcons[name];}function pierce(value){return{type:PIERCE,value:value};}function shield(value){var self=arguments.length>1&&arguments[1]!==undefined?arguments[1]:true;return{type:SHIELD,value:value,self:self};}function heal(value){var self=arguments.length>1&&arguments[1]!==undefined?arguments[1]:true;return{type:HEAL,value:value,self:self};}

/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/heal.c963fe2e.svg";

/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/retaliate.170dbe3a.svg";

/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/shield.bb5c34b1.svg";

/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/pierce.588df0b3.svg";

/***/ }),
/* 161 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/add_target.6a9b0572.svg";

/***/ }),
/* 162 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
function _interopRequireDefault(e){return e&&e.__esModule?e:{default:e}}function _objectWithoutProperties(e,t){var r={};for(var o in e)t.indexOf(o)>=0||Object.prototype.hasOwnProperty.call(e,o)&&(r[o]=e[o]);return r}function Reveal(e){function t(e){return e?_?{duration:n,delay:f,count:s,forever:d,className:_,style:{}}:y:i?{duration:void 0===o?u:o,delay:p,count:a,forever:l,className:i,style:{}}:c}var r=e.children,o=e.timeout,u=e.duration,p=e.delay,a=e.count,l=e.forever,n=e.durationOut,f=e.delayOut,s=e.countOut,d=e.foreverOut,i=e.effect,_=e.effectOut,c=e.inEffect,y=e.outEffect,O=_objectWithoutProperties(e,["children","timeout","duration","delay","count","forever","durationOut","delayOut","countOut","foreverOut","effect","effectOut","inEffect","outEffect"]);return(0,_wrap2.default)(O,t(!1),t(!0),r)}Object.defineProperty(exports,"__esModule",{value:!0});var _extends=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var r=arguments[t];for(var o in r)Object.prototype.hasOwnProperty.call(r,o)&&(e[o]=r[o])}return e},_propTypes=__webpack_require__(1),_globals=__webpack_require__(2),_wrap=__webpack_require__(3),_wrap2=_interopRequireDefault(_wrap),_Fade=__webpack_require__(22),_Fade2=_interopRequireDefault(_Fade),propTypes={in:_propTypes.object,out:(0,_propTypes.oneOfType)([_propTypes.object,(0,_propTypes.oneOf)([!1])]),effect:_propTypes.string,effectOut:_propTypes.string,duration:_propTypes.number,timeout:_propTypes.number,delay:_propTypes.number,count:_propTypes.number,forever:_propTypes.bool,durationOut:_propTypes.number,delayOut:_propTypes.number,countOut:_propTypes.number,foreverOut:_propTypes.bool},defaultProps=_extends({},_globals.defaults,{durationOut:_globals.defaults.duration,delayOut:_globals.defaults.delay,countOut:_globals.defaults.count,foreverOut:_globals.defaults.forever,inEffect:(0,_Fade2.default)(_globals.defaults),outEffect:(0,_Fade2.default)(_extends({out:!0},_globals.defaults))});Reveal.propTypes=propTypes,Reveal.defaultProps=defaultProps,exports.default=Reveal,module.exports=exports.default;

/***/ }),
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
function _interopRequireDefault(e){return e&&e.__esModule?e:{default:e}}function _defineProperty(e,t,i){return t in e?Object.defineProperty(e,t,{value:i,enumerable:!0,configurable:!0,writable:!0}):e[t]=i,e}function _classCallCheck(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function _possibleConstructorReturn(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function _inherits(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}Object.defineProperty(exports,"__esModule",{value:!0});var _typeof="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e},_slicedToArray=function(){function e(e,t){var i=[],s=!0,o=!1,n=void 0;try{for(var r,a=e[Symbol.iterator]();!(s=(r=a.next()).done)&&(i.push(r.value),!t||i.length!==t);s=!0);}catch(e){o=!0,n=e}finally{try{!s&&a.return&&a.return()}finally{if(o)throw n}}return i}return function(t,i){if(Array.isArray(t))return t;if(Symbol.iterator in Object(t))return e(t,i);throw new TypeError("Invalid attempt to destructure non-iterable instance")}}(),_extends=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var i=arguments[t];for(var s in i)Object.prototype.hasOwnProperty.call(i,s)&&(e[s]=i[s])}return e},_createClass=function(){function e(e,t){for(var i=0;i<t.length;i++){var s=t[i];s.enumerable=s.enumerable||!1,s.configurable=!0,"value"in s&&(s.writable=!0),Object.defineProperty(e,s.key,s)}}return function(t,i,s){return i&&e(t.prototype,i),s&&e(t,s),t}}(),_react=__webpack_require__(0),_react2=_interopRequireDefault(_react),_propTypes=__webpack_require__(1),_globals=__webpack_require__(2),inOut=(0,_propTypes.shape)({make:_propTypes.func,duration:_propTypes.number.isRequired,delay:_propTypes.number.isRequired,forever:_propTypes.bool,count:_propTypes.number.isRequired,style:_propTypes.object.isRequired,reverse:_propTypes.bool}),propTypes={collapse:_propTypes.bool,collapseEl:_propTypes.element,cascade:_propTypes.bool,wait:_propTypes.number,force:_propTypes.bool,disabled:_propTypes.bool,appear:_propTypes.bool,enter:_propTypes.bool,exit:_propTypes.bool,fraction:_propTypes.number,refProp:_propTypes.string,innerRef:_propTypes.func,onReveal:_propTypes.func,unmountOnExit:_propTypes.bool,mountOnEnter:_propTypes.bool,inEffect:inOut.isRequired,outEffect:(0,_propTypes.oneOfType)([inOut,(0,_propTypes.oneOf)([!1])]).isRequired,ssrReveal:_propTypes.bool,collapseOnly:_propTypes.bool,ssrFadeout:_propTypes.bool},defaultProps={fraction:.2,refProp:"ref"},contextTypes={transitionGroup:_propTypes.object},RevealBase=function(e){function t(e,i){_classCallCheck(this,t);var s=_possibleConstructorReturn(this,(t.__proto__||Object.getPrototypeOf(t)).call(this,e,i));return s.isOn=void 0===e.when||!!e.when,s.state={collapse:e.collapse?t.getInitialCollapseStyle(e):void 0,style:{opacity:s.isOn&&!e.ssrReveal||!e.outEffect?void 0:0}},s.savedChild=!1,s.isShown=!1,_globals.observerMode?s.handleObserve=s.handleObserve.bind(s):(s.revealHandler=s.makeHandler(s.reveal),s.resizeHandler=s.makeHandler(s.resize)),s.saveRef=s.saveRef.bind(s),s}return _inherits(t,e),_createClass(t,[{key:"saveRef",value:function(e){this.childRef&&this.childRef(e),this.props.innerRef&&this.props.innerRef(e),this.el!==e&&(this.el=e&&"offsetHeight"in e?e:void 0,this.observe(this.props,!0))}},{key:"invisible",value:function(){this&&this.el&&(this.savedChild=!1,this.isShown||(this.setState({hasExited:!0,collapse:this.props.collapse?_extends({},this.state.collapse,{visibility:"hidden"}):null,style:{opacity:0}}),!_globals.observerMode&&this.props.collapse&&window.document.dispatchEvent(_globals.collapseend)))}},{key:"animationEnd",value:function(e,t,i){var s=this,o=i.forever,n=i.count,r=i.delay,a=i.duration;if(!o){var l=function(){s&&s.el&&(s.animationEndTimeout=void 0,e.call(s))};this.animationEndTimeout=window.setTimeout(l,r+(a+(t?a:0)*n))}}},{key:"getDimensionValue",value:function(){return this.el.offsetHeight+parseInt(window.getComputedStyle(this.el,null).getPropertyValue("margin-top"),10)+parseInt(window.getComputedStyle(this.el,null).getPropertyValue("margin-bottom"),10)}},{key:"collapse",value:function(e,t,i){var s=i.duration+(t.cascade?i.duration:0),o=this.isOn?this.getDimensionValue():0,n=void 0,r=void 0;if(t.collapseOnly)n=i.duration/3,r=i.delay;else{var a=s>>2,l=a>>1;n=a,r=i.delay+(this.isOn?0:s-a-l),e.style.animationDuration=s-a+(this.isOn?l:-l)+"ms",e.style.animationDelay=i.delay+(this.isOn?a-l:0)+"ms"}return e.collapse={height:o,transition:"height "+n+"ms ease "+r+"ms",overflow:t.collapseOnly?"hidden":void 0},e}},{key:"animate",value:function(e){if(this&&this.el&&(this.unlisten(),this.isShown!==this.isOn)){this.isShown=this.isOn;var t=!this.isOn&&e.outEffect,i=e[t?"outEffect":"inEffect"],s="style"in i&&i.style.animationName||void 0,o=void 0;e.collapseOnly?o={hasAppeared:!0,hasExited:!1,style:{opacity:1}}:((e.outEffect||this.isOn)&&i.make&&(s=i.make),o={hasAppeared:!0,hasExited:!1,collapse:void 0,style:_extends({},i.style,{animationDuration:i.duration+"ms",animationDelay:i.delay+"ms",animationIterationCount:i.forever?"infinite":i.count,opacity:1,animationName:s}),className:i.className}),this.setState(e.collapse?this.collapse(o,e,i):o),t?(this.savedChild=_react2.default.cloneElement(this.getChild()),this.animationEnd(this.invisible,e.cascade,i)):this.savedChild=!1,this.onReveal(e)}}},{key:"onReveal",value:function(e){e.onReveal&&this.isOn&&(this.onRevealTimeout&&(this.onRevealTimeout=window.clearTimeout(this.onRevealTimeout)),e.wait?this.onRevealTimeout=window.setTimeout(e.onReveal,e.wait):e.onReveal())}},{key:"componentWillUnmount",value:function(){this.unlisten(),_globals.ssr&&(0,_globals.disableSsr)()}},{key:"handleObserve",value:function(e,t){_slicedToArray(e,1)[0].intersectionRatio>0&&(t.disconnect(),this.observer=null,this.reveal(this.props,!0))}},{key:"observe",value:function(e){var t=arguments.length>1&&void 0!==arguments[1]&&arguments[1];if(this.el&&_globals.observerMode){if(this.observer){if(!t)return;this.observer.disconnect()}else if(t)return;this.observer=new IntersectionObserver(this.handleObserve,{threshold:e.fraction}),this.observer.observe(this.el)}}},{key:"reveal",value:function(e){var t=this,i=arguments.length>1&&void 0!==arguments[1]&&arguments[1];_globals.globalHide||(0,_globals.hideAll)(),this&&this.el&&(e||(e=this.props),_globals.ssr&&(0,_globals.disableSsr)(),this.isOn&&this.isShown&&void 0!==e.spy?(this.isShown=!1,this.setState({style:{}}),window.setTimeout(function(){return t.reveal(e)},200)):i||this.inViewport(e)||e.force?this.animate(e):_globals.observerMode?this.observe(e):this.listen())}},{key:"componentDidMount",value:function(){var e=this;if(this.el&&!this.props.disabled){this.props.collapseOnly||("make"in this.props.inEffect&&this.props.inEffect.make(!1,this.props),void 0!==this.props.when&&this.props.outEffect&&"make"in this.props.outEffect&&this.props.outEffect.make(!0,this.props));var i=this.context.transitionGroup,s=i&&!i.isMounting?!("enter"in this.props&&!1===this.props.enter):this.props.appear;return this.isOn&&((void 0!==this.props.when||void 0!==this.props.spy)&&!s||_globals.ssr&&!_globals.fadeOutEnabled&&!this.props.ssrFadeout&&this.props.outEffect&&!this.props.ssrReveal&&t.getTop(this.el)<window.pageYOffset+window.innerHeight)?(this.isShown=!0,this.setState({hasAppeared:!0,collapse:this.props.collapse?{height:this.getDimensionValue()}:this.state.collapse,style:{opacity:1}}),void this.onReveal(this.props)):_globals.ssr&&(_globals.fadeOutEnabled||this.props.ssrFadeout)&&this.props.outEffect&&t.getTop(this.el)<window.pageYOffset+window.innerHeight?(this.setState({style:{opacity:0,transition:"opacity 1000ms 1000ms"}}),void window.setTimeout(function(){return e.reveal(e.props,!0)},2e3)):void(this.isOn&&(this.props.force?this.animate(this.props):this.reveal(this.props)))}}},{key:"cascade",value:function(e){var t=this,i=void 0;i="string"==typeof e?e.split("").map(function(e,t){return _react2.default.createElement("span",{key:t,style:{display:"inline-block",whiteSpace:"pre"}},e)}):_react2.default.Children.toArray(e);var s=this.props[this.isOn||!this.props.outEffect?"inEffect":"outEffect"],o=s.duration,n=s.reverse,r=i.length,a=2*o;this.props.collapse&&(a=parseInt(this.state.style.animationDuration,10),o=a/2);var l=n?r:0;return i=i.map(function(e){return"object"===(void 0===e?"undefined":_typeof(e))&&e?_react2.default.cloneElement(e,{style:_extends({},e.props.style,t.state.style,{animationDuration:Math.round((0,_globals.cascade)(n?l--:l++,0,r,o,a))+"ms"})}):e})}},{key:"componentWillReceiveProps",value:function(e){if(void 0!==e.when&&(this.isOn=!!e.when),e.fraction!==this.props.fraction&&this.observe(e,!0),!this.isOn&&e.onExited&&"exit"in e&&!1===e.exit)return void e.onExited();e.disabled||(e.collapse&&!this.props.collapse&&(this.setState({style:{},collapse:t.getInitialCollapseStyle(e)}),this.isShown=!1),e.when===this.props.when&&e.spy===this.props.spy||this.reveal(e),this.onRevealTimeout&&!this.isOn&&(this.onRevealTimeout=window.clearTimeout(this.onRevealTimeout)))}},{key:"getChild",value:function(){if(this.savedChild&&!this.props.disabled)return this.savedChild;if("object"===_typeof(this.props.children)){var e=_react2.default.Children.only(this.props.children);return"type"in e&&"string"==typeof e.type||"ref"!==this.props.refProp?e:_react2.default.createElement("div",null,e)}return _react2.default.createElement("div",null,this.props.children)}},{key:"render",value:function(){var e=void 0;e=this.state.hasAppeared?!this.props.unmountOnExit||!this.state.hasExited||this.isOn:!this.props.mountOnEnter||this.isOn;var t=this.getChild();"function"==typeof t.ref&&(this.childRef=t.ref);var i=!1,s=t.props,o=s.style,n=s.className,r=s.children,a=this.props.disabled?n:(this.props.outEffect?_globals.namespace:"")+(this.state.className?" "+this.state.className:"")+(n?" "+n:"")||void 0,l=void 0;"function"==typeof this.state.style.animationName&&(this.state.style.animationName=this.state.style.animationName(!this.isOn,this.props)),this.props.cascade&&!this.props.disabled&&r&&this.state.style.animationName?(i=this.cascade(r),l=_extends({},o,{opacity:1})):l=this.props.disabled?o:_extends({},o,this.state.style);var p=_extends({},this.props.props,_defineProperty({className:a,style:l},this.props.refProp,this.saveRef)),h=_react2.default.cloneElement(t,p,e?i||r:void 0);return void 0!==this.props.collapse?this.props.collapseEl?_react2.default.cloneElement(this.props.collapseEl,{style:_extends({},this.props.collapseEl.style,this.props.disabled?void 0:this.state.collapse),children:h}):_react2.default.createElement("div",{style:this.props.disabled?void 0:this.state.collapse,children:h}):h}},{key:"makeHandler",value:function(e){var t=this,i=function(){e.call(t,t.props),t.ticking=!1};return function(){t.ticking||((0,_globals.raf)(i),t.ticking=!0)}}},{key:"inViewport",value:function(e){if(!this.el||window.document.hidden)return!1;var i=this.el.offsetHeight,s=window.pageYOffset-t.getTop(this.el),o=Math.min(i,window.innerHeight)*(_globals.globalHide?e.fraction:0);return s>o-window.innerHeight&&s<i-o}},{key:"resize",value:function(e){this&&this.el&&this.isOn&&this.inViewport(e)&&(this.unlisten(),this.isShown=this.isOn,this.setState({hasExited:!this.isOn,hasAppeared:!0,collapse:void 0,style:{opacity:this.isOn||!e.outEffect?1:0}}),this.onReveal(e))}},{key:"listen",value:function(){_globals.observerMode||this.isListener||(this.isListener=!0,window.addEventListener("scroll",this.revealHandler,{passive:!0}),window.addEventListener("orientationchange",this.revealHandler,{passive:!0}),window.document.addEventListener("visibilitychange",this.revealHandler,{passive:!0}),window.document.addEventListener("collapseend",this.revealHandler,{passive:!0}),window.addEventListener("resize",this.resizeHandler,{passive:!0}))}},{key:"unlisten",value:function(){!_globals.observerMode&&this.isListener&&(window.removeEventListener("scroll",this.revealHandler,{passive:!0}),window.removeEventListener("orientationchange",this.revealHandler,{passive:!0}),window.document.removeEventListener("visibilitychange",this.revealHandler,{passive:!0}),window.document.removeEventListener("collapseend",this.revealHandler,{passive:!0}),window.removeEventListener("resize",this.resizeHandler,{passive:!0}),this.isListener=!1),this.onRevealTimeout&&(this.onRevealTimeout=window.clearTimeout(this.onRevealTimeout)),this.animationEndTimeout&&(this.animationEndTimeout=window.clearTimeout(this.animationEndTimeout))}}],[{key:"getInitialCollapseStyle",value:function(e){return{height:0,visibility:e.when?void 0:"hidden"}}},{key:"getTop",value:function(e){for(;void 0===e.offsetTop;)e=e.parentNode;for(var t=e.offsetTop;e.offsetParent;t+=e.offsetTop)e=e.offsetParent;return t}}]),t}(_react2.default.Component);RevealBase.propTypes=propTypes,RevealBase.defaultProps=defaultProps,RevealBase.contextTypes=contextTypes,RevealBase.displayName="RevealBase",exports.default=RevealBase,module.exports=exports.default;

/***/ }),
/* 164 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
function _interopRequireDefault(o){return o&&o.__esModule?o:{default:o}}function _objectWithoutProperties(o,n){var r={};for(var t in o)n.indexOf(t)>=0||Object.prototype.hasOwnProperty.call(o,t)&&(r[t]=o[t]);return r}function make(o,n){var r=n.left,t=n.right,e=n.up,a=n.down,p=n.top,i=n.bottom,s=n.mirror,l=n.opposite,u=(r?1:0)|(t?2:0)|(p||a?4:0)|(i||e?8:0)|(s?16:0)|(l?32:0)|(o?64:0);if(lookup.hasOwnProperty(u))return lookup[u];if(!s!=!(o&&l)){var d=[t,r,i,p,a,e];r=d[0],t=d[1],p=d[2],i=d[3],e=d[4],a=d[5]}var f=r||t,c=p||i||e||a,m=f||c,y=void 0,v=void 0,_=void 0,b=void 0,x=void 0,T=void 0,g=void 0,h=void 0,k=void 0,w=void 0,q=void 0,O=void 0,P=void 0,j=void 0;return o?(b=f?(t?"-":"")+"20px":0,x=c?(e||i?"":"-")+"10px":"0",T=(a||p?"":"-")+"20px",P=f?(r?"-":"")+"2000px":"0",j=c?(a||p?"-":"")+"2000px":"0"):(v=f?(r?"-":"")+"3000px":"0",_=c?(a||p?"-":"")+"3000px":"0",g=f?(t?"-":"")+"25px":"0",h=c?(e||i?"-":"")+"25px":"0",k=f?(r?"-":"")+"10px":"0",w=c?(a||p?"-":"")+"10px":"0",q=f?(t?"-":"")+"5px":"0",O=c?(e||i?"-":"")+"5px":"0"),y=m?o?"\n        20% {\n          transform: translate3d("+b+", "+x+", 0);\n          }\n        "+(c?"40%, 45% {\n            opacity: 1;\n            transform: translate3d(0, "+T+", 0);\n          }":"")+"\n          to {\n            opacity: 0;\n            transform: translate3d("+P+", "+j+", 0);\n        }\n      ":"from, 60%, 75%, 90%, to {\n        animation-timing-function: cubic-bezier(0.215, 0.610, 0.355, 1.000);\n      }\n      from {\n        opacity: 0;\n        transform: translate3d("+v+", "+_+", 0);\n      }\n      60% {\n        opacity: 1;\n        transform: translate3d("+g+", "+h+", 0);\n      }\n      75% {\n        transform: translate3d("+k+", "+w+", 0);\n      }\n      90% {\n        transform: translate3d("+q+", "+O+", 0);\n      }\n      to {\n        transform: none;\n      }":o?"20% {\n          transform: scale3d(.9, .9, .9);\n        }\n        50%, 55% {\n          opacity: 1;\n          transform: scale3d(1.1, 1.1, 1.1);\n        }\n        to {\n          opacity: 0;\n          transform: scale3d(.3, .3, .3);\n      }":"from, 20%, 40%, 60%, 80%, to {\n        animation-timing-function: cubic-bezier(0.215, 0.610, 0.355, 1.000);\n      }\n      0% {\n        opacity: 0;\n        transform: scale3d(.3, .3, .3);\n      }\n      20% {\n        transform: scale3d(1.1, 1.1, 1.1);\n      }\n      40% {\n        transform: scale3d(.9, .9, .9);\n      }\n      60% {\n        opacity: 1;\n        transform: scale3d(1.03, 1.03, 1.03);\n      }\n      80% {\n        transform: scale3d(.97, .97, .97);\n      }\n      to {\n        opacity: 1;\n        transform: scale3d(1, 1, 1);\n      }",lookup[u]=(0,_globals.animation)(y),lookup[u]}function Bounce(){var o=arguments.length>0&&void 0!==arguments[0]?arguments[0]:_globals.defaults,n=o.children,r=(o.out,o.forever),t=o.timeout,e=o.duration,a=void 0===e?_globals.defaults.duration:e,p=o.delay,i=void 0===p?_globals.defaults.delay:p,s=o.count,l=void 0===s?_globals.defaults.count:s,u=_objectWithoutProperties(o,["children","out","forever","timeout","duration","delay","count"]),d={make:make,duration:void 0===t?a:t,delay:i,forever:r,count:l,style:{animationFillMode:"both"},reverse:u.left};return(0,_wrap2.default)(u,d,d,n)}Object.defineProperty(exports,"__esModule",{value:!0});var _propTypes=__webpack_require__(1),_wrap=__webpack_require__(3),_wrap2=_interopRequireDefault(_wrap),_globals=__webpack_require__(2),propTypes={out:_propTypes.bool,left:_propTypes.bool,right:_propTypes.bool,top:_propTypes.bool,bottom:_propTypes.bool,mirror:_propTypes.bool,opposite:_propTypes.bool,duration:_propTypes.number,timeout:_propTypes.number,delay:_propTypes.number,count:_propTypes.number,forever:_propTypes.bool},lookup={};Bounce.propTypes=propTypes,exports.default=Bounce,module.exports=exports.default;

/***/ }),
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
function _interopRequireDefault(o){return o&&o.__esModule?o:{default:o}}function _objectWithoutProperties(o,e){var r={};for(var t in o)e.indexOf(t)>=0||Object.prototype.hasOwnProperty.call(o,t)&&(r[t]=o[t]);return r}function make(o,e){var r=e.left,t=e.right,p=e.up,l=e.down,a=e.top,u=e.bottom,i=e.big,n=e.mirror,s=e.opposite,d=(r?1:0)|(t?2:0)|(a||l?4:0)|(u||p?8:0)|(n?16:0)|(s?32:0)|(o?64:0)|(i?128:0);if(lookup.hasOwnProperty(d))return lookup[d];if(!n!=!(o&&s)){var _=[t,r,u,a,l,p];r=_[0],t=_[1],a=_[2],u=_[3],p=_[4],l=_[5]}var y=i?"2000px":"100%",b=r?"-"+y:t?y:"0",f=l||a?"-"+y:p||u?y:"0";return lookup[d]=(0,_globals.animation)("\n    "+(o?"to":"from")+" {opacity: 0;transform: translate3d("+b+", "+f+", 0) rotate3d(0, 0, 1, -120deg);}\n\t  "+(o?"from":"to")+" {opacity: 1;transform: none}\n  "),lookup[d]}function Roll(){var o=arguments.length>0&&void 0!==arguments[0]?arguments[0]:_globals.defaults,e=o.children,r=(o.out,o.forever),t=o.timeout,p=o.duration,l=void 0===p?_globals.defaults.duration:p,a=o.delay,u=void 0===a?_globals.defaults.delay:a,i=o.count,n=void 0===i?_globals.defaults.count:i,s=_objectWithoutProperties(o,["children","out","forever","timeout","duration","delay","count"]),d={make:make,duration:void 0===t?l:t,delay:u,forever:r,count:n,style:{animationFillMode:"both"}};return(0,_wrap2.default)(s,d,d,e)}Object.defineProperty(exports,"__esModule",{value:!0});var _wrap=__webpack_require__(3),_wrap2=_interopRequireDefault(_wrap),_propTypes=__webpack_require__(1),_globals=__webpack_require__(2),propTypes={out:_propTypes.bool,left:_propTypes.bool,right:_propTypes.bool,top:_propTypes.bool,bottom:_propTypes.bool,big:_propTypes.bool,mirror:_propTypes.bool,opposite:_propTypes.bool,duration:_propTypes.number,timeout:_propTypes.number,delay:_propTypes.number,count:_propTypes.number,forever:_propTypes.bool},lookup={};Roll.propTypes=propTypes,exports.default=Roll,module.exports=exports.default;

/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
function _interopRequireDefault(o){return o&&o.__esModule?o:{default:o}}function _objectWithoutProperties(o,e){var r={};for(var t in o)e.indexOf(t)>=0||Object.prototype.hasOwnProperty.call(o,t)&&(r[t]=o[t]);return r}function make(o,e){var r=e.left,t=e.right,p=e.up,l=e.down,u=e.top,a=e.bottom,i=e.big,n=e.mirror,s=e.opposite,d=(r?1:0)|(t?2:0)|(u||l?4:0)|(a||p?8:0)|(n?16:0)|(s?32:0)|(o?64:0)|(i?128:0);if(lookup.hasOwnProperty(d))return lookup[d];var _=r||t||p||l||u||a,f=void 0,b=void 0;if(_){if(!n!=!(o&&s)){var y=[t,r,a,u,l,p];r=y[0],t=y[1],u=y[2],a=y[3],p=y[4],l=y[5]}var m=i?"2000px":"100%";f=r?"-"+m:t?m:"0",b=l||u?"-"+m:p||a?m:"0"}return lookup[d]=(0,_globals.animation)((o?"to":"from")+" {"+(_?" transform: translate3d("+f+", "+b+", 0);":"")+"}\n     "+(o?"from":"to")+" {transform: none;} "),lookup[d]}function Slide(){var o=arguments.length>0&&void 0!==arguments[0]?arguments[0]:_globals.defaults,e=o.children,r=(o.out,o.forever),t=o.timeout,p=o.duration,l=void 0===p?_globals.defaults.duration:p,u=o.delay,a=void 0===u?_globals.defaults.delay:u,i=o.count,n=void 0===i?_globals.defaults.count:i,s=_objectWithoutProperties(o,["children","out","forever","timeout","duration","delay","count"]),d={make:make,duration:void 0===t?l:t,delay:a,forever:r,count:n,style:{animationFillMode:"both"},reverse:s.left};return(0,_wrap2.default)(s,d,d,e)}Object.defineProperty(exports,"__esModule",{value:!0});var _propTypes=__webpack_require__(1),_wrap=__webpack_require__(3),_wrap2=_interopRequireDefault(_wrap),_globals=__webpack_require__(2),propTypes={out:_propTypes.bool,left:_propTypes.bool,right:_propTypes.bool,top:_propTypes.bool,bottom:_propTypes.bool,big:_propTypes.bool,mirror:_propTypes.bool,opposite:_propTypes.bool,duration:_propTypes.number,timeout:_propTypes.number,delay:_propTypes.number,count:_propTypes.number,forever:_propTypes.bool},lookup={};Slide.propTypes=propTypes,exports.default=Slide,module.exports=exports.default;

/***/ }),
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
function _interopRequireDefault(e){return e&&e.__esModule?e:{default:e}}function _objectWithoutProperties(e,o){var t={};for(var r in e)o.indexOf(r)>=0||Object.prototype.hasOwnProperty.call(e,r)&&(t[r]=e[r]);return t}function make(e,o){var t=o.left,r=o.right,n=o.top,p=o.bottom,i=o.x,a=o.y,s=o.mirror,l=o.opposite,u=(t?1:0)|(r||a?2:0)|(n||i?4:0)|(p?8:0)|(s?16:0)|(l?32:0)|(e?64:0);if(lookup.hasOwnProperty(u))return lookup[u];if(!s!=!(e&&l)){var d=[r,t,p,n,a,i];t=d[0],r=d[1],n=d[2],p=d[3],i=d[4],a=d[5]}var f=void 0;if(i||a||t||r||n||p){var m=i||n||p?(p?"-":"")+"1":"0",c=a||r||t?(t?"-":"")+"1":"0";f=e?"from {\n          transform: perspective(400px);\n        }\n        30% {\n          transform: perspective(400px) rotate3d("+m+", "+c+", 0, -15deg);\n          opacity: 1;\n        }\n        to {\n          transform: perspective(400px) rotate3d("+m+", "+c+", 0, 90deg);\n          opacity: 0;\n        }":"from {\n          transform: perspective(400px) rotate3d("+m+", "+c+", 0, 90deg);\n          animation-timing-function: ease-in;\n          opacity: 0;\n        }\n        40% {\n          transform: perspective(400px) rotate3d("+m+", "+c+", 0, -20deg);\n          animation-timing-function: ease-in;\n        }\n        60% {\n          transform: perspective(400px) rotate3d("+m+", "+c+", 0, 10deg);\n          opacity: 1;\n        }\n        80% {\n          transform: perspective(400px) rotate3d("+m+", "+c+", 0, -5deg);\n        }\n        to {\n          transform: perspective(400px);\n        }"}else f="from {\n          transform: perspective(400px) rotate3d(0, 1, 0, -360deg);\n          animation-timing-function: ease-out;\n          opacity: "+(e?"1":"0")+";\n        }\n        40% {\n          transform: perspective(400px) translate3d(0, 0, 150px) rotate3d(0, 1, 0, -190deg);\n          animation-timing-function: ease-out;\n        }\n        50% {\n          transform: perspective(400px) translate3d(0, 0, 150px) rotate3d(0, 1, 0, -170deg);\n          animation-timing-function: ease-in;\n        }\n        to {\n          transform: perspective(400px);\n          animation-timing-function: ease-in;\n          opacity: "+(e?"0":"1")+";\n        }";return lookup[u]=(0,_globals.animation)(f),lookup[u]}function Flip(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:_globals.defaults,o=e.children,t=(e.out,e.forever),r=e.timeout,n=e.duration,p=void 0===n?_globals.defaults.duration:n,i=e.delay,a=void 0===i?_globals.defaults.delay:i,s=e.count,l=void 0===s?_globals.defaults.count:s,u=_objectWithoutProperties(e,["children","out","forever","timeout","duration","delay","count"]),d={make:make,duration:void 0===r?p:r,delay:a,forever:t,count:l,style:{animationFillMode:"both",backfaceVisibility:"visible"}};return(0,_wrap2.default)(u,d,d,o)}Object.defineProperty(exports,"__esModule",{value:!0});var _propTypes=__webpack_require__(1),_wrap=__webpack_require__(3),_wrap2=_interopRequireDefault(_wrap),_globals=__webpack_require__(2),propTypes={out:_propTypes.bool,left:_propTypes.bool,right:_propTypes.bool,top:_propTypes.bool,bottom:_propTypes.bool,mirror:_propTypes.bool,opposite:_propTypes.bool,duration:_propTypes.number,timeout:_propTypes.number,delay:_propTypes.number,count:_propTypes.number,forever:_propTypes.bool},lookup={};Flip.propTypes=propTypes,exports.default=Flip,module.exports=exports.default;

/***/ }),
/* 168 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
function _interopRequireDefault(o){return o&&o.__esModule?o:{default:o}}function _objectWithoutProperties(o,e){var r={};for(var t in o)e.indexOf(t)>=0||Object.prototype.hasOwnProperty.call(o,t)&&(r[t]=o[t]);return r}function make(o,e){var r=e.left,t=e.right,p=e.up,a=e.down,l=e.top,u=e.bottom,i=e.mirror,n=e.opposite,s=(r?1:0)|(t?2:0)|(l||a?4:0)|(u||p?8:0)|(i?16:0)|(n?32:0)|(o?64:0);if(lookup.hasOwnProperty(s))return lookup[s];if(!i!=!(o&&n)){var d=[t,r,u,l,a,p];r=d[0],t=d[1],l=d[2],u=d[3],p=d[4],a=d[5]}var f="-200deg",_="center";return(a||l)&&r&&(f="-45deg"),((a||l)&&t||(p||u)&&r)&&(f="45deg"),(p||u)&&t&&(f="-90deg"),(r||t)&&(_=(r?"left":"right")+" bottom"),lookup[s]=(0,_globals.animation)("\n    "+(o?"to":"from")+" { opacity: 0; transform-origin: "+_+"; transform: rotate3d(0, 0, 1, "+f+");}\n    "+(o?"from":"to")+" { opacity: 1; transform-origin: "+_+"; transform: none;}\n  "),lookup[s]}function Rotate(){var o=arguments.length>0&&void 0!==arguments[0]?arguments[0]:_globals.defaults,e=o.children,r=(o.out,o.forever),t=o.timeout,p=o.duration,a=void 0===p?_globals.defaults.duration:p,l=o.delay,u=void 0===l?_globals.defaults.delay:l,i=o.count,n=void 0===i?_globals.defaults.count:i,s=_objectWithoutProperties(o,["children","out","forever","timeout","duration","delay","count"]),d={make:make,duration:void 0===t?a:t,delay:u,forever:r,count:n,style:{animationFillMode:"both"}};return(0,_wrap2.default)(s,d,d,e)}Object.defineProperty(exports,"__esModule",{value:!0});var _propTypes=__webpack_require__(1),_wrap=__webpack_require__(3),_wrap2=_interopRequireDefault(_wrap),_globals=__webpack_require__(2),propTypes={out:_propTypes.bool,left:_propTypes.bool,right:_propTypes.bool,top:_propTypes.bool,bottom:_propTypes.bool,mirror:_propTypes.bool,opposite:_propTypes.bool,duration:_propTypes.number,timeout:_propTypes.number,delay:_propTypes.number,count:_propTypes.number,forever:_propTypes.bool},lookup={};Rotate.propTypes=propTypes,exports.default=Rotate,module.exports=exports.default;

/***/ }),
/* 169 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
function _interopRequireDefault(o){return o&&o.__esModule?o:{default:o}}function _objectWithoutProperties(o,e){var r={};for(var t in o)e.indexOf(t)>=0||Object.prototype.hasOwnProperty.call(o,t)&&(r[t]=o[t]);return r}function make(o,e){var r=e.left,t=e.right,p=e.mirror,n=e.opposite,a=(r?1:0)|(t?2:0)|(p?16:0)|(n?32:0)|(o?64:0);if(lookup.hasOwnProperty(a))return lookup[a];if(!p!=!(o&&n)){var i=[t,r];r=i[0],t=i[1]}var l=r?"-100%":t?"100%":"0",u=o?"from {\n        opacity: 1;\n      }\n      to {\n        transform: translate3d("+l+", 0, 0) skewX(30deg);\n        opacity: 0;\n      }\n    ":"from {\n        transform: translate3d("+l+", 0, 0) skewX(-30deg);\n        opacity: 0;\n      }\n      60% {\n        transform: skewX(20deg);\n        opacity: 1;\n      }\n      80% {\n        transform: skewX(-5deg);\n        opacity: 1;\n      }\n      to {\n        transform: none;\n        opacity: 1;\n      }";return lookup[a]=(0,_globals.animation)(u),lookup[a]}function LightSpeed(){var o=arguments.length>0&&void 0!==arguments[0]?arguments[0]:_globals.defaults,e=o.children,r=(o.out,o.forever),t=o.timeout,p=o.duration,n=void 0===p?_globals.defaults.duration:p,a=o.delay,i=void 0===a?_globals.defaults.delay:a,l=o.count,u=void 0===l?_globals.defaults.count:l,s=_objectWithoutProperties(o,["children","out","forever","timeout","duration","delay","count"]),d={make:make,duration:void 0===t?n:t,delay:i,forever:r,count:u,style:{animationFillMode:"both"}};s.left,s.right,s.mirror,s.opposite;return(0,_wrap2.default)(s,d,d,e)}Object.defineProperty(exports,"__esModule",{value:!0});var _wrap=__webpack_require__(3),_wrap2=_interopRequireDefault(_wrap),_propTypes=__webpack_require__(1),_globals=__webpack_require__(2),propTypes={out:_propTypes.bool,left:_propTypes.bool,right:_propTypes.bool,mirror:_propTypes.bool,opposite:_propTypes.bool,duration:_propTypes.number,timeout:_propTypes.number,delay:_propTypes.number,count:_propTypes.number,forever:_propTypes.bool},lookup={};LightSpeed.propTypes=propTypes,exports.default=LightSpeed,module.exports=exports.default;

/***/ }),
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
function _interopRequireDefault(o){return o&&o.__esModule?o:{default:o}}function _objectWithoutProperties(o,e){var r={};for(var t in o)e.indexOf(t)>=0||Object.prototype.hasOwnProperty.call(o,t)&&(r[t]=o[t]);return r}function make(o,e){var r=e.left,t=e.right,p=e.up,n=e.down,a=e.top,i=e.bottom,l=e.mirror,u=e.opposite,s=(r?1:0)|(t?2:0)|(a||n?4:0)|(i||p?8:0)|(l?16:0)|(u?32:0)|(o?64:0);if(lookup.hasOwnProperty(s))return lookup[s];if(!l!=!(o&&u)){var d=[t,r,i,a,n,p];r=d[0],t=d[1],a=d[2],i=d[3],p=d[4],n=d[5]}var f=r||t,c=a||i||p||n,m=f||c,y=void 0,b=void 0,_=void 0,v=void 0,T=void 0;return m?o?(b=f?(r?"":"-")+"42px":"0",_=c?(n||a?"-":"")+"60px":"0",v=f?(t?"":"-")+"2000px":"0",T=c?(p||i?"":"-")+"2000px":"0",y="40% {\n          opacity: 1;\n          transform: scale3d(.475, .475, .475) translate3d("+b+", "+_+", 0);\n        }\n        to {\n          opacity: 0;\n          transform: scale(.1) translate3d("+v+", "+T+", 0);\n          transform-origin: "+(c?"center bottom":(r?"left":"right")+" center")+";\n        }"):(b=f?(r?"-":"")+"1000px":"0",_=c?(n||a?"-":"")+"1000px":"0",v=f?(t?"-":"")+"10px":"0",T=c?(p||i?"-":"")+"60px":"0",y="from {\n          opacity: 0;\n          transform: scale3d(.1, .1, .1) translate3d("+b+", "+_+", 0);\n          animation-timing-function: cubic-bezier(0.550, 0.055, 0.675, 0.190);\n        }\n        60% {\n          opacity: 1;\n          transform: scale3d(.475, .475, .475) translate3d("+v+", "+T+", 0);\n          animation-timing-function: cubic-bezier(0.175, 0.885, 0.320, 1);\n        }"):y=(o?"to":"from")+" {opacity: 0; transform: scale3d(.1, .1, .1);} "+(o?"from":"to")+" { opacity: 1; transform: none;}",lookup[s]=(0,_globals.animation)(y),lookup[s]}function Zoom(){var o=arguments.length>0&&void 0!==arguments[0]?arguments[0]:_globals.defaults,e=o.children,r=(o.out,o.forever),t=o.timeout,p=o.duration,n=void 0===p?_globals.defaults.duration:p,a=o.delay,i=void 0===a?_globals.defaults.delay:a,l=o.count,u=void 0===l?_globals.defaults.count:l,s=_objectWithoutProperties(o,["children","out","forever","timeout","duration","delay","count"]),d={make:make,duration:void 0===t?n:t,delay:i,forever:r,count:u,style:{animationFillMode:"both"},reverse:s.left};return(0,_wrap2.default)(s,d,d,e)}Object.defineProperty(exports,"__esModule",{value:!0});var _propTypes=__webpack_require__(1),_wrap=__webpack_require__(3),_wrap2=_interopRequireDefault(_wrap),_globals=__webpack_require__(2),propTypes={out:_propTypes.bool,left:_propTypes.bool,right:_propTypes.bool,top:_propTypes.bool,bottom:_propTypes.bool,mirror:_propTypes.bool,opposite:_propTypes.bool,duration:_propTypes.number,timeout:_propTypes.number,delay:_propTypes.number,count:_propTypes.number,forever:_propTypes.bool},lookup={};Zoom.propTypes=propTypes,exports.default=Zoom,module.exports=exports.default;

/***/ }),
/* 171 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reactstrap__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_monsterImages_monsterImagesList__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_stats__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib_monsters__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lib_icons__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__MonsterContainer_css__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__MonsterContainer_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__MonsterContainer_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__StatusPopover__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_reveal__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_reveal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react_reveal__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// import { MONSTERS } from "../lib/monsters/index";
// console.log(BOSS_STATS["The Colorless"][3](4));
var BossContainer=function(_Component){_inherits(BossContainer,_Component);function BossContainer(props){_classCallCheck(this,BossContainer);// console.log(this.props);
var _this=_possibleConstructorReturn(this,(BossContainer.__proto__||Object.getPrototypeOf(BossContainer)).call(this,props));_this.toggleActive=function(monsterNumber){var newMonsterList=_this.state.monsterList;//reset for new monster
if(!newMonsterList[monsterNumber-1].active){newMonsterList[monsterNumber-1].maxHP=_this.state.maxHP;newMonsterList[monsterNumber-1].currentHP=_this.state.maxHP;newMonsterList[monsterNumber-1].rank="normal";newMonsterList[monsterNumber-1].statuses={"disarm":false,"immobilize":false,"wound":false,"muddle":false,"poison":false,"stun":false,"invisible":false,"strengthen":false};}newMonsterList[monsterNumber-1].active=!newMonsterList[monsterNumber-1].active;_this.setState({monsterList:newMonsterList});};_this.toggleStatus=function(monsterNumber,status){var newMonsterList=_this.state.monsterList;newMonsterList[monsterNumber-1].statuses[status]=!newMonsterList[monsterNumber-1].statuses[status];_this.setState({monsterList:newMonsterList});console.log("set "+_this.props.monsterType+" "+monsterNumber+" "+status+" to "+newMonsterList[monsterNumber-1].statuses[status]);};_this.killMonster=function(monsterNumber){var newMonsterList=_this.state.monsterList;newMonsterList[monsterNumber-1].currentHP=0;newMonsterList[monsterNumber-1].active=false;_this.setState({monsterList:newMonsterList});console.log("killed "+_this.props.monsterType+" "+monsterNumber);};_this.changeHP=function(monsterNumber,hpChange){var newMonsterList=_this.state.monsterList;newMonsterList[monsterNumber-1].currentHP+=hpChange;if(newMonsterList[monsterNumber-1].currentHP>=newMonsterList[monsterNumber-1].maxHP){newMonsterList[monsterNumber-1].currentHP=newMonsterList[monsterNumber-1].maxHP;}if(newMonsterList[monsterNumber-1].currentHP<0){newMonsterList[monsterNumber-1].currentHP=0;}_this.setState({monsterList:newMonsterList});};_this.changePlayerCount=function(){var newPlayerCount=_this.state.playerCount+1;if(newPlayerCount>4){newPlayerCount=2;}_this.setState({playerCount:newPlayerCount,maxHP:__WEBPACK_IMPORTED_MODULE_4__lib_monsters__["a" /* BOSS_STATS */][_this.props.monsterType][_this.props.level](newPlayerCount).maxHP},function(){if(_this.state.monsterList[0].active){_this.toggleActive(1);}});};_this.clearStatuses=function(monsterNumber){var newMonsterList=_this.state.monsterList;newMonsterList[monsterNumber-1].statuses={"disarm":false,"immobilize":false,"wound":false,"muddle":false,"poison":false,"stun":false,"invisible":false,"strengthen":false};_this.setState({monsterList:newMonsterList});};_this.state={playerCount:4,monsterList:[],tokenCount:1,removePopoverOpen:false,collapseOpen:true};_this.toggleStatus=_this.toggleStatus.bind(_this);_this.clearStatuses=_this.clearStatuses.bind(_this);_this.togglePopover=_this.togglePopover.bind(_this);_this.toggleCollapse=_this.toggleCollapse.bind(_this);return _this;}_createClass(BossContainer,[{key:'componentWillMount',value:function componentWillMount(){var _this2=this;this.setState({maxHP:__WEBPACK_IMPORTED_MODULE_4__lib_monsters__["a" /* BOSS_STATS */][this.props.monsterType][this.props.level](this.state.playerCount).maxHP,attack:__WEBPACK_IMPORTED_MODULE_4__lib_monsters__["a" /* BOSS_STATS */][this.props.monsterType][this.props.level](this.state.playerCount).attack,range:__WEBPACK_IMPORTED_MODULE_4__lib_monsters__["a" /* BOSS_STATS */][this.props.monsterType][this.props.level](this.state.playerCount).range,move:__WEBPACK_IMPORTED_MODULE_4__lib_monsters__["a" /* BOSS_STATS */][this.props.monsterType][this.props.level](this.state.playerCount).move,immunities:__WEBPACK_IMPORTED_MODULE_4__lib_monsters__["a" /* BOSS_STATS */][this.props.monsterType][this.props.level](this.state.playerCount).immunities},function(){if(_this2.state.range===0){var range=_this2.state.range;range="-";_this2.setState({range:range});}if(_this2.state.attack===0){var attack=_this2.state.attack;attack="-";_this2.setState({attack:attack});}if(_this2.state.move===0){var move=_this2.state.move;move="-";_this2.setState({move:move});}var tokenCount=_this2.state.tokenCount;if(_this2.props.monsterType.includes("Inox Bodyguard")){tokenCount=2;_this2.setState({tokenCount:2});}var monsterList=[];for(var i=1;i<=tokenCount;i++){monsterList.push({"number":i,"active":false,"maxHP":_this2.state.maxHP,"currentHP":_this2.state.maxHP,"statuses":{"disarm":false,"immobilize":false,"wound":false,"muddle":false,"poison":false,"stun":false,"invisible":false,"strengthen":false},"rank":"normal"});}// console.log(monsterList);
_this2.setState({monsterList:monsterList});// console.log(BOSS_STATS[this.props.monsterType][this.props.level](this.state.playerCount))
});}},{key:'togglePopover',value:function togglePopover(){this.setState({removePopoverOpen:!this.state.removePopoverOpen});}},{key:'toggleCollapse',value:function toggleCollapse(){this.setState({collapseOpen:!this.state.collapseOpen});}},{key:'render',value:function render(){var _this3=this;var statsStyle={color:"#ffffff",backgroundColor:"#0F0F0F",borderColor:"#1b1e21"};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["b" /* Card */],{className:'text-white bg-dark'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["d" /* CardHeader */],{style:{fontFamily:"PirataOne"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["y" /* Row */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["e" /* Col */],{md:'4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'img-fluid rounded',style:{height:"30px",width:"30px",cursor:"pointer"},id:"thumbnail-"+this.props.monsterType.replace(/\s+/g,''),src:__WEBPACK_IMPORTED_MODULE_2__lib_monsterImages_monsterImagesList__["a" /* default */][this.props.monsterType],alt:this.props.monsterType,onClick:this.toggleCollapse}),' \xA0\xA0',this.props.monsterType,' : ',this.props.level)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["e" /* Col */],{md:'4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["y" /* Row */],null,!this.state.collapseOpen?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_reveal__["Fade"],{bottom:true,duration:300},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:statsStyle},'\xA0 HP: ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,this.state.maxHP),', \xA0',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'img-fluid MonsterTracker--StatIcon',src:Object(__WEBPACK_IMPORTED_MODULE_3__lib_stats__["d" /* iconForStat */])(__WEBPACK_IMPORTED_MODULE_3__lib_stats__["a" /* ATTACK */]),alt:'attack'}),': ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,this.state.attack),', \xA0',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'img-fluid MonsterTracker--StatIcon',src:Object(__WEBPACK_IMPORTED_MODULE_3__lib_stats__["d" /* iconForStat */])(__WEBPACK_IMPORTED_MODULE_3__lib_stats__["b" /* MOVEMENT */]),alt:'move'}),': ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,this.state.move),', \xA0',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'img-fluid MonsterTracker--StatIcon',src:Object(__WEBPACK_IMPORTED_MODULE_3__lib_stats__["d" /* iconForStat */])(__WEBPACK_IMPORTED_MODULE_3__lib_stats__["c" /* RANGE */]),alt:'range'}),': ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,this.state.range),' \xA0\xA0')):null,!this.state.collapseOpen?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_reveal__["Fade"],{bottom:true,duration:300},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:statsStyle},'Immune:',this.state.immunities.map(function(immunity){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{key:immunity,className:'img-fluid MonsterTracker--StatusEffectIcon',src:Object(__WEBPACK_IMPORTED_MODULE_5__lib_icons__["a" /* getIcon */])(immunity.toUpperCase()),alt:immunity});}))):null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["e" /* Col */],{md:'4',className:'text-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,this.state.monsterList.map(function(monster,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["a" /* Button */],{key:i+1,size:'xs',onClick:function onClick(){_this3.toggleActive(i+1);},className:_this3.state.monsterList[i].active?"btn btn-secondary":"btn btn-outline-secondary"},_this3.props.monsterType,' \xA0',_this3.state.tokenCount>1?i+1:null);}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["f" /* Collapse */],{isOpen:this.state.collapseOpen},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["g" /* Container */],{fluid:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["y" /* Row */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["e" /* Col */],{md:'2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'img-fluid rounded mx-auto d-block',id:"removeMonsterPopover-"+this.props.monsterType.replace(/\s+/g,''),src:__WEBPACK_IMPORTED_MODULE_2__lib_monsterImages_monsterImagesList__["a" /* default */][this.props.monsterType],alt:this.props.monsterType,onClick:this.togglePopover}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["u" /* Popover */],{placement:'auto',isOpen:this.state.removePopoverOpen,target:"removeMonsterPopover-"+this.props.monsterType.replace(/\s+/g,''),toggle:this.togglePopover},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["v" /* PopoverBody */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["a" /* Button */],{color:'info',onClick:this.changePlayerCount},'Player Count: ',this.state.playerCount,' '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["a" /* Button */],{color:'danger',onClick:function onClick(){_this3.props.removeMonster("Boss: "+_this3.props.monsterType);}},'Remove monster type')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["e" /* Col */],{md:'5'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["y" /* Row */],{className:'no-gutter'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["e" /* Col */],{md:'6'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["n" /* ListGroup */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["o" /* ListGroupItem */],{style:statsStyle},'HP: ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,this.state.maxHP)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["o" /* ListGroupItem */],{style:statsStyle},'Attack ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'img-fluid MonsterTracker--StatIcon',src:Object(__WEBPACK_IMPORTED_MODULE_3__lib_stats__["d" /* iconForStat */])(__WEBPACK_IMPORTED_MODULE_3__lib_stats__["a" /* ATTACK */]),alt:'attack'}),': ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,this.state.attack)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["o" /* ListGroupItem */],{style:statsStyle},'Move ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'img-fluid MonsterTracker--StatIcon',src:Object(__WEBPACK_IMPORTED_MODULE_3__lib_stats__["d" /* iconForStat */])(__WEBPACK_IMPORTED_MODULE_3__lib_stats__["b" /* MOVEMENT */]),alt:'movement'}),': ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,this.state.move)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["o" /* ListGroupItem */],{style:statsStyle},'Range ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'img-fluid MonsterTracker--StatIcon',src:Object(__WEBPACK_IMPORTED_MODULE_3__lib_stats__["d" /* iconForStat */])(__WEBPACK_IMPORTED_MODULE_3__lib_stats__["c" /* RANGE */]),alt:'range'}),': ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,this.state.range)))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["e" /* Col */],{md:'6'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["n" /* ListGroup */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["o" /* ListGroupItem */],{style:statsStyle},'Immunities: ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),this.state.immunities.map(function(immunity){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{key:immunity,className:'img-fluid MonsterTracker--StatusEffectIcon',src:Object(__WEBPACK_IMPORTED_MODULE_5__lib_icons__["a" /* getIcon */])(immunity.toUpperCase()),alt:immunity});})))))))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["g" /* Container */],{fluid:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["y" /* Row */],{className:'no-gutter'},this.state.monsterList.map(function(monster,i){if(_this3.state.monsterList[i].active){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["e" /* Col */],{md:'12',xs:'12',key:i+1},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_reveal__["Fade"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["b" /* Card */],{inverse:true,className:'bg-boss'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["d" /* CardHeader */],{style:{fontFamily:"PirataOne"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["g" /* Container */],{fluid:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["y" /* Row */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["e" /* Col */],{md:'8'},_this3.props.monsterType,' \xA0',_this3.state.tokenCount>1?i+1:null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["e" /* Col */],{md:'4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["a" /* Button */],{color:'danger',size:'sm',onClick:function onClick(){_this3.killMonster(i+1);}},'Kill'))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["c" /* CardBody */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["g" /* Container */],{fluid:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["y" /* Row */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["e" /* Col */],{md:'8'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["x" /* Progress */],{style:{height:"30px"},color:'danger',value:_this3.state.monsterList[i].currentHP,max:_this3.state.monsterList[i].maxHP},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,_this3.state.monsterList[i].currentHP))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["e" /* Col */],{md:'4',className:'text-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["a" /* Button */],{color:'danger',size:'sm',onClick:function onClick(){_this3.changeHP(i+1,-1);}},'-'),' \xA0\xA0',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__StatusPopover__["a" /* default */],{text:"S",placement:'auto',id:"Statuses-"+_this3.props.monsterType.replace(/\s+/g,'')+"-"+(i+1),toggleStatus:_this3.toggleStatus,clearStatuses:_this3.clearStatuses,statusList:_this3.state.monsterList[i].statuses,monsterType:_this3.props.monsterType,monsterNumber:i+1}),' \xA0\xA0',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["a" /* Button */],{color:'success',size:'sm',onClick:function onClick(){_this3.changeHP(i+1,1);}},'+'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["y" /* Row */],null,Object.keys(_this3.state.monsterList[i].statuses).map(function(status){if(_this3.state.monsterList[i].statuses[status]){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:status},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_reveal__["Fade"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'img-fluid MonsterTracker--StatusEffectIcon',src:Object(__WEBPACK_IMPORTED_MODULE_5__lib_icons__["a" /* getIcon */])(status.toUpperCase()),alt:status,onClick:function onClick(){_this3.toggleStatus(i+1,status);},style:{cursor:"pointer"}})));}else{return null;}})))))));}else{return null;}}))));}}]);return BossContainer;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (BossContainer);

/***/ }),
/* 172 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reactstrap__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MainArea_css__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MainArea_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__MainArea_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var NavigationBar=function(_Component){_inherits(NavigationBar,_Component);function NavigationBar(props){_classCallCheck(this,NavigationBar);var _this=_possibleConstructorReturn(this,(NavigationBar.__proto__||Object.getPrototypeOf(NavigationBar)).call(this,props));_this.toggle=_this.toggle.bind(_this);_this.togglePopover=_this.togglePopover.bind(_this);_this.state={isOpen:false,popoverOpen:false};return _this;}_createClass(NavigationBar,[{key:'toggle',value:function toggle(){this.setState({isOpen:!this.state.isOpen});}},{key:'togglePopover',value:function togglePopover(){this.setState({popoverOpen:!this.state.popoverOpen});}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["s" /* Navbar */],{style:{backgroundColor:"#202020"},dark:true,expand:'md'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["g" /* Container */],{fluid:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["t" /* NavbarBrand */],{style:{fontFamily:"PirataOne",color:"#ffffff"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fas fa-bars',onClick:this.props.toggleSidebar,style:{color:"#ffffff",width:"40px",cursor:"pointer"}}),!this.props.scenarioLoaded?"Gloomhaven Monster Tracker":this.props.scenarioName+": Level "+this.props.scenarioLevel),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["p" /* Nav */],{className:'ml-auto',navbar:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["q" /* NavItem */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["r" /* NavLink */],{id:'help',className:'mx-auto',onClick:this.togglePopover,style:{cursor:"pointer"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fas fa-info-circle'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["u" /* Popover */],{placement:'auto',isOpen:this.state.popoverOpen,target:'help',toggle:this.togglePopover},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["w" /* PopoverHeader */],null,'Help/Tips'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["v" /* PopoverBody */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,'Load a scenario, or add individual monsters from the sidebar menu'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,'To save vertical space, click the monster thumbnail to collapse the stats card'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,'Clicking on a monster image opens a popup',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,'remove monster type'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,'change player count (for boss HP, default 4)'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,'Click on an individual monster\'s active status effect to remove it')))))))));}}]);return NavigationBar;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (NavigationBar);

/***/ }),
/* 173 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _sidebar = __webpack_require__(174);

var _sidebar2 = _interopRequireDefault(_sidebar);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _sidebar2.default;

/***/ }),
/* 174 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CANCEL_DISTANCE_ON_SCROLL = 20;

var defaultStyles = {
  root: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    overflow: 'hidden'
  },
  sidebar: {
    zIndex: 2,
    position: 'absolute',
    top: 0,
    bottom: 0,
    transition: 'transform .3s ease-out',
    WebkitTransition: '-webkit-transform .3s ease-out',
    willChange: 'transform',
    overflowY: 'auto'
  },
  content: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    overflowY: 'scroll',
    WebkitOverflowScrolling: 'touch',
    transition: 'left .3s ease-out, right .3s ease-out'
  },
  overlay: {
    zIndex: 1,
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    opacity: 0,
    visibility: 'hidden',
    transition: 'opacity .3s ease-out, visibility .3s ease-out',
    backgroundColor: 'rgba(0,0,0,.3)'
  },
  dragHandle: {
    zIndex: 1,
    position: 'fixed',
    top: 0,
    bottom: 0
  }
};

var Sidebar = function (_Component) {
  _inherits(Sidebar, _Component);

  function Sidebar(props) {
    _classCallCheck(this, Sidebar);

    var _this = _possibleConstructorReturn(this, (Sidebar.__proto__ || Object.getPrototypeOf(Sidebar)).call(this, props));

    _this.state = {
      // the detected width of the sidebar in pixels
      sidebarWidth: props.defaultSidebarWidth,

      // keep track of touching params
      touchIdentifier: null,
      touchStartX: null,
      touchStartY: null,
      touchCurrentX: null,
      touchCurrentY: null,

      // if touch is supported by the browser
      dragSupported: false
    };

    _this.overlayClicked = _this.overlayClicked.bind(_this);
    _this.onTouchStart = _this.onTouchStart.bind(_this);
    _this.onTouchMove = _this.onTouchMove.bind(_this);
    _this.onTouchEnd = _this.onTouchEnd.bind(_this);
    _this.onScroll = _this.onScroll.bind(_this);
    _this.saveSidebarRef = _this.saveSidebarRef.bind(_this);
    return _this;
  }

  _createClass(Sidebar, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.setState({
        dragSupported: (typeof window === 'undefined' ? 'undefined' : _typeof(window)) === 'object' && 'ontouchstart' in window
      });
      this.saveSidebarWidth();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      // filter out the updates when we're touching
      if (!this.isTouching()) {
        this.saveSidebarWidth();
      }
    }
  }, {
    key: 'onTouchStart',
    value: function onTouchStart(ev) {
      // filter out if a user starts swiping with a second finger
      if (!this.isTouching()) {
        var touch = ev.targetTouches[0];
        this.setState({
          touchIdentifier: touch.identifier,
          touchStartX: touch.clientX,
          touchStartY: touch.clientY,
          touchCurrentX: touch.clientX,
          touchCurrentY: touch.clientY
        });
      }
    }
  }, {
    key: 'onTouchMove',
    value: function onTouchMove(ev) {
      if (this.isTouching()) {
        for (var ind = 0; ind < ev.targetTouches.length; ind++) {
          // we only care about the finger that we are tracking
          if (ev.targetTouches[ind].identifier === this.state.touchIdentifier) {
            this.setState({
              touchCurrentX: ev.targetTouches[ind].clientX,
              touchCurrentY: ev.targetTouches[ind].clientY
            });
            break;
          }
        }
      }
    }
  }, {
    key: 'onTouchEnd',
    value: function onTouchEnd() {
      if (this.isTouching()) {
        // trigger a change to open if sidebar has been dragged beyond dragToggleDistance
        var touchWidth = this.touchSidebarWidth();

        if (this.props.open && touchWidth < this.state.sidebarWidth - this.props.dragToggleDistance || !this.props.open && touchWidth > this.props.dragToggleDistance) {
          this.props.onSetOpen(!this.props.open);
        }

        this.setState({
          touchIdentifier: null,
          touchStartX: null,
          touchStartY: null,
          touchCurrentX: null,
          touchCurrentY: null
        });
      }
    }

    // This logic helps us prevents the user from sliding the sidebar horizontally
    // while scrolling the sidebar vertically. When a scroll event comes in, we're
    // cancelling the ongoing gesture if it did not move horizontally much.

  }, {
    key: 'onScroll',
    value: function onScroll() {
      if (this.isTouching() && this.inCancelDistanceOnScroll()) {
        this.setState({
          touchIdentifier: null,
          touchStartX: null,
          touchStartY: null,
          touchCurrentX: null,
          touchCurrentY: null
        });
      }
    }

    // True if the on going gesture X distance is less than the cancel distance

  }, {
    key: 'inCancelDistanceOnScroll',
    value: function inCancelDistanceOnScroll() {
      var cancelDistanceOnScroll = void 0;

      if (this.props.pullRight) {
        cancelDistanceOnScroll = Math.abs(this.state.touchCurrentX - this.state.touchStartX) < CANCEL_DISTANCE_ON_SCROLL;
      } else {
        cancelDistanceOnScroll = Math.abs(this.state.touchStartX - this.state.touchCurrentX) < CANCEL_DISTANCE_ON_SCROLL;
      }
      return cancelDistanceOnScroll;
    }
  }, {
    key: 'isTouching',
    value: function isTouching() {
      return this.state.touchIdentifier !== null;
    }
  }, {
    key: 'overlayClicked',
    value: function overlayClicked() {
      if (this.props.open) {
        this.props.onSetOpen(false);
      }
    }
  }, {
    key: 'saveSidebarWidth',
    value: function saveSidebarWidth() {
      var width = this.sidebar.offsetWidth;

      if (width !== this.state.sidebarWidth) {
        this.setState({ sidebarWidth: width });
      }
    }
  }, {
    key: 'saveSidebarRef',
    value: function saveSidebarRef(node) {
      this.sidebar = node;
    }

    // calculate the sidebarWidth based on current touch info

  }, {
    key: 'touchSidebarWidth',
    value: function touchSidebarWidth() {
      // if the sidebar is open and start point of drag is inside the sidebar
      // we will only drag the distance they moved their finger
      // otherwise we will move the sidebar to be below the finger.
      if (this.props.pullRight) {
        if (this.props.open && window.innerWidth - this.state.touchStartX < this.state.sidebarWidth) {
          if (this.state.touchCurrentX > this.state.touchStartX) {
            return this.state.sidebarWidth + this.state.touchStartX - this.state.touchCurrentX;
          }
          return this.state.sidebarWidth;
        }
        return Math.min(window.innerWidth - this.state.touchCurrentX, this.state.sidebarWidth);
      }

      if (this.props.open && this.state.touchStartX < this.state.sidebarWidth) {
        if (this.state.touchCurrentX > this.state.touchStartX) {
          return this.state.sidebarWidth;
        }
        return this.state.sidebarWidth - this.state.touchStartX + this.state.touchCurrentX;
      }
      return Math.min(this.state.touchCurrentX, this.state.sidebarWidth);
    }
  }, {
    key: 'render',
    value: function render() {
      var sidebarStyle = _extends({}, defaultStyles.sidebar, this.props.styles.sidebar);
      var contentStyle = _extends({}, defaultStyles.content, this.props.styles.content);
      var overlayStyle = _extends({}, defaultStyles.overlay, this.props.styles.overlay);
      var useTouch = this.state.dragSupported && this.props.touch;
      var isTouching = this.isTouching();
      var rootProps = {
        className: this.props.rootClassName,
        style: _extends({}, defaultStyles.root, this.props.styles.root),
        role: "navigation"
      };
      var dragHandle = void 0;

      // sidebarStyle right/left
      if (this.props.pullRight) {
        sidebarStyle.right = 0;
        sidebarStyle.transform = 'translateX(100%)';
        sidebarStyle.WebkitTransform = 'translateX(100%)';
        if (this.props.shadow) {
          sidebarStyle.boxShadow = '-2px 2px 4px rgba(0, 0, 0, 0.15)';
        }
      } else {
        sidebarStyle.left = 0;
        sidebarStyle.transform = 'translateX(-100%)';
        sidebarStyle.WebkitTransform = 'translateX(-100%)';
        if (this.props.shadow) {
          sidebarStyle.boxShadow = '2px 2px 4px rgba(0, 0, 0, 0.15)';
        }
      }

      if (isTouching) {
        var percentage = this.touchSidebarWidth() / this.state.sidebarWidth;

        // slide open to what we dragged
        if (this.props.pullRight) {
          sidebarStyle.transform = 'translateX(' + (1 - percentage) * 100 + '%)';
          sidebarStyle.WebkitTransform = 'translateX(' + (1 - percentage) * 100 + '%)';
        } else {
          sidebarStyle.transform = 'translateX(-' + (1 - percentage) * 100 + '%)';
          sidebarStyle.WebkitTransform = 'translateX(-' + (1 - percentage) * 100 + '%)';
        }

        // fade overlay to match distance of drag
        overlayStyle.opacity = percentage;
        overlayStyle.visibility = 'visible';
      } else if (this.props.docked) {
        // show sidebar
        if (this.state.sidebarWidth !== 0) {
          sidebarStyle.transform = 'translateX(0%)';
          sidebarStyle.WebkitTransform = 'translateX(0%)';
        }

        // make space on the left/right side of the content for the sidebar
        if (this.props.pullRight) {
          contentStyle.right = this.state.sidebarWidth + 'px';
        } else {
          contentStyle.left = this.state.sidebarWidth + 'px';
        }
      } else if (this.props.open) {
        // slide open sidebar
        sidebarStyle.transform = 'translateX(0%)';
        sidebarStyle.WebkitTransform = 'translateX(0%)';

        // show overlay
        overlayStyle.opacity = 1;
        overlayStyle.visibility = 'visible';
      }

      if (isTouching || !this.props.transitions) {
        sidebarStyle.transition = 'none';
        sidebarStyle.WebkitTransition = 'none';
        contentStyle.transition = 'none';
        overlayStyle.transition = 'none';
      }

      if (useTouch) {
        if (this.props.open) {
          rootProps.onTouchStart = this.onTouchStart;
          rootProps.onTouchMove = this.onTouchMove;
          rootProps.onTouchEnd = this.onTouchEnd;
          rootProps.onTouchCancel = this.onTouchEnd;
          rootProps.onScroll = this.onScroll;
        } else {
          var dragHandleStyle = _extends({}, defaultStyles.dragHandle, this.props.styles.dragHandle);
          dragHandleStyle.width = this.props.touchHandleWidth;

          // dragHandleStyle right/left
          if (this.props.pullRight) {
            dragHandleStyle.right = 0;
          } else {
            dragHandleStyle.left = 0;
          }

          dragHandle = _react2.default.createElement('div', { style: dragHandleStyle,
            onTouchStart: this.onTouchStart, onTouchMove: this.onTouchMove,
            onTouchEnd: this.onTouchEnd, onTouchCancel: this.onTouchEnd });
        }
      }

      return _react2.default.createElement(
        'div',
        rootProps,
        _react2.default.createElement(
          'div',
          { className: this.props.sidebarClassName, style: sidebarStyle, ref: this.saveSidebarRef },
          this.props.sidebar
        ),
        _react2.default.createElement('div', { className: this.props.overlayClassName,
          style: overlayStyle,
          role: 'presentation',
          tabIndex: '0',
          onClick: this.overlayClicked
        }),
        _react2.default.createElement(
          'div',
          { className: this.props.contentClassName, style: contentStyle },
          dragHandle,
          this.props.children
        )
      );
    }
  }]);

  return Sidebar;
}(_react.Component);

Sidebar.propTypes = {
  // main content to render
  children: _propTypes2.default.node.isRequired,

  // styles
  styles: _propTypes2.default.shape({
    root: _propTypes2.default.object,
    sidebar: _propTypes2.default.object,
    content: _propTypes2.default.object,
    overlay: _propTypes2.default.object,
    dragHandle: _propTypes2.default.object
  }),

  // root component optional class
  rootClassName: _propTypes2.default.string,

  // sidebar optional class
  sidebarClassName: _propTypes2.default.string,

  // content optional class
  contentClassName: _propTypes2.default.string,

  // overlay optional class
  overlayClassName: _propTypes2.default.string,

  // sidebar content to render
  sidebar: _propTypes2.default.node.isRequired,

  // boolean if sidebar should be docked
  docked: _propTypes2.default.bool,

  // boolean if sidebar should slide open
  open: _propTypes2.default.bool,

  // boolean if transitions should be disabled
  transitions: _propTypes2.default.bool,

  // boolean if touch gestures are enabled
  touch: _propTypes2.default.bool,

  // max distance from the edge we can start touching
  touchHandleWidth: _propTypes2.default.number,

  // Place the sidebar on the right
  pullRight: _propTypes2.default.bool,

  // Enable/Disable sidebar shadow
  shadow: _propTypes2.default.bool,

  // distance we have to drag the sidebar to toggle open state
  dragToggleDistance: _propTypes2.default.number,

  // callback called when the overlay is clicked
  onSetOpen: _propTypes2.default.func,

  // Intial sidebar width when page loads
  defaultSidebarWidth: _propTypes2.default.number
};

Sidebar.defaultProps = {
  docked: false,
  open: false,
  transitions: true,
  touch: true,
  touchHandleWidth: 20,
  pullRight: false,
  shadow: true,
  dragToggleDistance: 30,
  onSetOpen: function onSetOpen() {},
  styles: {},
  defaultSidebarWidth: 0
};

exports.default = Sidebar;

/***/ }),
/* 175 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SCENARIO_DEFINITIONS; });
//special_rules should be treated with some kind of macro that recognises them and applies them when loading
// SPECIAL_RULES =
// {
//     living_corpse_two_levels_extra:
//         {   "description": "All living corpses are two levels higher than the scenario level, up to a max of 7",
//             "affected_deck": "Living Corpse",
//             "extra_levels": 2
//         }
// };
var SCENARIO_DEFINITIONS=[{name:"#1 Black Barrow",decks:[{"name":"Bandit Guard","deck_name":"Guard"},{"name":"Bandit Archer","deck_name":"Archer"},{"name":"Living Bones","deck_name":"Living Bones"}]},{name:"#2 Barrow Lair",decks:[{"name":"Bandit Archer"},{"name":"Boss: Bandit Commander"},{"name":"Living Bones"},{"name":"Living Corpse"}]},{name:"#3 Inox Encampment",decks:[{"name":"Inox Guard"},{"name":"Inox Archer"},{"name":"Inox Shaman"}]},{name:"#4 Crypt of the Damned",decks:[{"name":"Living Bones"},{"name":"Bandit Archer"},{"name":"Cultist"},{"name":"Earth Demon"},{"name":"Wind Demon"}]},{name:"#5 Ruinous Crypt",decks:[{"name":"Cultist"},{"name":"Living Bones"},{"name":"Living Corpse"},{"name":"Night Demon"},{"name":"Flame Demon"},{"name":"Frost Demon"}]},{name:"#6 Decaying Crypt",decks:[{"name":"Living Bones"},{"name":"Living Corpse"},{"name":"Living Spirit"}]},{name:"#7 Vibrant Grotto",decks:[{"name":"Forest Imp"},{"name":"Cave Bear"},{"name":"Inox Shaman"},{"name":"Earth Demon"}]},{name:"#8 Gloomhaven Warehouse",decks:[{"name":"Living Bones"},{"name":"Living Corpse"},{"name":"Boss: Inox Bodyguard"}]},{name:"#9 Diamond Mine",decks:[{"name":"Hound"},{"name":"Vermling Scout"},{"name":"Boss: Merciless Overseer"}]},{name:"#10 Plane of Elemental Power",decks:[{"name":"Flame Demon"},{"name":"Earth Demon"},{"name":"Sun Demon"}]},{name:"#11 Gloomhaven Square A",decks:[{"name":"Living Bones"},{"name":"Living Corpse"},{"name":"City Guard"},{"name":"City Archer"},{"name":"Boss: Captain of the Guard"}]},{name:"#12 Gloomhaven Square B",decks:[{"name":"Living Bones"},{"name":"Living Corpse"},{"name":"Cultist"},{"name":"City Guard"},{"name":"City Archer"},{"name":"Boss: Jekserah"}]},{name:"#13 Temple of the Seer",decks:[{"name":"Stone Golem"},{"name":"Cave Bear"},{"name":"Living Spirit"},{"name":"Spitting Drake"}]},{name:"#14 Frozen Hollow",decks:[{"name":"Hound"},{"name":"Living Spirit"},{"name":"Frost Demon"}]},{name:"#15 Shrine of Strength",decks:[{"name":"Stone Golem"},{"name":"Savvas Icestorm"},{"name":"Frost Demon"},{"name":"Wind Demon"},{"name":"Harrower Infester"}]},{name:"#16 Mountain Pass",decks:[{"name":"Earth Demon"},{"name":"Wind Demon"},{"name":"Inox Guard"},{"name":"Inox Archer"}]},{name:"#17 Lost Island",decks:[{"name":"Vermling Scout"},{"name":"Vermling Shaman"},{"name":"Cave Bear"}]},{name:"#18 Abandoned Sewers",decks:[{"name":"Giant Viper"},{"name":"Ooze"},{"name":"Vermling Scout"}]},{name:"#19 Forgotten Crypt",decks:[{"name":"Cultist"},{"name":"Living Bones"},{"name":"Living Spirit"},{"name":"Living Corpse"}]},{name:"#20 Necromancer's Sanctum",decks:[{"name":"Living Bones"},{"name":"Cultist"},{"name":"Night Demon"},{"name":"Living Corpse"},{"name":"Boss: Jekserah"}]},{name:"#21 Infernal Throne",decks:[{"name":"Sun Demon"},{"name":"Frost Demon"},{"name":"Night Demon"},{"name":"Wind Demon"},{"name":"Earth Demon"},{"name":"Flame Demon"},{"name":"Boss: Prime Demon"}]},{name:"#22 Temple of the Elements",decks:[{"name":"Living Bones"},{"name":"Cultist"},{"name":"Earth Demon"},{"name":"Flame Demon"},{"name":"Frost Demon"},{"name":"Wind Demon"}]},{name:"#23 Deep Ruins",decks:[{"name":"Stone Golem"},{"name":"Ancient Artillery"},{"name":"Living Bones"},{"name":"Living Spirit"}]},{name:"#24 Echo Chamber",decks:[{"name":"Rending Drake"},{"name":"Ooze"},{"name":"Living Spirit"}]},{name:"#25 Icecrag Ascent",decks:[{"name":"Hound"},{"name":"Rending Drake"},{"name":"Spitting Drake"}]},{name:"#26 Ancient Cistern",decks:[{"name":"Living Corpse"},{"name":"Ooze"},{"name":"Night Demon"},{"name":"Black Imp"}]},{name:"#27 Ruinous Rift",decks:[{"name":"Night Demon"},{"name":"Wind Demon"},{"name":"Frost Demon"},{"name":"Sun Demon"},{"name":"Earth Demon"},{"name":"Flame Demon"}]},{name:"#28 Outer Ritual Chamber",decks:[{"name":"Living Corpse"},{"name":"Cultist"},{"name":"Living Bones"},{"name":"Night Demon"},{"name":"Sun Demon"}]},{name:"#29 Sanctuary of Gloom",decks:[{"name":"Living Bones"},{"name":"Living Corpse"},{"name":"Living Spirit"},{"name":"Black Imp"}]},{name:"#30 Shrine of the Depths",decks:[{"name":"Ooze"},{"name":"Lurker"},{"name":"Deep Terror"}]},{name:"#31 Plane of the Night",decks:[{"name":"Deep Terror"},{"name":"Night Demon"},{"name":"Black Imp"}]},{name:"#32 Decrepit Wood",decks:[{"name":"Harrower Infester"},{"name":"Giant Viper"},{"name":"Deep Terror"},{"name":"Black Imp"}]},{name:"#33 Savvas Armory",decks:[{"name":"Savvas Icestorm"},{"name":"Savvas Lavaflow"},{"name":"Frost Demon"},{"name":"Flame Demon"},{"name":"Wind Demon"},{"name":"Earth Demon"}]},{name:"#34 Scorched Summit",decks:[{"name":"Rending Drake"},{"name":"Spitting Drake"},{"name":"Boss: Elder Drake"}]},{name:"#35 Gloomhaven Battlements A",decks:[{"name":"Flame Demon"},{"name":"Frost Demon"},{"name":"Earth Demon"},{"name":"Wind Demon"}]},{name:"#36 Gloomhaven Battlements B",decks:[{"name":"Flame Demon"},{"name":"Frost Demon"},{"name":"Earth Demon"},{"name":"Wind Demon"},{"name":"City Archer"},{"name":"Boss: Prime Demon"}]},{name:"#37 Doom Trench",decks:[{"name":"Lurker"},{"name":"Deep Terror"},{"name":"Harrower Infester"}]},{name:"#38 Slave Pens",decks:[{"name":"Inox Guard"},{"name":"Inox Archer"},{"name":"Inox Shaman"},{"name":"Stone Golem"}]},{name:"#39 Treacherous Divide",decks:[{"name":"Cave Bear"},{"name":"Frost Demon"},{"name":"Spitting Drake"},{"name":"Cultist"},{"name":"Living Bones"}]},{name:"#40 Ancient Defense Network",decks:[{"name":"Living Corpse"},{"name":"Flame Demon"},{"name":"Cave Bear"},{"name":"Stone Golem"},{"name":"Forest Imp"}]},{name:"#41 Timeworn Tomb",decks:[{"name":"Ancient Artillery"},{"name":"Living Corpse"},{"name":"Living Spirit"},{"name":"Stone Golem"}]},{name:"#42 Realm of the Voice",decks:[{"name":"Night Demon"},{"name":"Wind Demon"},{"name":"Living Spirit"}]},{name:"#43 - Drake Nest",decks:[{"name":"Flame Demon"},{"name":"Rending Drake"},{"name":"Spitting Drake"}]},{name:"#44 Tribal Assault",decks:[{"name":"Inox Guard"},{"name":"Inox Archer"},{"name":"Hound"},{"name":"Inox Shaman"}]},{name:"#45 Rebel Swamp",decks:[{"name":"City Guard"},{"name":"City Archer"},{"name":"Hound"}]},{name:"#46 Nightmare Peak",decks:[{"name":"Night Demon"},{"name":"Frost Demon"},{"name":"Wind Demon"},{"name":"Savvas Icestorm"},{"name":"Boss: Winged Horror"}]},{name:"#47 Lair of the Unseeing Eye",decks:[{"name":"Lurker"},{"name":"Deep Terror"},{"name":"Harrower Infester"},{"name":"Boss: The Sightless Eye"}]},{name:"#48 - Shadow Weald",decks:[{"name":"Forest Imp"},{"name":"Earth Demon"},{"name":"Harrower Infester"},{"name":"Boss: Dark Rider"}]},{name:"#49 Rebel's Stand",decks:[{"name":"Giant Viper"},{"name":"City Archer"},{"name":"City Guard"},{"name":"Ancient Artillery"}]},{name:"#50 Ghost Fortress",decks:[{"name":"Night Demon"},{"name":"Sun Demon"},{"name":"Earth Demon"}]},{name:"#51 The Void",decks:[{"name":"Boss: The Gloom"}]},{name:"#52 Noxious Cellar",decks:[{"name":"Spitting Drake"},{"name":"Ooze"},{"name":"Vermling Scout"},{"name":"Living Corpse"},{"name":"Vermling Shaman"}]},{name:"#53 Crypt Basement",decks:[{"name":"Ooze"},{"name":"Living Corpse"},{"name":"Living Spirit"},{"name":"Living Bones"},{"name":"Giant Viper"}]},{name:"#54 Palace of Ice",decks:[{"name":"Cave Bear"},{"name":"Living Spirit"},{"name":"Frost Demon"},{"name":"Harrower Infester"}]},//TODO Show message that this is random, use deck tab instead
{name:"#55 Foggy Thicket",decks:[]},{name:"#56 Bandit's Wood",decks:[{"name":"Hound"},{"name":"Bandit Archer"},{"name":"Rending Drake"},{"name":"Bandit Guard"}]},{name:"#57 Investigation",decks:[{"name":"City Guard"},{"name":"City Archer"},{"name":"Hound"}]},{name:"#58 Bloody Shack",decks:[{"name":"Earth Demon"},{"name":"Harrower Infester"},{"name":"Black Imp"},{"name":"City Guard"}]},{name:"#59 Forgotten Grove",decks:[{"name":"Cave Bear"},{"name":"Hound"},{"name":"Forest Imp"}]},{name:"#60 Alchemy Lab",decks:[{"name":"Ooze"},{"name":"Giant Viper"},{"name":"Hound"},{"name":"Rending Drake"},{"name":"Spitting Drake"}]},{name:"#61 Fading Lighthouse",decks:[{"name":"Ooze"},{"name":"Giant Viper"},{"name":"Frost Demon"},{"name":"Flame Demon"}]},{name:"#62 Pit of Souls",decks:[{"name":"Living Bones"},{"name":"Living Spirit"}]},{name:"#63 Magma Pit",decks:[{"name":"Vermling Scout"},{"name":"Inox Guard"},{"name":"Inox Archer"},{"name":"Flame Demon"}]},{name:"#64 Underwater Lagoon",decks:[{"name":"Ooze"},{"name":"Forest Imp"},{"name":"Rending Drake"}]},{name:"#65 Sulfur Mine",decks:[{"name":"Vermling Scout"},{"name":"Hound"},{"name":"Inox Shaman"}]},{name:"#66 Clockwork Cove",decks:[{"name":"Ooze"},{"name":"Ancient Artillery"},{"name":"Living Spirit"},{"name":"Stone Golem"}]},{name:"#67 Arcane Library",decks:[{"name":"Forest Imp"},{"name":"Cave Bear"},{"name":"Stone Golem"}]},{name:"#68 Toxic Moor",decks:[{"name":"Rending Drake"},{"name":"Black Imp"},{"name":"Giant Viper"},{"name":"Living Corpse"}]},{name:"#69 Well of the Unfortunate",decks:[{"name":"Vermling Scout"},{"name":"Vermling Shaman"},{"name":"Forest Imp"},{"name":"Stone Golem"},{"name":"Living Spirit"}]},{name:"#70 Chained Isle",decks:[{"name":"Night Demon"},{"name":"Wind Demon"},{"name":"Living Spirit"}]},{name:"#71 Windswept Highlands",decks:[{"name":"Spitting Drake"},{"name":"Wind Demon"},{"name":"Sun Demon"}]},{name:"#72 Oozing Grove",decks:[{"name":"Ooze"},{"name":"Forest Imp"},{"name":"Giant Viper"}]},{name:"#73 Rockslide Ridge",decks:[{"name":"Hound"},{"name":"Inox Archer"},{"name":"Ancient Artillery"},{"name":"Inox Guard"},{"name":"Inox Shaman"}]},{name:"#74 Merchant Ship",decks:[{"name":"Bandit Guard"},{"name":"Bandit Archer"},{"name":"Lurker"},{"name":"Deep Terror"}]},{name:"#75 Overgrown Graveyard",decks:[{"name":"Living Bones"},{"name":"Living Corpse"},{"name":"Living Spirit"}]},{name:"#76 Harrower Hive",decks:[{"name":"Giant Viper"},{"name":"Living Bones"},{"name":"Night Demon"},{"name":"Harrower Infester"}]},{name:"#77 Vault of Secrets",decks:[{"name":"City Guard"},{"name":"City Archer"},{"name":"Stone Golem"},{"name":"Hound"}]},{name:"#78 Sacrifice Pit",decks:[{"name":"Bandit Guard"},{"name":"Bandit Archer"},{"name":"Cultist"},{"name":"Living Bones"},{"name":"Black Imp"}]},{name:"#79 Lost Temple",decks:[{"name":"Stone Golem"},{"name":"Giant Viper"},{"name":"Boss: The Betrayer"}]},{name:"#80 Vigil Keep",decks:[{"name":"City Guard"},{"name":"City Archer"},{"name":"Ancient Artillery"},{"name":"Hound"}]},{name:"#81 Temple of the Eclipse",decks:[{"name":"Night Demon"},{"name":"Sun Demon"},{"name":"Stone Golem"},{"name":"Ancient Artillery"},{"name":"Boss: The Colorless"}]},{name:"#82 Burning Mountain",decks:[{"name":"Earth Demon"},{"name":"Flame Demon"},{"name":"Stone Golem"}]},{name:"#83 Shadows Within",decks:[{"name":"Hound"},{"name":"Cultist"},{"name":"Living Bones"},{"name":"Living Spirit"},{"name":"Flame Demon"}]},{name:"#84 Crystalline Cave",decks:[{"name":"Flame Demon"},{"name":"Frost Demon"},{"name":"Earth Demon"}]},{name:"#85 Sun Temple",decks:[{"name":"Hound"},{"name":"Black Imp"},{"name":"Night Demon"},{"name":"Sun Demon"}]},{name:"#86 Harried Village",decks:[{"name":"Cave Bear"},{"name":"Vermling Shaman"},{"name":"Vermling Scout"},{"name":"Lurker"}]},{name:"#87 Corrupted Cove",decks:[{"name":"Lurker"},{"name":"Deep Terror"},{"name":"Ooze"},{"name":"Black Imp"}]},{name:"#88 Plane of Water",decks:[{"name":"Frost Demon"},{"name":"Ooze"},{"name":"Lurker"}]},{name:"#89 Syndicate Hideout",decks:[{"name":"Bandit Archer"},{"name":"Bandit Guard"},{"name":"Cultist"},{"name":"Giant Viper"}]},{name:"#90 Demonic Rift",decks:[{"name":"Earth Demon"},{"name":"Wind Demon"},{"name":"Night Demon"},{"name":"Living Spirit"}]},{name:"#91 Wild Melee",decks:[{"name":"Cave Bear"},{"name":"Hound"},{"name":"Bandit Guard"},{"name":"Bandit Archer"},{"name":"Living Spirit"}]},{name:"#92 Back Alley Brawl",decks:[{"name":"Bandit Guard"},{"name":"City Guard"},{"name":"Inox Guard"},{"name":"Bandit Archer"},{"name":"City Archer"},{"name":"Savvas Icestorm"},{"name":"Frost Demon"},{"name":"Wind Demon"}]},{name:"#93 Sunken Vessel",decks:[{"name":"Lurker"},{"name":"Frost Demon"},{"name":"Living Spirit"}]},{name:"#94 Vermling Nest",decks:[{"name":"Hound"},{"name":"Vermling Scout"},{"name":"Vermling Shaman"},{"name":"Cave Bear"}]},{name:"#95 Payment Due",decks:[{"name":"Deep Terror"},{"name":"Flame Demon"},{"name":"Earth Demon"},{"name":"Savvas Lavaflow"}]}];

/***/ }),
/* 176 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = register;
/* unused harmony export unregister */
// In production, we register a service worker to serve assets from local cache.
// This lets the app load faster on subsequent visits in production, and gives
// it offline capabilities. However, it also means that developers (and users)
// will only see deployed updates on the "N+1" visit to a page, since previously
// cached resources are updated in the background.
// To learn more about the benefits of this model, read https://goo.gl/KwvDNy.
// This link also includes instructions on opting out of this behavior.
var isLocalhost=Boolean(window.location.hostname==='localhost'||// [::1] is the IPv6 localhost address.
window.location.hostname==='[::1]'||// 127.0.0.1/8 is considered localhost for IPv4.
window.location.hostname.match(/^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/));function register(){if("production"==='production'&&'serviceWorker'in navigator){// The URL constructor is available in all browsers that support SW.
var publicUrl=new URL("",window.location);if(publicUrl.origin!==window.location.origin){// Our service worker won't work if PUBLIC_URL is on a different origin
// from what our page is served on. This might happen if a CDN is used to
// serve assets; see https://github.com/facebookincubator/create-react-app/issues/2374
return;}window.addEventListener('load',function(){var swUrl=""+'/service-worker.js';if(isLocalhost){// This is running on localhost. Lets check if a service worker still exists or not.
checkValidServiceWorker(swUrl);// Add some additional logging to localhost, pointing developers to the
// service worker/PWA documentation.
navigator.serviceWorker.ready.then(function(){console.log('This web app is being served cache-first by a service '+'worker. To learn more, visit https://goo.gl/SC7cgQ');});}else{// Is not local host. Just register service worker
registerValidSW(swUrl);}});}}function registerValidSW(swUrl){navigator.serviceWorker.register(swUrl).then(function(registration){registration.onupdatefound=function(){var installingWorker=registration.installing;installingWorker.onstatechange=function(){if(installingWorker.state==='installed'){if(navigator.serviceWorker.controller){// At this point, the old content will have been purged and
// the fresh content will have been added to the cache.
// It's the perfect time to display a "New content is
// available; please refresh." message in your web app.
console.log('New content is available; please refresh.');}else{// At this point, everything has been precached.
// It's the perfect time to display a
// "Content is cached for offline use." message.
console.log('Content is cached for offline use.');}}};};}).catch(function(error){console.error('Error during service worker registration:',error);});}function checkValidServiceWorker(swUrl){// Check if the service worker can be found. If it can't reload the page.
fetch(swUrl).then(function(response){// Ensure service worker exists, and that we really are getting a JS file.
if(response.status===404||response.headers.get('content-type').indexOf('javascript')===-1){// No service worker found. Probably a different app. Reload the page.
navigator.serviceWorker.ready.then(function(registration){registration.unregister().then(function(){window.location.reload();});});}else{// Service worker found. Proceed as normal.
registerValidSW(swUrl);}}).catch(function(){console.log('No internet connection found. App is running in offline mode.');});}function unregister(){if('serviceWorker'in navigator){navigator.serviceWorker.ready.then(function(registration){registration.unregister();});}}

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// static/js/main.b61fa099.js